import React from "react";
import "antd/dist/antd.css";
import { DatePicker, Space } from "antd";
import { useState, useEffect } from "react";
import axios from "axios";
import $ from "jquery";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";
import CompareArrowsIcon from "@mui/icons-material/CompareArrows";
import AirplaneTicketSharpIcon from "@mui/icons-material/AirplaneTicketSharp";
import AirplaneTicketIcon from "@mui/icons-material/AirplaneTicket";
import CircleIcon from "@mui/icons-material/Circle";

import { Menu, Dropdown, message } from "antd";
import { DownOutlined } from "@ant-design/icons";
import { Button, Tooltip } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { InputNumber } from "antd";
import { AutoComplete } from "antd";
import { Layout } from "antd";
import { Row, Col } from "antd";
import { Tag } from "antd";
import { CloseCircleOutlined } from "@ant-design/icons";
import {serverport} from '../Environment'

const { Header, Footer, Sider, Content } = Layout;
const { RangePicker } = DatePicker;
const filter = createFilterOptions();
var j = {}; // Depature flight
var k = {}; // arrival flight
var search = {};
j["From"] = "";
j["To"] = "";
j["FlightDate"] = "";
k["FlightDate"] = "";
var cabin = ""; // cabin class (F,B,E)
var AdultNo = 0; // No of Passengers (Adult & childern)
var childNo = 0;

export default function DatePick(props) {
  const [errVisible, setErrorVisible] = useState(false);
  const [errVisible1, setErrorVisible1] = useState(false);
  const [flightOne, setFlightOne] = useState({});
  const [flightTwo, setFlightTwo] = useState({});
  const [searchQuery, setSearchQuery] = useState({});
  const [chosenClass, setChosenClass] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const style = {};

  // Flight Code
  const options = [
    { label: "(GKA) Goroka - Papua New Guinea", value: "GKA" },
    { label: "(MAG) Madang - Papua New Guinea", value: "MAG" },
    { label: "(HGU) Mount Hagen - Papua New Guinea", value: "HGU" },
    { label: "(LAE) Nadzab - Papua New Guinea", value: "LAE" },
    {
      label: "(POM) Port Moresby Jacksons Intl - Papua New Guinea",
      value: "POM",
    },
    { label: "(WWK) Wewak Intl - Papua New Guinea", value: "WWK" },
    { label: "(UAK) Narsarsuaq - Greenland", value: "UAK" },
    { label: "(GOH) Nuuk - Greenland", value: "GOH" },
    { label: "(SFJ) Sondre Stromfjord - Greenland", value: "SFJ" },
    { label: "(THU) Thule Air Base - Greenland", value: "THU" },
    { label: "(AEY) Akureyri - Iceland", value: "AEY" },
    { label: "(EGS) Egilsstadir - Iceland", value: "EGS" },
    { label: "(HFN) Hornafjordur - Iceland", value: "HFN" },
    { label: "(HZK) Husavik - Iceland", value: "HZK" },
    { label: "(IFJ) Isafjordur - Iceland", value: "IFJ" },
    { label: "(KEF) Keflavik International Airport - Iceland", value: "KEF" },
    { label: "(PFJ) Patreksfjordur - Iceland", value: "PFJ" },
    { label: "(RKV) Reykjavik - Iceland", value: "RKV" },
    { label: "(SIJ) Siglufjordur - Iceland", value: "SIJ" },
    { label: "(VEY) Vestmannaeyjar - Iceland", value: "VEY" },
    { label: "(YAM) Sault Ste Marie - Canada", value: "YAM" },
    { label: "(YAV) Winnipeg St Andrews - Canada", value: "YAV" },
    { label: "(YAW) Shearwater - Canada", value: "YAW" },
    { label: "(YAY) St Anthony - Canada", value: "YAY" },
    { label: "(YAZ) Tofino - Canada", value: "YAZ" },
    { label: "(YBB) Kugaaruk - Canada", value: "YBB" },
    { label: "(YBC) Baie Comeau - Canada", value: "YBC" },
    { label: "(YBG) Bagotville - Canada", value: "YBG" },
    { label: "(YBK) Baker Lake - Canada", value: "YBK" },
    { label: "(YBL) Campbell River - Canada", value: "YBL" },
    { label: "(YBR) Brandon Muni - Canada", value: "YBR" },
    { label: "(YCB) Cambridge Bay - Canada", value: "YCB" },
    { label: "(YCD) Nanaimo - Canada", value: "YCD" },
    { label: "(YCG) Castlegar - Canada", value: "YCG" },
    { label: "(YCH) Miramichi - Canada", value: "YCH" },
    { label: "(YCL) Charlo - Canada", value: "YCL" },
    { label: "(YCO) Kugluktuk - Canada", value: "YCO" },
    { label: "(YCT) Coronation - Canada", value: "YCT" },
    { label: "(YCW) Chilliwack - Canada", value: "YCW" },
    { label: "(YCY) Clyde River - Canada", value: "YCY" },
    { label: "(YZS) Fairmont Hot Springs - Canada", value: "YZS" },
    { label: "(YDA) Dawson City - Canada", value: "YDA" },
    { label: "(YDB) Burwash - Canada", value: "YDB" },
    { label: "(YDC) Princeton - Canada", value: "YDC" },
    { label: "(YDF) Deer Lake - Canada", value: "YDF" },
    { label: "(YDL) Dease Lake - Canada", value: "YDL" },
    { label: "(YDN) Dauphin Barker - Canada", value: "YDN" },
    { label: "(YDQ) Dawson Creek - Canada", value: "YDQ" },
    { label: "(YEG) Edmonton Intl - Canada", value: "YEG" },
    { label: "(YEK) Arviat - Canada", value: "YEK" },
    { label: "(YEN) Estevan - Canada", value: "YEN" },
    { label: "(YET) Edson - Canada", value: "YET" },
    { label: "(YEU) Eureka - Canada", value: "YEU" },
    { label: "(YEV) Inuvik Mike Zubko - Canada", value: "YEV" },
    { label: "(YFB) Iqaluit - Canada", value: "YFB" },
    { label: "(YFC) Fredericton - Canada", value: "YFC" },
    { label: "(YFO) Flin Flon - Canada", value: "YFO" },
    { label: "(YFR) Fort Resolution - Canada", value: "YFR" },
    { label: "(YFS) Fort Simpson - Canada", value: "YFS" },
    { label: "(YGK) Kingston - Canada", value: "YGK" },
    { label: "(YGL) La Grande Riviere - Canada", value: "YGL" },
    { label: "(YGP) Gaspe - Canada", value: "YGP" },
    { label: "(YGQ) Geraldton Greenstone Regional - Canada", value: "YGQ" },
    { label: "(YGR) Iles De La Madeleine - Canada", value: "YGR" },
    { label: "(YHB) Hudson Bay - Canada", value: "YHB" },
    { label: "(YHD) Dryden Rgnl - Canada", value: "YHD" },
    { label: "(YHI) Ulukhaktok Holman - Canada", value: "YHI" },
    { label: "(YHK) Gjoa Haven - Canada", value: "YHK" },
    { label: "(YHM) Hamilton - Canada", value: "YHM" },
    { label: "(YHU) St Hubert - Canada", value: "YHU" },
    { label: "(YHY) Hay River - Canada", value: "YHY" },
    { label: "(YHZ) Halifax Intl - Canada", value: "YHZ" },
    { label: "(YIB) Atikokan Muni - Canada", value: "YIB" },
    { label: "(YIO) Pond Inlet - Canada", value: "YIO" },
    { label: "(YJN) St Jean - Canada", value: "YJN" },
    { label: "(YJT) Stephenville - Canada", value: "YJT" },
    { label: "(YKA) Kamloops - Canada", value: "YKA" },
    { label: "(YKF) Waterloo - Canada", value: "YKF" },
    { label: "(YKL) Schefferville - Canada", value: "YKL" },
    { label: "(YKY) Kindersley - Canada", value: "YKY" },
    { label: "(YKZ) Buttonville Muni - Canada", value: "YKZ" },
    { label: "(YLD) Chapleau - Canada", value: "YLD" },
    { label: "(YLJ) Meadow Lake - Canada", value: "YLJ" },
    { label: "(YLL) Lloydminster - Canada", value: "YLL" },
    { label: "(YLT) Alert - Canada", value: "YLT" },
    { label: "(YLW) Kelowna - Canada", value: "YLW" },
    { label: "(YMA) Mayo - Canada", value: "YMA" },
    {
      label: "(YMJ) Moose Jaw Air Vice Marshal C M Mcewen - Canada",
      value: "YMJ",
    },
    { label: "(YMM) Fort Mcmurray - Canada", value: "YMM" },
    { label: "(YMO) Moosonee - Canada", value: "YMO" },
    { label: "(YMW) Maniwaki - Canada", value: "YMW" },
    { label: "(YMX) Montreal Intl Mirabel - Canada", value: "YMX" },
    { label: "(YNA) Natashquan - Canada", value: "YNA" },
    { label: "(YND) Gatineau - Canada", value: "YND" },
    { label: "(YNM) Matagami - Canada", value: "YNM" },
    { label: "(YOC) Old Crow - Canada", value: "YOC" },
    { label: "(YOD) Cold Lake - Canada", value: "YOD" },
    { label: "(YOJ) High Level - Canada", value: "YOJ" },
    { label: "(YOW) Ottawa Macdonald Cartier Intl - Canada", value: "YOW" },
    { label: "(YPA) Prince Albert Glass Field - Canada", value: "YPA" },
    { label: "(YPE) Peace River - Canada", value: "YPE" },
    { label: "(YPG) Southport - Canada", value: "YPG" },
    { label: "(YPL) Pickle Lake - Canada", value: "YPL" },
    { label: "(YPN) Port Menier - Canada", value: "YPN" },
    { label: "(YPQ) Peterborough - Canada", value: "YPQ" },
    { label: "(YPR) Prince Rupert - Canada", value: "YPR" },
    { label: "(YPY) Fort Chipewyan - Canada", value: "YPY" },
    { label: "(YQA) Muskoka - Canada", value: "YQA" },
    { label: "(YQB) Quebec Jean Lesage Intl - Canada", value: "YQB" },
    { label: "(YQF) Red Deer Regional - Canada", value: "YQF" },
    { label: "(YQG) Windsor - Canada", value: "YQG" },
    { label: "(YQH) Watson Lake - Canada", value: "YQH" },
    { label: "(YQK) Kenora - Canada", value: "YQK" },
    { label: "(YQL) Lethbridge - Canada", value: "YQL" },
    { label: "(YQM) Greater Moncton Intl - Canada", value: "YQM" },
    { label: "(YQQ) Comox - Canada", value: "YQQ" },
    { label: "(YQR) Regina Intl - Canada", value: "YQR" },
    { label: "(YQT) Thunder Bay - Canada", value: "YQT" },
    { label: "(YQU) Grande Prairie - Canada", value: "YQU" },
    { label: "(YQV) Yorkton Muni - Canada", value: "YQV" },
    { label: "(YQW) North Battleford - Canada", value: "YQW" },
    { label: "(YQX) Gander Intl - Canada", value: "YQX" },
    { label: "(YQY) Sydney - Canada", value: "YQY" },
    { label: "(YQZ) Quesnel - Canada", value: "YQZ" },
    { label: "(YRB) Resolute Bay - Canada", value: "YRB" },
    { label: "(YRI) Riviere Du Loup - Canada", value: "YRI" },
    { label: "(YRJ) Roberval - Canada", value: "YRJ" },
    { label: "(YRM) Rocky Mountain House - Canada", value: "YRM" },
    { label: "(YRT) Rankin Inlet - Canada", value: "YRT" },
    { label: "(YSB) Sudbury - Canada", value: "YSB" },
    { label: "(YSC) Sherbrooke - Canada", value: "YSC" },
    { label: "(YSJ) Saint John - Canada", value: "YSJ" },
    { label: "(YSM) Fort Smith - Canada", value: "YSM" },
    { label: "(YSR) Nanisivik - Canada", value: "YSR" },
    { label: "(YSU) Summerside - Canada", value: "YSU" },
    { label: "(YSY) Sachs Harbour - Canada", value: "YSY" },
    { label: "(YTE) Cape Dorset - Canada", value: "YTE" },
    { label: "(YTH) Thompson - Canada", value: "YTH" },
    { label: "(YTR) Trenton - Canada", value: "YTR" },
    { label: "(YTS) Timmins - Canada", value: "YTS" },
    { label: "(YTZ) City Centre - Canada", value: "YTZ" },
    { label: "(YUB) Tuktoyaktuk - Canada", value: "YUB" },
    { label: "(YUL) Pierre Elliott Trudeau Intl - Canada", value: "YUL" },
    { label: "(YUT) Repulse Bay - Canada", value: "YUT" },
    { label: "(YUX) Hall Beach - Canada", value: "YUX" },
    { label: "(YUY) Rouyn Noranda - Canada", value: "YUY" },
    { label: "(YVC) La Ronge - Canada", value: "YVC" },
    { label: "(YVG) Vermilion - Canada", value: "YVG" },
    { label: "(YVM) Qikiqtarjuaq - Canada", value: "YVM" },
    { label: "(YVO) Val D Or - Canada", value: "YVO" },
    { label: "(YVP) Kuujjuaq - Canada", value: "YVP" },
    { label: "(YVQ) Norman Wells - Canada", value: "YVQ" },
    { label: "(YVR) Vancouver Intl - Canada", value: "YVR" },
    { label: "(YVT) Buffalo Narrows - Canada", value: "YVT" },
    { label: "(YVV) Wiarton - Canada", value: "YVV" },
    { label: "(YWA) Petawawa - Canada", value: "YWA" },
    { label: "(YWG) Winnipeg Intl - Canada", value: "YWG" },
    { label: "(YWK) Wabush - Canada", value: "YWK" },
    { label: "(YWL) Williams Lake - Canada", value: "YWL" },
    { label: "(YWY) Wrigley - Canada", value: "YWY" },
    { label: "(YXC) Canadian Rockies Intl - Canada", value: "YXC" },
    { label: "(YXD) Edmonton City Centre - Canada", value: "YXD" },
    { label: "(YXE) Saskatoon J G Diefenbaker Intl - Canada", value: "YXE" },
    { label: "(YXH) Medicine Hat - Canada", value: "YXH" },
    { label: "(YXJ) Fort St John - Canada", value: "YXJ" },
    { label: "(YXL) Sioux Lookout - Canada", value: "YXL" },
    { label: "(YXP) Pangnirtung - Canada", value: "YXP" },
    { label: "(YXR) Timiskaming Rgnl - Canada", value: "YXR" },
    { label: "(YXS) Prince George - Canada", value: "YXS" },
    { label: "(YXT) Terrace - Canada", value: "YXT" },
    { label: "(YXU) London - Canada", value: "YXU" },
    { label: "(YXX) Abbotsford - Canada", value: "YXX" },
    { label: "(YXY) Whitehorse Intl - Canada", value: "YXY" },
    { label: "(YYB) North Bay - Canada", value: "YYB" },
    { label: "(YYC) Calgary Intl - Canada", value: "YYC" },
    { label: "(YYD) Smithers - Canada", value: "YYD" },
    { label: "(YYE) Fort Nelson - Canada", value: "YYE" },
    { label: "(YYF) Penticton - Canada", value: "YYF" },
    { label: "(YYG) Charlottetown - Canada", value: "YYG" },
    { label: "(YYH) Taloyoak - Canada", value: "YYH" },
    { label: "(YYJ) Victoria Intl - Canada", value: "YYJ" },
    { label: "(YYL) Lynn Lake - Canada", value: "YYL" },
    { label: "(YYN) Swift Current - Canada", value: "YYN" },
    { label: "(YYQ) Churchill - Canada", value: "YYQ" },
    { label: "(YYR) Goose Bay - Canada", value: "YYR" },
    { label: "(YYT) St Johns Intl - Canada", value: "YYT" },
    { label: "(YYU) Kapuskasing - Canada", value: "YYU" },
    { label: "(YYW) Armstrong - Canada", value: "YYW" },
    { label: "(YYY) Mont Joli - Canada", value: "YYY" },
    { label: "(YYZ) Lester B Pearson Intl - Canada", value: "YYZ" },
    { label: "(YZD) Downsview - Canada", value: "YZD" },
    { label: "(YZE) Gore Bay Manitoulin - Canada", value: "YZE" },
    { label: "(YZF) Yellowknife - Canada", value: "YZF" },
    { label: "(YZH) Slave Lake - Canada", value: "YZH" },
    { label: "(YZP) Sandspit - Canada", value: "YZP" },
    { label: "(YZR) Chris Hadfield - Canada", value: "YZR" },
    { label: "(YZT) Port Hardy - Canada", value: "YZT" },
    { label: "(YZU) Whitecourt - Canada", value: "YZU" },
    { label: "(YZV) Sept Iles - Canada", value: "YZV" },
    { label: "(YZW) Teslin - Canada", value: "YZW" },
    { label: "(YZX) Greenwood - Canada", value: "YZX" },
    { label: "(ZFA) Faro - Canada", value: "ZFA" },
    { label: "(ZFM) Fort Mcpherson - Canada", value: "ZFM" },
    { label: "(BJA) Soummam - Algeria", value: "BJA" },
    { label: "(ALG) Houari Boumediene - Algeria", value: "ALG" },
    { label: "(DJG) Tiska - Algeria", value: "DJG" },
    { label: "(QFD) Boufarik - Algeria", value: "QFD" },
    { label: "(VVZ) Illizi Takhamalt - Algeria", value: "VVZ" },
    { label: "(TMR) Tamanrasset - Algeria", value: "TMR" },
    { label: "(GJL) Jijel - Algeria", value: "GJL" },
    { label: "(AAE) Annaba - Algeria", value: "AAE" },
    { label: "(CZL) Mohamed Boudiaf Intl - Algeria", value: "CZL" },
    { label: "(TEE) Cheikh Larbi Tebessi - Algeria", value: "TEE" },
    { label: "(HRM) Hassi R Mel - Algeria", value: "HRM" },
    { label: "(TID) Bou Chekif - Algeria", value: "TID" },
    { label: "(TIN) Tindouf - Algeria", value: "TIN" },
    { label: "(QAS) Ech Cheliff - Algeria", value: "QAS" },
    { label: "(TAF) Tafaraoui - Algeria", value: "TAF" },
    { label: "(TLM) Zenata - Algeria", value: "TLM" },
    { label: "(ORN) Es Senia - Algeria", value: "ORN" },
    { label: "(MUW) Ghriss - Algeria", value: "MUW" },
    {
      label: "(AZR) Touat Cheikh Sidi Mohamed Belkebir - Algeria",
      value: "AZR",
    },
    { label: "(BSK) Biskra - Algeria", value: "BSK" },
    { label: "(ELG) El Golea - Algeria", value: "ELG" },
    { label: "(GHA) Noumerat - Algeria", value: "GHA" },
    { label: "(HME) Oued Irara - Algeria", value: "HME" },
    { label: "(INZ) In Salah - Algeria", value: "INZ" },
    { label: "(TGR) Sidi Mahdi - Algeria", value: "TGR" },
    { label: "(LOO) Laghouat - Algeria", value: "LOO" },
    { label: "(TMX) Timimoun - Algeria", value: "TMX" },
    { label: "(OGX) Ouargla - Algeria", value: "OGX" },
    { label: "(IAM) In Amenas - Algeria", value: "IAM" },
    { label: "(COO) Cadjehoun - Benin", value: "COO" },
    { label: "(OUA) Ouagadougou - Burkina Faso", value: "OUA" },
    { label: "(BOY) Bobo Dioulasso - Burkina Faso", value: "BOY" },
    { label: "(ACC) Kotoka Intl - Ghana", value: "ACC" },
    { label: "(TML) Tamale - Ghana", value: "TML" },
    { label: "(NYI) Sunyani - Ghana", value: "NYI" },
    { label: "(TKD) Takoradi - Ghana", value: "TKD" },
    {
      label: "(ABJ) Abidjan Felix Houphouet Boigny Intl - Cote d'Ivoire",
      value: "ABJ",
    },
    { label: "(BYK) Bouake - Cote d'Ivoire", value: "BYK" },
    { label: "(DJO) Daloa - Cote d'Ivoire", value: "DJO" },
    { label: "(HGO) Korhogo - Cote d'Ivoire", value: "HGO" },
    { label: "(MJC) Man - Cote d'Ivoire", value: "MJC" },
    { label: "(SPY) San Pedro - Cote d'Ivoire", value: "SPY" },
    { label: "(ASK) Yamoussoukro - Cote d'Ivoire", value: "ASK" },
    { label: "(ABV) Nnamdi Azikiwe Intl - Nigeria", value: "ABV" },
    { label: "(AKR) Akure - Nigeria", value: "AKR" },
    { label: "(BNI) Benin - Nigeria", value: "BNI" },
    { label: "(CBQ) Calabar - Nigeria", value: "CBQ" },
    { label: "(ENU) Enugu - Nigeria", value: "ENU" },
    { label: "(QUS) Gusau - Nigeria", value: "QUS" },
    { label: "(IBA) Ibadan - Nigeria", value: "IBA" },
    { label: "(ILR) Ilorin - Nigeria", value: "ILR" },
    { label: "(JOS) Yakubu Gowon - Nigeria", value: "JOS" },
    { label: "(KAD) Kaduna - Nigeria", value: "KAD" },
    { label: "(KAN) Mallam Aminu Intl - Nigeria", value: "KAN" },
    { label: "(MIU) Maiduguri - Nigeria", value: "MIU" },
    { label: "(MDI) Makurdi - Nigeria", value: "MDI" },
    { label: "(LOS) Murtala Muhammed - Nigeria", value: "LOS" },
    { label: "(MXJ) Minna New - Nigeria", value: "MXJ" },
    { label: "(PHC) Port Harcourt Intl - Nigeria", value: "PHC" },
    { label: "(SKO) Sadiq Abubakar Iii Intl - Nigeria", value: "SKO" },
    { label: "(YOL) Yola - Nigeria", value: "YOL" },
    { label: "(ZAR) Zaria - Nigeria", value: "ZAR" },
    { label: "(MFQ) Maradi - Niger", value: "MFQ" },
    { label: "(NIM) Diori Hamani - Niger", value: "NIM" },
    { label: "(THZ) Tahoua - Niger", value: "THZ" },
    { label: "(AJY) Manu Dayak - Niger", value: "AJY" },
    { label: "(ZND) Zinder - Niger", value: "ZND" },
    { label: "(MIR) Habib Bourguiba Intl - Tunisia", value: "MIR" },
    { label: "(TUN) Carthage - Tunisia", value: "TUN" },
    { label: "(GAF) Gafsa - Tunisia", value: "GAF" },
    { label: "(GAE) Gabes - Tunisia", value: "GAE" },
    { label: "(DJE) Zarzis - Tunisia", value: "DJE" },
    { label: "(EBM) El Borma - Tunisia", value: "EBM" },
    { label: "(SFA) Thyna - Tunisia", value: "SFA" },
    { label: "(TOE) Nefta - Tunisia", value: "TOE" },
    { label: "(LRL) Niamtougou International - Togo", value: "LRL" },
    { label: "(LFW) Gnassingbe Eyadema Intl - Togo", value: "LFW" },
    { label: "(ANR) Deurne - Belgium", value: "ANR" },
    { label: "(BRU) Brussels Natl - Belgium", value: "BRU" },
    { label: "(CRL) Brussels South - Belgium", value: "CRL" },
    { label: "(QKT) Wevelgem - Belgium", value: "QKT" },
    { label: "(LGG) Liege - Belgium", value: "LGG" },
    { label: "(OST) Oostende - Belgium", value: "OST" },
    { label: "(BBJ) Bautzen - Germany", value: "BBJ" },
    { label: "(AOC) Altenburg Nobitz - Germany", value: "AOC" },
    { label: "(4I7) Putnam County Airport - United States", value: "4I7" },
    { label: "(BBH) Barth - Germany", value: "BBH" },
    { label: "(SXF) Schonefeld - Germany", value: "SXF" },
    { label: "(DRS) Dresden - Germany", value: "DRS" },
    { label: "(ERF) Erfurt - Germany", value: "ERF" },
    { label: "(FRA) Frankfurt Main - Germany", value: "FRA" },
    { label: "(FMO) Munster Osnabruck - Germany", value: "FMO" },
    { label: "(HAM) Hamburg - Germany", value: "HAM" },
    { label: "(THF) Tempelhof - Germany", value: "THF" },
    { label: "(CGN) Koln Bonn - Germany", value: "CGN" },
    { label: "(DUS) Dusseldorf - Germany", value: "DUS" },
    { label: "(MUC) Franz Josef Strauss - Germany", value: "MUC" },
    { label: "(NUE) Nurnberg - Germany", value: "NUE" },
    { label: "(LEJ) Leipzig Halle - Germany", value: "LEJ" },
    { label: "(SCN) Saarbrucken - Germany", value: "SCN" },
    { label: "(STR) Stuttgart - Germany", value: "STR" },
    { label: "(TXL) Tegel - Germany", value: "TXL" },
    { label: "(HAJ) Hannover - Germany", value: "HAJ" },
    { label: "(BRE) Neuenland - Germany", value: "BRE" },
    { label: "(HHN) Frankfurt Hahn - Germany", value: "HHN" },
    { label: "(MHG) Mannheim City - Germany", value: "MHG" },
    { label: "(XFW) Hamburg Finkenwerder - Germany", value: "XFW" },
    { label: "(KEL) Kiel Holtenau - Germany", value: "KEL" },
    { label: "(LBC) Lubeck Blankensee - Germany", value: "LBC" },
    { label: "(ZCA) Arnsberg Menden - Germany", value: "ZCA" },
    { label: "(ESS) Essen Mulheim - Germany", value: "ESS" },
    { label: "(MGL) Monchengladbach - Germany", value: "MGL" },
    { label: "(PAD) Paderborn Lippstadt - Germany", value: "PAD" },
    { label: "(DTM) Dortmund - Germany", value: "DTM" },
    { label: "(AGB) Augsburg - Germany", value: "AGB" },
    { label: "(OBF) Oberpfaffenhofen - Germany", value: "OBF" },
    { label: "(FDH) Friedrichshafen - Germany", value: "FDH" },
    { label: "(SZW) Schwerin Parchim - Germany", value: "SZW" },
    { label: "(ZSN) Stendal Borstel - Germany", value: "ZSN" },
    { label: "(BYU) Bayreuth - Germany", value: "BYU" },
    { label: "(HOQ) Hof Plauen - Germany", value: "HOQ" },
    { label: "(ZNV) Koblenz Winningen - Germany", value: "ZNV" },
    { label: "(ZQF) Trier Fohren - Germany", value: "ZQF" },
    { label: "(ZQC) Speyer - Germany", value: "ZQC" },
    { label: "(ZQL) Donaueschingen Villingen - Germany", value: "ZQL" },
    { label: "(BWE) Braunschweig Wolfsburg - Germany", value: "BWE" },
    { label: "(KSF) Kassel Calden - Germany", value: "KSF" },
    { label: "(BRV) Bremerhaven - Germany", value: "BRV" },
    { label: "(EME) Emden - Germany", value: "EME" },
    { label: "(WVN) Wilhelmshaven Mariensiel - Germany", value: "WVN" },
    { label: "(BMK) Borkum - Germany", value: "BMK" },
    { label: "(NRD) Norderney - Germany", value: "NRD" },
    { label: "(FLF) Flensburg Schaferhaus - Germany", value: "FLF" },
    { label: "(GWT) Westerland Sylt - Germany", value: "GWT" },
    { label: "(KDL) Kardla - Estonia", value: "KDL" },
    { label: "(URE) Kuressaare - Estonia", value: "URE" },
    { label: "(EPU) Parnu - Estonia", value: "EPU" },
    { label: "(TLL) Tallinn - Estonia", value: "TLL" },
    { label: "(TAY) Tartu - Estonia", value: "TAY" },
    { label: "(ENF) Enontekio - Finland", value: "ENF" },
    { label: "(KEV) Halli - Finland", value: "KEV" },
    { label: "(HEM) Helsinki Malmi - Finland", value: "HEM" },
    { label: "(HEL) Helsinki Vantaa - Finland", value: "HEL" },
    { label: "(HYV) Hyvinkaa - Finland", value: "HYV" },
    { label: "(IVL) Ivalo - Finland", value: "IVL" },
    { label: "(JOE) Joensuu - Finland", value: "JOE" },
    { label: "(JYV) Jyvaskyla - Finland", value: "JYV" },
    { label: "(KAU) Kauhava - Finland", value: "KAU" },
    { label: "(KEM) Kemi Tornio - Finland", value: "KEM" },
    { label: "(KAJ) Kajaani - Finland", value: "KAJ" },
    { label: "(KOK) Kruunupyy - Finland", value: "KOK" },
    { label: "(KAO) Kuusamo - Finland", value: "KAO" },
    { label: "(KTT) Kittila - Finland", value: "KTT" },
    { label: "(KUO) Kuopio - Finland", value: "KUO" },
    { label: "(LPP) Lappeenranta - Finland", value: "LPP" },
    { label: "(MHQ) Mariehamn - Finland", value: "MHQ" },
    { label: "(MIK) Mikkeli - Finland", value: "MIK" },
    { label: "(OUL) Oulu - Finland", value: "OUL" },
    { label: "(POR) Pori - Finland", value: "POR" },
    { label: "(RVN) Rovaniemi - Finland", value: "RVN" },
    { label: "(SVL) Savonlinna - Finland", value: "SVL" },
    { label: "(SOT) Sodankyla - Finland", value: "SOT" },
    { label: "(TMP) Tampere Pirkkala - Finland", value: "TMP" },
    { label: "(TKU) Turku - Finland", value: "TKU" },
    { label: "(QVY) Utti - Finland", value: "QVY" },
    { label: "(VAA) Vaasa - Finland", value: "VAA" },
    { label: "(VRK) Varkaus - Finland", value: "VRK" },
    { label: "(BFS) Belfast Intl - United Kingdom", value: "BFS" },
    { label: "(ENK) St Angelo - United Kingdom", value: "ENK" },
    { label: "(BHD) Belfast City - United Kingdom", value: "BHD" },
    { label: "(LDY) City of Derry - United Kingdom", value: "LDY" },
    { label: "(BHX) Birmingham - United Kingdom", value: "BHX" },
    { label: "(CVT) Coventry - United Kingdom", value: "CVT" },
    { label: "(GLO) Gloucestershire - United Kingdom", value: "GLO" },
    { label: "(MAN) Manchester - United Kingdom", value: "MAN" },
    { label: "(NQY) St Mawgan - United Kingdom", value: "NQY" },
    { label: "(LYE) Lyneham - United Kingdom", value: "LYE" },
    { label: "(YEO) Yeovilton - United Kingdom", value: "YEO" },
    { label: "(CWL) Cardiff - United Kingdom", value: "CWL" },
    { label: "(SWS) Swansea - United Kingdom", value: "SWS" },
    { label: "(BRS) Bristol - United Kingdom", value: "BRS" },
    { label: "(LPL) Liverpool - United Kingdom", value: "LPL" },
    { label: "(LTN) Luton - United Kingdom", value: "LTN" },
    { label: "(PLH) Plymouth - United Kingdom", value: "PLH" },
    { label: "(BOH) Bournemouth - United Kingdom", value: "BOH" },
    { label: "(SOU) Southampton - United Kingdom", value: "SOU" },
    { label: "(QLA) Lasham - United Kingdom", value: "QLA" },
    { label: "(ACI) Alderney - Guernsey", value: "ACI" },
    { label: "(GCI) Guernsey - Guernsey", value: "GCI" },
    { label: "(JER) Jersey - Jersey", value: "JER" },
    { label: "(ESH) Shoreham - United Kingdom", value: "ESH" },
    { label: "(BQH) Biggin Hill - United Kingdom", value: "BQH" },
    { label: "(LGW) Gatwick - United Kingdom", value: "LGW" },
    { label: "(LCY) City - United Kingdom", value: "LCY" },
    { label: "(FAB) Farnborough - United Kingdom", value: "FAB" },
    { label: "(BBS) Blackbushe - United Kingdom", value: "BBS" },
    { label: "(LHR) Heathrow - United Kingdom", value: "LHR" },
    { label: "(SEN) Southend - United Kingdom", value: "SEN" },
    { label: "(LYX) Lydd - United Kingdom", value: "LYX" },
    { label: "(MSE) Manston - United Kingdom", value: "MSE" },
    { label: "(CAX) Carlisle - United Kingdom", value: "CAX" },
    { label: "(BLK) Blackpool - United Kingdom", value: "BLK" },
    { label: "(HUY) Humberside - United Kingdom", value: "HUY" },
    { label: "(BWF) Walney Island - United Kingdom", value: "BWF" },
    { label: "(LBA) Leeds Bradford - United Kingdom", value: "LBA" },
    { label: "(CEG) Hawarden - United Kingdom", value: "CEG" },
    { label: "(IOM) Isle Of Man - Isle of Man", value: "IOM" },
    { label: "(NCL) Newcastle - United Kingdom", value: "NCL" },
    {
      label: "(MME) Durham Tees Valley Airport - United Kingdom",
      value: "MME",
    },
    { label: "(EMA) Nottingham East Midlands - United Kingdom", value: "EMA" },
    { label: "(KOI) Kirkwall - United Kingdom", value: "KOI" },
    { label: "(LSI) Sumburgh - United Kingdom", value: "LSI" },
    { label: "(WIC) Wick - United Kingdom", value: "WIC" },
    { label: "(ABZ) Dyce - United Kingdom", value: "ABZ" },
    { label: "(INV) Inverness - United Kingdom", value: "INV" },
    { label: "(GLA) Glasgow - United Kingdom", value: "GLA" },
    { label: "(EDI) Edinburgh - United Kingdom", value: "EDI" },
    { label: "(ILY) Islay - United Kingdom", value: "ILY" },
    { label: "(PIK) Prestwick - United Kingdom", value: "PIK" },
    { label: "(BEB) Benbecula - United Kingdom", value: "BEB" },
    { label: "(SDZ) Scatsta - United Kingdom", value: "SDZ" },
    { label: "(DND) Dundee - United Kingdom", value: "DND" },
    { label: "(SYY) Stornoway - United Kingdom", value: "SYY" },
    { label: "(TRE) Tiree - United Kingdom", value: "TRE" },
    { label: "(ADX) Leuchars - United Kingdom", value: "ADX" },
    { label: "(LMO) Lossiemouth - United Kingdom", value: "LMO" },
    { label: "(CBG) Cambridge - United Kingdom", value: "CBG" },
    { label: "(NWI) Norwich - United Kingdom", value: "NWI" },
    { label: "(STN) Stansted - United Kingdom", value: "STN" },
    { label: "(EXT) Exeter - United Kingdom", value: "EXT" },
    { label: "(FZO) Bristol Filton - United Kingdom", value: "FZO" },
    { label: "(OXF) Kidlington - United Kingdom", value: "OXF" },
    { label: "(MHZ) Mildenhall - United Kingdom", value: "MHZ" },
    { label: "(FFD) Fairford - United Kingdom", value: "FFD" },
    { label: "(BZZ) Brize Norton - United Kingdom", value: "BZZ" },
    { label: "(ODH) Odiham - United Kingdom", value: "ODH" },
    { label: "(NHT) Northolt - United Kingdom", value: "NHT" },
    { label: "(QCY) Coningsby - United Kingdom", value: "QCY" },
    { label: "(BEQ) Honington - United Kingdom", value: "BEQ" },
    { label: "(WTN) Waddington - United Kingdom", value: "WTN" },
    { label: "(KNF) Marham - United Kingdom", value: "KNF" },
    { label: "(MPN) Mount Pleasant - Falkland Islands", value: "MPN" },
    { label: "(AMS) Schiphol - Netherlands", value: "AMS" },
    { label: "(MST) Maastricht - Netherlands", value: "MST" },
    { label: "(EIN) Eindhoven - Netherlands", value: "EIN" },
    { label: "(GRQ) Eelde - Netherlands", value: "GRQ" },
    { label: "(DHR) De Kooy - Netherlands", value: "DHR" },
    { label: "(LWR) Leeuwarden - Netherlands", value: "LWR" },
    { label: "(RTM) Rotterdam - Netherlands", value: "RTM" },
    { label: "(UTC) Soesterberg - Netherlands", value: "UTC" },
    { label: "(ENS) Twenthe - Netherlands", value: "ENS" },
    { label: "(LID) Valkenburg - Netherlands", value: "LID" },
    { label: "(WOE) Woensdrecht - Netherlands", value: "WOE" },
    { label: "(ORK) Cork - Ireland", value: "ORK" },
    { label: "(GWY) Galway - Ireland", value: "GWY" },
    { label: "(DUB) Dublin - Ireland", value: "DUB" },
    { label: "(NOC) Ireland West Knock - Ireland", value: "NOC" },
    { label: "(KIR) Kerry - Ireland", value: "KIR" },
    { label: "(SNN) Shannon - Ireland", value: "SNN" },
    { label: "(SXL) Sligo - Ireland", value: "SXL" },
    { label: "(WAT) Waterford - Ireland", value: "WAT" },
    { label: "(AAR) Aarhus - Denmark", value: "AAR" },
    { label: "(BLL) Billund - Denmark", value: "BLL" },
    { label: "(CPH) Kastrup - Denmark", value: "CPH" },
    { label: "(EBJ) Esbjerg - Denmark", value: "EBJ" },
    { label: "(KRP) Karup - Denmark", value: "KRP" },
    { label: "(ODE) Odense - Denmark", value: "ODE" },
    { label: "(RKE) Roskilde - Denmark", value: "RKE" },
    { label: "(RNN) Bornholm Ronne - Denmark", value: "RNN" },
    { label: "(SGD) Sonderborg - Denmark", value: "SGD" },
    { label: "(SKS) Skrydstrup - Denmark", value: "SKS" },
    { label: "(TED) Thisted - Denmark", value: "TED" },
    { label: "(FAE) Vagar - Faroe Islands", value: "FAE" },
    { label: "(STA) Stauning - Denmark", value: "STA" },
    { label: "(AAL) Aalborg - Denmark", value: "AAL" },
    { label: "(LUX) Luxembourg - Luxembourg", value: "LUX" },
    { label: "(AES) Vigra - Norway", value: "AES" },
    { label: "(ANX) Andenes - Norway", value: "ANX" },
    { label: "(ALF) Alta - Norway", value: "ALF" },
    { label: "(BNN) Bronnoy - Norway", value: "BNN" },
    { label: "(BOO) Bodo - Norway", value: "BOO" },
    { label: "(BGO) Flesland - Norway", value: "BGO" },
    { label: "(BJF) Batsfjord - Norway", value: "BJF" },
    { label: "(KRS) Kjevik - Norway", value: "KRS" },
    { label: "(BDU) Bardufoss - Norway", value: "BDU" },
    { label: "(EVE) Evenes - Norway", value: "EVE" },
    { label: "(VDB) Leirin - Norway", value: "VDB" },
    { label: "(FRO) Floro - Norway", value: "FRO" },
    { label: "(OSL) Gardermoen - Norway", value: "OSL" },
    { label: "(HAU) Karmoy - Norway", value: "HAU" },
    { label: "(HAA) Hasvik - Norway", value: "HAA" },
    { label: "(KSU) Kvernberget - Norway", value: "KSU" },
    { label: "(KKN) Hoybuktmoen - Norway", value: "KKN" },
    { label: "(FAN) Lista - Norway", value: "FAN" },
    { label: "(MOL) Aro - Norway", value: "MOL" },
    { label: "(MJF) Kjaerstad - Norway", value: "MJF" },
    { label: "(LKL) Banak - Norway", value: "LKL" },
    { label: "(NTB) Notodden - Norway", value: "NTB" },
    { label: "(OLA) Orland - Norway", value: "OLA" },
    { label: "(RRS) Roros - Norway", value: "RRS" },
    { label: "(RYG) Moss - Norway", value: "RYG" },
    { label: "(LYR) Longyear - Norway", value: "LYR" },
    { label: "(SKE) Geiteryggen - Norway", value: "SKE" },
    { label: "(SRP) Sorstokken - Norway", value: "SRP" },
    { label: "(SSJ) Stokka - Norway", value: "SSJ" },
    { label: "(TOS) Langnes - Norway", value: "TOS" },
    { label: "(TRF) Torp - Norway", value: "TRF" },
    { label: "(TRD) Vaernes - Norway", value: "TRD" },
    { label: "(SVG) Sola - Norway", value: "SVG" },
    { label: "(GDN) Lech Walesa - Poland", value: "GDN" },
    { label: "(KRK) Balice - Poland", value: "KRK" },
    { label: "(KTW) Pyrzowice - Poland", value: "KTW" },
    { label: "(POZ) Lawica - Poland", value: "POZ" },
    { label: "(RZE) Jasionka - Poland", value: "RZE" },
    { label: "(SZZ) Goleniow - Poland", value: "SZZ" },
    { label: "(OSP) Redzikowo - Poland", value: "OSP" },
    { label: "(WAW) Okecie - Poland", value: "WAW" },
    { label: "(WRO) Strachowice - Poland", value: "WRO" },
    { label: "(IEG) Babimost - Poland", value: "IEG" },
    { label: "(RNB) Ronneby - Sweden", value: "RNB" },
    { label: "(GOT) Landvetter - Sweden", value: "GOT" },
    { label: "(JKG) Jonkoping - Sweden", value: "JKG" },
    { label: "(LDK) Lidkoping - Sweden", value: "LDK" },
    { label: "(GSE) Save - Sweden", value: "GSE" },
    { label: "(KVB) Skovde - Sweden", value: "KVB" },
    { label: "(THN) Trollhattan Vanersborg - Sweden", value: "THN" },
    { label: "(KSK) Karlskoga - Sweden", value: "KSK" },
    { label: "(MXX) Mora - Sweden", value: "MXX" },
    { label: "(NYO) Skavsta - Sweden", value: "NYO" },
    { label: "(KID) Kristianstad - Sweden", value: "KID" },
    { label: "(JLD) Landskrona - Sweden", value: "JLD" },
    { label: "(OSK) Oskarshamn - Sweden", value: "OSK" },
    { label: "(KLR) Kalmar - Sweden", value: "KLR" },
    { label: "(MMX) Sturup - Sweden", value: "MMX" },
    { label: "(HAD) Halmstad - Sweden", value: "HAD" },
    { label: "(VXO) Kronoberg - Sweden", value: "VXO" },
    { label: "(EVG) Sveg - Sweden", value: "EVG" },
    { label: "(GEV) Gallivare - Sweden", value: "GEV" },
    { label: "(HUV) Hudiksvall - Sweden", value: "HUV" },
    { label: "(KRF) Kramfors Solleftea - Sweden", value: "KRF" },
    { label: "(LYC) Lycksele - Sweden", value: "LYC" },
    { label: "(SDL) Sundsvall Harnosand - Sweden", value: "SDL" },
    { label: "(OER) Ornskoldsvik - Sweden", value: "OER" },
    { label: "(KRN) Kiruna - Sweden", value: "KRN" },
    { label: "(SFT) Skelleftea - Sweden", value: "SFT" },
    { label: "(UME) Umea - Sweden", value: "UME" },
    { label: "(VHM) Vilhelmina - Sweden", value: "VHM" },
    { label: "(AJR) Arvidsjaur - Sweden", value: "AJR" },
    { label: "(ORB) Orebro - Sweden", value: "ORB" },
    { label: "(VST) Vasteras - Sweden", value: "VST" },
    { label: "(LLA) Kallax - Sweden", value: "LLA" },
    { label: "(ARN) Arlanda - Sweden", value: "ARN" },
    { label: "(BMA) Bromma - Sweden", value: "BMA" },
    { label: "(BLE) Borlange - Sweden", value: "BLE" },
    { label: "(HLF) Hultsfred - Sweden", value: "HLF" },
    { label: "(GVX) Gavle - Sweden", value: "GVX" },
    { label: "(LPI) Saab - Sweden", value: "LPI" },
    { label: "(NRK) Kungsangen - Sweden", value: "NRK" },
    { label: "(VBY) Visby - Sweden", value: "VBY" },
    { label: "(SPM) Spangdahlem Ab - Germany", value: "SPM" },
    { label: "(RMS) Ramstein Ab - Germany", value: "RMS" },
    { label: "(GHF) Giebelstadt Aaf - Germany", value: "GHF" },
    { label: "(ZCN) Celle - Germany", value: "ZCN" },
    { label: "(ZNF) Hanau Aaf - Germany", value: "ZNF" },
    { label: "(GKE) Geilenkirchen - Germany", value: "GKE" },
    { label: "(RLG) Laage - Germany", value: "RLG" },
    { label: "(FEL) Furstenfeldbruck - Germany", value: "FEL" },
    { label: "(GUT) Gutersloh - Germany", value: "GUT" },
    { label: "(ALJ) Alexander Bay - South Africa", value: "ALJ" },
    { label: "(AGZ) Aggeneys - South Africa", value: "AGZ" },
    { label: "(BIY) Bhisho - South Africa", value: "BIY" },
    { label: "(BFN) Bloemfontein Intl - South Africa", value: "BFN" },
    { label: "(CPT) Cape Town Intl - South Africa", value: "CPT" },
    { label: "(DUR) Durban Intl - South Africa", value: "DUR" },
    { label: "(ELS) East London - South Africa", value: "ELS" },
    { label: "(GCJ) Grand Central - South Africa", value: "GCJ" },
    { label: "(GRJ) George - South Africa", value: "GRJ" },
    { label: "(HDS) Hoedspruit Afb - South Africa", value: "HDS" },
    { label: "(JNB) Johannesburg Intl - South Africa", value: "JNB" },
    { label: "(KIM) Kimberley - South Africa", value: "KIM" },
    { label: "(KLZ) Kleinsee - South Africa", value: "KLZ" },
    { label: "(HLA) Lanseria - South Africa", value: "HLA" },
    { label: "(LAY) Ladysmith - South Africa", value: "LAY" },
    { label: "(MGH) Margate - South Africa", value: "MGH" },
    { label: "(MEZ) Messina - South Africa", value: "MEZ" },
    { label: "(NCS) Newcastle - South Africa", value: "NCS" },
    { label: "(DUH) Oudtshoorn - South Africa", value: "DUH" },
    { label: "(PLZ) Port Elizabeth Intl - South Africa", value: "PLZ" },
    { label: "(PHW) Phalaborwa - South Africa", value: "PHW" },
    { label: "(PTG) Polokwane International - South Africa", value: "PTG" },
    { label: "(PZB) Pietermaritzburg - South Africa", value: "PZB" },
    { label: "(NTY) Pilanesberg Intl - South Africa", value: "NTY" },
    { label: "(UTW) Queenstown - South Africa", value: "UTW" },
    { label: "(RCB) Richards Bay - South Africa", value: "RCB" },
    { label: "(SBU) Springbok - South Africa", value: "SBU" },
    { label: "(SIS) Sishen - South Africa", value: "SIS" },
    { label: "(SZK) Skukuza - South Africa", value: "SZK" },
    { label: "(LTA) Tzaneen - South Africa", value: "LTA" },
    { label: "(ULD) Prince Mangosuthu Buthelezi - South Africa", value: "ULD" },
    { label: "(UTN) Upington - South Africa", value: "UTN" },
    { label: "(UTT) Mthatha - South Africa", value: "UTT" },
    { label: "(VRU) Vryburg - South Africa", value: "VRU" },
    { label: "(VIR) Virginia - South Africa", value: "VIR" },
    { label: "(PRY) Wonderboom - South Africa", value: "PRY" },
    { label: "(WEL) Welkom - South Africa", value: "WEL" },
    { label: "(FRW) Francistown - Botswana", value: "FRW" },
    { label: "(JWA) Jwaneng - Botswana", value: "JWA" },
    { label: "(BBK) Kasane - Botswana", value: "BBK" },
    { label: "(MUB) Maun - Botswana", value: "MUB" },
    { label: "(GBE) Sir Seretse Khama Intl - Botswana", value: "GBE" },
    { label: "(PKW) Selebi Phikwe - Botswana", value: "PKW" },
    { label: "(BZV) Maya Maya - Congo (Brazzaville)", value: "BZV" },
    { label: "(FTX) Owando - Congo (Kinshasa)", value: "FTX" },
    { label: "(OUE) Ouesso - Congo (Kinshasa)", value: "OUE" },
    { label: "(PNR) Pointe Noire - Congo (Brazzaville)", value: "PNR" },
    { label: "(MTS) Matsapha - Swaziland", value: "MTS" },
    { label: "(BGF) Bangui M Poko - Central African Republic", value: "BGF" },
    { label: "(BBT) Berberati - Central African Republic", value: "BBT" },
    { label: "(BSG) Bata - Equatorial Guinea", value: "BSG" },
    { label: "(SSG) Malabo - Equatorial Guinea", value: "SSG" },
    { label: "(MRU) Sir Seewoosagur Ramgoolam Intl - Mauritius", value: "MRU" },
    { label: "(RRG) Plaine Corail - Mauritius", value: "RRG" },
    { label: "(TKC) Tiko - Cameroon", value: "TKC" },
    { label: "(DLA) Douala - Cameroon", value: "DLA" },
    { label: "(MVR) Salak - Cameroon", value: "MVR" },
    { label: "(FOM) Foumban Nkounja - Cameroon", value: "FOM" },
    { label: "(NGE) Ngaoundere - Cameroon", value: "NGE" },
    { label: "(GOU) Garoua - Cameroon", value: "GOU" },
    { label: "(BFX) Bafoussam - Cameroon", value: "BFX" },
    { label: "(BPC) Bamenda - Cameroon", value: "BPC" },
    { label: "(YAO) Yaounde Ville - Cameroon", value: "YAO" },
    { label: "(LVI) Livingstone - Zambia", value: "LVI" },
    { label: "(LUN) Lusaka Intl - Zambia", value: "LUN" },
    { label: "(MFU) Mfuwe - Zambia", value: "MFU" },
    { label: "(NLA) Ndola - Zambia", value: "NLA" },
    { label: "(KIW) Southdowns - Zambia", value: "KIW" },
    { label: "(HAH) Prince Said Ibrahim - Comoros", value: "HAH" },
    { label: "(NWA) Bandaressalam - Comoros", value: "NWA" },
    { label: "(AJN) Ouani - Comoros", value: "AJN" },
    { label: "(DZA) Dzaoudzi Pamandzi - Mayotte", value: "DZA" },
    { label: "(RUN) St Denis Gillot - Reunion", value: "RUN" },
    { label: "(ZSE) St Pierre Pierrefonds - Reunion", value: "ZSE" },
    { label: "(TNR) Ivato - Madagascar", value: "TNR" },
    { label: "(ZVA) Miandrivazo - Madagascar", value: "ZVA" },
    { label: "(SMS) Sainte Marie - Madagascar", value: "SMS" },
    { label: "(TMM) Toamasina - Madagascar", value: "TMM" },
    { label: "(MOQ) Morondava - Madagascar", value: "MOQ" },
    { label: "(DIE) Arrachart - Madagascar", value: "DIE" },
    { label: "(WMR) Avaratra - Madagascar", value: "WMR" },
    { label: "(ZWA) Andapa - Madagascar", value: "ZWA" },
    { label: "(AMB) Ambilobe - Madagascar", value: "AMB" },
    { label: "(ANM) Antsirabato - Madagascar", value: "ANM" },
    { label: "(HVA) Analalava - Madagascar", value: "HVA" },
    { label: "(MJN) Philibert Tsiranana - Madagascar", value: "MJN" },
    { label: "(NOS) Fascene - Madagascar", value: "NOS" },
    { label: "(BPY) Besalampy - Madagascar", value: "BPY" },
    { label: "(WMN) Maroantsetra - Madagascar", value: "WMN" },
    { label: "(SVB) Sambava - Madagascar", value: "SVB" },
    { label: "(VOH) Vohimarina - Madagascar", value: "VOH" },
    { label: "(WAI) Ambalabe - Madagascar", value: "WAI" },
    { label: "(FTU) Tolagnaro - Madagascar", value: "FTU" },
    { label: "(WFI) Fianarantsoa - Madagascar", value: "WFI" },
    { label: "(RVA) Farafangana - Madagascar", value: "RVA" },
    { label: "(WVK) Manakara - Madagascar", value: "WVK" },
    { label: "(MNJ) Mananjary - Madagascar", value: "MNJ" },
    { label: "(MXM) Morombe - Madagascar", value: "MXM" },
    { label: "(TLE) Toliara - Madagascar", value: "TLE" },
    { label: "(SSY) Mbanza Congo - Angola", value: "SSY" },
    { label: "(BUG) Benguela - Angola", value: "BUG" },
    { label: "(CAB) Cabinda - Angola", value: "CAB" },
    { label: "(CPX) Culebra Airport - Puerto Rico", value: "CPX" },
    { label: "(NOV) Huambo - Angola", value: "NOV" },
    { label: "(SVP) Kuito - Angola", value: "SVP" },
    { label: "(LAD) Luanda 4 De Fevereiro - Angola", value: "LAD" },
    { label: "(MEG) Malanje - Angola", value: "MEG" },
    { label: "(SPP) Menongue - Angola", value: "SPP" },
    { label: "(GXG) Negage - Angola", value: "GXG" },
    { label: "(PBN) Porto Amboim - Angola", value: "PBN" },
    { label: "(VHC) Saurimo - Angola", value: "VHC" },
    { label: "(SZA) Soyo - Angola", value: "SZA" },
    { label: "(SDD) Lubango - Angola", value: "SDD" },
    { label: "(LUO) Luena - Angola", value: "LUO" },
    { label: "(UGO) Uige - Angola", value: "UGO" },
    { label: "(XGN) Xangongo - Angola", value: "XGN" },
    { label: "(OYE) Oyem - Gabon", value: "OYE" },
    { label: "(OKN) Okondja - Gabon", value: "OKN" },
    { label: "(LBQ) Lambarene - Gabon", value: "LBQ" },
    { label: "(BMM) Bitam - Gabon", value: "BMM" },
    { label: "(POG) Port Gentil - Gabon", value: "POG" },
    { label: "(OMB) Omboue Hopital - Gabon", value: "OMB" },
    { label: "(MKU) Makokou - Gabon", value: "MKU" },
    { label: "(LBV) Leon M Ba - Gabon", value: "LBV" },
    { label: "(MVB) Mvengue - Gabon", value: "MVB" },
    { label: "(PCP) Principe - Sao Tome and Principe", value: "PCP" },
    { label: "(TMS) Sao Tome Intl - Sao Tome and Principe", value: "TMS" },
    { label: "(BEW) Beira - Mozambique", value: "BEW" },
    { label: "(INH) Inhambane - Mozambique", value: "INH" },
    { label: "(VXC) Lichinga - Mozambique", value: "VXC" },
    { label: "(MPM) Maputo - Mozambique", value: "MPM" },
    { label: "(MZB) Mocimboa Da Praia - Mozambique", value: "MZB" },
    { label: "(MNC) Nacala - Mozambique", value: "MNC" },
    { label: "(APL) Nampula - Mozambique", value: "APL" },
    { label: "(POL) Pemba - Mozambique", value: "POL" },
    { label: "(UEL) Quelimane - Mozambique", value: "UEL" },
    { label: "(TET) Tete Chingodzi - Mozambique", value: "TET" },
    { label: "(VNX) Vilankulo - Mozambique", value: "VNX" },
    { label: "(DES) Desroches - Seychelles", value: "DES" },
    { label: "(SEZ) Seychelles Intl - Seychelles", value: "SEZ" },
    { label: "(PRI) Praslin - Seychelles", value: "PRI" },
    { label: "(AEH) Abeche - Chad", value: "AEH" },
    { label: "(MQQ) Moundou - Chad", value: "MQQ" },
    { label: "(NDJ) Ndjamena Hassan Djamous - Chad", value: "NDJ" },
    { label: "(FYT) Faya Largeau - Chad", value: "FYT" },
    { label: "(BUQ) J M Nkomo Intl - Zimbabwe", value: "BUQ" },
    { label: "(BFO) Buffalo Range - Zimbabwe", value: "BFO" },
    { label: "(VFA) Victoria Falls Intl - Zimbabwe", value: "VFA" },
    { label: "(HRE) Harare Intl - Zimbabwe", value: "HRE" },
    { label: "(KAB) Kariba Intl - Zimbabwe", value: "KAB" },
    { label: "(MVZ) Masvingo Intl - Zimbabwe", value: "MVZ" },
    { label: "(GWE) Gweru Thornhill - Zimbabwe", value: "GWE" },
    { label: "(WKM) Hwange National Park - Zimbabwe", value: "WKM" },
    { label: "(BLZ) Chileka Intl - Malawi", value: "BLZ" },
    { label: "(KGJ) Karonga - Malawi", value: "KGJ" },
    { label: "(LLW) Kamuzu Intl - Malawi", value: "LLW" },
    { label: "(ZZU) Mzuzu - Malawi", value: "ZZU" },
    { label: "(MSU) Moshoeshoe I Intl - Lesotho", value: "MSU" },
    { label: "(FIH) Ndjili Intl - Congo (Kinshasa)", value: "FIH" },
    { label: "(NLO) Ndolo - Congo (Kinshasa)", value: "NLO" },
    { label: "(MNB) Muanda - Congo (Kinshasa)", value: "MNB" },
    { label: "(FDU) Bandundu - Congo (Kinshasa)", value: "FDU" },
    { label: "(KKW) Kikwit - Congo (Kinshasa)", value: "KKW" },
    { label: "(MDK) Mbandaka - Congo (Kinshasa)", value: "MDK" },
    { label: "(BDT) Gbadolite - Congo (Kinshasa)", value: "BDT" },
    { label: "(GMA) Gemena - Congo (Kinshasa)", value: "GMA" },
    { label: "(LIQ) Lisala - Congo (Kinshasa)", value: "LIQ" },
    { label: "(FKI) Kisangani Simisini - Congo (Kinshasa)", value: "FKI" },
    { label: "(IRP) Matari - Congo (Kinshasa)", value: "IRP" },
    { label: "(BUX) Bunia - Congo (Kinshasa)", value: "BUX" },
    { label: "(BKY) Bukavu Kavumu - Congo (Kinshasa)", value: "BKY" },
    { label: "(GOM) Goma - Congo (Kinshasa)", value: "GOM" },
    { label: "(KND) Kindu - Congo (Kinshasa)", value: "KND" },
    { label: "(FBM) Lubumbashi Intl - Congo (Kinshasa)", value: "FBM" },
    { label: "(KWZ) Kolwezi - Congo (Kinshasa)", value: "KWZ" },
    { label: "(FMI) Kalemie - Congo (Kinshasa)", value: "FMI" },
    { label: "(KMN) Kamina Base - Congo (Kinshasa)", value: "KMN" },
    { label: "(KGA) Kananga - Congo (Kinshasa)", value: "KGA" },
    { label: "(MJM) Mbuji Mayi - Congo (Kinshasa)", value: "MJM" },
    { label: "(BKO) Senou - Mali", value: "BKO" },
    { label: "(GAQ) Gao - Mali", value: "GAQ" },
    { label: "(KYS) Kayes Dag Dag - Mali", value: "KYS" },
    { label: "(MZI) Ambodedjo - Mali", value: "MZI" },
    { label: "(TOM) Tombouctou - Mali", value: "TOM" },
    { label: "(BJL) Banjul Intl - Gambia", value: "BJL" },
    { label: "(FUE) Fuerteventura - Spain", value: "FUE" },
    { label: "(VDE) Hierro - Spain", value: "VDE" },
    { label: "(SPC) La Palma - Spain", value: "SPC" },
    { label: "(LPA) Gran Canaria - Spain", value: "LPA" },
    { label: "(ACE) Lanzarote - Spain", value: "ACE" },
    { label: "(TFS) Tenerife Sur - Spain", value: "TFS" },
    { label: "(TFN) Tenerife Norte - Spain", value: "TFN" },
    { label: "(MLN) Melilla - Spain", value: "MLN" },
    { label: "(FNA) Freetown Lungi - Sierra Leone", value: "FNA" },
    { label: "(MLW) Monrovia Spriggs Payne - Liberia", value: "MLW" },
    { label: "(ROB) Monrovia Roberts Intl - Liberia", value: "ROB" },
    { label: "(AGA) Inezgane - Morocco", value: "AGA" },
    { label: "(TTA) Plage Blanche - Morocco", value: "TTA" },
    { label: "(FEZ) Saiss - Morocco", value: "FEZ" },
    { label: "(ERH) Moulay Ali Cherif - Morocco", value: "ERH" },
    { label: "(MEK) Bassatine - Morocco", value: "MEK" },
    { label: "(OUD) Angads - Morocco", value: "OUD" },
    { label: "(RBA) Sale - Morocco", value: "RBA" },
    { label: "(CMN) Mohammed V Intl - Morocco", value: "CMN" },
    { label: "(RAK) Menara - Morocco", value: "RAK" },
    { label: "(NNA) Kenitra - Morocco", value: "NNA" },
    { label: "(OZZ) Ouarzazate - Morocco", value: "OZZ" },
    { label: "(AHU) Cherif El Idrissi - Morocco", value: "AHU" },
    { label: "(TTU) Saniat Rmel - Morocco", value: "TTU" },
    { label: "(TNG) Ibn Batouta - Morocco", value: "TNG" },
    { label: "(ZIG) Ziguinchor - Senegal", value: "ZIG" },
    { label: "(CSK) Cap Skiring - Senegal", value: "CSK" },
    { label: "(KLC) Kaolack - Senegal", value: "KLC" },
    { label: "(DKR) Leopold Sedar Senghor Intl - Senegal", value: "DKR" },
    { label: "(XLS) Saint Louis - Senegal", value: "XLS" },
    { label: "(BXE) Bakel - Senegal", value: "BXE" },
    { label: "(KGG) Kedougou - Senegal", value: "KGG" },
    { label: "(TUD) Tambacounda - Senegal", value: "TUD" },
    { label: "(IEO) Aioun El Atrouss - Mauritania", value: "IEO" },
    { label: "(TIY) Tidjikja - Mauritania", value: "TIY" },
    { label: "(KFA) Kiffa - Mauritania", value: "KFA" },
    { label: "(EMN) Nema - Mauritania", value: "EMN" },
    { label: "(KED) Kaedi - Mauritania", value: "KED" },
    { label: "(NKC) Nouakchott - Mauritania", value: "NKC" },
    { label: "(SEY) Selibady - Mauritania", value: "SEY" },
    { label: "(ATR) Atar - Mauritania", value: "ATR" },
    { label: "(NDB) Nouadhibou - Mauritania", value: "NDB" },
    { label: "(FIG) Fria - Guinea", value: "FIG" },
    { label: "(FAA) Faranah - Guinea", value: "FAA" },
    { label: "(LEK) Labe - Guinea", value: "LEK" },
    { label: "(SID) Amilcar Cabral Intl - Cape Verde", value: "SID" },
    { label: "(BVC) Rabil - Cape Verde", value: "BVC" },
    { label: "(MMO) Maio - Cape Verde", value: "MMO" },
    { label: "(SNE) Preguica - Cape Verde", value: "SNE" },
    { label: "(VXE) Sao Pedro - Cape Verde", value: "VXE" },
    { label: "(ADD) Bole Intl - Ethiopia", value: "ADD" },
    { label: "(AMH) Arba Minch - Ethiopia", value: "AMH" },
    { label: "(AXU) Axum - Ethiopia", value: "AXU" },
    { label: "(BJR) Bahir Dar - Ethiopia", value: "BJR" },
    { label: "(DIR) Dire Dawa Intl - Ethiopia", value: "DIR" },
    { label: "(GMB) Gambella - Ethiopia", value: "GMB" },
    { label: "(GDQ) Gondar - Ethiopia", value: "GDQ" },
    { label: "(JIM) Jimma - Ethiopia", value: "JIM" },
    { label: "(LLI) Lalibella - Ethiopia", value: "LLI" },
    { label: "(MQX) Makale - Ethiopia", value: "MQX" },
    { label: "(ASO) Asosa - Ethiopia", value: "ASO" },
    { label: "(BJM) Bujumbura Intl - Burundi", value: "BJM" },
    { label: "(HGA) Egal Intl - Somalia", value: "HGA" },
    { label: "(BBO) Berbera - Somalia", value: "BBO" },
    { label: "(KMU) Kisimayu - Somalia", value: "KMU" },
    { label: "(C91) Dowagiac Municipal Airport - United States", value: "C91" },
    { label: "(ALY) Alexandria Intl - Egypt", value: "ALY" },
    { label: "(ABS) Abu Simbel - Egypt", value: "ABS" },
    { label: "(CAI) Cairo Intl - Egypt", value: "CAI" },
    { label: "(HRG) Hurghada Intl - Egypt", value: "HRG" },
    { label: "(EGR) El Gora - Egypt", value: "EGR" },
    { label: "(LXR) Luxor Intl - Egypt", value: "LXR" },
    { label: "(MUH) Mersa Matruh - Egypt", value: "MUH" },
    { label: "(PSD) Port Said - Egypt", value: "PSD" },
    { label: "(SKV) St Catherine Intl - Egypt", value: "SKV" },
    { label: "(ASW) Aswan Intl - Egypt", value: "ASW" },
    { label: "(ELT) El Tor - Egypt", value: "ELT" },
    { label: "(EDL) Eldoret Intl - Kenya", value: "EDL" },
    { label: "(KIS) Kisumu - Kenya", value: "KIS" },
    { label: "(KTL) Kitale - Kenya", value: "KTL" },
    {
      label: "(CDI) Cambridge Municipal Airport - United States",
      value: "CDI",
    },
    { label: "(LOK) Lodwar - Kenya", value: "LOK" },
    { label: "(LAU) Lamu Manda - Kenya", value: "LAU" },
    { label: "(MBA) Mombasa Moi Intl - Kenya", value: "MBA" },
    { label: "(WIL) Nairobi Wilson - Kenya", value: "WIL" },
    { label: "(WJR) Wajir - Kenya", value: "WJR" },
    { label: "(GHT) Ghat - Libya", value: "GHT" },
    { label: "(AKF) Kufra - Libya", value: "AKF" },
    { label: "(BEN) Benina - Libya", value: "BEN" },
    { label: "(SEB) Sebha - Libya", value: "SEB" },
    { label: "(TIP) Tripoli Intl - Libya", value: "TIP" },
    { label: "(LTD) Ghadames East - Libya", value: "LTD" },
    { label: "(GYI) Gisenyi - Rwanda", value: "GYI" },
    { label: "(KGL) Kigali Intl - Rwanda", value: "KGL" },
    { label: "(KME) Kamembe - Rwanda", value: "KME" },
    { label: "(DOG) Dongola - Sudan", value: "DOG" },
    { label: "(ELF) El Fashir - Sudan", value: "ELF" },
    { label: "(KSL) Kassala - Sudan", value: "KSL" },
    { label: "(EBD) El Obeid - Sudan", value: "EBD" },
    { label: "(JUB) Juba - South Sudan", value: "JUB" },
    { label: "(MAK) Malakal - Sudan", value: "MAK" },
    { label: "(KRT) Khartoum - Sudan", value: "KRT" },
    { label: "(ARK) Arusha - Tanzania", value: "ARK" },
    { label: "(DAR) Mwalimu Julius K Nyerere Intl - Tanzania", value: "DAR" },
    { label: "(DOD) Dodoma - Tanzania", value: "DOD" },
    { label: "(IRI) Iringa - Tanzania", value: "IRI" },
    { label: "(JRO) Kilimanjaro Intl - Tanzania", value: "JRO" },
    { label: "(LKY) Lake Manyara - Tanzania", value: "LKY" },
    { label: "(MYW) Mtwara - Tanzania", value: "MYW" },
    { label: "(MWZ) Mwanza - Tanzania", value: "MWZ" },
    { label: "(PMA) Pemba - Tanzania", value: "PMA" },
    { label: "(TGT) Tanga - Tanzania", value: "TGT" },
    { label: "(ZNZ) Zanzibar - Tanzania", value: "ZNZ" },
    { label: "(EBB) Entebbe Intl - Uganda", value: "EBB" },
    { label: "(QDU) Dusseldorf Hauptbahnhof - Germany", value: "QDU" },
    { label: "(SRT) Soroti - Uganda", value: "SRT" },
    { label: "(TIA) Tirana Rinas - Albania", value: "TIA" },
    { label: "(BOJ) Burgas - Bulgaria", value: "BOJ" },
    { label: "(GOZ) Gorna Oryahovitsa - Bulgaria", value: "GOZ" },
    { label: "(PDV) Plovdiv - Bulgaria", value: "PDV" },
    { label: "(SOF) Sofia - Bulgaria", value: "SOF" },
    { label: "(VAR) Varna - Bulgaria", value: "VAR" },
    { label: "(LCA) Larnaca - Cyprus", value: "LCA" },
    { label: "(PFO) Pafos Intl - Cyprus", value: "PFO" },
    { label: "(AKT) Akrotiri - Cyprus", value: "AKT" },
    { label: "(DBV) Dubrovnik - Croatia", value: "DBV" },
    { label: "(OSI) Osijek - Croatia", value: "OSI" },
    { label: "(PUY) Pula - Croatia", value: "PUY" },
    { label: "(RJK) Rijeka - Croatia", value: "RJK" },
    { label: "(SPU) Split - Croatia", value: "SPU" },
    { label: "(ZAG) Zagreb - Croatia", value: "ZAG" },
    { label: "(ZAD) Zadar - Croatia", value: "ZAD" },
    { label: "(ALC) Alicante - Spain", value: "ALC" },
    { label: "(LEI) Almeria - Spain", value: "LEI" },
    { label: "(OVD) Asturias - Spain", value: "OVD" },
    { label: "(ODB) Cordoba - Spain", value: "ODB" },
    { label: "(BIO) Bilbao - Spain", value: "BIO" },
    { label: "(BCN) Barcelona - Spain", value: "BCN" },
    { label: "(BJZ) Talavera La Real - Spain", value: "BJZ" },
    { label: "(LCG) A Coruna - Spain", value: "LCG" },
    { label: "(GRO) Girona - Spain", value: "GRO" },
    { label: "(GRX) Granada - Spain", value: "GRX" },
    { label: "(IBZ) Ibiza - Spain", value: "IBZ" },
    { label: "(XRY) Jerez - Spain", value: "XRY" },
    { label: "(MJV) Murcia San Javier - Spain", value: "MJV" },
    { label: "(PKH) Alexion - Greece", value: "PKH" },
    { label: "(MAD) Barajas - Spain", value: "MAD" },
    { label: "(AGP) Malaga - Spain", value: "AGP" },
    { label: "(MAH) Menorca - Spain", value: "MAH" },
    { label: "(OZP) Moron Ab - Spain", value: "OZP" },
    { label: "(PNA) Pamplona - Spain", value: "PNA" },
    { label: "(REU) Reus - Spain", value: "REU" },
    { label: "(SLM) Salamanca - Spain", value: "SLM" },
    { label: "(EAS) San Sebastian - Spain", value: "EAS" },
    { label: "(SCQ) Santiago - Spain", value: "SCQ" },
    { label: "(LEU) Seo De Urgel - Spain", value: "LEU" },
    { label: "(TOJ) Torrejon - Spain", value: "TOJ" },
    { label: "(VLC) Valencia - Spain", value: "VLC" },
    { label: "(VLL) Valladolid - Spain", value: "VLL" },
    { label: "(VIT) Vitoria - Spain", value: "VIT" },
    { label: "(VGO) Vigo - Spain", value: "VGO" },
    { label: "(SDR) Santander - Spain", value: "SDR" },
    { label: "(ZAZ) Zaragoza Ab - Spain", value: "ZAZ" },
    { label: "(SVQ) Sevilla - Spain", value: "SVQ" },
    { label: "(CQF) Calais Dunkerque - France", value: "CQF" },
    { label: "(LTQ) Le Touquet Paris Plage - France", value: "LTQ" },
    { label: "(AGF) La Garenne - France", value: "AGF" },
    { label: "(BOD) Merignac - France", value: "BOD" },
    { label: "(EGC) Roumaniere - France", value: "EGC" },
    { label: "(CNG) Chateaubernard - France", value: "CNG" },
    { label: "(PIS) Biard - France", value: "PIS" },
    { label: "(LIG) Bellegarde - France", value: "LIG" },
    { label: "(NIT) Souche - France", value: "NIT" },
    { label: "(TLS) Blagnac - France", value: "TLS" },
    { label: "(PUF) Pau Pyrenees - France", value: "PUF" },
    { label: "(LDE) Lourdes - France", value: "LDE" },
    { label: "(ANG) Brie Champniers - France", value: "ANG" },
    { label: "(BVE) La Roche - France", value: "BVE" },
    { label: "(PGX) Bassillac - France", value: "PGX" },
    { label: "(BIQ) Anglet - France", value: "BIQ" },
    { label: "(XAC) La Teste De Buch - France", value: "XAC" },
    { label: "(LBI) Le Sequestre - France", value: "LBI" },
    { label: "(DCM) Mazamet - France", value: "DCM" },
    { label: "(RDZ) Marcillac - France", value: "RDZ" },
    { label: "(RYN) Medis - France", value: "RYN" },
    { label: "(RCO) St Agnant - France", value: "RCO" },
    { label: "(CMR) Houssen - France", value: "CMR" },
    { label: "(DLE) Tavaux - France", value: "DLE" },
    { label: "(OBS) Ardeche Meridionale - France", value: "OBS" },
    { label: "(LPY) Loudes - France", value: "LPY" },
    { label: "(XBK) Ceyzeriat - France", value: "XBK" },
    { label: "(XVF) Tarare - France", value: "XVF" },
    { label: "(XMU) Montbeugny - France", value: "XMU" },
    { label: "(ETZ) Metz Nancy Lorraine - France", value: "ETZ" },
    { label: "(BIA) Poretta - France", value: "BIA" },
    { label: "(CLY) Saint Catherine - France", value: "CLY" },
    { label: "(FSC) Sud Corse - France", value: "FSC" },
    { label: "(AJA) Campo Dell Oro - France", value: "AJA" },
    { label: "(SOZ) Solenzara - France", value: "SOZ" },
    { label: "(AUF) Branches - France", value: "AUF" },
    { label: "(CMF) Aix Les Bains - France", value: "CMF" },
    { label: "(CFE) Auvergne - France", value: "CFE" },
    { label: "(BOU) Bourges - France", value: "BOU" },
    { label: "(XCD) Champforgeuil - France", value: "XCD" },
    { label: "(QNJ) Annemasse - France", value: "QNJ" },
    { label: "(LYS) Saint Exupery - France", value: "LYS" },
    { label: "(QNX) Charnay - France", value: "QNX" },
    { label: "(RNE) Renaison - France", value: "RNE" },
    { label: "(NCY) Meythet - France", value: "NCY" },
    { label: "(GNB) Saint Geoirs - France", value: "GNB" },
    { label: "(MCU) Domerat - France", value: "MCU" },
    { label: "(VAF) Chabeuil - France", value: "VAF" },
    { label: "(VHY) Charmeil - France", value: "VHY" },
    { label: "(AUR) Aurillac - France", value: "AUR" },
    { label: "(CHR) Deols - France", value: "CHR" },
    { label: "(LYN) Bron - France", value: "LYN" },
    { label: "(QXB) Aix Les Milles - France", value: "QXB" },
    { label: "(CEQ) Mandelieu - France", value: "CEQ" },
    { label: "(EBU) Boutheon - France", value: "EBU" },
    { label: "(CCF) Salvaza - France", value: "CCF" },
    { label: "(MRS) Provence - France", value: "MRS" },
    { label: "(NCE) Cote D\\\\'Azur - France", value: "NCE" },
    { label: "(PGF) Rivesaltes - France", value: "PGF" },
    { label: "(CTT) Le Castellet - France", value: "CTT" },
    { label: "(MPL) Mediterranee - France", value: "MPL" },
    { label: "(BZR) Vias - France", value: "BZR" },
    { label: "(AVN) Caumont - France", value: "AVN" },
    { label: "(MEN) Brenoux - France", value: "MEN" },
    { label: "(BVA) Tille - France", value: "BVA" },
    { label: "(LEH) Octeville - France", value: "LEH" },
    { label: "(ORE) Bricy - France", value: "ORE" },
    { label: "(XCR) Vatry - France", value: "XCR" },
    { label: "(URO) Vallee De Seine - France", value: "URO" },
    { label: "(TUF) Val De Loire - France", value: "TUF" },
    { label: "(CET) Le Pontreau - France", value: "CET" },
    { label: "(LVA) Entrammes - France", value: "LVA" },
    { label: "(LBG) Le Bourget - France", value: "LBG" },
    { label: "(CSF) Creil - France", value: "CSF" },
    { label: "(CDG) Charles De Gaulle - France", value: "CDG" },
    { label: "(TNF) Toussus Le Noble - France", value: "TNF" },
    { label: "(ORY) Orly - France", value: "ORY" },
    { label: "(POX) Cormeilles En Vexin - France", value: "POX" },
    { label: "(QYR) Barberey - France", value: "QYR" },
    { label: "(NVS) Fourchambault - France", value: "NVS" },
    { label: "(LIL) Lesquin - France", value: "LIL" },
    { label: "(BES) Guipavas - France", value: "BES" },
    { label: "(CER) Maupertus - France", value: "CER" },
    { label: "(DNR) Pleurtuit - France", value: "DNR" },
    { label: "(GFR) Granville - France", value: "GFR" },
    { label: "(DOL) St Gatien - France", value: "DOL" },
    { label: "(LRT) Lann Bihoue - France", value: "LRT" },
    { label: "(EDM) Les Ajoncs - France", value: "EDM" },
    { label: "(CFR) Carpiquet - France", value: "CFR" },
    { label: "(LME) Arnage - France", value: "LME" },
    { label: "(RNS) St Jacques - France", value: "RNS" },
    { label: "(LAI) Lannion - France", value: "LAI" },
    { label: "(UIP) Pluguffan - France", value: "UIP" },
    { label: "(NTE) Nantes Atlantique - France", value: "NTE" },
    { label: "(SBK) Armor - France", value: "SBK" },
    { label: "(MXN) Ploujean - France", value: "MXN" },
    { label: "(VNE) Meucon - France", value: "VNE" },
    { label: "(SNR) Montoir - France", value: "SNR" },
    { label: "(MLH) Bale Mulhouse - France", value: "MLH" },
    { label: "(DIJ) Longvic - France", value: "DIJ" },
    { label: "(MZM) Frescaty - France", value: "MZM" },
    { label: "(EPL) Mirecourt - France", value: "EPL" },
    { label: "(ENC) Essey - France", value: "ENC" },
    { label: "(RHE) Champagne - France", value: "RHE" },
    { label: "(SXB) Entzheim - France", value: "SXB" },
    { label: "(TLN) Le Palyvestre - France", value: "TLN" },
    { label: "(FNI) Garons - France", value: "FNI" },
    { label: "(MQC) Miquelon - Saint Pierre and Miquelon", value: "MQC" },
    { label: "(FSP) St Pierre - Saint Pierre and Miquelon", value: "FSP" },
    { label: "(PYR) Andravida - Greece", value: "PYR" },
    { label: "(AGQ) Agrinion - Greece", value: "AGQ" },
    { label: "(AXD) Dimokritos - Greece", value: "AXD" },
    { label: "(VOL) Nea Anchialos - Greece", value: "VOL" },
    { label: "(JKH) Chios - Greece", value: "JKH" },
    { label: "(IOA) Ioannina - Greece", value: "IOA" },
    { label: "(HER) Nikos Kazantzakis - Greece", value: "HER" },
    { label: "(KSO) Aristotelis - Greece", value: "KSO" },
    { label: "(KIT) Kithira - Greece", value: "KIT" },
    { label: "(EFL) Kefallinia - Greece", value: "EFL" },
    { label: "(KLX) Kalamata - Greece", value: "KLX" },
    { label: "(KGS) Kos - Greece", value: "KGS" },
    { label: "(AOK) Karpathos - Greece", value: "AOK" },
    { label: "(CFU) Ioannis Kapodistrias Intl - Greece", value: "CFU" },
    { label: "(KSJ) Kasos - Greece", value: "KSJ" },
    { label: "(KVA) Megas Alexandros Intl - Greece", value: "KVA" },
    { label: "(KZI) Filippos - Greece", value: "KZI" },
    { label: "(LRS) Leros - Greece", value: "LRS" },
    { label: "(LXS) Limnos - Greece", value: "LXS" },
    { label: "(LRA) Larisa - Greece", value: "LRA" },
    { label: "(JMK) Mikonos - Greece", value: "JMK" },
    { label: "(MJT) Mitilini - Greece", value: "MJT" },
    { label: "(PVK) Aktio - Greece", value: "PVK" },
    { label: "(RHO) Rhodes Diagoras - Greece", value: "RHO" },
    { label: "(GPA) Araxos - Greece", value: "GPA" },
    { label: "(CHQ) Souda - Greece", value: "CHQ" },
    { label: "(JSI) Alexandros Papadiamantis - Greece", value: "JSI" },
    { label: "(SMI) Samos - Greece", value: "SMI" },
    { label: "(LYM) Ashford - United Kingdom", value: "LYM" },
    { label: "(JTR) Santorini - Greece", value: "JTR" },
    { label: "(JSH) Sitia - Greece", value: "JSH" },
    { label: "(SKU) Skiros - Greece", value: "SKU" },
    { label: "(SKG) Makedonia - Greece", value: "SKG" },
    { label: "(ZTH) Dionysios Solomos - Greece", value: "ZTH" },
    { label: "(BUD) Ferihegy - Hungary", value: "BUD" },
    { label: "(DEB) Debrecen - Hungary", value: "DEB" },
    {
      label: "(SUE) Door County Cherryland Airport - United States",
      value: "SUE",
    },
    { label: "(CRV) Crotone - Italy", value: "CRV" },
    { label: "(BRI) Bari - Italy", value: "BRI" },
    { label: "(FOG) Gino Lisa - Italy", value: "FOG" },
    { label: "(TAR) Grottaglie - Italy", value: "TAR" },
    { label: "(LCC) Lecce - Italy", value: "LCC" },
    { label: "(PSR) Pescara - Italy", value: "PSR" },
    { label: "(BDS) Casale - Italy", value: "BDS" },
    { label: "(SUF) Lamezia Terme - Italy", value: "SUF" },
    { label: "(CTA) Catania Fontanarossa - Italy", value: "CTA" },
    { label: "(LMP) Lampedusa - Italy", value: "LMP" },
    { label: "(PNL) Pantelleria - Italy", value: "PNL" },
    { label: "(PMO) Palermo - Italy", value: "PMO" },
    { label: "(REG) Reggio Calabria - Italy", value: "REG" },
    { label: "(TPS) Trapani Birgi - Italy", value: "TPS" },
    { label: "(NSY) Sigonella - Italy", value: "NSY" },
    { label: "(AHO) Alghero - Italy", value: "AHO" },
    { label: "(DCI) Decimomannu - Italy", value: "DCI" },
    { label: "(CAG) Elmas - Italy", value: "CAG" },
    { label: "(OLB) Olbia Costa Smeralda - Italy", value: "OLB" },
    { label: "(TTB) Tortoli - Italy", value: "TTB" },
    { label: "(MXP) Malpensa - Italy", value: "MXP" },
    { label: "(BGY) Bergamo Orio Al Serio - Italy", value: "BGY" },
    { label: "(TRN) Torino - Italy", value: "TRN" },
    { label: "(ALL) Albenga - Italy", value: "ALL" },
    { label: "(GOA) Genova Sestri - Italy", value: "GOA" },
    { label: "(LIN) Linate - Italy", value: "LIN" },
    { label: "(PMF) Parma - Italy", value: "PMF" },
    { label: "(QPZ) Piacenza - Italy", value: "QPZ" },
    {
      label: "(0P2) Shoestring Aviation Airfield - United States",
      value: "0P2",
    },
    { label: "(CUF) Levaldigi - Italy", value: "CUF" },
    { label: "(AVB) Aviano Ab - Italy", value: "AVB" },
    { label: "(BZO) Bolzano - Italy", value: "BZO" },
    { label: "(BLQ) Bologna - Italy", value: "BLQ" },
    { label: "(TSF) Treviso - Italy", value: "TSF" },
    { label: "(FRL) Forli - Italy", value: "FRL" },
    { label: "(VBS) Montichiari - Italy", value: "VBS" },
    { label: "(TRS) Ronchi Dei Legionari - Italy", value: "TRS" },
    { label: "(RMI) Rimini - Italy", value: "RMI" },
    { label: "(VIC) Vicenza - Italy", value: "VIC" },
    { label: "(QPA) Padova - Italy", value: "QPA" },
    { label: "(VRN) Villafranca - Italy", value: "VRN" },
    { label: "(VCE) Venezia Tessera - Italy", value: "VCE" },
    { label: "(SAY) Ampugnano - Italy", value: "SAY" },
    { label: "(CIA) Ciampino - Italy", value: "CIA" },
    { label: "(FCO) Fiumicino - Italy", value: "FCO" },
    { label: "(EBA) Marina Di Campo - Italy", value: "EBA" },
    { label: "(QLT) Latina - Italy", value: "QLT" },
    { label: "(NAP) Capodichino - Italy", value: "NAP" },
    { label: "(PSA) Pisa - Italy", value: "PSA" },
    { label: "(FLR) Firenze - Italy", value: "FLR" },
    { label: "(GRS) Grosseto - Italy", value: "GRS" },
    { label: "(PEG) Perugia - Italy", value: "PEG" },
    { label: "(LJU) Ljubljana - Slovenia", value: "LJU" },
    { label: "(MBX) Maribor - Slovenia", value: "MBX" },
    { label: "(POW) Portoroz - Slovenia", value: "POW" },
    { label: "(KLV) Karlovy Vary - Czech Republic", value: "KLV" },
    { label: "(OSR) Mosnov - Czech Republic", value: "OSR" },
    { label: "(PED) Pardubice - Czech Republic", value: "PED" },
    { label: "(PRV) Prerov - Czech Republic", value: "PRV" },
    { label: "(PRG) Ruzyne - Czech Republic", value: "PRG" },
    { label: "(BRQ) Turany - Czech Republic", value: "BRQ" },
    { label: "(TLV) Ben Gurion - Israel", value: "TLV" },
    { label: "(BEV) Teyman - Israel", value: "BEV" },
    { label: "(ETH) Eilat - Israel", value: "ETH" },
    { label: "(HFA) Haifa - Israel", value: "HFA" },
    { label: "(RPN) Mahanaim I Ben Yaakov - Israel", value: "RPN" },
    { label: "(VDA) Ovda - Israel", value: "VDA" },
    { label: "(SDV) Sde Dov - Israel", value: "SDV" },
    { label: "(MLA) Luqa - Malta", value: "MLA" },
    { label: "(GRZ) Graz - Austria", value: "GRZ" },
    { label: "(INN) Innsbruck - Austria", value: "INN" },
    { label: "(LNZ) Linz - Austria", value: "LNZ" },
    { label: "(SZG) Salzburg - Austria", value: "SZG" },
    { label: "(VIE) Schwechat - Austria", value: "VIE" },
    { label: "(SMA) Santa Maria - Portugal", value: "SMA" },
    { label: "(BGC) Braganca - Portugal", value: "BGC" },
    { label: "(FLW) Flores - Portugal", value: "FLW" },
    { label: "(FAO) Faro - Portugal", value: "FAO" },
    { label: "(GRW) Graciosa - Portugal", value: "GRW" },
    { label: "(HOR) Horta - Portugal", value: "HOR" },
    { label: "(TER) Lajes - Portugal", value: "TER" },
    { label: "(PDL) Ponta Delgada - Portugal", value: "PDL" },
    { label: "(PIX) Pico - Portugal", value: "PIX" },
    { label: "(OPO) Porto - Portugal", value: "OPO" },
    { label: "(PXO) Porto Santo - Portugal", value: "PXO" },
    { label: "(LIS) Lisboa - Portugal", value: "LIS" },
    { label: "(SJZ) Sao Jorge - Portugal", value: "SJZ" },
    { label: "(VRL) Vila Real - Portugal", value: "VRL" },
    {
      label: "(PDT) Eastern Oregon Regional Airport - United States",
      value: "PDT",
    },
    { label: "(OMO) Mostar - Bosnia and Herzegovina", value: "OMO" },
    { label: "(SJJ) Sarajevo - Bosnia and Herzegovina", value: "SJJ" },
    { label: "(ARW) Arad - Romania", value: "ARW" },
    { label: "(BCM) Bacau - Romania", value: "BCM" },
    { label: "(BAY) Tautii Magheraus - Romania", value: "BAY" },
    { label: "(BBU) Aurel Vlaicu - Romania", value: "BBU" },
    { label: "(CND) Mihail Kogalniceanu - Romania", value: "CND" },
    { label: "(CLJ) Cluj Napoca - Romania", value: "CLJ" },
    { label: "(CSB) Caransebes - Romania", value: "CSB" },
    { label: "(CRA) Craiova - Romania", value: "CRA" },
    { label: "(IAS) Iasi - Romania", value: "IAS" },
    { label: "(OMR) Oradea - Romania", value: "OMR" },
    { label: "(OTP) Henri Coanda - Romania", value: "OTP" },
    { label: "(SBZ) Sibiu - Romania", value: "SBZ" },
    { label: "(SUJ) Satu Mare - Romania", value: "SUJ" },
    { label: "(SCV) Stefan Cel Mare - Romania", value: "SCV" },
    { label: "(TCE) Cataloi - Romania", value: "TCE" },
    { label: "(TGM) Transilvania Targu Mures - Romania", value: "TGM" },
    { label: "(TSR) Traian Vuia - Romania", value: "TSR" },
    { label: "(GVA) Geneve Cointrin - Switzerland", value: "GVA" },
    { label: "(SIR) Sion - Switzerland", value: "SIR" },
    { label: "(LUG) Lugano - Switzerland", value: "LUG" },
    { label: "(BRN) Bern Belp - Switzerland", value: "BRN" },
    { label: "(ZRH) Zurich - Switzerland", value: "ZRH" },
    { label: "(ACH) St Gallen Altenrhein - Switzerland", value: "ACH" },
    { label: "(SMV) Samedan - Switzerland", value: "SMV" },
    { label: "(ESB) Esenboga - Turkey", value: "ESB" },
    { label: "(ANK) Etimesgut - Turkey", value: "ANK" },
    { label: "(ADA) Adana - Turkey", value: "ADA" },
    { label: "(AFY) Afyon - Turkey", value: "AFY" },
    { label: "(AYT) Antalya - Turkey", value: "AYT" },
    { label: "(GZT) Oguzeli - Turkey", value: "GZT" },
    { label: "(KYA) Konya - Turkey", value: "KYA" },
    { label: "(MZH) Merzifon - Turkey", value: "MZH" },
    { label: "(VAS) Sivas - Turkey", value: "VAS" },
    { label: "(MLX) Erhac - Turkey", value: "MLX" },
    { label: "(ASR) Erkilet - Turkey", value: "ASR" },
    { label: "(DNZ) Cardak - Turkey", value: "DNZ" },
    { label: "(IST) Ataturk - Turkey", value: "IST" },
    { label: "(BZI) Balikesir - Turkey", value: "BZI" },
    { label: "(BDM) Bandirma - Turkey", value: "BDM" },
    { label: "(TYE) Tyonek Airport - United States", value: "TYE" },
    { label: "(ESK) Eskisehir - Turkey", value: "ESK" },
    { label: "(ADB) Adnan Menderes - Turkey", value: "ADB" },
    { label: "(IGL) Cigli - Turkey", value: "IGL" },
    { label: "(DLM) Dalaman - Turkey", value: "DLM" },
    { label: "(RIW) Riverton Regional - United States", value: "RIW" },
    { label: "(BXN) Imsik - Turkey", value: "BXN" },
    { label: "(EZS) Elazig - Turkey", value: "EZS" },
    { label: "(DIY) Diyarbakir - Turkey", value: "DIY" },
    { label: "(ERC) Erzincan - Turkey", value: "ERC" },
    { label: "(ERZ) Erzurum - Turkey", value: "ERZ" },
    { label: "(TZX) Trabzon - Turkey", value: "TZX" },
    { label: "(MTJ) Montrose Regional Airport - United States", value: "MTJ" },
    { label: "(VAN) Van - Turkey", value: "VAN" },
    { label: "(BAL) Batman - Turkey", value: "BAL" },
    { label: "(KIV) Chisinau Intl - Moldova", value: "KIV" },
    { label: "(OHD) Ohrid - Macedonia", value: "OHD" },
    { label: "(SKP) Skopje - Macedonia", value: "SKP" },
    { label: "(GIB) Gibraltar - Gibraltar", value: "GIB" },
    { label: "(BEG) Beograd - Serbia", value: "BEG" },
    { label: "(INI) Nis - Serbia", value: "INI" },
    { label: "(TGD) Podgorica - Montenegro", value: "TGD" },
    { label: "(PRN) Pristina - Serbia", value: "PRN" },
    { label: "(TIV) Tivat - Montenegro", value: "TIV" },
    { label: "(BTS) M R Stefanik - Slovakia", value: "BTS" },
    { label: "(KSC) Kosice - Slovakia", value: "KSC" },
    { label: "(PZY) Piestany - Slovakia", value: "PZY" },
    { label: "(SLD) Sliac - Slovakia", value: "SLD" },
    { label: "(TAT) Tatry - Slovakia", value: "TAT" },
    { label: "(1CS) Clow International Airport - United States", value: "1CS" },
    { label: "(NCA) North Caicos - Turks and Caicos Islands", value: "NCA" },
    { label: "(PLS) Providenciales - Turks and Caicos Islands", value: "PLS" },
    { label: "(XSC) South Caicos - Turks and Caicos Islands", value: "XSC" },
    { label: "(EPS) Arroyo Barril Intl - Dominican Republic", value: "EPS" },
    { label: "(BRX) Maria Montez Intl - Dominican Republic", value: "BRX" },
    { label: "(LRM) Casa De Campo Intl - Dominican Republic", value: "LRM" },
    { label: "(PUJ) Punta Cana Intl - Dominican Republic", value: "PUJ" },
    { label: "(POP) Gregorio Luperon Intl - Dominican Republic", value: "POP" },
    { label: "(SDQ) Las Americas Intl - Dominican Republic", value: "SDQ" },
    { label: "(STI) Cibao Intl - Dominican Republic", value: "STI" },
    { label: "(CBV) Coban - Guatemala", value: "CBV" },
    { label: "(GUA) La Aurora - Guatemala", value: "GUA" },
    { label: "(LCE) Goloson Intl - Honduras", value: "LCE" },
    { label: "(SAP) La Mesa Intl - Honduras", value: "SAP" },
    { label: "(GJA) Guanaja - Honduras", value: "GJA" },
    { label: "(RTB) Juan Manuel Galvez Intl - Honduras", value: "RTB" },
    { label: "(TEA) Tela - Honduras", value: "TEA" },
    { label: "(TGU) Toncontin Intl - Honduras", value: "TGU" },
    { label: "(OCJ) Boscobel - Jamaica", value: "OCJ" },
    { label: "(KIN) Norman Manley Intl - Jamaica", value: "KIN" },
    { label: "(MBJ) Sangster Intl - Jamaica", value: "MBJ" },
    { label: "(POT) Ken Jones - Jamaica", value: "POT" },
    { label: "(KTP) Tinson Pen - Jamaica", value: "KTP" },
    { label: "(ACA) General Juan N Alvarez Intl - Mexico", value: "ACA" },
    { label: "(NTR) Del Norte Intl - Mexico", value: "NTR" },
    { label: "(AGU) Jesus Teran Intl - Mexico", value: "AGU" },
    { label: "(HUX) Bahias De Huatulco Intl - Mexico", value: "HUX" },
    { label: "(CVJ) General Mariano Matamoros - Mexico", value: "CVJ" },
    { label: "(CME) Ciudad Del Carmen Intl - Mexico", value: "CME" },
    { label: "(CUL) Culiacan Intl - Mexico", value: "CUL" },
    { label: "(CTM) Chetumal Intl - Mexico", value: "CTM" },
    { label: "(CEN) Ciudad Obregon Intl - Mexico", value: "CEN" },
    {
      label: "(CPE) Ingeniero Alberto Acuna Ongay Intl - Mexico",
      value: "CPE",
    },
    { label: "(CJS) Abraham Gonzalez Intl - Mexico", value: "CJS" },
    { label: "(CUU) General R Fierro Villalobos Intl - Mexico", value: "CUU" },
    { label: "(CVM) General Pedro Jose Mendez Intl - Mexico", value: "CVM" },
    { label: "(ENW) Kenosha Regional Airport - United States", value: "ENW" },
    { label: "(CZM) Cozumel Intl - Mexico", value: "CZM" },
    { label: "(DGO) Durango Intl - Mexico", value: "DGO" },
    { label: "(TPQ) Tepic - Mexico", value: "TPQ" },
    { label: "(ESE) Ensenada - Mexico", value: "ESE" },
    {
      label: "(GDL) Don Miguel Hidalgo Y Costilla Intl - Mexico",
      value: "GDL",
    },
    { label: "(GYM) General Jose Maria Yanez Intl - Mexico", value: "GYM" },
    { label: "(TCN) Tehuacan - Mexico", value: "TCN" },
    { label: "(HMO) General Ignacio P Garcia Intl - Mexico", value: "HMO" },
    { label: "(CLQ) Colima - Mexico", value: "CLQ" },
    { label: "(ISJ) Isla Mujeres - Mexico", value: "ISJ" },
    { label: "(SLW) Plan De Guadalupe Intl - Mexico", value: "SLW" },
    { label: "(LZC) Lazaro Cardenas - Mexico", value: "LZC" },
    { label: "(LMM) Valle Del Fuerte Intl - Mexico", value: "LMM" },
    { label: "(BJX) Guanajuato Intl - Mexico", value: "BJX" },
    {
      label: "(LAP) General Manuel Marquez De Leon Intl - Mexico",
      value: "LAP",
    },
    { label: "(LTO) Loreto Intl - Mexico", value: "LTO" },
    { label: "(MAM) General Servando Canales Intl - Mexico", value: "MAM" },
    {
      label: "(MID) Licenciado Manuel Crescencio Rejon Int - Mexico",
      value: "MID",
    },
    {
      label: "(MXL) General Rodolfo Sanchez Taboada Intl - Mexico",
      value: "MXL",
    },
    { label: "(MLM) General Francisco J Mujica Intl - Mexico", value: "MLM" },
    { label: "(MTT) Minatitlan - Mexico", value: "MTT" },
    { label: "(LOV) Monclova Intl - Mexico", value: "LOV" },
    { label: "(MEX) Licenciado Benito Juarez Intl - Mexico", value: "MEX" },
    { label: "(MTY) General Mariano Escobedo Intl - Mexico", value: "MTY" },
    { label: "(MZT) General Rafael Buelna Intl - Mexico", value: "MZT" },
    { label: "(NOG) Nogales Intl - Mexico", value: "NOG" },
    { label: "(NLD) Quetzalcoatl Intl - Mexico", value: "NLD" },
    { label: "(OAX) Xoxocotlan Intl - Mexico", value: "OAX" },
    { label: "(PAZ) Tajin - Mexico", value: "PAZ" },
    { label: "(PBC) Hermanos Serdan Intl - Mexico", value: "PBC" },
    {
      label: "(PCA) Ingeniero Juan Guillermo Villasana - Mexico",
      value: "PCA",
    },
    { label: "(PPE) Puerto Penasco - Mexico", value: "PPE" },
    { label: "(PDS) Piedras Negras Intl - Mexico", value: "PDS" },
    {
      label: "(UPN) Licenciado Y Gen Ignacio Lopez Rayon - Mexico",
      value: "UPN",
    },
    {
      label: "(PVR) Licenciado Gustavo Diaz Ordaz Intl - Mexico",
      value: "PVR",
    },
    { label: "(PXM) Puerto Escondido Intl - Mexico", value: "PXM" },
    { label: "(QRO) Queretaro Intercontinental - Mexico", value: "QRO" },
    { label: "(REX) General Lucio Blanco Intl - Mexico", value: "REX" },
    { label: "(SJD) Los Cabos Intl - Mexico", value: "SJD" },
    { label: "(SLP) Ponciano Arriaga Intl - Mexico", value: "SLP" },
    { label: "(TXA) Tlaxcala - Mexico", value: "TXA" },
    { label: "(TRC) Torreon Intl - Mexico", value: "TRC" },
    { label: "(TGZ) Angel Albino Corzo - Mexico", value: "TGZ" },
    { label: "(TIJ) General Abelardo L Rodriguez Intl - Mexico", value: "TIJ" },
    {
      label: "(TAM) General Francisco Javier Mina Intl - Mexico",
      value: "TAM",
    },
    { label: "(TSL) Tamuin - Mexico", value: "TSL" },
    {
      label: "(TLC) Licenciado Adolfo Lopez Mateos Intl - Mexico",
      value: "TLC",
    },
    { label: "(TAP) Tapachula Intl - Mexico", value: "TAP" },
    { label: "(CUN) Cancun Intl - Mexico", value: "CUN" },
    { label: "(VSA) C P A Carlos Rovirosa Intl - Mexico", value: "VSA" },
    { label: "(VER) General Heriberto Jara Intl - Mexico", value: "VER" },
    { label: "(ZCL) General Leobardo C Ruiz Intl - Mexico", value: "ZCL" },
    { label: "(ZIH) Ixtapa Zihuatanejo Intl - Mexico", value: "ZIH" },
    { label: "(ZMM) Zamora - Mexico", value: "ZMM" },
    { label: "(ZLO) Playa De Oro Intl - Mexico", value: "ZLO" },
    { label: "(BEF) Bluefields - Nicaragua", value: "BEF" },
    { label: "(MGA) Managua Intl - Nicaragua", value: "MGA" },
    { label: "(PUZ) Puerto Cabezas - Nicaragua", value: "PUZ" },
    { label: "(BOC) Bocas Del Toro Intl - Panama", value: "BOC" },
    { label: "(CHX) Cap Manuel Nino Intl - Panama", value: "CHX" },
    { label: "(DAV) Enrique Malek Intl - Panama", value: "DAV" },
    { label: "(HOW) Howard - Panama", value: "HOW" },
    { label: "(PAC) Marcos A Gelabert Intl - Panama", value: "PAC" },
    { label: "(PTY) Tocumen Intl - Panama", value: "PTY" },
    { label: "(VGT) North Las Vegas Airport - United States", value: "VGT" },
    { label: "(OTR) Coto 47 - Costa Rica", value: "OTR" },
    { label: "(GLF) Golfito - Costa Rica", value: "GLF" },
    { label: "(LIR) Daniel Oduber Quiros Intl - Costa Rica", value: "LIR" },
    { label: "(LIO) Limon Intl - Costa Rica", value: "LIO" },
    { label: "(NOB) Nosara - Costa Rica", value: "NOB" },
    { label: "(SJO) Juan Santamaria Intl - Costa Rica", value: "SJO" },
    { label: "(PMZ) Palmar Sur - Costa Rica", value: "PMZ" },
    { label: "(XQP) La Managua - Costa Rica", value: "XQP" },
    { label: "(SAL) El Salvador Intl - El Salvador", value: "SAL" },
    { label: "(CAP) Cap Haitien Intl - Haiti", value: "CAP" },
    { label: "(PAP) Toussaint Louverture Intl - Haiti", value: "PAP" },
    { label: "(BCA) Gustavo Rizo - Cuba", value: "BCA" },
    { label: "(BYM) Carlos Manuel De Cespedes - Cuba", value: "BYM" },
    { label: "(AVI) Maximo Gomez - Cuba", value: "AVI" },
    { label: "(CFG) Jaime Gonzalez - Cuba", value: "CFG" },
    { label: "(CYO) Vilo Acuna Intl - Cuba", value: "CYO" },
    { label: "(CMW) Ignacio Agramonte Intl - Cuba", value: "CMW" },
    { label: "(SCU) Antonio Maceo Intl - Cuba", value: "SCU" },
    { label: "(GAO) Mariana Grajales - Cuba", value: "GAO" },
    { label: "(HAV) Jose Marti Intl - Cuba", value: "HAV" },
    { label: "(HOG) Frank Pais Intl - Cuba", value: "HOG" },
    { label: "(LCL) La Coloma - Cuba", value: "LCL" },
    { label: "(MOA) Orestes Acosta - Cuba", value: "MOA" },
    { label: "(MZO) Sierra Maestra - Cuba", value: "MZO" },
    { label: "(GER) Rafael Cabrera - Cuba", value: "GER" },
    { label: "(SNU) Abel Santamaria - Cuba", value: "SNU" },
    {
      label: "(C02) Grand Geneva Resort Airport - United States",
      value: "C02",
    },
    { label: "(VRA) Juan Gualberto Gomez Intl - Cuba", value: "VRA" },
    { label: "(VTU) Hermanos Ameijeiras - Cuba", value: "VTU" },
    { label: "(CYB) Gerrard Smith Intl - Cayman Islands", value: "CYB" },
    { label: "(GCM) Owen Roberts Intl - Cayman Islands", value: "GCM" },
    { label: "(ASD) Fresh Creek - Bahamas", value: "ASD" },
    { label: "(MHH) Marsh Harbour - Bahamas", value: "MHH" },
    { label: "(SAQ) San Andros - Bahamas", value: "SAQ" },
    { label: "(AXP) Spring Point - Bahamas", value: "AXP" },
    { label: "(TCB) Treasure Cay - Bahamas", value: "TCB" },
    { label: "(CCZ) Chub Cay - Bahamas", value: "CCZ" },
    { label: "(BIM) South Bimini - Bahamas", value: "BIM" },
    {
      label: "(DKB) De Kalb Taylor Municipal Airport - United States",
      value: "DKB",
    },
    { label: "(GGT) Exuma Intl - Bahamas", value: "GGT" },
    { label: "(ELH) North Eleuthera - Bahamas", value: "ELH" },
    { label: "(GHB) Governors Harbour - Bahamas", value: "GHB" },
    { label: "(RSD) Rock Sound - Bahamas", value: "RSD" },
    { label: "(FPO) Grand Bahama Intl - Bahamas", value: "FPO" },
    { label: "(IGA) Matthew Town - Bahamas", value: "IGA" },
    { label: "(LGI) Deadmans Cay - Bahamas", value: "LGI" },
    { label: "(SML) Stella Maris - Bahamas", value: "SML" },
    { label: "(MYG) Mayaguana - Bahamas", value: "MYG" },
    { label: "(NAS) Lynden Pindling Intl - Bahamas", value: "NAS" },
    { label: "(ZSA) San Salvador - Bahamas", value: "ZSA" },
    { label: "(BZE) Philip S W Goldson Intl - Belize", value: "BZE" },
    { label: "(AIT) Aitutaki - Cook Islands", value: "AIT" },
    { label: "(RAR) Rarotonga Intl - Cook Islands", value: "RAR" },
    { label: "(NAN) Nadi Intl - Fiji", value: "NAN" },
    { label: "(SUV) Nausori Intl - Fiji", value: "SUV" },
    { label: "(TBU) Fua Amotu Intl - Tonga", value: "TBU" },
    { label: "(VAV) Vavau Intl - Tonga", value: "VAV" },
    { label: "(TRW) Bonriki Intl - Kiribati", value: "TRW" },
    { label: "(TBF) Tabiteuea North - Kiribati", value: "TBF" },
    { label: "(MTL) Maitland Airport - Australia", value: "MTL" },
    { label: "(WLS) Wallis - Wallis and Futuna", value: "WLS" },
    { label: "(APW) Faleolo Intl - Samoa", value: "APW" },
    { label: "(PPG) Pago Pago Intl - American Samoa", value: "PPG" },
    { label: "(RUR) Rurutu - French Polynesia", value: "RUR" },
    { label: "(TUB) Tubuai - French Polynesia", value: "TUB" },
    { label: "(AAA) Anaa - French Polynesia", value: "AAA" },
    { label: "(TIH) Tikehau - French Polynesia", value: "TIH" },
    { label: "(REA) Reao - French Polynesia", value: "REA" },
    { label: "(FAV) Fakarava - French Polynesia", value: "FAV" },
    { label: "(XMH) Manihi - French Polynesia", value: "XMH" },
    { label: "(GMR) Totegegie - French Polynesia", value: "GMR" },
    { label: "(KKR) Kaukura - French Polynesia", value: "KKR" },
    { label: "(MKP) Makemo - French Polynesia", value: "MKP" },
    { label: "(PKP) Puka Puka - French Polynesia", value: "PKP" },
    { label: "(TKP) Takapoto - French Polynesia", value: "TKP" },
    { label: "(AXR) Arutua - French Polynesia", value: "AXR" },
    { label: "(MVT) Mataiva - French Polynesia", value: "MVT" },
    { label: "(TKX) Takaroa - French Polynesia", value: "TKX" },
    { label: "(NHV) Nuku Hiva - French Polynesia", value: "NHV" },
    { label: "(LAF) Purude University Airport - United States", value: "LAF" },
    { label: "(BOB) Bora Bora - French Polynesia", value: "BOB" },
    { label: "(RGI) Rangiroa - French Polynesia", value: "RGI" },
    { label: "(HUH) Huahine - French Polynesia", value: "HUH" },
    { label: "(MOZ) Moorea - French Polynesia", value: "MOZ" },
    { label: "(HOI) Hao - French Polynesia", value: "HOI" },
    { label: "(MAU) Maupiti - French Polynesia", value: "MAU" },
    { label: "(RFP) Raiatea - French Polynesia", value: "RFP" },
    { label: "(VLI) Port Vila Bauerfield - Vanuatu", value: "VLI" },
    { label: "(KNQ) Kone - New Caledonia", value: "KNQ" },
    { label: "(KOC) Koumac - New Caledonia", value: "KOC" },
    { label: "(LIF) Lifou - New Caledonia", value: "LIF" },
    { label: "(GEA) Magenta - New Caledonia", value: "GEA" },
    { label: "(MEE) Mare - New Caledonia", value: "MEE" },
    { label: "(TOU) Touho - New Caledonia", value: "TOU" },
    { label: "(UVE) Ouvea - New Caledonia", value: "UVE" },
    { label: "(NOU) La Tontouta - New Caledonia", value: "NOU" },
    { label: "(AKL) Auckland Intl - New Zealand", value: "AKL" },
    { label: "(TUO) Taupo - New Zealand", value: "TUO" },
    { label: "(AMZ) Ardmore - New Zealand", value: "AMZ" },
    { label: "(CHC) Christchurch Intl - New Zealand", value: "CHC" },
    { label: "(CHT) Chatham Islands - New Zealand", value: "CHT" },
    { label: "(DUD) Dunedin - New Zealand", value: "DUD" },
    { label: "(GIS) Gisborne - New Zealand", value: "GIS" },
    { label: "(MON) Glentanner - New Zealand", value: "MON" },
    { label: "(HKK) Hokitika - New Zealand", value: "HKK" },
    { label: "(HLZ) Hamilton - New Zealand", value: "HLZ" },
    { label: "(KKE) Kerikeri - New Zealand", value: "KKE" },
    { label: "(KAT) Kaitaia - New Zealand", value: "KAT" },
    { label: "(ALR) Alexandra - New Zealand", value: "ALR" },
    { label: "(GTN) Mount Cook - New Zealand", value: "GTN" },
    { label: "(TEU) Manapouri - New Zealand", value: "TEU" },
    { label: "(MRO) Masterton - New Zealand", value: "MRO" },
    { label: "(NPL) New Plymouth - New Zealand", value: "NPL" },
    { label: "(NSN) Nelson - New Zealand", value: "NSN" },
    { label: "(IVC) Invercargill - New Zealand", value: "IVC" },
    { label: "(OAM) Oamaru - New Zealand", value: "OAM" },
    { label: "(PMR) Palmerston North - New Zealand", value: "PMR" },
    { label: "(PPQ) Paraparaumu - New Zealand", value: "PPQ" },
    { label: "(ZQN) Queenstown - New Zealand", value: "ZQN" },
    { label: "(ROT) Rotorua - New Zealand", value: "ROT" },
    { label: "(TRG) Tauranga - New Zealand", value: "TRG" },
    { label: "(TIU) Timaru - New Zealand", value: "TIU" },
    { label: "(BHE) Woodbourne - New Zealand", value: "BHE" },
    { label: "(WKA) Wanaka - New Zealand", value: "WKA" },
    { label: "(WHK) Whakatane - New Zealand", value: "WHK" },
    { label: "(WLG) Wellington Intl - New Zealand", value: "WLG" },
    { label: "(WRE) Whangarei - New Zealand", value: "WRE" },
    { label: "(WSZ) Westport - New Zealand", value: "WSZ" },
    { label: "(WAG) Wanganui - New Zealand", value: "WAG" },
    { label: "(HEA) Herat - Afghanistan", value: "HEA" },
    { label: "(JAA) Jalalabad - Afghanistan", value: "JAA" },
    { label: "(KBL) Kabul Intl - Afghanistan", value: "KBL" },
    { label: "(KDH) Kandahar - Afghanistan", value: "KDH" },
    { label: "(MMZ) Maimana - Afghanistan", value: "MMZ" },
    { label: "(MZR) Mazar I Sharif - Afghanistan", value: "MZR" },
    { label: "(UND) Konduz - Afghanistan", value: "UND" },
    { label: "(BAH) Bahrain Intl - Bahrain", value: "BAH" },
    { label: "(AHB) Abha - Saudi Arabia", value: "AHB" },
    { label: "(HOF) Al Ahsa - Saudi Arabia", value: "HOF" },
    { label: "(ABT) Al Baha - Saudi Arabia", value: "ABT" },
    { label: "(BHH) Bisha - Saudi Arabia", value: "BHH" },
    { label: "(DMM) King Fahd Intl - Saudi Arabia", value: "DMM" },
    { label: "(DHA) King Abdulaziz Ab - Saudi Arabia", value: "DHA" },
    { label: "(GIZ) King Abdullah Bin Abdulaziz - Saudi Arabia", value: "GIZ" },
    { label: "(ELQ) Gassim - Saudi Arabia", value: "ELQ" },
    { label: "(URY) Guriat - Saudi Arabia", value: "URY" },
    { label: "(HAS) Hail - Saudi Arabia", value: "HAS" },
    { label: "(JED) King Abdulaziz Intl - Saudi Arabia", value: "JED" },
    { label: "(HBT) King Khaled Military City - Saudi Arabia", value: "HBT" },
    {
      label: "(MED) Prince Mohammad Bin Abdulaziz - Saudi Arabia",
      value: "MED",
    },
    { label: "(EAM) Nejran - Saudi Arabia", value: "EAM" },
    { label: "(AQI) Qaisumah - Saudi Arabia", value: "AQI" },
    { label: "(RAH) Rafha - Saudi Arabia", value: "RAH" },
    { label: "(RUH) King Khaled Intl - Saudi Arabia", value: "RUH" },
    { label: "(RAE) Arar - Saudi Arabia", value: "RAE" },
    { label: "(SHW) Sharurah - Saudi Arabia", value: "SHW" },
    { label: "(DGE) Mudgee Airport - Australia", value: "DGE" },
    { label: "(SLF) Sulayel - Saudi Arabia", value: "SLF" },
    { label: "(TUU) Tabuk - Saudi Arabia", value: "TUU" },
    { label: "(TIF) Taif - Saudi Arabia", value: "TIF" },
    { label: "(TUI) Turaif - Saudi Arabia", value: "TUI" },
    { label: "(OXD) Miami University Airport - United States", value: "OXD" },
    { label: "(EJH) Wejh - Saudi Arabia", value: "EJH" },
    { label: "(YNB) Yenbo - Saudi Arabia", value: "YNB" },
    { label: "(ABD) Abadan - Iran", value: "ABD" },
    { label: "(QMJ) Shahid Asyaee - Iran", value: "QMJ" },
    { label: "(MRX) Mahshahr - Iran", value: "MRX" },
    { label: "(AWZ) Ahwaz - Iran", value: "AWZ" },
    { label: "(BUZ) Bushehr - Iran", value: "BUZ" },
    { label: "(KIH) Kish Island - Iran", value: "KIH" },
    { label: "(BDH) Bandar Lengeh - Iran", value: "BDH" },
    { label: "(KSH) Shahid Ashrafi Esfahani - Iran", value: "KSH" },
    { label: "(SDG) Sanandaj - Iran", value: "SDG" },
    { label: "(RAS) Rasht - Iran", value: "RAS" },
    { label: "(MIE) Delaware County Airport - United States", value: "MIE" },
    { label: "(THR) Mehrabad Intl - Iran", value: "THR" },
    { label: "(BND) Bandar Abbass Intl - Iran", value: "BND" },
    { label: "(KER) Kerman - Iran", value: "KER" },
    { label: "(XBJ) Birjand - Iran", value: "XBJ" },
    { label: "(WSY) Whitsunday Airstrip - Australia", value: "WSY" },
    { label: "(RZR) Ramsar - Iran", value: "RZR" },
    { label: "(RAF) Aeropuerto de Rafaela - Argentina", value: "RAF" },
    { label: "(SYZ) Shiraz Shahid Dastghaib Intl - Iran", value: "SYZ" },
    { label: "(QSA) Sabadell Airport - Spain", value: "QSA" },
    { label: "(TBZ) Tabriz Intl - Iran", value: "TBZ" },
    { label: "(AZD) Yazd Shahid Sadooghi - Iran", value: "AZD" },
    { label: "(ZBR) Chah Bahar - Iran", value: "ZBR" },
    { label: "(ZAH) Zahedan Intl - Iran", value: "ZAH" },
    { label: "(AMM) Queen Alia Intl - Jordan", value: "AMM" },
    { label: "(ADJ) Marka Intl - Jordan", value: "ADJ" },
    { label: "(AQJ) Aqaba King Hussein Intl - Jordan", value: "AQJ" },
    { label: "(OMF) King Hussein - Jordan", value: "OMF" },
    { label: "(KWI) Kuwait Intl - Kuwait", value: "KWI" },
    { label: "(BEY) Rafic Hariri Intl - Lebanon", value: "BEY" },
    { label: "(AUH) Abu Dhabi Intl - United Arab Emirates", value: "AUH" },
    { label: "(AZI) Bateen - United Arab Emirates", value: "AZI" },
    { label: "(MVA) Reykjahlid Airport - Iceland", value: "MVA" },
    { label: "(DXB) Dubai Intl - United Arab Emirates", value: "DXB" },
    { label: "(FJR) Fujairah Intl - United Arab Emirates", value: "FJR" },
    { label: "(RKT) Ras Al Khaimah Intl - United Arab Emirates", value: "RKT" },
    { label: "(SHJ) Sharjah Intl - United Arab Emirates", value: "SHJ" },
    { label: "(KHS) Khasab - Oman", value: "KHS" },
    { label: "(MSH) Masirah - Oman", value: "MSH" },
    { label: "(MCT) Seeb Intl - Oman", value: "MCT" },
    { label: "(SLL) Salalah - Oman", value: "SLL" },
    { label: "(TTH) Thumrait - Oman", value: "TTH" },
    { label: "(XYD) Lyon Part-Dieu Railway - France", value: "XYD" },
    { label: "(LYP) Faisalabad Intl - Pakistan", value: "LYP" },
    { label: "(GWD) Gwadar - Pakistan", value: "GWD" },
    { label: "(GIL) Gilgit - Pakistan", value: "GIL" },
    { label: "(KHI) Jinnah Intl - Pakistan", value: "KHI" },
    { label: "(LHE) Allama Iqbal Intl - Pakistan", value: "LHE" },
    { label: "(MFG) Muzaffarabad - Pakistan", value: "MFG" },
    { label: "(MJD) Moenjodaro - Pakistan", value: "MJD" },
    { label: "(MUX) Multan Intl - Pakistan", value: "MUX" },
    { label: "(WNS) Nawabshah - Pakistan", value: "WNS" },
    { label: "(PJG) Panjgur - Pakistan", value: "PJG" },
    { label: "(PSI) Pasni - Pakistan", value: "PSI" },
    { label: "(PEW) Peshawar Intl - Pakistan", value: "PEW" },
    { label: "(UET) Quetta - Pakistan", value: "UET" },
    { label: "(RYK) Sheikh Zayed - Pakistan", value: "RYK" },
    { label: "(ISB) Chaklala - Pakistan", value: "ISB" },
    { label: "(RAZ) Rawalakot - Pakistan", value: "RAZ" },
    { label: "(1RL) Point Roberts Airpark - United States", value: "1RL" },
    { label: "(SKZ) Sukkur - Pakistan", value: "SKZ" },
    { label: "(SDT) Saidu Sharif - Pakistan", value: "SDT" },
    { label: "(SUL) Sui - Pakistan", value: "SUL" },
    { label: "(BDN) Talhar - Pakistan", value: "BDN" },
    { label: "(PZH) Zhob - Pakistan", value: "PZH" },
    { label: "(BSR) Basrah Intl - Iraq", value: "BSR" },
    { label: "(ALP) Aleppo Intl - Syria", value: "ALP" },
    { label: "(DAM) Damascus Intl - Syria", value: "DAM" },
    { label: "(DEZ) Deir Zzor - Syria", value: "DEZ" },
    { label: "(LTK) Bassel Al Assad Intl - Syria", value: "LTK" },
    { label: "(PMS) Palmyra - Syria", value: "PMS" },
    { label: "(DOH) Doha Intl - Qatar", value: "DOH" },
    { label: "(CIS) Canton - Kiribati", value: "CIS" },
    { label: "(ROP) Rota Intl - Northern Mariana Islands", value: "ROP" },
    {
      label: "(SPN) Francisco C Ada Saipan Intl - Northern Mariana Islands",
      value: "SPN",
    },
    { label: "(UAM) Andersen Afb - Guam", value: "UAM" },
    { label: "(GUM) Guam Intl - Guam", value: "GUM" },
    { label: "(TIQ) Tinian Intl - Northern Mariana Islands", value: "TIQ" },
    { label: "(NSO) Scone Airport - Australia", value: "NSO" },
    { label: "(MAJ) Marshall Islands Intl - Marshall Islands", value: "MAJ" },
    { label: "(KWA) Bucholz Aaf - Marshall Islands", value: "KWA" },
    { label: "(CXI) Cassidy Intl - Kiribati", value: "CXI" },
    { label: "(MDY) Midway Atoll - Midway Islands", value: "MDY" },
    { label: "(TKK) Chuuk Intl - Micronesia", value: "TKK" },
    { label: "(PNI) Pohnpei Intl - Micronesia", value: "PNI" },
    { label: "(ROR) Babelthuap - Palau", value: "ROR" },
    { label: "(KSA) Kosrae - Micronesia", value: "KSA" },
    { label: "(YAP) Yap Intl - Micronesia", value: "YAP" },
    { label: "(KNH) Shang Yi - Taiwan", value: "KNH" },
    { label: "(PIF) Pingtung South - Taiwan", value: "PIF" },
    { label: "(TTT) Fengnin - Taiwan", value: "TTT" },
    { label: "(GNI) Lyudao - Taiwan", value: "GNI" },
    { label: "(KHH) Kaohsiung Intl - Taiwan", value: "KHH" },
    { label: "(CYI) Chiayi - Taiwan", value: "CYI" },
    { label: "(KYD) Lanyu - Taiwan", value: "KYD" },
    { label: "(RMQ) Ching Chuang Kang - Taiwan", value: "RMQ" },
    { label: "(CES) Cessnock Airport - Australia", value: "CES" },
    { label: "(TNN) Tainan - Taiwan", value: "TNN" },
    { label: "(MZG) Magong - Taiwan", value: "MZG" },
    { label: "(TSA) Sungshan - Taiwan", value: "TSA" },
    { label: "(TPE) Taoyuan Intl - Taiwan", value: "TPE" },
    { label: "(WOT) Wang An - Taiwan", value: "WOT" },
    { label: "(HUN) Hualien - Taiwan", value: "HUN" },
    { label: "(NRT) Narita Intl - Japan", value: "NRT" },
    { label: "(MMJ) Matsumoto - Japan", value: "MMJ" },
    { label: "(IBR) Hyakuri - Japan", value: "IBR" },
    { label: "(IWO) Iwo Jima - Japan", value: "IWO" },
    { label: "(SHM) Nanki Shirahama - Japan", value: "SHM" },
    { label: "(OBO) Obihiro - Japan", value: "OBO" },
    { label: "(CTS) New Chitose - Japan", value: "CTS" },
    { label: "(HKD) Hakodate - Japan", value: "HKD" },
    { label: "(SPK) Chitose - Japan", value: "SPK" },
    { label: "(MMB) Memanbetsu - Japan", value: "MMB" },
    { label: "(SHB) Nakashibetsu - Japan", value: "SHB" },
    { label: "(WKJ) Wakkanai - Japan", value: "WKJ" },
    { label: "(IKI) Iki - Japan", value: "IKI" },
    { label: "(UBJ) Yamaguchi Ube - Japan", value: "UBJ" },
    { label: "(TSJ) Tsushima - Japan", value: "TSJ" },
    { label: "(MBE) Monbetsu - Japan", value: "MBE" },
    { label: "(AKJ) Asahikawa - Japan", value: "AKJ" },
    { label: "(OIR) Okushiri - Japan", value: "OIR" },
    { label: "(RIS) Rishiri - Japan", value: "RIS" },
    { label: "(KUM) Yakushima - Japan", value: "KUM" },
    { label: "(FUJ) Fukue - Japan", value: "FUJ" },
    { label: "(FUK) Fukuoka - Japan", value: "FUK" },
    { label: "(TNE) New Tanegashima - Japan", value: "TNE" },
    { label: "(KOJ) Kagoshima - Japan", value: "KOJ" },
    { label: "(KMI) Miyazaki - Japan", value: "KMI" },
    { label: "(OIT) Oita - Japan", value: "OIT" },
    { label: "(KKJ) New Kitakyushu - Japan", value: "KKJ" },
    { label: "(KMJ) Kumamoto - Japan", value: "KMJ" },
    { label: "(NGS) Nagasaki - Japan", value: "NGS" },
    { label: "(ASJ) Amami - Japan", value: "ASJ" },
    { label: "(TKN) Tokunoshima - Japan", value: "TKN" },
    { label: "(KMQ) Komatsu - Japan", value: "KMQ" },
    { label: "(OKI) Oki - Japan", value: "OKI" },
    { label: "(TOY) Toyama - Japan", value: "TOY" },
    { label: "(HIJ) Hiroshima - Japan", value: "HIJ" },
    { label: "(OKJ) Okayama - Japan", value: "OKJ" },
    { label: "(IZO) Izumo - Japan", value: "IZO" },
    { label: "(YGJ) Yonago Kitaro - Japan", value: "YGJ" },
    { label: "(KCZ) Kochi - Japan", value: "KCZ" },
    { label: "(MYJ) Matsuyama - Japan", value: "MYJ" },
    { label: "(ITM) Osaka Intl - Japan", value: "ITM" },
    { label: "(TTJ) Tottori - Japan", value: "TTJ" },
    { label: "(TKS) Tokushima - Japan", value: "TKS" },
    { label: "(TAK) Takamatsu - Japan", value: "TAK" },
    { label: "(AOJ) Aomori - Japan", value: "AOJ" },
    { label: "(GAJ) Yamagata - Japan", value: "GAJ" },
    { label: "(HNA) Hanamaki - Japan", value: "HNA" },
    { label: "(AXT) Akita - Japan", value: "AXT" },
    { label: "(MSJ) Misawa Ab - Japan", value: "MSJ" },
    { label: "(SDJ) Sendai - Japan", value: "SDJ" },
    { label: "(LKS) Sazena - Czech Republic", value: "LKS" },
    { label: "(HAC) Hachijojima - Japan", value: "HAC" },
    { label: "(OIM) Oshima - Japan", value: "OIM" },
    { label: "(HND) Tokyo Intl - Japan", value: "HND" },
    { label: "(OKO) Yokota Ab - Japan", value: "OKO" },
    { label: "(KWJ) Gwangju - South Korea", value: "KWJ" },
    { label: "(RSU) Yeosu - South Korea", value: "RSU" },
    { label: "(SHO) Sokcho - South Korea", value: "SHO" },
    { label: "(KAG) Gangneung - South Korea", value: "KAG" },
    { label: "(MQB) Macomb Municipal Airport - United States", value: "MQB" },
    { label: "(CJU) Jeju Intl - South Korea", value: "CJU" },
    { label: "(PUS) Gimhae Intl - South Korea", value: "PUS" },
    { label: "(USN) Ulsan - South Korea", value: "USN" },
    { label: "(SSN) Seoul Ab - South Korea", value: "SSN" },
    { label: "(OSN) Osan Ab - South Korea", value: "OSN" },
    { label: "(GMP) Gimpo - South Korea", value: "GMP" },
    { label: "(KPO) Pohang - South Korea", value: "KPO" },
    { label: "(TAE) Daegu Ab - South Korea", value: "TAE" },
    { label: "(YEC) Yecheon - South Korea", value: "YEC" },
    { label: "(OKA) Naha - Japan", value: "OKA" },
    { label: "(DNA) Kadena Ab - Japan", value: "DNA" },
    { label: "(ISG) Ishigaki - Japan", value: "ISG" },
    { label: "(UEO) Kumejima - Japan", value: "UEO" },
    { label: "(MMD) Minami Daito - Japan", value: "MMD" },
    { label: "(MMY) Miyako - Japan", value: "MMY" },
    { label: "(KTD) Kitadaito - Japan", value: "KTD" },
    { label: "(SHI) Shimojishima - Japan", value: "SHI" },
    { label: "(RNJ) Yoron - Japan", value: "RNJ" },
    { label: "(OGN) Yonaguni - Japan", value: "OGN" },
    { label: "(MNL) Ninoy Aquino Intl - Philippines", value: "MNL" },
    { label: "(MYP) Mary Airport - Turkmenistan", value: "MYP" },
    { label: "(CBO) Cotabato - Philippines", value: "CBO" },
    { label: "(CGY) Cagayan De Oro - Philippines", value: "CGY" },
    { label: "(PAG) Pagadian - Philippines", value: "PAG" },
    { label: "(ZAM) Zamboanga Intl - Philippines", value: "ZAM" },
    { label: "(BAG) Baguio - Philippines", value: "BAG" },
    { label: "(TAC) Daniel Z Romualdez - Philippines", value: "TAC" },
    { label: "(BCD) Bacolod - Philippines", value: "BCD" },
    { label: "(GEN) Gardermoen Airport - Norway", value: "GEN" },
    { label: "(DGT) Dumaguete - Philippines", value: "DGT" },
    { label: "(ILO) Iloilo - Philippines", value: "ILO" },
    { label: "(KLO) Kalibo - Philippines", value: "KLO" },
    { label: "(AUW) Wausau Downtown Airport - United States", value: "AUW" },
    { label: "(PPS) Puerto Princesa - Philippines", value: "PPS" },
    { label: "(SJI) Antique - Philippines", value: "SJI" },
    { label: "(COC) Comodoro Pierrestegui - Argentina", value: "COC" },
    { label: "(GHU) Gualeguaychu - Argentina", value: "GHU" },
    { label: "(PRA) General Urquiza - Argentina", value: "PRA" },
    { label: "(ROS) Rosario - Argentina", value: "ROS" },
    { label: "(SFN) Sauce Viejo - Argentina", value: "SFN" },
    { label: "(AEP) Aeroparque Jorge Newbery - Argentina", value: "AEP" },
    { label: "(COR) Ambrosio L V Taravella - Argentina", value: "COR" },
    { label: "(LPG) La Plata - Argentina", value: "LPG" },
    { label: "(MDZ) El Plumerillo - Argentina", value: "MDZ" },
    { label: "(LGS) Malargue - Argentina", value: "LGS" },
    { label: "(AFA) San Rafael - Argentina", value: "AFA" },
    { label: "(CTC) Catamarca - Argentina", value: "CTC" },
    { label: "(SDE) Santiago Del Estero - Argentina", value: "SDE" },
    { label: "(IRJ) La Rioja - Argentina", value: "IRJ" },
    { label: "(TUC) Teniente Benjamin Matienzo - Argentina", value: "TUC" },
    { label: "(UAQ) San Juan - Argentina", value: "UAQ" },
    { label: "(RCU) Rio Cuarto Area De Material - Argentina", value: "RCU" },
    { label: "(VDR) Villa Dolores - Argentina", value: "VDR" },
    { label: "(LUQ) San Luis - Argentina", value: "LUQ" },
    { label: "(CNQ) Corrientes - Argentina", value: "CNQ" },
    { label: "(RES) Resistencia - Argentina", value: "RES" },
    { label: "(FMA) Formosa - Argentina", value: "FMA" },
    { label: "(IGR) Cataratas Del Iguazu - Argentina", value: "IGR" },
    { label: "(AOL) Paso De Los Libres - Argentina", value: "AOL" },
    { label: "(PSS) Posadas - Argentina", value: "PSS" },
    { label: "(SLA) Salta - Argentina", value: "SLA" },
    { label: "(JUJ) Jujuy - Argentina", value: "JUJ" },
    { label: "(ORA) Oran - Argentina", value: "ORA" },
    { label: "(C47) Portage Municipal Airport - United States", value: "C47" },
    { label: "(EHL) El Bolson - Argentina", value: "EHL" },
    { label: "(CRD) Comodoro Rivadavia - Argentina", value: "CRD" },
    { label: "(EQS) Esquel - Argentina", value: "EQS" },
    { label: "(REL) Almirante Zar - Argentina", value: "REL" },
    { label: "(VDM) Gobernador Castello - Argentina", value: "VDM" },
    { label: "(PMY) El Tehuelche - Argentina", value: "PMY" },
    { label: "(PUD) Puerto Deseado - Argentina", value: "PUD" },
    { label: "(RGA) Rio Grande - Argentina", value: "RGA" },
    { label: "(RGL) Rio Gallegos - Argentina", value: "RGL" },
    { label: "(USH) Ushuaia Malvinas Argentinas - Argentina", value: "USH" },
    { label: "(ULA) San Julian - Argentina", value: "ULA" },
    { label: "(PMQ) Perito Moreno - Argentina", value: "PMQ" },
    { label: "(RZA) Santa Cruz - Argentina", value: "RZA" },
    { label: "(BHI) Comandante Espora - Argentina", value: "BHI" },
    {
      label: "(IWD) Gogebic Iron County Airport - United States",
      value: "IWD",
    },
    { label: "(MDQ) Mar Del Plata - Argentina", value: "MDQ" },
    { label: "(NQN) Presidente Peron - Argentina", value: "NQN" },
    { label: "(MCD) Mackinac Island Airport - United States", value: "MCD" },
    { label: "(RSA) Santa Rosa - Argentina", value: "RSA" },
    { label: "(BRC) San Carlos De Bariloche - Argentina", value: "BRC" },
    { label: "(TDL) Tandil - Argentina", value: "TDL" },
    { label: "(VLG) Villa Gesell - Argentina", value: "VLG" },
    { label: "(CPC) Aviador C Campos - Argentina", value: "CPC" },
    { label: "(CDJ) Conceicao Do Araguaia - Brazil", value: "CDJ" },
    { label: "(AQA) Araraquara - Brazil", value: "AQA" },
    { label: "(AJU) Santa Maria - Brazil", value: "AJU" },
    { label: "(AFL) Alta Floresta - Brazil", value: "AFL" },
    { label: "(ARU) Aracatuba - Brazil", value: "ARU" },
    { label: "(BEL) Val De Cans Intl - Brazil", value: "BEL" },
    { label: "(BGX) Comandante Gustavo Kraemer - Brazil", value: "BGX" },
    {
      label: "(PLU) Pampulha Carlos Drummond De Andrade - Brazil",
      value: "PLU",
    },
    { label: "(BFH) Bacacheri - Brazil", value: "BFH" },
    { label: "(BSB) Presidente Juscelino Kubitschek - Brazil", value: "BSB" },
    { label: "(BAU) Bauru - Brazil", value: "BAU" },
    { label: "(BVB) Boa Vista - Brazil", value: "BVB" },
    { label: "(CAC) Cascavel - Brazil", value: "CAC" },
    { label: "(CNF) Tancredo Neves Intl - Brazil", value: "CNF" },
    { label: "(CGR) Campo Grande - Brazil", value: "CGR" },
    { label: "(XAP) Chapeco - Brazil", value: "XAP" },
    { label: "(CLN) Carolina - Brazil", value: "CLN" },
    { label: "(CCM) Forquilhinha - Brazil", value: "CCM" },
    { label: "(CAW) Bartolomeu Lisandro - Brazil", value: "CAW" },
    { label: "(CMG) Corumba Intl - Brazil", value: "CMG" },
    { label: "(CWB) Afonso Pena - Brazil", value: "CWB" },
    { label: "(CRQ) Caravelas - Brazil", value: "CRQ" },
    { label: "(CXJ) Campo Dos Bugres - Brazil", value: "CXJ" },
    { label: "(CGB) Marechal Rondon - Brazil", value: "CGB" },
    { label: "(CZS) Cruzeiro do Sul - Brazil", value: "CZS" },
    { label: "(PPB) Presidente Prudente - Brazil", value: "PPB" },
    { label: "(MAO) Eduardo Gomes Intl - Brazil", value: "MAO" },
    { label: "(IGU) Cataratas Intl - Brazil", value: "IGU" },
    { label: "(FLN) Hercilio Luz - Brazil", value: "FLN" },
    { label: "(FEN) Fernando De Noronha - Brazil", value: "FEN" },
    { label: "(FOR) Pinto Martins Intl - Brazil", value: "FOR" },
    { label: "(GIG) Galeao Antonio Carlos Jobim - Brazil", value: "GIG" },
    { label: "(GYN) Santa Genoveva - Brazil", value: "GYN" },
    {
      label: "(GRU) Guarulhos Gov Andre Franco Montouro - Brazil",
      value: "GRU",
    },
    { label: "(ATM) Altamira - Brazil", value: "ATM" },
    { label: "(IOS) Ilheus - Brazil", value: "IOS" },
    { label: "(IPN) Usiminas - Brazil", value: "IPN" },
    { label: "(IMP) Prefeito Renato Moreira - Brazil", value: "IMP" },
    { label: "(JDF) Francisco De Assis - Brazil", value: "JDF" },
    { label: "(JPA) Presidente Castro Pinto - Brazil", value: "JPA" },
    { label: "(JOI) Lauro Carneiro De Loyola - Brazil", value: "JOI" },
    { label: "(CPV) Presidente Joao Suassuna - Brazil", value: "CPV" },
    { label: "(VCP) Viracopos - Brazil", value: "VCP" },
    { label: "(LIP) Lins - Brazil", value: "LIP" },
    { label: "(LDB) Londrina - Brazil", value: "LDB" },
    { label: "(LAZ) Bom Jesus Da Lapa - Brazil", value: "LAZ" },
    { label: "(MAB) Maraba - Brazil", value: "MAB" },
    {
      label: "(MGF) Regional De Maringa Silvio label Junior - Brazil",
      value: "MGF",
    },
    { label: "(MOC) Mario Ribeiro - Brazil", value: "MOC" },
    {
      label: "(GRM) Grand Marais Cook County Airport - United States",
      value: "GRM",
    },
    { label: "(MCZ) Zumbi Dos Palmares - Brazil", value: "MCZ" },
    { label: "(MCP) Macapa - Brazil", value: "MCP" },
    { label: "(MNX) Manicore - Brazil", value: "MNX" },
    { label: "(NVT) Ministro Victor Konder Intl - Brazil", value: "NVT" },
    { label: "(GEL) Santo Angelo - Brazil", value: "GEL" },
    { label: "(NAT) Augusto Severo - Brazil", value: "NAT" },
    { label: "(POA) Salgado Filho - Brazil", value: "POA" },
    { label: "(POO) Pocos De Caldas - Brazil", value: "POO" },
    { label: "(PFB) Lauro Kurtz - Brazil", value: "PFB" },
    { label: "(PET) Pelotas - Brazil", value: "PET" },
    { label: "(PNZ) Senador Nilo Coelho - Brazil", value: "PNZ" },
    { label: "(PNB) Porto Nacional - Brazil", value: "PNB" },
    { label: "(PMG) Ponta Pora - Brazil", value: "PMG" },
    {
      label: "(PVH) Governador Jorge Teixeira De Oliveira - Brazil",
      value: "PVH",
    },
    {
      label: "(NPZ) Porter County Municipal Airport - United States",
      value: "NPZ",
    },
    { label: "(RBR) PlÃ¡cido de Castro - Brazil", value: "RBR" },
    { label: "(REC) Guararapes Gilberto Freyre Intl - Brazil", value: "REC" },
    { label: "(RIG) Rio Grande - Brazil", value: "RIG" },
    { label: "(SDU) Santos Dumont - Brazil", value: "SDU" },
    { label: "(RAO) Leite Lopes - Brazil", value: "RAO" },
    { label: "(STU) Santa Cruz - Brazil", value: "STU" },
    { label: "(SJK) Professor Urbano Ernesto Stumpf - Brazil", value: "SJK" },
    { label: "(SLZ) Marechal Cunha Machado Intl - Brazil", value: "SLZ" },
    { label: "(CGH) Congonhas - Brazil", value: "CGH" },
    { label: "(SJP) Sao Jose Do Rio Preto - Brazil", value: "SJP" },
    { label: "(SSZ) Base Aerea De Santos - Brazil", value: "SSZ" },
    { label: "(SSA) Deputado Luis Eduardo Magalhaes - Brazil", value: "SSA" },
    { label: "(TMT) Trombetas - Brazil", value: "TMT" },
    { label: "(THE) Senador Petronio Portella - Brazil", value: "THE" },
    { label: "(TFF) Tefe - Brazil", value: "TFF" },
    { label: "(TBT) Tabatinga - Brazil", value: "TBT" },
    { label: "(TUR) Tucurui - Brazil", value: "TUR" },
    { label: "(PAV) Paulo Afonso - Brazil", value: "PAV" },
    { label: "(URG) Rubem Berta - Brazil", value: "URG" },
    { label: "(UDI) Ten Cel Av Cesar Bombonato - Brazil", value: "UDI" },
    { label: "(UBA) Uberaba - Brazil", value: "UBA" },
    { label: "(VAG) Major Brigadeiro Trompowsky - Brazil", value: "VAG" },
    { label: "(BVH) Vilhena - Brazil", value: "BVH" },
    { label: "(VIX) Goiabeiras - Brazil", value: "VIX" },
    { label: "(QPS) Campo Fontenelle - Brazil", value: "QPS" },
    { label: "(ARI) Chacalluta - Chile", value: "ARI" },
    { label: "(BBA) Balmaceda - Chile", value: "BBA" },
    { label: "(CCH) Chile Chico - Chile", value: "CCH" },
    { label: "(CJC) El Loa - Chile", value: "CJC" },
    { label: "(PUQ) Carlos Ibanez Del Campo Intl - Chile", value: "PUQ" },
    { label: "(GXQ) Teniente Vidal - Chile", value: "GXQ" },
    { label: "(IQQ) Diego Aracena Intl - Chile", value: "IQQ" },
    { label: "(SCL) Arturo Merino Benitez Intl - Chile", value: "SCL" },
    { label: "(ANF) Cerro Moreno Intl - Chile", value: "ANF" },
    { label: "(LSQ) Maria Dolores - Chile", value: "LSQ" },
    { label: "(CCP) Carriel Sur Intl - Chile", value: "CCP" },
    { label: "(IPC) Mataveri Intl - Chile", value: "IPC" },
    { label: "(ZOS) Canal Bajo Carlos Hott Siebert - Chile", value: "ZOS" },
    { label: "(LSC) La Florida - Chile", value: "LSC" },
    { label: "(ZCO) Maquehue - Chile", value: "ZCO" },
    { label: "(PMC) El Tepual Intl - Chile", value: "PMC" },
    { label: "(WCH) Chaiten - Chile", value: "WCH" },
    { label: "(ZAL) Pichoy - Chile", value: "ZAL" },
    { label: "(ATF) Chachoan - Ecuador", value: "ATF" },
    { label: "(OCC) Francisco De Orellana - Ecuador", value: "OCC" },
    { label: "(CUE) Mariscal Lamar - Ecuador", value: "CUE" },
    { label: "(GPS) Seymour - Ecuador", value: "GPS" },
    { label: "(GYE) Jose Joaquin De Olmedo Intl - Ecuador", value: "GYE" },
    { label: "(XMS) Coronel E Carvajal - Ecuador", value: "XMS" },
    { label: "(MCH) General Manuel Serrano - Ecuador", value: "MCH" },
    { label: "(MEC) Eloy Alfaro Intl - Ecuador", value: "MEC" },
    { label: "(PVO) Reales Tamarindos - Ecuador", value: "PVO" },
    { label: "(UIO) Mariscal Sucre Intl - Ecuador", value: "UIO" },
    { label: "(SNC) General Ulpiano Paez - Ecuador", value: "SNC" },
    { label: "(TPC) Tarapoa - Ecuador", value: "TPC" },
    { label: "(TUA) Teniente Coronel Luis A Mantilla - Ecuador", value: "TUA" },
    { label: "(ASU) Silvio Pettirossi Intl - Paraguay", value: "ASU" },
    { label: "(AXM) El Eden - Colombia", value: "AXM" },
    { label: "(PUU) Tres De Mayo - Colombia", value: "PUU" },
    { label: "(BGA) Palonegro - Colombia", value: "BGA" },
    { label: "(BOG) Eldorado Intl - Colombia", value: "BOG" },
    { label: "(BAQ) Ernesto Cortissoz - Colombia", value: "BAQ" },
    { label: "(BSC) Jose Celestino Mutis - Colombia", value: "BSC" },
    { label: "(BUN) Gerardo Tobar Lopez - Colombia", value: "BUN" },
    { label: "(CUC) Camilo Daza - Colombia", value: "CUC" },
    { label: "(CTG) Rafael Nunez - Colombia", value: "CTG" },
    { label: "(CLO) Alfonso Bonilla Aragon Intl - Colombia", value: "CLO" },
    { label: "(TCO) La Florida - Colombia", value: "TCO" },
    { label: "(CZU) Las Brujas - Colombia", value: "CZU" },
    { label: "(EJA) Yariguies - Colombia", value: "EJA" },
    { label: "(FLA) Gustavo Artunduaga Paredes - Colombia", value: "FLA" },
    { label: "(MXY) McCarthy Airport - United States", value: "MXY" },
    { label: "(GPI) Juan Casiano - Colombia", value: "GPI" },
    { label: "(IBE) Perales - Colombia", value: "IBE" },
    { label: "(IPI) San Luis - Colombia", value: "IPI" },
    { label: "(LET) Alfredo Vasquez Cobo - Colombia", value: "LET" },
    { label: "(EOH) Olaya Herrera - Colombia", value: "EOH" },
    { label: "(MGN) Baracoa - Colombia", value: "MGN" },
    { label: "(MTR) Los Garzones - Colombia", value: "MTR" },
    { label: "(MVP) Fabio Alberto Leon Bentley - Colombia", value: "MVP" },
    { label: "(MZL) La Nubia - Colombia", value: "MZL" },
    { label: "(NVA) Benito Salas - Colombia", value: "NVA" },
    { label: "(OCV) Aguas Claras - Colombia", value: "OCV" },
    { label: "(OTU) Otu - Colombia", value: "OTU" },
    { label: "(PCR) Puerto Carreno - Colombia", value: "PCR" },
    { label: "(PEI) Matecana - Colombia", value: "PEI" },
    { label: "(PPN) Guillermo Leon Valencia - Colombia", value: "PPN" },
    { label: "(PSO) Antonio Narino - Colombia", value: "PSO" },
    { label: "(PVA) El Embrujo - Colombia", value: "PVA" },
    { label: "(MDE) Jose Maria Cordova - Colombia", value: "MDE" },
    { label: "(RCH) Almirante Padilla - Colombia", value: "RCH" },
    { label: "(SJE) Jorge E Gonzalez Torres - Colombia", value: "SJE" },
    { label: "(SMR) Simon Bolivar - Colombia", value: "SMR" },
    { label: "(ADZ) Gustavo Rojas Pinilla - Colombia", value: "ADZ" },
    { label: "(SVI) Eduardo Falla Solano - Colombia", value: "SVI" },
    { label: "(TME) Tame - Colombia", value: "TME" },
    { label: "(AUC) Santiago Perez - Colombia", value: "AUC" },
    { label: "(UIB) El Carano - Colombia", value: "UIB" },
    { label: "(ULQ) Farfan - Colombia", value: "ULQ" },
    { label: "(VUP) Alfonso Lopez Pumarejo - Colombia", value: "VUP" },
    { label: "(VVC) Vanguardia - Colombia", value: "VVC" },
    { label: "(BJO) Bermejo - Bolivia", value: "BJO" },
    { label: "(CBB) Jorge Wilsterman - Bolivia", value: "CBB" },
    { label: "(CIJ) Heroes Del Acre - Bolivia", value: "CIJ" },
    { label: "(LPB) El Alto Intl - Bolivia", value: "LPB" },
    { label: "(POI) Capitan Nicolas Rojas - Bolivia", value: "POI" },
    { label: "(PSZ) Tte De Av Salvador Ogaya G - Bolivia", value: "PSZ" },
    { label: "(SRE) Juana Azurduy De Padilla - Bolivia", value: "SRE" },
    { label: "(TJA) Capitan Oriel Lea Plaza - Bolivia", value: "TJA" },
    { label: "(TDD) Tte Av Jorge Henrich Arauz - Bolivia", value: "TDD" },
    { label: "(VVI) Viru Viru Intl - Bolivia", value: "VVI" },
    { label: "(BYC) Yacuiba - Bolivia", value: "BYC" },
    { label: "(PBM) Johan A Pengel Intl - Surilabel", value: "PBM" },
    { label: "(CAY) Rochambeau - French Guiana", value: "CAY" },
    { label: "(SWD) Seward Airport - United States", value: "SWD" },
    { label: "(PCL) Cap Fap David Abenzur Rengifo Intl - Peru", value: "PCL" },
    {
      label: "(CHM) Teniente Jaime A De Montreuil Morales - Peru",
      value: "CHM",
    },
    { label: "(CIX) Capt Jose A Quinones Gonzales Intl - Peru", value: "CIX" },
    { label: "(AYP) Coronel Fap Alfredo Mendivil Duarte - Peru", value: "AYP" },
    { label: "(ANS) Andahuaylas - Peru", value: "ANS" },
    {
      label: "(ATA) Comandante Fap German Arias Graziani - Peru",
      value: "ATA",
    },
    { label: "(LIM) Jorge Chavez Intl - Peru", value: "LIM" },
    { label: "(JJI) Juanjui - Peru", value: "JJI" },
    { label: "(JUL) Juliaca - Peru", value: "JUL" },
    {
      label: "(MGC) Michigan City Municipal Airport - United States",
      value: "MGC",
    },
    { label: "(TBP) Pedro Canga - Peru", value: "TBP" },
    { label: "(YMS) Moises Benzaquen Rengifo - Peru", value: "YMS" },
    { label: "(CHH) Chachapoyas - Peru", value: "CHH" },
    {
      label: "(IQT) Coronel Francisco Secada Vignetta Intl - Peru",
      value: "IQT",
    },
    { label: "(AQP) Rodriguez Ballon - Peru", value: "AQP" },
    { label: "(TRU) Capitan Carlos Martinez De Pinillos - Peru", value: "TRU" },
    { label: "(PIO) Pisco Intl - Peru", value: "PIO" },
    {
      label: "(TPP) Cadete Guillermo Del Castillo Paredes - Peru",
      value: "TPP",
    },
    {
      label: "(TCQ) Coronel Carlos Ciriani Santa Rosa Intl - Peru",
      value: "TCQ",
    },
    { label: "(PEM) Padre Aldamiz - Peru", value: "PEM" },
    {
      label: "(PIU) Capitan Fap Guillermo Concha Iberico - Peru",
      value: "PIU",
    },
    { label: "(TYL) Capitan Montes - Peru", value: "TYL" },
    {
      label: "(CUZ) Teniente Alejandro Velasco Astete Intl - Peru",
      value: "CUZ",
    },
    { label: "(MVD) Carrasco Intl - Uruguay", value: "MVD" },
    { label: "(STY) Nueva Hesperides Intl - Uruguay", value: "STY" },
    { label: "(AGV) Oswaldo Guevara Mujica - Venezuela", value: "AGV" },
    { label: "(AAO) Anaco - Venezuela", value: "AAO" },
    {
      label: "(BLA) General Jose Antonio Anzoategui Intl - Venezuela",
      value: "BLA",
    },
    { label: "(BNS) Barinas - Venezuela", value: "BNS" },
    { label: "(BRM) Barquisimeto Intl - Venezuela", value: "BRM" },
    { label: "(CBL) Ciudad Bolivar - Venezuela", value: "CBL" },
    { label: "(CAJ) Canaima - Venezuela", value: "CAJ" },
    {
      label: "(CUP) General Jose Francisco Bermudez - Venezuela",
      value: "CUP",
    },
    { label: "(CZE) Jose Leonardo Chirinos - Venezuela", value: "CZE" },
    { label: "(CUM) Antonio Jose De Sucre - Venezuela", value: "CUM" },
    { label: "(GUI) Guiria - Venezuela", value: "GUI" },
    { label: "(GUQ) Guanare - Venezuela", value: "GUQ" },
    { label: "(LSP) Josefa Camejo - Venezuela", value: "LSP" },
    { label: "(LFR) La Fria - Venezuela", value: "LFR" },
    { label: "(MAR) La Chinita Intl - Venezuela", value: "MAR" },
    { label: "(MRD) Alberto Carnevalli - Venezuela", value: "MRD" },
    {
      label: "(PMV) Del Caribe Intl Gen Santiago Marino - Venezuela",
      value: "PMV",
    },
    { label: "(CCS) Simon Bolivar Intl - Venezuela", value: "CCS" },
    { label: "(MUN) Maturin - Venezuela", value: "MUN" },
    { label: "(PYH) Casique Aramare - Venezuela", value: "PYH" },
    { label: "(PBL) General Bartolome Salom Intl - Venezuela", value: "PBL" },
    { label: "(PZO) General Manuel Carlos Piar - Venezuela", value: "PZO" },
    { label: "(SVZ) San Antonio Del Tachira - Venezuela", value: "SVZ" },
    { label: "(STD) Mayor Buenaventura Vivas - Venezuela", value: "STD" },
    { label: "(SFH) Sub Teniente Nestor Arias - Venezuela", value: "SFH" },
    { label: "(SFD) San Fernando De Apure - Venezuela", value: "SFD" },
    { label: "(SOM) San Tome - Venezuela", value: "SOM" },
    { label: "(STB) Santa Barbara Del Zulia - Venezuela", value: "STB" },
    { label: "(TUV) Tucupita - Venezuela", value: "TUV" },
    { label: "(VLN) Arturo Michelena Intl - Venezuela", value: "VLN" },
    { label: "(VLV) Dr Antonio Nicolas Briceno - Venezuela", value: "VLV" },
    { label: "(VDP) Valle De La Pascua - Venezuela", value: "VDP" },
    { label: "(LTM) Lethem - Guyana", value: "LTM" },
    { label: "(ANU) V C Bird Intl - Antigua and Barbuda", value: "ANU" },
    { label: "(BGI) Grantley Adams Intl - Barbados", value: "BGI" },
    { label: "(DCF) Canefield - Dominica", value: "DCF" },
    { label: "(DOM) Melville Hall - Dominica", value: "DOM" },
    { label: "(FDF) Le Lamentin - Martinique", value: "FDF" },
    { label: "(SFG) Grand Case - Guadeloupe", value: "SFG" },
    { label: "(PTP) Le Raizet - Guadeloupe", value: "PTP" },
    { label: "(GND) Point Salines Intl - Grenada", value: "GND" },
    { label: "(STT) Cyril E King - Virgin Islands", value: "STT" },
    { label: "(STX) Henry E Rohlsen - Virgin Islands", value: "STX" },
    { label: "(BQN) Rafael Hernandez - Puerto Rico", value: "BQN" },
    { label: "(FAJ) Diego Jimenez Torres - Puerto Rico", value: "FAJ" },
    {
      label: "(SIG) Fernando Luis Ribas Dominicci - Puerto Rico",
      value: "SIG",
    },
    { label: "(MAZ) Eugenio Maria De Hostos - Puerto Rico", value: "MAZ" },
    { label: "(PSE) Mercedita - Puerto Rico", value: "PSE" },
    { label: "(SJU) Luis Munoz Marin Intl - Puerto Rico", value: "SJU" },
    { label: "(SKB) Robert L Bradshaw - Saint Kitts and Nevis", value: "SKB" },
    { label: "(SLU) George F L Charles - Saint Lucia", value: "SLU" },
    { label: "(UVF) Hewanorra Intl - Saint Lucia", value: "UVF" },
    { label: "(AUA) Reina Beatrix Intl - Aruba", value: "AUA" },
    { label: "(BON) Flamingo - Netherlands Antilles", value: "BON" },
    { label: "(CUR) Hato - Netherlands Antilles", value: "CUR" },
    { label: "(EUX) F D Roosevelt - Netherlands Antilles", value: "EUX" },
    {
      label: "(SXM) Princess Juliana Intl - Netherlands Antilles",
      value: "SXM",
    },
    { label: "(AXA) Wallblake - Anguilla", value: "AXA" },
    { label: "(TAB) Crown Point - Trinidad and Tobago", value: "TAB" },
    { label: "(POS) Piarco - Trinidad and Tobago", value: "POS" },
    {
      label: "(EIS) Terrance B Lettsome Intl - British Virgin Islands",
      value: "EIS",
    },
    { label: "(AET) Allakaket Airport - United States", value: "AET" },
    { label: "(CIW) Canouan - Saint Vincent and the Grenadines", value: "CIW" },
    {
      label: "(MQS) Mustique - Saint Vincent and the Grenadines",
      value: "MQS",
    },
    {
      label: "(SVD) E T Joshua - Saint Vincent and the Grenadines",
      value: "SVD",
    },
    { label: "(ALA) Almaty - Kazakhstan", value: "ALA" },
    { label: "(TSE) Astana Intl - Kazakhstan", value: "TSE" },
    { label: "(DMB) Taraz - Kazakhstan", value: "DMB" },
    { label: "(FRU) Manas - Kyrgyzstan", value: "FRU" },
    { label: "(OSS) Osh - Kyrgyzstan", value: "OSS" },
    { label: "(CIT) Shymkent - Kazakhstan", value: "CIT" },
    { label: "(YAK) Yakutat - United States", value: "YAK" },
    { label: "(URA) Uralsk - Kazakhstan", value: "URA" },
    { label: "(PWQ) Pavlodar - Kazakhstan", value: "PWQ" },
    { label: "(PLX) Semipalatinsk - Kazakhstan", value: "PLX" },
    { label: "(AKX) Aktyubinsk - Kazakhstan", value: "AKX" },
    { label: "(GYD) Heydar Aliyev - Azerbaijan", value: "GYD" },
    { label: "(YKS) Yakutsk - Russia", value: "YKS" },
    { label: "(MJZ) Mirny - Russia", value: "MJZ" },
    { label: "(BQS) Ignatyevo - Russia", value: "BQS" },
    { label: "(KHV) Novy - Russia", value: "KHV" },
    {
      label: "(MQT) Sawyer International Airport - United States",
      value: "MQT",
    },
    { label: "(PVS) Provideniya Bay - Russia", value: "PVS" },
    { label: "(GDX) Sokol - Russia", value: "GDX" },
    { label: "(PWE) Pevek - Russia", value: "PWE" },
    { label: "(PKC) Yelizovo - Russia", value: "PKC" },
    { label: "(UUS) Khomutovo - Russia", value: "UUS" },
    { label: "(VVO) Knevichi - Russia", value: "VVO" },
    { label: "(HTA) Kadala - Russia", value: "HTA" },
    { label: "(BTK) Bratsk - Russia", value: "BTK" },
    { label: "(IKT) Irkutsk - Russia", value: "IKT" },
    { label: "(UUD) Mukhino - Russia", value: "UUD" },
    { label: "(KBP) Boryspil Intl - Ukraine", value: "KBP" },
    { label: "(DOK) Donetsk Intl - Ukraine", value: "DOK" },
    { label: "(DNK) Dnipropetrovsk Intl - Ukraine", value: "DNK" },
    { label: "(SIP) Simferopol Intl - Ukraine", value: "SIP" },
    { label: "(IEV) Zhuliany Intl - Ukraine", value: "IEV" },
    { label: "(LWO) Lviv Intl - Ukraine", value: "LWO" },
    { label: "(IMT) Ford Airport - United States", value: "IMT" },
    { label: "(ODS) Odesa Intl - Ukraine", value: "ODS" },
    { label: "(LED) Pulkovo - Russia", value: "LED" },
    { label: "(MMK) Murmansk - Russia", value: "MMK" },
    { label: "(GME) Gomel - Belarus", value: "GME" },
    { label: "(VTB) Vitebsk - Belarus", value: "VTB" },
    { label: "(KGD) Khrabrovo - Russia", value: "KGD" },
    { label: "(MHP) Minsk 1 - Belarus", value: "MHP" },
    { label: "(MSQ) Minsk 2 - Belarus", value: "MSQ" },
    { label: "(ABA) Abakan - Russia", value: "ABA" },
    { label: "(BAX) Barnaul - Russia", value: "BAX" },
    { label: "(KEJ) Kemerovo - Russia", value: "KEJ" },
    { label: "(OMS) Omsk - Russia", value: "OMS" },
    { label: "(KRR) Pashkovskiy - Russia", value: "KRR" },
    { label: "(MCX) Uytash - Russia", value: "MCX" },
    { label: "(MRV) Mineralnyye Vody - Russia", value: "MRV" },
    { label: "(STW) Shpakovskoye - Russia", value: "STW" },
    { label: "(ROV) Rostov Na Donu - Russia", value: "ROV" },
    { label: "(AER) Sochi - Russia", value: "AER" },
    { label: "(ASF) Astrakhan - Russia", value: "ASF" },
    { label: "(VOG) Gumrak - Russia", value: "VOG" },
    { label: "(CEK) Balandino - Russia", value: "CEK" },
    { label: "(MQF) Magnitogorsk - Russia", value: "MQF" },
    { label: "(GBZ) Great Barrier Island - New Zealand", value: "GBZ" },
    { label: "(NJC) Nizhnevartovsk - Russia", value: "NJC" },
    { label: "(PEE) Bolshoye Savino - Russia", value: "PEE" },
    { label: "(SGC) Surgut - Russia", value: "SGC" },
    { label: "(SVX) Koltsovo - Russia", value: "SVX" },
    { label: "(ASB) Ashgabat - Turkmenistan", value: "ASB" },
    { label: "(KRW) Turkmenbashi - Turkmenistan", value: "KRW" },
    { label: "(DYU) Dushanbe - Tajikistan", value: "DYU" },
    { label: "(BHK) Bukhara - Uzbekistan", value: "BHK" },
    { label: "(SKD) Samarkand - Uzbekistan", value: "SKD" },
    { label: "(IUD) Al Udeid AB - Qatar", value: "IUD" },
    { label: "(TAS) Yuzhny - Uzbekistan", value: "TAS" },
    { label: "(BZK) Bryansk - Russia", value: "BZK" },
    { label: "(SVO) Sheremetyevo - Russia", value: "SVO" },
    { label: "(KLD) Migalovo - Russia", value: "KLD" },
    { label: "(VOZ) Chertovitskoye - Russia", value: "VOZ" },
    { label: "(VKO) Vnukovo - Russia", value: "VKO" },
    { label: "(SCW) Syktyvkar - Russia", value: "SCW" },
    { label: "(KZN) Kazan - Russia", value: "KZN" },
    { label: "(REN) Orenburg - Russia", value: "REN" },
    { label: "(UFA) Ufa - Russia", value: "UFA" },
    { label: "(KBY) Kurumoch - Russia", value: "KBY" },
    { label: "(AMD) Ahmedabad - India", value: "AMD" },
    { label: "(AKD) Akola - India", value: "AKD" },
    { label: "(IXU) Aurangabad - India", value: "IXU" },
    { label: "(BOM) Chhatrapati Shivaji Intl - India", value: "BOM" },
    { label: "(PAB) Bilaspur - India", value: "PAB" },
    { label: "(BHJ) Bhuj - India", value: "BHJ" },
    { label: "(IXG) Belgaum - India", value: "IXG" },
    { label: "(BDQ) Vadodara - India", value: "BDQ" },
    { label: "(BHO) Bhopal - India", value: "BHO" },
    { label: "(BHU) Bhavnagar - India", value: "BHU" },
    { label: "(NMB) Daman - India", value: "NMB" },
    { label: "(GOI) Goa - India", value: "GOI" },
    { label: "(IDR) Devi Ahilyabai Holkar - India", value: "IDR" },
    { label: "(JLR) Jabalpur - India", value: "JLR" },
    { label: "(JGA) Jamnagar - India", value: "JGA" },
    { label: "(IXY) Kandla - India", value: "IXY" },
    { label: "(HJR) Khajuraho - India", value: "HJR" },
    { label: "(KLH) Kolhapur - India", value: "KLH" },
    { label: "(IXK) Keshod - India", value: "IXK" },
    { label: "(NAG) Dr Ambedkar Intl - India", value: "NAG" },
    { label: "(ISK) Nasik Road - India", value: "ISK" },
    { label: "(PNQ) Pune - India", value: "PNQ" },
    { label: "(PBD) Porbandar - India", value: "PBD" },
    { label: "(RAJ) Rajkot - India", value: "RAJ" },
    { label: "(RPR) Raipur - India", value: "RPR" },
    { label: "(SSE) Sholapur - India", value: "SSE" },
    { label: "(STV) Surat - India", value: "STV" },
    { label: "(UDR) Udaipur - India", value: "UDR" },
    { label: "(CMB) Bandaranaike Intl Colombo - Sri Lanka", value: "CMB" },
    { label: "(RML) Colombo Ratmalana - Sri Lanka", value: "RML" },
    { label: "(GOY) Amparai - Sri Lanka", value: "GOY" },
    { label: "(JAF) Kankesanturai - Sri Lanka", value: "JAF" },
    { label: "(TRR) China Bay - Sri Lanka", value: "TRR" },
    { label: "(KIK) Kirkuk AB - Iraq", value: "KIK" },
    { label: "(PNH) Phnom Penh Intl - Cambodia", value: "PNH" },
    { label: "(REP) Siem Reap - Cambodia", value: "REP" },
    { label: "(IXA) Agartala - India", value: "IXA" },
    { label: "(AJL) Aizawl - India", value: "AJL" },
    { label: "(IXB) Bagdogra - India", value: "IXB" },
    { label: "(BBI) Bhubaneshwar - India", value: "BBI" },
    { label: "(CCU) Netaji Subhash Chandra Bose Intl - India", value: "CCU" },
    { label: "(COH) Cooch Behar - India", value: "COH" },
    { label: "(DBD) Dhanbad - India", value: "DBD" },
    { label: "(ESC) Delta County Airport - United States", value: "ESC" },
    { label: "(GAY) Gaya - India", value: "GAY" },
    { label: "(IMF) Imphal - India", value: "IMF" },
    { label: "(IXW) Jamshedpur - India", value: "IXW" },
    { label: "(JRH) Jorhat - India", value: "JRH" },
    { label: "(IXH) Kailashahar - India", value: "IXH" },
    { label: "(IXS) Silchar - India", value: "IXS" },
    { label: "(IXI) Lilabari - India", value: "IXI" },
    { label: "(MOH) Dibrugarh - India", value: "MOH" },
    { label: "(PAT) Patna - India", value: "PAT" },
    { label: "(IXR) Birsa Munda - India", value: "IXR" },
    { label: "(RRK) Rourkela - India", value: "RRK" },
    { label: "(VTZ) Vishakhapatnam - India", value: "VTZ" },
    { label: "(CXB) Coxs Bazar - Bangladesh", value: "CXB" },
    { label: "(CGP) Shah Amanat Intl - Bangladesh", value: "CGP" },
    { label: "(IRD) Ishurdi - Bangladesh", value: "IRD" },
    { label: "(JSR) Jessore - Bangladesh", value: "JSR" },
    { label: "(RJH) Shah Mokhdum - Bangladesh", value: "RJH" },
    { label: "(SPD) Saidpur - Bangladesh", value: "SPD" },
    { label: "(ZYL) Osmany Intl - Bangladesh", value: "ZYL" },
    { label: "(DAC) Zia Intl - Bangladesh", value: "DAC" },
    { label: "(HKG) Hong Kong Intl - Hong Kong", value: "HKG" },
    { label: "(AGR) Agra - India", value: "AGR" },
    { label: "(IXD) Allahabad - India", value: "IXD" },
    { label: "(ATQ) Amritsar - India", value: "ATQ" },
    { label: "(VNS) Varanasi - India", value: "VNS" },
    { label: "(KUU) Kullu Manali - India", value: "KUU" },
    { label: "(IXC) Chandigarh - India", value: "IXC" },
    { label: "(DED) Dehradun - India", value: "DED" },
    { label: "(DEL) Indira Gandhi Intl - India", value: "DEL" },
    { label: "(GWL) Gwalior - India", value: "GWL" },
    { label: "(JDH) Jodhpur - India", value: "JDH" },
    { label: "(JAI) Jaipur - India", value: "JAI" },
    { label: "(JSA) Jaisalmer - India", value: "JSA" },
    { label: "(IXJ) Jammu - India", value: "IXJ" },
    { label: "(KNU) Kanpur - India", value: "KNU" },
    { label: "(KTU) Kota - India", value: "KTU" },
    { label: "(LUH) Ludhiana - India", value: "LUH" },
    { label: "(IXL) Leh - India", value: "IXL" },
    { label: "(LKO) Lucknow - India", value: "LKO" },
    { label: "(IXP) Pathankot - India", value: "IXP" },
    { label: "(PGH) Pantnagar - India", value: "PGH" },
    { label: "(SXR) Srinagar - India", value: "SXR" },
    { label: "(TNI) Satna - India", value: "TNI" },
    { label: "(BXH) Balkhash Airport - Kazakhstan", value: "BXH" },
    { label: "(LPQ) Luang Phabang Intl - Laos", value: "LPQ" },
    { label: "(PKZ) Pakse - Laos", value: "PKZ" },
    { label: "(ZVK) Savannakhet - Laos", value: "ZVK" },
    { label: "(VTE) Wattay Intl - Laos", value: "VTE" },
    { label: "(MFM) Macau Intl - Macau", value: "MFM" },
    { label: "(BWA) Bhairahawa - Nepal", value: "BWA" },
    { label: "(KTM) Tribhuvan Intl - Nepal", value: "KTM" },
    { label: "(PKR) Pokhara - Nepal", value: "PKR" },
    { label: "(SIF) Simara - Nepal", value: "SIF" },
    { label: "(BIR) Biratnagar - Nepal", value: "BIR" },
    { label: "(AGX) Agatti - India", value: "AGX" },
    { label: "(BLR) Bangalore - India", value: "BLR" },
    { label: "(BEP) Bellary - India", value: "BEP" },
    { label: "(VGA) Vijayawada - India", value: "VGA" },
    { label: "(CJB) Coimbatore - India", value: "CJB" },
    { label: "(COK) Cochin - India", value: "COK" },
    { label: "(CCJ) Calicut - India", value: "CCJ" },
    { label: "(CDP) Cuddapah - India", value: "CDP" },
    { label: "(HYD) Hyderabad - India", value: "HYD" },
    { label: "(IXM) Madurai - India", value: "IXM" },
    { label: "(IXE) Mangalore - India", value: "IXE" },
    { label: "(MAA) Chennai Intl - India", value: "MAA" },
    { label: "(IXZ) Port Blair - India", value: "IXZ" },
    { label: "(PNY) Pondicherry - India", value: "PNY" },
    { label: "(RJA) Rajahmundry - India", value: "RJA" },
    { label: "(TIR) Tirupati - India", value: "TIR" },
    { label: "(TRZ) Trichy - India", value: "TRZ" },
    { label: "(TRV) Thiruvananthapuram Intl - India", value: "TRV" },
    { label: "(PBH) Paro - Bhutan", value: "PBH" },
    { label: "(MLE) Male Intl - Maldives", value: "MLE" },
    { label: "(DMK) Don Muang Intl - Thailand", value: "DMK" },
    { label: "(NAH) Naha - Indonesia", value: "NAH" },
    { label: "(UTP) U Taphao Intl - Thailand", value: "UTP" },
    { label: "(LPT) Lampang - Thailand", value: "LPT" },
    { label: "(PRH) Phrae - Thailand", value: "PRH" },
    { label: "(HHQ) Hua Hin - Thailand", value: "HHQ" },
    { label: "(PHS) Phitsanulok - Thailand", value: "PHS" },
    { label: "(NAW) Narathiwat - Thailand", value: "NAW" },
    { label: "(KBV) Krabi - Thailand", value: "KBV" },
    { label: "(PAN) Pattani - Thailand", value: "PAN" },
    { label: "(USM) Samui - Thailand", value: "USM" },
    { label: "(HKT) Phuket Intl - Thailand", value: "HKT" },
    { label: "(HDY) Hat Yai Intl - Thailand", value: "HDY" },
    { label: "(TST) Trang - Thailand", value: "TST" },
    { label: "(UTH) Udon Thani - Thailand", value: "UTH" },
    { label: "(SNO) Sakon Nakhon - Thailand", value: "SNO" },
    { label: "(LOE) Loei - Thailand", value: "LOE" },
    { label: "(OKB) Orchid Beach - Australia", value: "OKB" },
    { label: "(DAD) Danang Intl - Vietnam", value: "DAD" },
    { label: "(HAN) Noibai Intl - Vietnam", value: "HAN" },
    { label: "(NHA) Nhatrang - Vietnam", value: "NHA" },
    { label: "(SGN) Tansonnhat Intl - Vietnam", value: "SGN" },
    { label: "(BMQ) Bamburi - Kenya", value: "BMQ" },
    { label: "(HEH) Heho - Burma", value: "HEH" },
    { label: "(KET) Kengtung - Burma", value: "KET" },
    {
      label: "(MWA) Williamson Country Regional Airport - United States",
      value: "MWA",
    },
    { label: "(KYP) Kyaukpyu - Burma", value: "KYP" },
    { label: "(LSH) Lashio - Burma", value: "LSH" },
    { label: "(MDL) Mandalay Intl - Burma", value: "MDL" },
    { label: "(MGZ) Myeik - Burma", value: "MGZ" },
    { label: "(MYT) Myitkyina - Burma", value: "MYT" },
    { label: "(MOG) Mong Hsat - Burma", value: "MOG" },
    { label: "(PBU) Putao - Burma", value: "PBU" },
    { label: "(AKY) Sittwe - Burma", value: "AKY" },
    { label: "(SNW) Thandwe - Burma", value: "SNW" },
    { label: "(THL) Tachileik - Burma", value: "THL" },
    { label: "(RGN) Yangon Intl - Burma", value: "RGN" },
    { label: "(UPG) Hasanuddin - Indonesia", value: "UPG" },
    { label: "(BIK) Frans Kaisiepo - Indonesia", value: "BIK" },
    { label: "(NBX) Nabire - Indonesia", value: "NBX" },
    { label: "(TIM) Moses Kilangin - Indonesia", value: "TIM" },
    { label: "(DJJ) Sentani - Indonesia", value: "DJJ" },
    { label: "(WMX) Wamena - Indonesia", value: "WMX" },
    { label: "(MKQ) Mopah - Indonesia", value: "MKQ" },
    { label: "(GTO) Jalaluddin - Indonesia", value: "GTO" },
    { label: "(ICN) Incheon Intl - South Korea", value: "ICN" },
    { label: "(PLW) Mutiara - Indonesia", value: "PLW" },
    { label: "(MDC) Sam Ratulangi - Indonesia", value: "MDC" },
    { label: "(PSJ) Kasiguncu - Indonesia", value: "PSJ" },
    { label: "(OTI) Pitu - Indonesia", value: "OTI" },
    { label: "(TTE) Sultan Babullah - Indonesia", value: "TTE" },
    { label: "(LUW) Bubung - Indonesia", value: "LUW" },
    { label: "(AMQ) Pattimura - Indonesia", value: "AMQ" },
    { label: "(FKQ) Fak Fak - Indonesia", value: "FKQ" },
    { label: "(KNG) Kaimana - Indonesia", value: "KNG" },
    { label: "(BXB) Babo - Indonesia", value: "BXB" },
    { label: "(MKW) Rendani - Indonesia", value: "MKW" },
    { label: "(SOQ) Jefman - Indonesia", value: "SOQ" },
    { label: "(BTU) Bintulu - Malaysia", value: "BTU" },
    { label: "(KCH) Kuching Intl - Malaysia", value: "KCH" },
    { label: "(LMN) Limbang - Malaysia", value: "LMN" },
    { label: "(MUR) Marudi - Malaysia", value: "MUR" },
    { label: "(MYY) Miri - Malaysia", value: "MYY" },
    { label: "(SBW) Sibu - Malaysia", value: "SBW" },
    { label: "(LDU) Lahad Datu - Malaysia", value: "LDU" },
    { label: "(BKI) Kota Kinabalu Intl - Malaysia", value: "BKI" },
    { label: "(LBU) Labuan - Malaysia", value: "LBU" },
    { label: "(TWU) Tawau - Malaysia", value: "TWU" },
    { label: "(BWN) Brunei Intl - Brunei", value: "BWN" },
    { label: "(PKU) Sultan Syarif Kasim Ii - Indonesia", value: "PKU" },
    { label: "(DUM) Pinang Kampai - Indonesia", value: "DUM" },
    { label: "(CGK) Soekarno Hatta Intl - Indonesia", value: "CGK" },
    { label: "(GNS) Binaka - Indonesia", value: "GNS" },
    { label: "(PDG) Minangkabau - Indonesia", value: "PDG" },
    { label: "(MES) Polonia - Indonesia", value: "MES" },
    { label: "(KTG) Rahadi Usman - Indonesia", value: "KTG" },
    { label: "(PNK) Supadio - Indonesia", value: "PNK" },
    { label: "(DJB) Sultan Thaha - Indonesia", value: "DJB" },
    { label: "(BKS) Fatmawati Soekarno - Indonesia", value: "BKS" },
    { label: "(PLM) Sultan Mahmud Badaruddin Ii - Indonesia", value: "PLM" },
    { label: "(RGT) Japura - Indonesia", value: "RGT" },
    { label: "(BZY) Balti International Airport - Moldova", value: "BZY" },
    { label: "(BTJ) Sultan Iskandarmuda - Indonesia", value: "BTJ" },
    { label: "(AOR) Sultan Abdul Halim - Malaysia", value: "AOR" },
    { label: "(KBR) Sultan Ismail Petra - Malaysia", value: "KBR" },
    { label: "(KUA) Kuantan - Malaysia", value: "KUA" },
    { label: "(KTE) Kerteh - Malaysia", value: "KTE" },
    { label: "(IPH) Sultan Azlan Shah - Malaysia", value: "IPH" },
    { label: "(JHB) Sultan Ismail - Malaysia", value: "JHB" },
    { label: "(KUL) Kuala Lumpur Intl - Malaysia", value: "KUL" },
    { label: "(LGK) Langkawi Intl - Malaysia", value: "LGK" },
    { label: "(MKZ) Malacca - Malaysia", value: "MKZ" },
    { label: "(TGG) Sultan Mahmud - Malaysia", value: "TGG" },
    { label: "(PEN) Penang Intl - Malaysia", value: "PEN" },
    {
      label: "(DIL) Presidente Nicolau Lobato Intl - East Timor",
      value: "DIL",
    },
    { label: "(QPG) Paya Lebar - Singapore", value: "QPG" },
    { label: "(XSP) Seletar - Singapore", value: "XSP" },
    { label: "(SIN) Changi Intl - Singapore", value: "SIN" },
    { label: "(ABM) Bamaga Injinoo - Australia", value: "ABM" },
    { label: "(ASP) Alice Springs - Australia", value: "ASP" },
    { label: "(BNE) Brisbane Intl - Australia", value: "BNE" },
    { label: "(OOL) Gold Coast - Australia", value: "OOL" },
    { label: "(CNS) Cairns Intl - Australia", value: "CNS" },
    { label: "(CTL) Charleville - Australia", value: "CTL" },
    { label: "(ISA) Mount Isa - Australia", value: "ISA" },
    { label: "(MCY) Sunshine Coast - Australia", value: "MCY" },
    { label: "(MKY) Mackay - Australia", value: "MKY" },
    { label: "(PPP) Proserpine Whitsunday Coast - Australia", value: "PPP" },
    { label: "(ROK) Rockhampton - Australia", value: "ROK" },
    { label: "(TSV) Townsville - Australia", value: "TSV" },
    { label: "(WEI) Weipa - Australia", value: "WEI" },
    { label: "(AVV) Avalon - Australia", value: "AVV" },
    { label: "(ABX) Albury - Australia", value: "ABX" },
    { label: "(MEB) Melbourne Essendon - Australia", value: "MEB" },
    { label: "(HBA) Hobart - Australia", value: "HBA" },
    { label: "(LST) Launceston - Australia", value: "LST" },
    { label: "(MBW) Melbourne Moorabbin - Australia", value: "MBW" },
    { label: "(MEL) Melbourne Intl - Australia", value: "MEL" },
    { label: "(ADL) Adelaide Intl - Australia", value: "ADL" },
    { label: "(JAD) Perth Jandakot - Australia", value: "JAD" },
    { label: "(KTA) Karratha - Australia", value: "KTA" },
    { label: "(KGI) Kalgoorlie Boulder - Australia", value: "KGI" },
    { label: "(KNX) Kununurra - Australia", value: "KNX" },
    { label: "(LEA) Learmonth - Australia", value: "LEA" },
    { label: "(PHE) Port Hedland Intl - Australia", value: "PHE" },
    { label: "(PER) Perth Intl - Australia", value: "PER" },
    { label: "(UMR) Woomera - Australia", value: "UMR" },
    { label: "(XCH) Christmas Island - Christmas Island", value: "XCH" },
    { label: "(BWU) Sydney Bankstown - Australia", value: "BWU" },
    { label: "(CBR) Canberra - Australia", value: "CBR" },
    { label: "(CFS) Coffs Harbour - Australia", value: "CFS" },
    { label: "(CDU) Camden - Australia", value: "CDU" },
    { label: "(DBO) Dubbo - Australia", value: "DBO" },
    { label: "(NLK) Norfolk Island Intl - Norfolk Island", value: "NLK" },
    { label: "(RCM) Richmond - Australia", value: "RCM" },
    { label: "(SYD) Sydney Intl - Australia", value: "SYD" },
    { label: "(TMW) Tamworth - Australia", value: "TMW" },
    { label: "(WGA) Wagga Wagga - Australia", value: "WGA" },
    { label: "(PEK) Capital Intl - China", value: "PEK" },
    { label: "(HLD) Dongshan - China", value: "HLD" },
    { label: "(TSN) Binhai - China", value: "TSN" },
    { label: "(TYN) Wusu - China", value: "TYN" },
    { label: "(CAN) Baiyun Intl - China", value: "CAN" },
    { label: "(CSX) Huanghua - China", value: "CSX" },
    { label: "(KWL) Liangjiang - China", value: "KWL" },
    { label: "(NNG) Wuxu - China", value: "NNG" },
    { label: "(SZX) Baoan Intl - China", value: "SZX" },
    { label: "(CGO) Xinzheng - China", value: "CGO" },
    { label: "(WUH) Tianhe - China", value: "WUH" },
    { label: "(FNJ) Pyongyang Intl - Korea", value: "FNJ" },
    { label: "(ZGC) Zhongchuan - China", value: "ZGC" },
    { label: "(XIY) Xianyang - China", value: "XIY" },
    { label: "(ULN) Chinggis Khaan Intl - Mongolia", value: "ULN" },
    { label: "(KMG) Wujiaba - China", value: "KMG" },
    { label: "(XMN) Gaoqi - China", value: "XMN" },
    { label: "(KHN) Changbei Intl - China", value: "KHN" },
    { label: "(FOC) Changle - China", value: "FOC" },
    { label: "(HGH) Xiaoshan - China", value: "HGH" },
    { label: "(NGB) Lishe - China", value: "NGB" },
    { label: "(NKG) Lukou - China", value: "NKG" },
    { label: "(HFE) Luogang - China", value: "HFE" },
    { label: "(TAO) Liuting - China", value: "TAO" },
    { label: "(SHA) Hongqiao Intl - China", value: "SHA" },
    { label: "(YNT) Laishan - China", value: "YNT" },
    { label: "(CKG) Jiangbei - China", value: "CKG" },
    { label: "(KWE) Longdongbao - China", value: "KWE" },
    { label: "(CTU) Shuangliu - China", value: "CTU" },
    { label: "(XIC) Qingshan - China", value: "XIC" },
    { label: "(KHG) Kashi - China", value: "KHG" },
    { label: "(HTN) Hotan - China", value: "HTN" },
    { label: "(URC) Diwopu - China", value: "URC" },
    { label: "(HRB) Taiping - China", value: "HRB" },
    { label: "(HOJ) Hohenems - Austria", value: "HOJ" },
    { label: "(DLC) Zhoushuizi - China", value: "DLC" },
    { label: "(PVG) Pudong - China", value: "PVG" },
    { label: "(TOD) Pulau Tioman - Malaysia", value: "TOD" },
    {
      label: "(SZB) Subang-Sultan Abdul Aziz Shah Intl - Malaysia",
      value: "SZB",
    },
    { label: "(NTQ) Noto - Japan", value: "NTQ" },
    { label: "(HBE) Borg El Arab Intl - Egypt", value: "HBE" },
    { label: "(BTI) Barter Island Lrrs - United States", value: "BTI" },
    { label: "(K03) Wainwright As - United States", value: "K03" },
    { label: "(LUR) Cape Lisburne Lrrs - United States", value: "LUR" },
    { label: "(PIZ) Point Lay Lrrs - United States", value: "PIZ" },
    { label: "(ITO) Hilo Intl - United States", value: "ITO" },
    { label: "(ORL) Executive - United States", value: "ORL" },
    { label: "(BTT) Bettles - United States", value: "BTT" },
    { label: "(Z84) Clear - United States", value: "Z84" },
    { label: "(UTO) Indian Mountain Lrrs - United States", value: "UTO" },
    { label: "(FYU) Fort Yukon - United States", value: "FYU" },
    { label: "(SVW) Sparrevohn Lrrs - United States", value: "SVW" },
    { label: "(FRN) Bryant Ahp - United States", value: "FRN" },
    { label: "(TLJ) Tatalina Lrrs - United States", value: "TLJ" },
    { label: "(CZF) Cape Romanzof Lrrs - United States", value: "CZF" },
    { label: "(BED) Laurence G Hanscom Fld - United States", value: "BED" },
    { label: "(SNP) St Paul Island - United States", value: "SNP" },
    { label: "(EHM) Cape Newenham Lrrs - United States", value: "EHM" },
    { label: "(PBV) St George - United States", value: "PBV" },
    { label: "(ILI) Iliamna - United States", value: "ILI" },
    { label: "(PTU) Platinum - United States", value: "PTU" },
    { label: "(BMX) Big Mountain Afs - United States", value: "BMX" },
    { label: "(OSC) Oscoda Wurtsmith - United States", value: "OSC" },
    { label: "(OAR) Marina Muni - United States", value: "OAR" },
    { label: "(MHR) Sacramento Mather - United States", value: "MHR" },
    { label: "(BYS) Bicycle Lake Aaf - United States", value: "BYS" },
    { label: "(NXP) Twentynine Palms Eaf - United States", value: "NXP" },
    { label: "(FSM) Fort Smith Rgnl - United States", value: "FSM" },
    { label: "(MRI) Merrill Fld - United States", value: "MRI" },
    { label: "(GNT) Grants Milan Muni - United States", value: "GNT" },
    { label: "(PNC) Ponca City Rgnl - United States", value: "PNC" },
    { label: "(SVN) Hunter Aaf - United States", value: "SVN" },
    { label: "(GFK) Grand Forks Intl - United States", value: "GFK" },
    { label: "(PBF) Grider Fld - United States", value: "PBF" },
    { label: "(NSE) Whiting Fld Nas North - United States", value: "NSE" },
    { label: "(HNM) Hana - United States", value: "HNM" },
    { label: "(PRC) Ernest A Love Fld - United States", value: "PRC" },
    { label: "(TTN) Trenton Mercer - United States", value: "TTN" },
    {
      label: "(BOS) General Edward Lawrence Logan Intl - United States",
      value: "BOS",
    },
    { label: "(SUU) Travis Afb - United States", value: "SUU" },
    { label: "(RME) Griffiss Afld - United States", value: "RME" },
    { label: "(ENV) Wendover - United States", value: "ENV" },
    { label: "(BFM) Mobile Downtown - United States", value: "BFM" },
    { label: "(OAK) Metropolitan Oakland Intl - United States", value: "OAK" },
    { label: "(OMA) Eppley Afld - United States", value: "OMA" },
    { label: "(NOW) Port Angeles Cgas - United States", value: "NOW" },
    { label: "(OGG) Kahului - United States", value: "OGG" },
    { label: "(ICT) Wichita Mid Continent - United States", value: "ICT" },
    { label: "(MCI) Kansas City Intl - United States", value: "MCI" },
    { label: "(MSN) Dane Co Rgnl Truax Fld - United States", value: "MSN" },
    { label: "(DLG) Dillingham - United States", value: "DLG" },
    { label: "(HRO) Boone Co - United States", value: "HRO" },
    { label: "(PHX) Phoenix Sky Harbor Intl - United States", value: "PHX" },
    { label: "(BGR) Bangor Intl - United States", value: "BGR" },
    { label: "(FXE) Fort Lauderdale Executive - United States", value: "FXE" },
    { label: "(GGG) East Texas Rgnl - United States", value: "GGG" },
    { label: "(AND) Anderson Rgnl - United States", value: "AND" },
    { label: "(GEG) Spokane Intl - United States", value: "GEG" },
    { label: "(HWO) North Perry - United States", value: "HWO" },
    { label: "(SFO) San Francisco Intl - United States", value: "SFO" },
    { label: "(CTB) Cut Bank Muni - United States", value: "CTB" },
    { label: "(ARA) Acadiana Rgnl - United States", value: "ARA" },
    { label: "(GNV) Gainesville Rgnl - United States", value: "GNV" },
    { label: "(MEM) Memphis Intl - United States", value: "MEM" },
    { label: "(DUG) Bisbee Douglas Intl - United States", value: "DUG" },
    { label: "(BIG) Allen Aaf - United States", value: "BIG" },
    { label: "(CNW) Tstc Waco - United States", value: "CNW" },
    { label: "(ANN) Annette Island - United States", value: "ANN" },
    { label: "(CAR) Caribou Muni - United States", value: "CAR" },
    { label: "(LRF) Little Rock Afb - United States", value: "LRF" },
    { label: "(HUA) Redstone Aaf - United States", value: "HUA" },
    { label: "(POB) Pope Field - United States", value: "POB" },
    { label: "(DHT) Dalhart Muni - United States", value: "DHT" },
    { label: "(DLF) Laughlin Afb - United States", value: "DLF" },
    { label: "(LAX) Los Angeles Intl - United States", value: "LAX" },
    { label: "(ANB) Anniston Metro - United States", value: "ANB" },
    { label: "(CLE) Cleveland Hopkins Intl - United States", value: "CLE" },
    { label: "(DOV) Dover Afb - United States", value: "DOV" },
    {
      label: "(CVG) Cincinnati Northern Kentucky Intl - United States",
      value: "CVG",
    },
    { label: "(FME) Tipton - United States", value: "FME" },
    { label: "(NID) China Lake Naws - United States", value: "NID" },
    { label: "(HON) Huron Rgnl - United States", value: "HON" },
    { label: "(JNU) Juneau Intl - United States", value: "JNU" },
    { label: "(LFT) Lafayette Rgnl - United States", value: "LFT" },
    { label: "(EWR) Newark Liberty Intl - United States", value: "EWR" },
    { label: "(BOI) Boise Air Terminal - United States", value: "BOI" },
    { label: "(INS) Creech Afb - United States", value: "INS" },
    { label: "(GCK) Garden City Rgnl - United States", value: "GCK" },
    { label: "(MOT) Minot Intl - United States", value: "MOT" },
    { label: "(HHI) Wheeler Aaf - United States", value: "HHI" },
    { label: "(MXF) Maxwell Afb - United States", value: "MXF" },
    { label: "(RBM) Robinson Aaf - United States", value: "RBM" },
    { label: "(DAL) Dallas Love Fld - United States", value: "DAL" },
    { label: "(FCS) Butts Aaf - United States", value: "FCS" },
    { label: "(HLN) Helena Rgnl - United States", value: "HLN" },
    { label: "(NKX) Miramar Mcas - United States", value: "NKX" },
    { label: "(LUF) Luke Afb - United States", value: "LUF" },
    { label: "(HRT) Hurlburt Fld - United States", value: "HRT" },
    {
      label: "(HHR) Jack Northrop Fld Hawthorne Muni - United States",
      value: "HHR",
    },
    { label: "(HUL) Houlton Intl - United States", value: "HUL" },
    { label: "(END) Vance Afb - United States", value: "END" },
    { label: "(NTD) Point Mugu Nas - United States", value: "NTD" },
    { label: "(EDW) Edwards Afb - United States", value: "EDW" },
    { label: "(LCH) Lake Charles Rgnl - United States", value: "LCH" },
    { label: "(KOA) Kona Intl At Keahole - United States", value: "KOA" },
    { label: "(MYR) Myrtle Beach Intl - United States", value: "MYR" },
    { label: "(NLC) Lemoore Nas - United States", value: "NLC" },
    { label: "(ACK) Nantucket Mem - United States", value: "ACK" },
    { label: "(FAF) Felker Aaf - United States", value: "FAF" },
    { label: "(HOP) Campbell Aaf - United States", value: "HOP" },
    {
      label: "(DCA) Ronald Reagan Washington Natl - United States",
      value: "DCA",
    },
    { label: "(NHK) Patuxent River Nas - United States", value: "NHK" },
    { label: "(PSX) Palacios Muni - United States", value: "PSX" },
    { label: "(BYH) Arkansas Intl - United States", value: "BYH" },
    { label: "(ACY) Atlantic City Intl - United States", value: "ACY" },
    { label: "(TIK) Tinker Afb - United States", value: "TIK" },
    { label: "(ECG) Elizabeth City Cgas Rgnl - United States", value: "ECG" },
    { label: "(PUB) Pueblo Memorial - United States", value: "PUB" },
    {
      label: "(PQI) Northern Maine Rgnl At Presque Isle - United States",
      value: "PQI",
    },
    { label: "(IKR) Kirtland Air Force Base - United States", value: "IKR" },
    { label: "(GRF) Gray Aaf - United States", value: "GRF" },
    { label: "(ADQ) Kodiak - United States", value: "ADQ" },
    { label: "(UPP) Upolu - United States", value: "UPP" },
    {
      label: "(FLL) Fort Lauderdale Hollywood Intl - United States",
      value: "FLL",
    },
    { label: "(MKO) Davis Fld - United States", value: "MKO" },
    { label: "(INL) Falls Intl - United States", value: "INL" },
    { label: "(SLC) Salt Lake City Intl - United States", value: "SLC" },
    { label: "(CDS) Childress Muni - United States", value: "CDS" },
    { label: "(BIX) Keesler Afb - United States", value: "BIX" },
    { label: "(LSF) Lawson Aaf - United States", value: "LSF" },
    { label: "(NQI) Kingsville Nas - United States", value: "NQI" },
    { label: "(FRI) Marshall Aaf - United States", value: "FRI" },
    { label: "(MDT) Harrisburg Intl - United States", value: "MDT" },
    { label: "(LNK) Lincoln - United States", value: "LNK" },
    { label: "(LAN) Capital City - United States", value: "LAN" },
    { label: "(MUE) Waimea Kohala - United States", value: "MUE" },
    { label: "(MSS) Massena Intl Richards Fld - United States", value: "MSS" },
    { label: "(HKY) Hickory Rgnl - United States", value: "HKY" },
    { label: "(SPG) Albert Whitted - United States", value: "SPG" },
    { label: "(FMY) Page Fld - United States", value: "FMY" },
    {
      label: "(IAH) George Bush Intercontinental - United States",
      value: "IAH",
    },
    { label: "(MLT) Millinocket Muni - United States", value: "MLT" },
    { label: "(ADW) Andrews Afb - United States", value: "ADW" },
    { label: "(INT) Smith Reynolds - United States", value: "INT" },
    {
      label: "(VCV) Southern California Logistics - United States",
      value: "VCV",
    },
    { label: "(CEW) Bob Sikes - United States", value: "CEW" },
    { label: "(GTB) Wheeler Sack Aaf - United States", value: "GTB" },
    { label: "(PHN) St Clair Co Intl - United States", value: "PHN" },
    { label: "(BFL) Meadows Fld - United States", value: "BFL" },
    { label: "(ELP) El Paso Intl - United States", value: "ELP" },
    { label: "(HRL) Valley Intl - United States", value: "HRL" },
    { label: "(CAE) Columbia Metropolitan - United States", value: "CAE" },
    { label: "(DMA) Davis Monthan Afb - United States", value: "DMA" },
    { label: "(NPA) Pensacola Nas - United States", value: "NPA" },
    { label: "(PNS) Pensacola Rgnl - United States", value: "PNS" },
    { label: "(RDR) Grand Forks Afb - United States", value: "RDR" },
    { label: "(HOU) William P Hobby - United States", value: "HOU" },
    { label: "(BKF) Buckley Afb - United States", value: "BKF" },
    { label: "(ORT) Northway - United States", value: "ORT" },
    { label: "(PAQ) Palmer Muni - United States", value: "PAQ" },
    { label: "(PIT) Pittsburgh Intl - United States", value: "PIT" },
    { label: "(BRW) Wiley Post Will Rogers Mem - United States", value: "BRW" },
    { label: "(EFD) Ellington Fld - United States", value: "EFD" },
    { label: "(NUW) Whidbey Island Nas - United States", value: "NUW" },
    { label: "(ALI) Alice Intl - United States", value: "ALI" },
    { label: "(VAD) Moody Afb - United States", value: "VAD" },
    { label: "(MIA) Miami Intl - United States", value: "MIA" },
    { label: "(SEA) Seattle Tacoma Intl - United States", value: "SEA" },
    { label: "(CHA) Lovell Fld - United States", value: "CHA" },
    { label: "(BDR) Igor I Sikorsky Mem - United States", value: "BDR" },
    { label: "(JAN) Jackson Evers Intl - United States", value: "JAN" },
    { label: "(GLS) Scholes Intl At Galveston - United States", value: "GLS" },
    { label: "(LGB) Long Beach - United States", value: "LGB" },
    { label: "(HDH) Dillingham - United States", value: "HDH" },
    { label: "(IPT) Williamsport Rgnl - United States", value: "IPT" },
    { label: "(IND) Indianapolis Intl - United States", value: "IND" },
    { label: "(SZL) Whiteman Afb - United States", value: "SZL" },
    { label: "(AKC) Akron Fulton Intl - United States", value: "AKC" },
    { label: "(GWO) Greenwood Leflore - United States", value: "GWO" },
    { label: "(HPN) Westchester Co - United States", value: "HPN" },
    { label: "(FOK) Francis S Gabreski - United States", value: "FOK" },
    { label: "(JBR) Jonesboro Muni - United States", value: "JBR" },
    { label: "(TNX) Tonopah Test Range - United States", value: "TNX" },
    { label: "(LNA) Palm Beach Co Park - United States", value: "LNA" },
    { label: "(NZY) North Island Nas - United States", value: "NZY" },
    { label: "(BIF) Biggs Aaf - United States", value: "BIF" },
    { label: "(YUM) Yuma Mcas Yuma Intl - United States", value: "YUM" },
    { label: "(CNM) Cavern City Air Terminal - United States", value: "CNM" },
    { label: "(DLH) Duluth Intl - United States", value: "DLH" },
    { label: "(BET) Bethel - United States", value: "BET" },
    { label: "(LOU) Bowman Fld - United States", value: "LOU" },
    {
      label: "(FHU) Sierra Vista Muni Libby Aaf - United States",
      value: "FHU",
    },
    { label: "(LIH) Lihue - United States", value: "LIH" },
    {
      label: "(HUF) Terre Haute Intl Hulman Fld - United States",
      value: "HUF",
    },
    { label: "(HVR) Havre City Co - United States", value: "HVR" },
    { label: "(MWH) Grant Co Intl - United States", value: "MWH" },
    { label: "(MPV) Edward F Knapp State - United States", value: "MPV" },
    { label: "(RIC) Richmond Intl - United States", value: "RIC" },
    { label: "(SHV) Shreveport Rgnl - United States", value: "SHV" },
    { label: "(CDV) Merle K Mudhole Smith - United States", value: "CDV" },
    { label: "(ORF) Norfolk Intl - United States", value: "ORF" },
    { label: "(BPT) Southeast Texas Rgnl - United States", value: "BPT" },
    { label: "(SAV) Savannah Hilton Head Intl - United States", value: "SAV" },
    { label: "(HIF) Hill Afb - United States", value: "HIF" },
    { label: "(OME) Nome - United States", value: "OME" },
    {
      label: "(SPB) Scappoose Industrial Airpark - United States",
      value: "SPB",
    },
    {
      label: "(PIE) St Petersburg Clearwater Intl - United States",
      value: "PIE",
    },
    {
      label: "(MNM) Menominee Marinette Twin Co - United States",
      value: "MNM",
    },
    { label: "(CXO) Lone Star Executive - United States", value: "CXO" },
    { label: "(SCC) Deadhorse - United States", value: "SCC" },
    { label: "(SAT) San Antonio Intl - United States", value: "SAT" },
    { label: "(ROC) Greater Rochester Intl - United States", value: "ROC" },
    { label: "(COF) Patrick Afb - United States", value: "COF" },
    { label: "(TEB) Teterboro - United States", value: "TEB" },
    { label: "(RCA) Ellsworth Afb - United States", value: "RCA" },
    { label: "(RDU) Raleigh Durham Intl - United States", value: "RDU" },
    { label: "(DAY) James M Cox Dayton Intl - United States", value: "DAY" },
    { label: "(ENA) Kenai Muni - United States", value: "ENA" },
    { label: "(MLC) Mc Alester Rgnl - United States", value: "MLC" },
    { label: "(IAG) Niagara Falls Intl - United States", value: "IAG" },
    { label: "(CFD) Coulter Fld - United States", value: "CFD" },
    {
      label: "(PHF) Newport News Williamsburg Intl - United States",
      value: "PHF",
    },
    { label: "(ESF) Esler Rgnl - United States", value: "ESF" },
    { label: "(LTS) Altus Afb - United States", value: "LTS" },
    { label: "(TUS) Tucson Intl - United States", value: "TUS" },
    { label: "(MIB) Minot Afb - United States", value: "MIB" },
    { label: "(BAB) Beale Afb - United States", value: "BAB" },
    { label: "(IKK) Greater Kankakee - United States", value: "IKK" },
    { label: "(GSB) Seymour Johnson Afb - United States", value: "GSB" },
    {
      label: "(PVD) Theodore Francis Green State - United States",
      value: "PVD",
    },
    {
      label: "(SBY) Salisbury Ocean City Wicomico Rgnl - United States",
      value: "SBY",
    },
    { label: "(RIU) Rancho Murieta - United States", value: "RIU" },
    { label: "(BUR) Bob Hope - United States", value: "BUR" },
    { label: "(DTW) Detroit Metro Wayne Co - United States", value: "DTW" },
    { label: "(TPA) Tampa Intl - United States", value: "TPA" },
    { label: "(PMB) Pembina Muni - United States", value: "PMB" },
    { label: "(POE) Polk Aaf - United States", value: "POE" },
    { label: "(EIL) Eielson Afb - United States", value: "EIL" },
    { label: "(HIB) Chisholm Hibbing - United States", value: "HIB" },
    { label: "(LFK) Angelina Co - United States", value: "LFK" },
    { label: "(MAF) Midland Intl - United States", value: "MAF" },
    { label: "(GRB) Austin Straubel Intl - United States", value: "GRB" },
    { label: "(ADM) Ardmore Muni - United States", value: "ADM" },
    { label: "(WRI) Mc Guire Afb - United States", value: "WRI" },
    { label: "(NKT) Cherry Point Mcas - United States", value: "NKT" },
    { label: "(SBO) Emanuel Co - United States", value: "SBO" },
    { label: "(AGS) Augusta Rgnl At Bush Fld - United States", value: "AGS" },
    { label: "(ISN) Sloulin Fld Intl - United States", value: "ISN" },
    { label: "(LIT) Adams Fld - United States", value: "LIT" },
    { label: "(SWF) Stewart Intl - United States", value: "SWF" },
    { label: "(BDE) Baudette Intl - United States", value: "BDE" },
    { label: "(SAC) Sacramento Executive - United States", value: "SAC" },
    { label: "(HOM) Homer - United States", value: "HOM" },
    {
      label: "(TBN) Waynesville Rgnl Arpt At Forney Fld - United States",
      value: "TBN",
    },
    { label: "(MGE) Dobbins Arb - United States", value: "MGE" },
    { label: "(SKA) Fairchild Afb - United States", value: "SKA" },
    { label: "(HTL) Roscommon Co - United States", value: "HTL" },
    { label: "(PAM) Tyndall Afb - United States", value: "PAM" },
    { label: "(DFW) Dallas Fort Worth Intl - United States", value: "DFW" },
    { label: "(MLB) Melbourne Intl - United States", value: "MLB" },
    { label: "(TCM) Mc Chord Afb - United States", value: "TCM" },
    { label: "(AUS) Austin Bergstrom Intl - United States", value: "AUS" },
    { label: "(LCK) Rickenbacker Intl - United States", value: "LCK" },
    { label: "(TYS) Mc Ghee Tyson - United States", value: "TYS" },
    { label: "(HLR) Hood Aaf - United States", value: "HLR" },
    { label: "(STL) Lambert St Louis Intl - United States", value: "STL" },
    { label: "(MIV) Millville Muni - United States", value: "MIV" },
    {
      label: "(SPS) Sheppard Afb Wichita Falls Muni - United States",
      value: "SPS",
    },
    { label: "(LUK) Cincinnati Muni Lunken Fld - United States", value: "LUK" },
    {
      label: "(ATL) Hartsfield Jackson Atlanta Intl - United States",
      value: "ATL",
    },
    { label: "(MER) Castle - United States", value: "MER" },
    { label: "(MCC) Mc Clellan Afld - United States", value: "MCC" },
    { label: "(GRR) Gerald R Ford Intl - United States", value: "GRR" },
    { label: "(INK) Winkler Co - United States", value: "INK" },
    { label: "(FAT) Fresno Yosemite Intl - United States", value: "FAT" },
    { label: "(VRB) Vero Beach Muni - United States", value: "VRB" },
    { label: "(IPL) Imperial Co - United States", value: "IPL" },
    { label: "(BNA) Nashville Intl - United States", value: "BNA" },
    { label: "(LRD) Laredo Intl - United States", value: "LRD" },
    { label: "(EDF) Elmendorf Afb - United States", value: "EDF" },
    { label: "(OTZ) Ralph Wien Mem - United States", value: "OTZ" },
    { label: "(AOO) Altoona Blair Co - United States", value: "AOO" },
    { label: "(DYS) Dyess Afb - United States", value: "DYS" },
    {
      label: "(ELD) South Arkansas Rgnl At Goodwin Fld - United States",
      value: "ELD",
    },
    { label: "(LGA) La Guardia - United States", value: "LGA" },
    { label: "(TLH) Tallahassee Rgnl - United States", value: "TLH" },
    { label: "(DPA) Dupage - United States", value: "DPA" },
    { label: "(ACT) Waco Rgnl - United States", value: "ACT" },
    { label: "(AUG) Augusta State - United States", value: "AUG" },
    { label: "(INJ) Hillsboro Muni - United States", value: "INJ" },
    { label: "(NIP) Jacksonville Nas - United States", value: "NIP" },
    { label: "(MKL) Mc Kellar Sipes Rgnl - United States", value: "MKL" },
    { label: "(MKK) Molokai - United States", value: "MKK" },
    { label: "(FTK) Godman Aaf - United States", value: "FTK" },
    { label: "(SJT) San Angelo Rgnl Mathis Fld - United States", value: "SJT" },
    { label: "(CXL) Calexico Intl - United States", value: "CXL" },
    { label: "(CIC) Chico Muni - United States", value: "CIC" },
    { label: "(BTV) Burlington Intl - United States", value: "BTV" },
    { label: "(JAX) Jacksonville Intl - United States", value: "JAX" },
    { label: "(DRO) Durango La Plata Co - United States", value: "DRO" },
    { label: "(IAD) Washington Dulles Intl - United States", value: "IAD" },
    { label: "(CLL) Easterwood Fld - United States", value: "CLL" },
    { label: "(SFF) Felts Fld - United States", value: "SFF" },
    { label: "(MKE) General Mitchell Intl - United States", value: "MKE" },
    { label: "(ABI) Abilene Rgnl - United States", value: "ABI" },
    { label: "(COU) Columbia Rgnl - United States", value: "COU" },
    { label: "(PDX) Portland Intl - United States", value: "PDX" },
    {
      label: "(TNT) Dade Collier Training And Transition - United States",
      value: "TNT",
    },
    { label: "(PBI) Palm Beach Intl - United States", value: "PBI" },
    { label: "(FTW) Fort Worth Meacham Intl - United States", value: "FTW" },
    { label: "(OGS) Ogdensburg Intl - United States", value: "OGS" },
    { label: "(FMH) Otis Angb - United States", value: "FMH" },
    { label: "(BFI) Boeing Fld King Co Intl - United States", value: "BFI" },
    {
      label: "(SKF) Lackland Afb Kelly Fld Annex - United States",
      value: "SKF",
    },
    { label: "(HNL) Honolulu Intl - United States", value: "HNL" },
    { label: "(DSM) Des Moines Intl - United States", value: "DSM" },
    { label: "(EWN) Craven Co Rgnl - United States", value: "EWN" },
    { label: "(SAN) San Diego Intl - United States", value: "SAN" },
    { label: "(MLU) Monroe Rgnl - United States", value: "MLU" },
    { label: "(SSC) Shaw Afb - United States", value: "SSC" },
    { label: "(ONT) Ontario Intl - United States", value: "ONT" },
    { label: "(GVT) Majors - United States", value: "GVT" },
    { label: "(ROW) Roswell Intl Air Center - United States", value: "ROW" },
    { label: "(DET) Coleman A Young Muni - United States", value: "DET" },
    {
      label: "(BRO) Brownsville South Padre Island Intl - United States",
      value: "BRO",
    },
    { label: "(DHN) Dothan Rgnl - United States", value: "DHN" },
    { label: "(WWD) Cape May Co - United States", value: "WWD" },
    { label: "(NFL) Fallon Nas - United States", value: "NFL" },
    { label: "(MTC) Selfridge Angb - United States", value: "MTC" },
    { label: "(FMN) Four Corners Rgnl - United States", value: "FMN" },
    { label: "(CRP) Corpus Christi Intl - United States", value: "CRP" },
    { label: "(SYR) Syracuse Hancock Intl - United States", value: "SYR" },
    { label: "(NQX) Key West Nas - United States", value: "NQX" },
    { label: "(MDW) Chicago Midway Intl - United States", value: "MDW" },
    {
      label: "(SJC) Norman Y Mineta San Jose Intl - United States",
      value: "SJC",
    },
    { label: "(HOB) Lea Co Rgnl - United States", value: "HOB" },
    { label: "(PNE) Northeast Philadelphia - United States", value: "PNE" },
    { label: "(DEN) Denver Intl - United States", value: "DEN" },
    { label: "(PHL) Philadelphia Intl - United States", value: "PHL" },
    {
      label: "(SUX) Sioux Gateway Col Bud Day Fld - United States",
      value: "SUX",
    },
    { label: "(MCN) Middle Georgia Rgnl - United States", value: "MCN" },
    { label: "(TCS) Truth Or Consequences Muni - United States", value: "TCS" },
    { label: "(PMD) Palmdale Rgnl Usaf Plt 42 - United States", value: "PMD" },
    { label: "(RND) Randolph Afb - United States", value: "RND" },
    { label: "(NJK) El Centro Naf - United States", value: "NJK" },
    { label: "(CMH) Port Columbus Intl - United States", value: "CMH" },
    { label: "(FYV) Drake Fld - United States", value: "FYV" },
    { label: "(FSI) Henry Post Aaf - United States", value: "FSI" },
    { label: "(PNM) Princeton Muni - United States", value: "PNM" },
    { label: "(FFO) Wright Patterson Afb - United States", value: "FFO" },
    { label: "(GAL) Edward G Pitka Sr - United States", value: "GAL" },
    { label: "(MWL) Mineral Wells - United States", value: "MWL" },
    { label: "(IAB) Mc Connell Afb - United States", value: "IAB" },
    { label: "(NBG) New Orleans Nas Jrb - United States", value: "NBG" },
    { label: "(BFT) Beaufort - United States", value: "BFT" },
    { label: "(TXK) Texarkana Rgnl Webb Fld - United States", value: "TXK" },
    { label: "(PBG) Plattsburgh Intl - United States", value: "PBG" },
    { label: "(APG) Phillips Aaf - United States", value: "APG" },
    { label: "(TCC) Tucumcari Muni - United States", value: "TCC" },
    { label: "(ANC) Ted Stevens Anchorage Intl - United States", value: "ANC" },
    { label: "(GRK) Robert Gray Aaf - United States", value: "GRK" },
    { label: "(ZUN) Black Rock - United States", value: "ZUN" },
    { label: "(BLI) Bellingham Intl - United States", value: "BLI" },
    { label: "(NQA) Millington Rgnl Jetport - United States", value: "NQA" },
    {
      label: "(EKN) Elkins Randolph Co Jennings Randolph - United States",
      value: "EKN",
    },
    { label: "(HFD) Hartford Brainard - United States", value: "HFD" },
    { label: "(SFZ) North Central State - United States", value: "SFZ" },
    { label: "(MOB) Mobile Rgnl - United States", value: "MOB" },
    { label: "(NUQ) Moffett Federal Afld - United States", value: "NUQ" },
    { label: "(SAF) Santa Fe Muni - United States", value: "SAF" },
    { label: "(BKH) Barking Sands Pmrf - United States", value: "BKH" },
    { label: "(DRI) Beauregard Rgnl - United States", value: "DRI" },
    { label: "(BSF) Bradshaw Aaf - United States", value: "BSF" },
    { label: "(OLS) Nogales Intl - United States", value: "OLS" },
    { label: "(MCF) Macdill Afb - United States", value: "MCF" },
    { label: "(BLV) Scott Afb Midamerica - United States", value: "BLV" },
    { label: "(OPF) Opa Locka - United States", value: "OPF" },
    { label: "(DRT) Del Rio Intl - United States", value: "DRT" },
    { label: "(RSW) Southwest Florida Intl - United States", value: "RSW" },
    { label: "(AKN) King Salmon - United States", value: "AKN" },
    { label: "(MUI) Muir Aaf - United States", value: "MUI" },
    { label: "(JHM) Kapalua - United States", value: "JHM" },
    { label: "(JFK) John F Kennedy Intl - United States", value: "JFK" },
    { label: "(HST) Homestead Arb - United States", value: "HST" },
    { label: "(RAL) Riverside Muni - United States", value: "RAL" },
    { label: "(FLV) Sherman Aaf - United States", value: "FLV" },
    { label: "(WAL) Wallops Flight Facility - United States", value: "WAL" },
    { label: "(HMN) Holloman Afb - United States", value: "HMN" },
    { label: "(NXX) Willow Grove Nas Jrb - United States", value: "NXX" },
    {
      label: "(CYS) Cheyenne Rgnl Jerry Olson Fld - United States",
      value: "CYS",
    },
    { label: "(SCK) Stockton Metropolitan - United States", value: "SCK" },
    { label: "(CHS) Charleston Afb Intl - United States", value: "CHS" },
    { label: "(RNO) Reno Tahoe Intl - United States", value: "RNO" },
    { label: "(KTN) Ketchikan Intl - United States", value: "KTN" },
    { label: "(YIP) Willow Run - United States", value: "YIP" },
    { label: "(VBG) Vandenberg Afb - United States", value: "VBG" },
    { label: "(BHM) Birmingham Intl - United States", value: "BHM" },
    { label: "(NEL) Lakehurst Naes - United States", value: "NEL" },
    { label: "(SYA) Eareckson As - United States", value: "SYA" },
    { label: "(LSV) Nellis Afb - United States", value: "LSV" },
    { label: "(RIV) March Arb - United States", value: "RIV" },
    { label: "(MOD) Modesto City Co Harry Sham - United States", value: "MOD" },
    { label: "(SMF) Sacramento Intl - United States", value: "SMF" },
    { label: "(UGN) Waukegan Rgnl - United States", value: "UGN" },
    {
      label: "(COS) City Of Colorado Springs Muni - United States",
      value: "COS",
    },
    { label: "(BUF) Buffalo Niagara Intl - United States", value: "BUF" },
    { label: "(SKY) Griffing Sandusky - United States", value: "SKY" },
    { label: "(PAE) Snohomish Co - United States", value: "PAE" },
    { label: "(MUO) Mountain Home Afb - United States", value: "MUO" },
    { label: "(CDC) Cedar City Rgnl - United States", value: "CDC" },
    { label: "(BDL) Bradley Intl - United States", value: "BDL" },
    { label: "(MFE) Mc Allen Miller Intl - United States", value: "MFE" },
    { label: "(NGU) Norfolk Ns - United States", value: "NGU" },
    { label: "(CEF) Westover Arb Metropolitan - United States", value: "CEF" },
    { label: "(LBB) Lubbock Preston Smith Intl - United States", value: "LBB" },
    { label: "(ORD) Chicago Ohare Intl - United States", value: "ORD" },
    { label: "(BCT) Boca Raton - United States", value: "BCT" },
    { label: "(FAI) Fairbanks Intl - United States", value: "FAI" },
    { label: "(NYG) Quantico Mcaf - United States", value: "NYG" },
    { label: "(CVS) Cannon Afb - United States", value: "CVS" },
    { label: "(NGF) Kaneohe Bay Mcaf - United States", value: "NGF" },
    { label: "(OFF) Offutt Afb - United States", value: "OFF" },
    { label: "(GKN) Gulkana - United States", value: "GKN" },
    { label: "(ART) Watertown Intl - United States", value: "ART" },
    { label: "(PSP) Palm Springs Intl - United States", value: "PSP" },
    { label: "(AMA) Rick Husband Amarillo Intl - United States", value: "AMA" },
    { label: "(FOD) Fort Dodge Rgnl - United States", value: "FOD" },
    { label: "(BAD) Barksdale Afb - United States", value: "BAD" },
    { label: "(FOE) Forbes Fld - United States", value: "FOE" },
    { label: "(COT) Cotulla Lasalle Co - United States", value: "COT" },
    { label: "(ILM) Wilmington Intl - United States", value: "ILM" },
    { label: "(BTR) Baton Rouge Metro Ryan Fld - United States", value: "BTR" },
    { label: "(NMM) Meridian Nas - United States", value: "NMM" },
    { label: "(TYR) Tyler Pounds Rgnl - United States", value: "TYR" },
    { label: "(BWI) Baltimore Washington Intl - United States", value: "BWI" },
    { label: "(HBR) Hobart Muni - United States", value: "HBR" },
    { label: "(LNY) Lanai - United States", value: "LNY" },
    { label: "(AEX) Alexandria Intl - United States", value: "AEX" },
    { label: "(WSD) Condron Aaf - United States", value: "WSD" },
    { label: "(CDB) Cold Bay - United States", value: "CDB" },
    { label: "(TUL) Tulsa Intl - United States", value: "TUL" },
    { label: "(SIT) Sitka Rocky Gutierrez - United States", value: "SIT" },
    { label: "(ISP) Long Island Mac Arthur - United States", value: "ISP" },
    { label: "(MSP) Minneapolis St Paul Intl - United States", value: "MSP" },
    { label: "(ILG) New Castle - United States", value: "ILG" },
    { label: "(DUT) Unalaska - United States", value: "DUT" },
    {
      label: "(MSY) Louis Armstrong New Orleans Intl - United States",
      value: "MSY",
    },
    { label: "(PWM) Portland Intl Jetport - United States", value: "PWM" },
    { label: "(OKC) Will Rogers World - United States", value: "OKC" },
    { label: "(ALB) Albany Intl - United States", value: "ALB" },
    { label: "(VDZ) Valdez Pioneer Fld - United States", value: "VDZ" },
    { label: "(LFI) Langley Afb - United States", value: "LFI" },
    { label: "(SNA) John Wayne Arpt Orange Co - United States", value: "SNA" },
    { label: "(CBM) Columbus Afb - United States", value: "CBM" },
    { label: "(TMB) Kendall Tamiami Executive - United States", value: "TMB" },
    { label: "(NTU) Oceana Nas - United States", value: "NTU" },
    { label: "(GUS) Grissom Arb - United States", value: "GUS" },
    { label: "(CPR) Natrona Co Intl - United States", value: "CPR" },
    { label: "(VPS) Eglin Afb - United States", value: "VPS" },
    { label: "(SEM) Craig Fld - United States", value: "SEM" },
    { label: "(EYW) Key West Intl - United States", value: "EYW" },
    { label: "(CLT) Charlotte Douglas Intl - United States", value: "CLT" },
    { label: "(LAS) Mc Carran Intl - United States", value: "LAS" },
    { label: "(MCO) Orlando Intl - United States", value: "MCO" },
    { label: "(FLO) Florence Rgnl - United States", value: "FLO" },
    { label: "(GTF) Great Falls Intl - United States", value: "GTF" },
    { label: "(YNG) Youngstown Warren Rgnl - United States", value: "YNG" },
    { label: "(FBK) Ladd Aaf - United States", value: "FBK" },
    { label: "(MMV) Mc Minnville Muni - United States", value: "MMV" },
    { label: "(WRB) Robins Afb - United States", value: "WRB" },
    { label: "(BKK) Suvarnabhumi Intl - Thailand", value: "BKK" },
    { label: "(KDI) Wolter Monginsidi - Indonesia", value: "KDI" },
    { label: "(SBG) Maimun Saleh - Indonesia", value: "SBG" },
    { label: "(MLG) Abdul Rachman Saleh - Indonesia", value: "MLG" },
    { label: "(BDO) Husein Sastranegara - Indonesia", value: "BDO" },
    { label: "(CBN) Penggung - Indonesia", value: "CBN" },
    { label: "(JOG) Adi Sutjipto - Indonesia", value: "JOG" },
    { label: "(CXP) Tunggul Wulung - Indonesia", value: "CXP" },
    { label: "(PCB) Pondok Cabe - Indonesia", value: "PCB" },
    { label: "(SRG) Achmad Yani - Indonesia", value: "SRG" },
    { label: "(BTH) Hang Nadim - Indonesia", value: "BTH" },
    { label: "(TJQ) H As Hanandjoeddin - Indonesia", value: "TJQ" },
    { label: "(PGK) Depati Amir - Indonesia", value: "PGK" },
    { label: "(TNJ) Kijang - Indonesia", value: "TNJ" },
    { label: "(SIQ) Dabo - Indonesia", value: "SIQ" },
    { label: "(BDJ) Syamsudin Noor - Indonesia", value: "BDJ" },
    { label: "(PKN) Iskandar - Indonesia", value: "PKN" },
    { label: "(PKY) Tjilik Riwut - Indonesia", value: "PKY" },
    { label: "(MOF) Wai Oti - Indonesia", value: "MOF" },
    { label: "(ENE) H Hasan Aroeboesman - Indonesia", value: "ENE" },
    { label: "(RTG) Satar Tacik - Indonesia", value: "RTG" },
    { label: "(KOE) El Tari - Indonesia", value: "KOE" },
    { label: "(LBJ) Mutiara Ii - Indonesia", value: "LBJ" },
    { label: "(BPN) Sepinggan - Indonesia", value: "BPN" },
    { label: "(TRK) Juwata - Indonesia", value: "TRK" },
    { label: "(SRI) Temindung - Indonesia", value: "SRI" },
    { label: "(AMI) Selaparang - Indonesia", value: "AMI" },
    { label: "(BMU) Muhammad Salahuddin - Indonesia", value: "BMU" },
    { label: "(WGP) Mau Hau - Indonesia", value: "WGP" },
    { label: "(SUB) Juanda - Indonesia", value: "SUB" },
    { label: "(SOC) Adi Sumarmo Wiryokusumo - Indonesia", value: "SOC" },
    { label: "(CNX) Chiang Mai Intl - Thailand", value: "CNX" },
    { label: "(CEI) Chiang Rai Intl - Thailand", value: "CEI" },
    { label: "(NST) Nakhon Si Thammarat - Thailand", value: "NST" },
    { label: "(DPS) Bali Ngurah Rai - Indonesia", value: "DPS" },
    { label: "(NAK) Nakhon Ratchasima - Thailand", value: "NAK" },
    { label: "(KOP) Nakhon Phanom - Thailand", value: "KOP" },
    { label: "(UBP) Ubon Ratchathani - Thailand", value: "UBP" },
    { label: "(KKC) Khon Kaen - Thailand", value: "KKC" },
    { label: "(THS) Sukhothai - Thailand", value: "THS" },
    { label: "(ATH) Eleftherios Venizelos Intl - Greece", value: "ATH" },
    { label: "(NGO) Chubu Centrair Intl - Japan", value: "NGO" },
    { label: "(UKB) Kobe - Japan", value: "UKB" },
    { label: "(PUW) Pullman-Moscow Rgnl - United States", value: "PUW" },
    { label: "(LWS) Lewiston Nez Perce Co - United States", value: "LWS" },
    { label: "(ELM) Elmira Corning Rgnl - United States", value: "ELM" },
    { label: "(ITH) Ithaca Tompkins Rgnl - United States", value: "ITH" },
    { label: "(MRY) Monterey Peninsula - United States", value: "MRY" },
    { label: "(SBA) Santa Barbara Muni - United States", value: "SBA" },
    { label: "(DAB) Daytona Beach Intl - United States", value: "DAB" },
    { label: "(LPX) Liepaja Intl - Latvia", value: "LPX" },
    { label: "(RIX) Riga Intl - Latvia", value: "RIX" },
    { label: "(SQQ) Siauliai Intl - Lithuania", value: "SQQ" },
    { label: "(HLJ) Barysiai - Lithuania", value: "HLJ" },
    { label: "(KUN) Kaunas Intl - Lithuania", value: "KUN" },
    { label: "(PLQ) Palanga Intl - Lithuania", value: "PLQ" },
    { label: "(VNO) Vilnius Intl - Lithuania", value: "VNO" },
    { label: "(PNV) Pajuostis - Lithuania", value: "PNV" },
    { label: "(EVN) Zvartnots - Armenia", value: "EVN" },
    { label: "(LWN) Gyumri - Armenia", value: "LWN" },
    { label: "(ASA) Assab Intl - Eritrea", value: "ASA" },
    { label: "(ASM) Asmara Intl - Eritrea", value: "ASM" },
    { label: "(MSW) Massawa Intl - Eritrea", value: "MSW" },
    { label: "(GZA) Yasser Arafat Intl - Palestine", value: "GZA" },
    { label: "(RIY) Riyan - Yemen", value: "RIY" },
    { label: "(BUS) Batumi - Georgia", value: "BUS" },
    { label: "(KUT) Kopitnari - Georgia", value: "KUT" },
    { label: "(TBS) Tbilisi - Georgia", value: "TBS" },
    { label: "(TAI) Taiz Intl - Yemen", value: "TAI" },
    { label: "(HOD) Hodeidah Intl - Yemen", value: "HOD" },
    { label: "(ADE) Aden Intl - Yemen", value: "ADE" },
    { label: "(AXK) Ataq - Yemen", value: "AXK" },
    { label: "(AAY) Al Ghaidah Intl - Yemen", value: "AAY" },
    { label: "(SAH) Sanaa Intl - Yemen", value: "SAH" },
    { label: "(FMM) Allgau - Germany", value: "FMM" },
    { label: "(BHN) Beihan - Yemen", value: "BHN" },
    { label: "(SCT) Socotra Intl - Yemen", value: "SCT" },
    { label: "(NAV) Kapadokya - Turkey", value: "NAV" },
    { label: "(EZE) Ministro Pistarini - Argentina", value: "EZE" },
    { label: "(EBL) Erbil Intl - Iraq", value: "EBL" },
    { label: "(EMD) Emerald - Australia", value: "EMD" },
    { label: "(KIX) Kansai - Japan", value: "KIX" },
    { label: "(JRB) Wall Street Heliport - United States", value: "JRB" },
    { label: "(TAG) Tagbilaran - Philippines", value: "TAG" },
    { label: "(JAV) Ilulissat - Greenland", value: "JAV" },
    { label: "(JCH) Qasigiannguit - Greenland", value: "JCH" },
    { label: "(JEG) Aasiaat - Greenland", value: "JEG" },
    { label: "(PMI) Son Sant Joan - Spain", value: "PMI" },
    { label: "(DRW) Darwin Intl - Australia", value: "DRW" },
    { label: "(URT) Surat Thani - Thailand", value: "URT" },
    { label: "(NYU) Bagan Intl - Burma", value: "NYU" },
    { label: "(MPH) Godofredo P - Philippines", value: "MPH" },
    { label: "(NSB) Bimini North Seaplane Base - Bahamas", value: "NSB" },
    { label: "(TKA) Talkeetna - United States", value: "TKA" },
    { label: "(GZM) Xewkija Heliport - Malta", value: "GZM" },
    { label: "(HVN) Tweed-New Haven Airport - United States", value: "HVN" },
    { label: "(AVL) Asheville Regional Airport - United States", value: "AVL" },
    { label: "(GSO) Piedmont Triad - United States", value: "GSO" },
    { label: "(FSD) Sioux Falls - United States", value: "FSD" },
    { label: "(AYQ) Ayers Rock - Australia", value: "AYQ" },
    {
      label: "(MHT) Manchester Regional Airport - United States",
      value: "MHT",
    },
    { label: "(APF) Naples Muni - United States", value: "APF" },
    { label: "(RDN) Redang - Malaysia", value: "RDN" },
    {
      label: "(SDF) Louisville International Airport - United States",
      value: "SDF",
    },
    { label: "(CHO) Charlottesville-Albemarle - United States", value: "CHO" },
    { label: "(ROA) Roanoke Regional - United States", value: "ROA" },
    { label: "(LEX) Blue Grass - United States", value: "LEX" },
    { label: "(EVV) Evansville Regional - United States", value: "EVV" },
    {
      label: "(ABQ) Albuquerque International Sunport - United States",
      value: "ABQ",
    },
    { label: "(BZN) Gallatin Field - United States", value: "BZN" },
    {
      label: "(BIL) Billings Logan International Airport - United States",
      value: "BIL",
    },
    { label: "(BTM) Bert Mooney Airport - United States", value: "BTM" },
    { label: "(TVC) Cherry Capital Airport - United States", value: "TVC" },
    { label: "(FRS) Mundo Maya International - Guatemala", value: "FRS" },
    {
      label: "(BHB) Hancock County - Bar Harbor - United States",
      value: "BHB",
    },
    {
      label: "(RKD) Knox County Regional Airport - United States",
      value: "RKD",
    },
    { label: "(JAC) Jackson Hole Airport - United States", value: "JAC" },
    {
      label: "(RFD) Chicago Rockford International Airport  - United States",
      value: "RFD",
    },
    { label: "(DME) Domododevo - Russia", value: "DME" },
    { label: "(SYX) Phoenix International - China", value: "SYX" },
    { label: "(MFN) Milford Sound Airport - New Zealand", value: "MFN" },
    { label: "(TSS) East 34th Street Heliport - United States", value: "TSS" },
    { label: "(LJG) Lijiang Airport - China", value: "LJG" },
    {
      label: "(GSP) Greenville-Spartanburg International - United States",
      value: "GSP",
    },
    { label: "(QKL) Cologne Railway - Germany", value: "QKL" },
    { label: "(ZWS) Stuttgart Railway Station - Germany", value: "ZWS" },
    { label: "(BMI) Central Illinois Rgnl - United States", value: "BMI" },
    { label: "(GPT) Gulfport-Biloxi - United States", value: "GPT" },
    { label: "(AZO) Kalamazoo - United States", value: "AZO" },
    { label: "(TOL) Toledo - United States", value: "TOL" },
    { label: "(FWA) Fort Wayne - United States", value: "FWA" },
    { label: "(DEC) Decatur - United States", value: "DEC" },
    { label: "(CID) Cedar Rapids - United States", value: "CID" },
    { label: "(LSE) La Crosse Municipal - United States", value: "LSE" },
    { label: "(CWA) Central Wisconsin - United States", value: "CWA" },
    { label: "(PIA) Peoria Regional - United States", value: "PIA" },
    { label: "(ATW) Appleton - United States", value: "ATW" },
    { label: "(RST) Rochester - United States", value: "RST" },
    { label: "(CMI) Champaign - United States", value: "CMI" },
    { label: "(MHK) Manhattan Reigonal - United States", value: "MHK" },
    { label: "(KGC) Kingscote Airport - Australia", value: "KGC" },
    { label: "(HVB) Hervey Bay Airport - Australia", value: "HVB" },
    {
      label: "(BSL) EuroAirport Basel-Mulhouse-Freiburg - Switzerland",
      value: "BSL",
    },
    { label: "(DLU) Dali - China", value: "DLU" },
    { label: "(JHG) Jinghong - China", value: "JHG" },
    { label: "(MZV) Mulu - Malaysia", value: "MZV" },
    { label: "(SSH) Sharm El Sheikh Intl - Egypt", value: "SSH" },
    { label: "(FKL) Franklin - United States", value: "FKL" },
    { label: "(NBO) Jomo Kenyatta International - Kenya", value: "NBO" },
    { label: "(SEU) Seronera - Tanzania", value: "SEU" },
    { label: "(FTE) El Calafate - Argentina", value: "FTE" },
    { label: "(ARM) Armidale - Australia", value: "ARM" },
    { label: "(GJT) Grand Junction Regional - United States", value: "GJT" },
    { label: "(SGU) St George Muni - United States", value: "SGU" },
    { label: "(DWH) David Wayne Hooks Field - United States", value: "DWH" },
    { label: "(S46) Port O\\\\'Connor Airfield - United States", value: "S46" },
    { label: "(SRQ) Sarasota Bradenton Intl - United States", value: "SRQ" },
    { label: "(VNY) Van Nuys - United States", value: "VNY" },
    { label: "(BDA) Bermuda Intl - Bermuda", value: "BDA" },
    { label: "(X21) Arthur Dunn Airpark - United States", value: "X21" },
    { label: "(MLI) Quad City Intl - United States", value: "MLI" },
    { label: "(PFN) Panama City Bay Co Intl - United States", value: "PFN" },
    { label: "(HIR) Honiara International - Solomon Islands", value: "HIR" },
    { label: "(PPT) Faa\\\\'a International - French Polynesia", value: "PPT" },
    { label: "(INU) Nauru Intl - Nauru", value: "INU" },
    { label: "(FUN) Funafuti International - Tuvalu", value: "FUN" },
    { label: "(OVB) Tolmachevo - Russia", value: "OVB" },
    { label: "(DWS) Orlando - United States", value: "DWS" },
    { label: "(XKH) Xieng Khouang - Laos", value: "XKH" },
    { label: "(HUI) Phu Bai - Vietnam", value: "HUI" },
    { label: "(BIS) Bismarck Municipal Airport - United States", value: "BIS" },
    { label: "(TEX) Telluride - United States", value: "TEX" },
    { label: "(INC) Yinchuan - China", value: "INC" },
    { label: "(HGN) Mae Hong Son - Thailand", value: "HGN" },
    {
      label: "(RAP) Rapid City Regional Airport - United States",
      value: "RAP",
    },
    { label: "(CLD) McClellan-Palomar Airport - United States", value: "CLD" },
    { label: "(FNT) Bishop International - United States", value: "FNT" },
    {
      label: "(DVO) Francisco Bangoy International - Philippines",
      value: "DVO",
    },
    { label: "(FNC) Madeira - Portugal", value: "FNC" },
    { label: "(STM) Santarem - Brazil", value: "STM" },
    { label: "(KOS) Sihanoukville - Cambodia", value: "KOS" },
    { label: "(YOA) Ekati - Canada", value: "YOA" },
    { label: "(NPE) Napier - New Zealand", value: "NPE" },
    { label: "(LEV) Levuka Airfield - Fiji", value: "LEV" },
    { label: "(LXA) Lhasa-Gonggar - China", value: "LXA" },
    { label: "(RDD) Redding Muni - United States", value: "RDD" },
    { label: "(EUG) Mahlon Sweet Fld - United States", value: "EUG" },
    { label: "(IDA) Idaho Falls Rgnl - United States", value: "IDA" },
    { label: "(MFR) Rogue Valley Intl Medford - United States", value: "MFR" },
    { label: "(KBZ) Kaikoura - New Zealand", value: "KBZ" },
    { label: "(RDM) Roberts Fld - United States", value: "RDM" },
    { label: "(PCN) Koromiko - New Zealand", value: "PCN" },
    {
      label: "(WDH) Windhoek Hosea Kutako International Airport  - Namibia",
      value: "WDH",
    },
    { label: "(YWH) Victoria Inner Harbour Airport - Canada", value: "YWH" },
    { label: "(CXH) Vancouver Coal Harbour - Canada", value: "CXH" },
    { label: "(TNA) Jinan - China", value: "TNA" },
    { label: "(CZX) Changzhou - China", value: "CZX" },
    { label: "(YBP) Yibin - China", value: "YBP" },
    { label: "(TJM) Roschino - Russia", value: "TJM" },
    {
      label: "(CAK) Akron Canton Regional Airport - United States",
      value: "CAK",
    },
    {
      label:
        "(HSV) Huntsville International Airport-Carl T Jones Field - United States",
      value: "HSV",
    },
    {
      label: "(PKB) Mid-Ohio Valley Regional Airport - United States",
      value: "PKB",
    },
    {
      label: "(MGM) Montgomery Regional Airport  - United States",
      value: "MGM",
    },
    {
      label: "(TRI) Tri-Cities Regional Airport - United States",
      value: "TRI",
    },
    { label: "(PAH) Barkley Regional Airport - United States", value: "PAH" },
    { label: "(KUF) Kurumoch - Russia", value: "KUF" },
    { label: "(JIB) Ambouli International Airport - Djibouti", value: "JIB" },
    { label: "(HAK) Meilan - China", value: "HAK" },
    { label: "(MFA) Mafia - Tanzania", value: "MFA" },
    { label: "(FCA) Glacier Park Intl - United States", value: "FCA" },
    { label: "(PGA) Page Municipal Airport - United States", value: "PGA" },
    { label: "(UII) Utila Airport - Honduras", value: "UII" },
    { label: "(SNV) Santa Elena Airport - Venezuela", value: "SNV" },
    { label: "(MBS) Mbs Intl - United States", value: "MBS" },
    {
      label: "(BGM) Greater Binghamton Edwin A Link Fld - United States",
      value: "BGM",
    },
    { label: "(BGW) Baghdad International Airport - Iraq", value: "BGW" },
    { label: "(NNT) Nan - Thailand", value: "NNT" },
    { label: "(ROI) Roi Et - Thailand", value: "ROI" },
    { label: "(BFV) Buri Ram - Thailand", value: "BFV" },
    { label: "(UNN) Ranong - Thailand", value: "UNN" },
    { label: "(TDX) Trat - Thailand", value: "TDX" },
    { label: "(BLH) Blythe Airport - United States", value: "BLH" },
    {
      label: "(CRK) Diosdado Macapagal International - Philippines",
      value: "CRK",
    },
    { label: "(SDK) Sandakan - Malaysia", value: "SDK" },
    { label: "(LXG) Luang Namtha - Laos", value: "LXG" },
    { label: "(ODY) Oudomxay - Laos", value: "ODY" },
    {
      label: "(SHE) Shenyang Taoxian International Airport - China",
      value: "SHE",
    },
    { label: "(DOY) Dongying Airport - China", value: "DOY" },
    { label: "(MNI) John A. Osborne Airport - Montserrat", value: "MNI" },
    {
      label: "(PSG) Petersburg James A. Johnson - United States",
      value: "PSG",
    },
    { label: "(LYA) Luoyang Airport - China", value: "LYA" },
    { label: "(XUZ) Xuzhou Guanyin Airport - China", value: "XUZ" },
    { label: "(IFN) Esfahan Shahid Beheshti Intl - Iran", value: "IFN" },
    { label: "(MWQ) Magwe - Burma", value: "MWQ" },
    { label: "(KHM) Khamti - Burma", value: "KHM" },
    { label: "(DLI) Dalat - Vietnam", value: "DLI" },
    { label: "(VDH) Dong Hoi - Vietnam", value: "VDH" },
    { label: "(VKG) Rach Gia - Vietnam", value: "VKG" },
    { label: "(CAH) Ca Mau - Vietnam", value: "CAH" },
    { label: "(VCL) Chu Lai - Vietnam", value: "VCL" },
    { label: "(TBB) Dong Tac - Vietnam", value: "TBB" },
    { label: "(PYY) Pai - Thailand", value: "PYY" },
    { label: "(BWK) Brac - Croatia", value: "BWK" },
    { label: "(NSI) Yaounde Nsimalen - Cameroon", value: "NSI" },
    { label: "(CKY) Conakry - Guinea", value: "CKY" },
    { label: "(AAH) Flugplatz Merzbrueck - Germany", value: "AAH" },
    { label: "(FKB) Baden Airpark - Germany", value: "FKB" },
    { label: "(SFB) Orlando Sanford Intl - United States", value: "SFB" },
    { label: "(PQC) Duong Dong Airport - Vietnam", value: "PQC" },
    {
      label:
        "(JST) John Murtha Johnstown-Cambria County Airport - United States",
      value: "JST",
    },
    { label: "(LUA) Lukla - Nepal", value: "LUA" },
    { label: "(BHP) Bhojpur - Nepal", value: "BHP" },
    { label: "(LDN) Lamidanda - Nepal", value: "LDN" },
    { label: "(JMO) Jomsom - Nepal", value: "JMO" },
    { label: "(NGX) Manang - Nepal", value: "NGX" },
    { label: "(PPL) Phaplu - Nepal", value: "PPL" },
    { label: "(TMK) Thamkharka - Nepal", value: "TMK" },
    { label: "(RUM) Rumjatar - Nepal", value: "RUM" },
    { label: "(DNP) Tulsipur - Nepal", value: "DNP" },
    { label: "(RUK) Rukumkot - Nepal", value: "RUK" },
    { label: "(JUM) Jumla - Nepal", value: "JUM" },
    { label: "(HRJ) Chaurjhari - Nepal", value: "HRJ" },
    { label: "(TPJ) Taplejung - Nepal", value: "TPJ" },
    { label: "(TMI) Tumling Tar - Nepal", value: "TMI" },
    { label: "(SKH) Surkhet - Nepal", value: "SKH" },
    { label: "(IMK) Simikot - Nepal", value: "IMK" },
    { label: "(DOP) Dolpa - Nepal", value: "DOP" },
    { label: "(BJH) Bajhang - Nepal", value: "BJH" },
    { label: "(DHI) Dhangarhi - Nepal", value: "DHI" },
    { label: "(MWX) Muan - South Korea", value: "MWX" },
    { label: "(JTY) Astypalaia - Greece", value: "JTY" },
    { label: "(JIK) Ikaria - Greece", value: "JIK" },
    { label: "(JKL) Kalymnos Island - Greece", value: "JKL" },
    { label: "(MLO) Milos - Greece", value: "MLO" },
    { label: "(JNX) Naxos - Greece", value: "JNX" },
    { label: "(PAS) Paros - Greece", value: "PAS" },
    { label: "(KZS) Kastelorizo - Greece", value: "KZS" },
    { label: "(RMF) Marsa Alam Intl - Egypt", value: "RMF" },
    { label: "(NRN) Niederrhein - Germany", value: "NRN" },
    { label: "(USU) Busuanga - Philippines", value: "USU" },
    { label: "(BXU) Butuan - Philippines", value: "BXU" },
    { label: "(DPL) Dipolog - Philippines", value: "DPL" },
    { label: "(LAO) Laoag Intl - Philippines", value: "LAO" },
    { label: "(LGP) Legazpi - Philippines", value: "LGP" },
    { label: "(OZC) Ozamis - Philippines", value: "OZC" },
    { label: "(ZQW) Zweibruecken - Germany", value: "ZQW" },
    { label: "(CEB) Mactan Cebu Intl - Philippines", value: "CEB" },
    {
      label: "(NOE) Sonderlandeplatz Norden-Norddeich - Germany",
      value: "NOE",
    },
    { label: "(JUI) Verkehrslandeplatz Juist - Germany", value: "JUI" },
    { label: "(BPS) Aeroporto de Porto Seguro - Brazil", value: "BPS" },
    { label: "(GDA) Gounda Airport - Central African Republic", value: "GDA" },
    { label: "(PMW) Palmas - Brazil", value: "PMW" },
    { label: "(CLV) Caldas Novas - Brazil", value: "CLV" },
    { label: "(MSO) Missoula Intl - United States", value: "MSO" },
    { label: "(BKQ) Blackall - Australia", value: "BKQ" },
    { label: "(BDB) Bundaberg - Australia", value: "BDB" },
    {
      label: "(GCN) Grand Canyon National Park Airport - United States",
      value: "GCN",
    },
    {
      label: "(SGR) Sugar Land Regional Airport - United States",
      value: "SGR",
    },
    { label: "(HIS) Hayman Island Airport - Australia", value: "HIS" },
    { label: "(APA) Centennial - United States", value: "APA" },
    { label: "(CVN) Clovis Muni - United States", value: "CVN" },
    { label: "(FST) Fort Stockton Pecos Co - United States", value: "FST" },
    { label: "(LVS) Las Vegas Muni - United States", value: "LVS" },
    { label: "(IWS) West Houston - United States", value: "IWS" },
    { label: "(LHX) La Junta Muni - United States", value: "LHX" },
    { label: "(LRU) Las Cruces Intl - United States", value: "LRU" },
    { label: "(BKD) Stephens Co - United States", value: "BKD" },
    {
      label: "(TPL) Draughon Miller Central Texas Rgnl - United States",
      value: "TPL",
    },
    { label: "(OZA) Ozona Muni - United States", value: "OZA" },
    { label: "(HEW) Athen Helenikon Airport - Greece", value: "HEW" },
    { label: "(WKL) Waikoloa Heliport - United States", value: "WKL" },
    { label: "(KDM) Kaadedhdhoo - Maldives", value: "KDM" },
    { label: "(LAK) Aklavik - Canada", value: "LAK" },
    { label: "(YWJ) Deline - Canada", value: "YWJ" },
    { label: "(ZFN) Tulita - Canada", value: "ZFN" },
    { label: "(YGH) Fort Good Hope - Canada", value: "YGH" },
    { label: "(TAH) Tanna island - Vanuatu", value: "TAH" },
    { label: "(YPC) Paulatuk - Canada", value: "YPC" },
    { label: "(SRZ) Santa Cruz - Bolivia", value: "SRZ" },
    { label: "(KUS) Kulusuk - Greenland", value: "KUS" },
    {
      label: "(SAB) Juancho E. Yrausquin - Netherlands Antilles",
      value: "SAB",
    },
    { label: "(EGE) Eagle Co Rgnl - United States", value: "EGE" },
    { label: "(SKN) Skagen - Norway", value: "SKN" },
    { label: "(CGF) Cuyahoga County - United States", value: "CGF" },
    { label: "(MFD) Mansfield Lahm Regional - United States", value: "MFD" },
    {
      label: "(CSG) Columbus Metropolitan Airport - United States",
      value: "CSG",
    },
    {
      label: "(LAW) Lawton-Fort Sill Regional Airport - United States",
      value: "LAW",
    },
    { label: "(FNL) Fort Collins Loveland Muni - United States", value: "FNL" },
    { label: "(FLG) Flagstaff Pulliam Airport - United States", value: "FLG" },
    { label: "(TVL) Lake Tahoe Airport - United States", value: "TVL" },
    {
      label: "(TWF) Magic Valley Regional Airport - United States",
      value: "TWF",
    },
    { label: "(MCM) Monaco - Monaco", value: "MCM" },
    { label: "(MVY) Martha\\\\'s Vineyard - United States", value: "MVY" },
    { label: "(UUU) Newport State - United States", value: "UUU" },
    { label: "(VSF) Hartness State - United States", value: "VSF" },
    { label: "(CON) Concord Municipal - United States", value: "CON" },
    { label: "(SFM) Sanford Regional - United States", value: "SFM" },
    { label: "(GON) Groton New London - United States", value: "GON" },
    {
      label: "(STC) Saint Cloud Regional Airport - United States",
      value: "STC",
    },
    { label: "(BPE) Bagan - Burma", value: "BPE" },
    {
      label: "(GTR) Golden Triangle Regional Airport - United States",
      value: "GTR",
    },
    { label: "(GOJ) Nizhny Novgorod - Russia", value: "GOJ" },
    { label: "(HQM) Bowerman Field - United States", value: "HQM" },
    { label: "(ERI) Erie Intl Tom Ridge Fld - United States", value: "ERI" },
    {
      label: "(HYA) Barnstable Muni Boardman Polando Fld - United States",
      value: "HYA",
    },
    { label: "(SPR) San Pedro - Belize", value: "SPR" },
    { label: "(SDX) Sedona - United States", value: "SDX" },
    {
      label: "(MGW) Morgantown Muni Walter L Bill Hart Fld - United States",
      value: "MGW",
    },
    { label: "(CRW) Yeager - United States", value: "CRW" },
    { label: "(AVP) Wilkes Barre Scranton Intl - United States", value: "AVP" },
    { label: "(BJI) Bemidji Regional Airport - United States", value: "BJI" },
    { label: "(BAK) Heydar Aliyev - Azerbaijan", value: "BAK" },
    { label: "(THG) Thangool - Australia", value: "THG" },
    { label: "(FGI) Fagali\\\\'i - Samoa", value: "FGI" },
    { label: "(BNK) Ballina Byron Gateway - Australia", value: "BNK" },
    {
      label: "(FAR) Hector International Airport - United States",
      value: "FAR",
    },
    { label: "(MKC) Downtown - United States", value: "MKC" },
    { label: "(AZA) Phoenix-Mesa Gateway - United States", value: "AZA" },
    { label: "(RBE) Ratanakiri - Cambodia", value: "RBE" },
    {
      label: "(GCC) Gillette-Campbell County Airport - United States",
      value: "GCC",
    },
    { label: "(TOF) Tomsk Bogashevo Airport - Russia", value: "TOF" },
    { label: "(NZJ) El Toro - United States", value: "NZJ" },
    { label: "(PHY) Phetchabun - Thailand", value: "PHY" },
    { label: "(CJM) Chumphon - Thailand", value: "CJM" },
    { label: "(JZH) Jiuzhaigou Huanglong - China", value: "JZH" },
    { label: "(SWA) Wai Sha Airport - China", value: "SWA" },
    { label: "(GEO) Cheddi Jagan Intl - Guyana", value: "GEO" },
    { label: "(AGT) Ciudad del Este - Paraguay", value: "AGT" },
    { label: "(OGL) Ogle - Guyana", value: "OGL" },
    { label: "(KAI) Kaieteur - Guyana", value: "KAI" },
    { label: "(DNH) Dunhuang Airport - China", value: "DNH" },
    { label: "(AOI) Falconara - Italy", value: "AOI" },
    { label: "(ECA) Iosco County - United States", value: "ECA" },
    { label: "(CPO) Copiapo - Chile", value: "CPO" },
    { label: "(TCP) Taba Intl - Egypt", value: "TCP" },
    { label: "(LYB) Edward Bodden Airfield - Cayman Islands", value: "LYB" },
    { label: "(BJV) Bodrum - Milas - Turkey", value: "BJV" },
    { label: "(TBJ) 7 Novembre - Tunisia", value: "TBJ" },
    { label: "(SAW) Sabiha Gokcen - Turkey", value: "SAW" },
    { label: "(SCE) University Park Airport - United States", value: "SCE" },
    { label: "(BME) Broome - Australia", value: "BME" },
    { label: "(NTL) Newcastle Airport - Australia", value: "NTL" },
    {
      label: "(KLU) Woerthersee International Airport - Austria",
      value: "KLU",
    },
    { label: "(CGU) General Manuel Carlos Piar - Venezuela", value: "CGU" },
    { label: "(HFT) Hammerfest Airport - Norway", value: "HFT" },
    { label: "(HVG) Valan - Norway", value: "HVG" },
    { label: "(MEH) Mehamn - Norway", value: "MEH" },
    { label: "(VDS) Airport - Norway", value: "VDS" },
    { label: "(IKA) Imam Khomeini - Iran", value: "IKA" },
    { label: "(MHD) Mashhad - Iran", value: "MHD" },
    { label: "(QEF) Egelsbach - Germany", value: "QEF" },
    { label: "(UIK) Ust-Ilimsk - Russia", value: "UIK" },
    { label: "(MDG) Mudanjiang - China", value: "MDG" },
    { label: "(MEI) Key Field - United States", value: "MEI" },
    { label: "(SPI) Abraham Lincoln Capital - United States", value: "SPI" },
    { label: "(HKV) Uzundzhovo - Bulgaria", value: "HKV" },
    { label: "(CEZ) Cortez Muni - United States", value: "CEZ" },
    { label: "(HDN) Yampa Valley - United States", value: "HDN" },
    { label: "(GUP) Gallup Muni - United States", value: "GUP" },
    { label: "(LBL) Liberal Muni - United States", value: "LBL" },
    { label: "(LAA) Lamar Muni - United States", value: "LAA" },
    { label: "(GLD) Renner Fld - United States", value: "GLD" },
    { label: "(COD) Yellowstone Rgnl - United States", value: "COD" },
    { label: "(HOV) Hovden - Norway", value: "HOV" },
    { label: "(ISC) ISLES OF SCILLY - United Kingdom", value: "ISC" },
    { label: "(SGF) Springfield Branson Natl - United States", value: "SGF" },
    { label: "(NVK) Framnes - Norway", value: "NVK" },
    { label: "(BVG) Berlevag - Norway", value: "BVG" },
    { label: "(FBU) Fornebu - Norway", value: "FBU" },
    { label: "(NSK) Alykel - Russia", value: "NSK" },
    { label: "(AAQ) Vityazevo - Russia", value: "AAQ" },
    { label: "(JLN) Joplin Rgnl - United States", value: "JLN" },
    { label: "(ABE) Lehigh Valley Intl - United States", value: "ABE" },
    { label: "(XNA) NW Arkansas Regional - United States", value: "XNA" },
    { label: "(GUW) Atyrau - Kazakhstan", value: "GUW" },
    { label: "(KZO) Kzyl-Orda - Kazakhstan", value: "KZO" },
    { label: "(SBN) South Bend Rgnl - United States", value: "SBN" },
    { label: "(BKA) Bykovo - Russia", value: "BKA" },
    { label: "(ARH) Talagi - Russia", value: "ARH" },
    { label: "(RTW) Central - Russia", value: "RTW" },
    { label: "(NUX) Novyi Urengoy - Russia", value: "NUX" },
    { label: "(NOJ) Noyabrsk - Russia", value: "NOJ" },
    { label: "(ZWU) Washington Union Station - United States", value: "ZWU" },
    { label: "(SCO) Aktau - Kazakhstan", value: "SCO" },
    { label: "(UCT) Ukhta - Russia", value: "UCT" },
    { label: "(USK) Usinsk - Russia", value: "USK" },
    { label: "(PEX) Pechora - Russia", value: "PEX" },
    { label: "(NNM) Naryan-Mar - Russia", value: "NNM" },
    { label: "(PKV) Kresty - Russia", value: "PKV" },
    { label: "(KGP) Kogalym International - Russia", value: "KGP" },
    { label: "(KJA) Emelyanovo - Russia", value: "KJA" },
    { label: "(KGF) Sary-Arka - Kazakhstan", value: "KGF" },
    { label: "(URJ) Uraj - Russia", value: "URJ" },
    { label: "(CRZ) Turkmenabat - Turkmenistan", value: "CRZ" },
    { label: "(IWA) Yuzhny - Russia", value: "IWA" },
    { label: "(CGQ) Changchun - China", value: "CGQ" },
    { label: "(KIJ) Niigata - Japan", value: "KIJ" },
    { label: "(JON) Johnston Atoll - Johnston Atoll", value: "JON" },
    { label: "(SMD) Smith Fld - United States", value: "SMD" },
    { label: "(ACV) Arcata - United States", value: "ACV" },
    { label: "(ATT) Camp Mabry Austin City - United States", value: "ATT" },
    { label: "(OAJ) Albert J Ellis - United States", value: "OAJ" },
    { label: "(TCL) Tuscaloosa Rgnl - United States", value: "TCL" },
    { label: "(DBQ) Dubuque Rgnl - United States", value: "DBQ" },
    { label: "(FDE) Forde Bringeland - Norway", value: "FDE" },
    { label: "(PYJ) Poliarny Airport - Russia", value: "PYJ" },
    { label: "(NAJ) Nakhchivan Airport - Azerbaijan", value: "NAJ" },
    { label: "(KVD) Ganja Airport - Azerbaijan", value: "KVD" },
    { label: "(UKK) Ust Kamenogorsk Airport - Kazakhstan", value: "UKK" },
    { label: "(PPK) Petropavlosk South Airport - Kazakhstan", value: "PPK" },
    { label: "(GBJ) Les Bases Airport - Guadeloupe", value: "GBJ" },
    { label: "(SFC) St-François Airport - Guadeloupe", value: "SFC" },
    { label: "(BBQ) Codrington Airport - Antigua and Barbuda", value: "BBQ" },
    { label: "(JPR) Ji-Paraná Airport - Brazil", value: "JPR" },
    { label: "(MYC) Escuela Mariscal Sucre Airport - Venezuela", value: "MYC" },
    { label: "(NZA) Maria Reiche Neuman Airport - Peru", value: "NZA" },
    {
      label: "(CJA) Mayor General FAP Armando Revoredo Iglesias Airport - Peru",
      value: "CJA",
    },
    { label: "(GTA) Gatokae Airport - Solomon Islands", value: "GTA" },
    { label: "(BXX) Boorama Airport - Somalia", value: "BXX" },
    { label: "(MVS) Mucuri Airport - Brazil", value: "MVS" },
    { label: "(ORG) Zorg en Hoop Airport - Surilabel", value: "ORG" },
    { label: "(REY) Reyes Airport - Bolivia", value: "REY" },
    { label: "(PUR) Puerto Rico Airport - Bolivia", value: "PUR" },
    { label: "(EYP) El Alcaraván Airport - Colombia", value: "EYP" },
    { label: "(ESM) General Rivadeneira Airport - Ecuador", value: "ESM" },
    { label: "(ZPC) Pucón Airport - Chile", value: "ZPC" },
    { label: "(TOW) Toledo Airport - Brazil", value: "TOW" },
    { label: "(RIA) Santa Maria Airport - Brazil", value: "RIA" },
    { label: "(LEC) Chapada Diamantina Airport - Brazil", value: "LEC" },
    { label: "(GUL) Goulburn Airport - Australia", value: "GUL" },
    {
      label: "(JDO) Orlando Bezerra de Menezes Airport - Brazil",
      value: "JDO",
    },
    { label: "(SST) Santa Teresita Airport - Argentina", value: "SST" },
    { label: "(GGS) Gobernador Gregores Airport - Argentina", value: "GGS" },
    { label: "(OES) Antoine De St Exupery Airport - Argentina", value: "OES" },
    { label: "(LHS) Las Heras Airport - Argentina", value: "LHS" },
    {
      label: "(TTG) General Enrique Mosconi Airport - Argentina",
      value: "TTG",
    },
    { label: "(MBT) Masbate Airport - Philippines", value: "MBT" },
    { label: "(CRM) Catarman National Airport - Philippines", value: "CRM" },
    { label: "(JOL) Jolo Airport - Philippines", value: "JOL" },
    { label: "(CGM) Camiguin Airport - Philippines", value: "CGM" },
    { label: "(CYU) Cuyo Airport - Philippines", value: "CYU" },
    {
      label: "(CJJ) Cheongju International Airport - South Korea",
      value: "CJJ",
    },
    { label: "(HIN) Sacheon Air Base - South Korea", value: "HIN" },
    { label: "(WJU) Wonju Airport - South Korea", value: "WJU" },
    { label: "(MPK) Mokpo Airport - South Korea", value: "MPK" },
    { label: "(KUV) Kunsan Air Base - South Korea", value: "KUV" },
    { label: "(MYE) Miyakejima Airport - Japan", value: "MYE" },
    { label: "(SYO) Shonai Airport - Japan", value: "SYO" },
    { label: "(ONJ) Odate Noshiro Airport - Japan", value: "ONJ" },
    { label: "(FKS) Fukushima Airport - Japan", value: "FKS" },
    { label: "(IWJ) Iwami Airport - Japan", value: "IWJ" },
    { label: "(NKM) Nagoya Airport - Japan", value: "NKM" },
    { label: "(HSG) Saga Airport - Japan", value: "HSG" },
    { label: "(OKD) Okadama Airport - Japan", value: "OKD" },
    { label: "(KUH) Kushiro Airport - Japan", value: "KUH" },
    { label: "(MFK) Matsu Beigan Airport - Taiwan", value: "MFK" },
    { label: "(HCN) Hengchun Airport - Taiwan", value: "HCN" },
    { label: "(LZN) Matsu Nangan Airport - Taiwan", value: "LZN" },
    { label: "(ENT) Eniwetok Airport - Marshall Islands", value: "ENT" },
    { label: "(LUP) Kalaupapa Airport - United States", value: "LUP" },
    { label: "(ENI) El Nido Airport - Philippines", value: "ENI" },
    { label: "(WPM) Wipim Airport - Papua New Guinea", value: "WPM" },
    { label: "(VMU) Baimuru Airport - Papua New Guinea", value: "VMU" },
    { label: "(UKU) Nuku Airport - Papua New Guinea", value: "UKU" },
    { label: "(TFI) Tufi Airport - Papua New Guinea", value: "TFI" },
    { label: "(SKC) Suki Airport - Papua New Guinea", value: "SKC" },
    { label: "(OPU) Balimo Airport - Papua New Guinea", value: "OPU" },
    { label: "(OBX) Obo Airport - Papua New Guinea", value: "OBX" },
    { label: "(LSA) Losuia Airport - Papua New Guinea", value: "LSA" },
    { label: "(LNV) Londolovit Airport - Papua New Guinea", value: "LNV" },
    { label: "(LMY) Lake Murray Airport - Papua New Guinea", value: "LMY" },
    { label: "(KUY) Kamusi Airport - Papua New Guinea", value: "KUY" },
    { label: "(KKD) Kokoda Airport - Papua New Guinea", value: "KKD" },
    { label: "(KDR) Kandrian Airport - Papua New Guinea", value: "KDR" },
    { label: "(JAQ) Jacquinot Bay Airport - Papua New Guinea", value: "JAQ" },
    { label: "(IIS) Nissan Island Airport - Papua New Guinea", value: "IIS" },
    { label: "(IHU) Ihu Airport - Papua New Guinea", value: "IHU" },
    { label: "(GMI) Gasmata Island Airport - Papua New Guinea", value: "GMI" },
    { label: "(ATP) Tadji Airport - Papua New Guinea", value: "ATP" },
    { label: "(WRG) Wrangell Airport - United States", value: "WRG" },
    { label: "(VAK) Chevak Airport - United States", value: "VAK" },
    { label: "(ANI) Aniak Airport - United States", value: "ANI" },
    { label: "(MOU) Mountain Village Airport - United States", value: "MOU" },
    { label: "(MCG) McGrath Airport - United States", value: "MCG" },
    { label: "(KLG) Kalskag Airport - United States", value: "KLG" },
    { label: "(HNS) Haines Airport - United States", value: "HNS" },
    { label: "(HCR) Holy Cross Airport - United States", value: "HCR" },
    { label: "(SGY) Skagway Airport - United States", value: "SGY" },
    { label: "(GST) Gustavus Airport - United States", value: "GST" },
    { label: "(ADK) Adak Airport - United States", value: "ADK" },
    { label: "(SAX) Sambu Airport - Panama", value: "SAX" },
    { label: "(OTD) Contadora Airport - Panama", value: "OTD" },
    { label: "(ELE) EL Real Airport - Panama", value: "ELE" },
    { label: "(BFQ) Bahia Piña Airport - Panama", value: "BFQ" },
    { label: "(GXF) Sayun International Airport - Yemen", value: "GXF" },
    { label: "(KAC) Kamishly Airport - Syria", value: "KAC" },
    { label: "(ISU) Sulaymaniyah International Airport - Iraq", value: "ISU" },
    { label: "(TUK) Turbat International Airport - Pakistan", value: "TUK" },
    { label: "(SYW) Sehwan Sharif Airport - Pakistan", value: "SYW" },
    { label: "(KDU) Skardu Airport - Pakistan", value: "KDU" },
    { label: "(PAJ) Parachinar Airport - Pakistan", value: "PAJ" },
    { label: "(ORW) Ormara Airport - Pakistan", value: "ORW" },
    { label: "(KDD) Khuzdar Airport - Pakistan", value: "KDD" },
    { label: "(HDD) Hyderabad Airport - Pakistan", value: "HDD" },
    { label: "(JIW) Jiwani Airport - Pakistan", value: "JIW" },
    { label: "(DSK) Dera Ismael Khan Airport - Pakistan", value: "DSK" },
    { label: "(DEA) Dera Ghazi Khan Airport - Pakistan", value: "DEA" },
    { label: "(DBA) Dalbandin Airport - Pakistan", value: "DBA" },
    { label: "(CJL) Chitral Airport - Pakistan", value: "CJL" },
    { label: "(BHV) Bahawalpur Airport - Pakistan", value: "BHV" },
    { label: "(BNP) Bannu Airport - Pakistan", value: "BNP" },
    {
      label: "(AAN) Al Ain International Airport - United Arab Emirates",
      value: "AAN",
    },
    { label: "(OMH) Uromiyeh Airport - Iran", value: "OMH" },
    { label: "(ADU) Ardabil Airport - Iran", value: "ADU" },
    { label: "(LRR) Lar Airport - Iran", value: "LRR" },
    { label: "(SRY) Sari Dasht E Naz Airport - Iran", value: "SRY" },
    { label: "(NSH) Noshahr Airport - Iran", value: "NSH" },
    { label: "(AFZ) Sabzevar National Airport - Iran", value: "AFZ" },
    { label: "(BJB) Bojnourd Airport - Iran", value: "BJB" },
    { label: "(RJN) Rafsanjan Airport - Iran", value: "RJN" },
    { label: "(BXR) Bam Airport - Iran", value: "BXR" },
    { label: "(KHD) Khoram Abad Airport - Iran", value: "KHD" },
    { label: "(EWD) Wadi Al Dawasir Airport - Saudi Arabia", value: "EWD" },
    { label: "(AJF) Al-Jawf Domestic Airport - Saudi Arabia", value: "AJF" },
    { label: "(DWD) Dawadmi Domestic Airport - Saudi Arabia", value: "DWD" },
    { label: "(XAU) Saul Airport - French Guiana", value: "XAU" },
    { label: "(FBD) Faizabad Airport - Afghanistan", value: "FBD" },
    { label: "(ILP) Île des Pins Airport - New Caledonia", value: "ILP" },
    { label: "(BMY) Belep Islands Airport - New Caledonia", value: "BMY" },
    { label: "(TGJ) Tiga Airport - New Caledonia", value: "TGJ" },
    { label: "(IPA) Ipota Airport - Vanuatu", value: "IPA" },
    { label: "(FTA) Futuna Airport - Vanuatu", value: "FTA" },
    { label: "(DLY) Dillon's Bay Airport - Vanuatu", value: "DLY" },
    { label: "(AWD) Aniwa Airport - Vanuatu", value: "AWD" },
    { label: "(AUY) Anelghowhat Airport - Vanuatu", value: "AUY" },
    { label: "(OLZ) North West Santo Airport - Vanuatu", value: "OLZ" },
    { label: "(SWJ) Southwest Bay Airport - Vanuatu", value: "SWJ" },
    { label: "(VLS) Valesdir Airport - Vanuatu", value: "VLS" },
    { label: "(ULB) Uléi Airport - Vanuatu", value: "ULB" },
    { label: "(TGH) Tongoa Island Airport - Vanuatu", value: "TGH" },
    {
      label: "(SON) Santo Pekoa International Airport - Vanuatu",
      value: "SON",
    },
    { label: "(RCL) Redcliffe Airport - Vanuatu", value: "RCL" },
    { label: "(ZGU) Gaua Island Airport - Vanuatu", value: "ZGU" },
    { label: "(NUS) Norsup Airport - Vanuatu", value: "NUS" },
    { label: "(LNE) Lonorore Airport - Vanuatu", value: "LNE" },
    { label: "(MWF) Naone Airport - Vanuatu", value: "MWF" },
    { label: "(LNB) Lamen Bay Airport - Vanuatu", value: "LNB" },
    { label: "(LPM) Lamap Airport - Vanuatu", value: "LPM" },
    { label: "(PBJ) Tavie Airport - Vanuatu", value: "PBJ" },
    { label: "(SSR) Sara Airport - Vanuatu", value: "SSR" },
    { label: "(LOD) Longana Airport - Vanuatu", value: "LOD" },
    { label: "(CCV) Craig Cove Airport - Vanuatu", value: "CCV" },
    { label: "(EAE) Sangafa Airport - Vanuatu", value: "EAE" },
    { label: "(TOH) Torres Airstrip - Vanuatu", value: "TOH" },
    { label: "(SLH) Sola Airport - Vanuatu", value: "SLH" },
    { label: "(MTV) Mota Lava Airport - Vanuatu", value: "MTV" },
    { label: "(UAH) Ua Huka Airport - French Polynesia", value: "UAH" },
    { label: "(UAP) Ua Pou Airport - French Polynesia", value: "UAP" },
    { label: "(AUQ) Hiva Oa-Atuona Airport - French Polynesia", value: "AUQ" },
    { label: "(AHE) Ahe Airport - French Polynesia", value: "AHE" },
    { label: "(APK) Apataki Airport - French Polynesia", value: "APK" },
    { label: "(MXS) Maota Airport - Samoa", value: "MXS" },
    { label: "(MWP) Mountain Airport - Nepal", value: "MWP" },
    { label: "(FUT) Pointe Vele Airport - Wallis and Futuna", value: "FUT" },
    { label: "(IUE) Niue International Airport - Niue", value: "IUE" },
    { label: "(VBV) Vanua Balavu Airport - Fiji", value: "VBV" },
    { label: "(NTT) Kuini Lavenia Airport - Tonga", value: "NTT" },
    { label: "(NFO) Mata'aho Airport - Tonga", value: "NFO" },
    { label: "(HPA) Lifuka Island Airport - Tonga", value: "HPA" },
    { label: "(EUA) Kaufana Airport - Tonga", value: "EUA" },
    { label: "(SVU) Savusavu Airport - Fiji", value: "SVU" },
    { label: "(RTA) Rotuma Airport - Fiji", value: "RTA" },
    { label: "(KXF) Koro Island Airport - Fiji", value: "KXF" },
    { label: "(TVU) Matei Airport - Fiji", value: "TVU" },
    { label: "(LBS) Labasa Airport - Fiji", value: "LBS" },
    { label: "(LKB) Lakeba Island Airport - Fiji", value: "LKB" },
    { label: "(NGI) Ngau Airport - Fiji", value: "NGI" },
    { label: "(MFJ) Moala Airport - Fiji", value: "MFJ" },
    { label: "(MNF) Mana Island Airport - Fiji", value: "MNF" },
    { label: "(KDV) Vunisea Airport - Fiji", value: "KDV" },
    { label: "(PTF) Malolo Lailai Island Airport - Fiji", value: "PTF" },
    { label: "(ICI) Cicia Airport - Fiji", value: "ICI" },
    { label: "(PYE) Penrhyn Island Airport - Cook Islands", value: "PYE" },
    { label: "(MOI) Mitiaro Island Airport - Cook Islands", value: "MOI" },
    { label: "(MUK) Mauke Airport - Cook Islands", value: "MUK" },
    { label: "(MHX) Manihiki Island Airport - Cook Islands", value: "MHX" },
    { label: "(MGS) Mangaia Island Airport - Cook Islands", value: "MGS" },
    { label: "(AIU) Atiu Island Airport - Cook Islands", value: "AIU" },
    { label: "(PID) Nassau Paradise Island Airport - Bahamas", value: "PID" },
    { label: "(CRI) Colonel Hill Airport - Bahamas", value: "CRI" },
    { label: "(CAT) New Bight Airport - Bahamas", value: "CAT" },
    { label: "(ATC) Arthurs Town Airport - Bahamas", value: "ATC" },
    { label: "(COX) Congo Town Airport - Bahamas", value: "COX" },
    { label: "(LBP) Long Banga Airport - Malaysia", value: "LBP" },
    { label: "(SCX) Salina Cruz Naval Air Station - Mexico", value: "SCX" },
    { label: "(TND) Alberto Delgado Airport - Cuba", value: "TND" },
    { label: "(CCC) Cayo Coco Airport - Cuba", value: "CCC" },
    { label: "(PAX) Port-de-Paix Airport - Haiti", value: "PAX" },
    { label: "(JEE) Jeremie Airport - Haiti", value: "JEE" },
    { label: "(PLD) Playa Samara Airport - Costa Rica", value: "PLD" },
    {
      label: "(SYQ) Tobias Bolanos International Airport - Costa Rica",
      value: "SYQ",
    },
    { label: "(PJM) Puerto Jimenez Airport - Costa Rica", value: "PJM" },
    { label: "(PBP) Islita Airport - Costa Rica", value: "PBP" },
    { label: "(TNO) Cabo Velas Airport - Costa Rica", value: "TNO" },
    { label: "(BCL) Barra del Colorado Airport - Costa Rica", value: "BCL" },
    { label: "(TTQ) Aerotortuguero Airport - Costa Rica", value: "TTQ" },
    { label: "(PLP) Captain Ramon Xatruch Airport - Panama", value: "PLP" },
    { label: "(JQE) Jaqué Airport - Panama", value: "JQE" },
    { label: "(ONX) Enrique Adolfo Jimenez Airport - Panama", value: "ONX" },
    { label: "(CTD) Alonso Valderrama Airport - Panama", value: "CTD" },
    { label: "(JAL) Lencero Airport - Mexico", value: "JAL" },
    { label: "(GUB) Guerrero Negro Airport - Mexico", value: "GUB" },
    { label: "(CUA) Ciudad Constitución Airport - Mexico", value: "CUA" },
    {
      label: "(CYW) Captain Rogelio Castillo National Airport - Mexico",
      value: "CYW",
    },
    { label: "(MIJ) Mili Island Airport - Marshall Islands", value: "MIJ" },
    { label: "(PEU) Puerto Lempira Airport - Honduras", value: "PEU" },
    { label: "(AHS) Ahuas Airport - Honduras", value: "AHS" },
    { label: "(WTO) Wotho Island Airport - Marshall Islands", value: "WTO" },
    { label: "(WTE) Wotje Atoll Airport - Marshall Islands", value: "WTE" },
    { label: "(WJA) Woja Airport - Marshall Islands", value: "WJA" },
    { label: "(UIT) Jaluit Airport - Marshall Islands", value: "UIT" },
    { label: "(RNP) Rongelap Island Airport - Marshall Islands", value: "RNP" },
    { label: "(NDK) Namorik Atoll Airport - Marshall Islands", value: "NDK" },
    { label: "(MJE) Majkin Airport - Marshall Islands", value: "MJE" },
    { label: "(MJB) Mejit Atoll Airport - Marshall Islands", value: "MJB" },
    { label: "(MAV) Maloelap Island Airport - Marshall Islands", value: "MAV" },
    { label: "(LIK) Likiep Airport - Marshall Islands", value: "LIK" },
    { label: "(KBT) Kaben Airport - Marshall Islands", value: "KBT" },
    { label: "(JEJ) Jeh Airport - Marshall Islands", value: "JEJ" },
    { label: "(JAT) Jabot Airport - Marshall Islands", value: "JAT" },
    { label: "(BII) Enyu Airfield - Marshall Islands", value: "BII" },
    { label: "(AUL) Aur Island Airport - Marshall Islands", value: "AUL" },
    { label: "(AIM) Ailuk Airport - Marshall Islands", value: "AIM" },
    { label: "(UTK) Utirik Airport - Marshall Islands", value: "UTK" },
    { label: "(AAZ) Quezaltenango Airport - Guatemala", value: "AAZ" },
    { label: "(PBR) Puerto Barrios Airport - Guatemala", value: "PBR" },
    {
      label:
        "(JBQ) Dr Joaquin Balaguer International Airport - Dominican Republic",
      value: "JBQ",
    },
    {
      label: "(AZS) Samaná El Catey International Airport - Dominican Republic",
      value: "AZS",
    },
    {
      label: "(SLX) Salt Cay Airport - Turks and Caicos Islands",
      value: "SLX",
    },
    {
      label: "(MDS) Middle Caicos Airport - Turks and Caicos Islands",
      value: "MDS",
    },
    {
      label:
        "(GDT) JAGS McCartney International Airport - Turks and Caicos Islands",
      value: "GDT",
    },
    { label: "(ILZ) Žilina Airport - Slovakia", value: "ILZ" },
    { label: "(QUB) Ubari Airport - Libya", value: "QUB" },
    { label: "(MRA) Misratah Airport - Libya", value: "MRA" },
    { label: "(SZF) Samsun-Çarşamba Airport - Turkey", value: "SZF" },
    { label: "(EDO) Balikesir Korfez Airport - Turkey", value: "EDO" },
    { label: "(ISE) Isparta Süleyman Demirel Airport - Turkey", value: "ISE" },
    { label: "(ADF) Adiyaman Airport - Turkey", value: "ADF" },
    { label: "(AJI) Agri Airport - Turkey", value: "AJI" },
    { label: "(KCM) Kahramanmaras Airport - Turkey", value: "KCM" },
    { label: "(SFQ) Sanliurfa Airport - Turkey", value: "SFQ" },
    { label: "(KSY) Kars Airport - Turkey", value: "KSY" },
    { label: "(USQ) Usak Airport - Turkey", value: "USQ" },
    {
      label: "(BNX) Banja Luka International Airport - Bosnia and Herzegovina",
      value: "BNX",
    },
    { label: "(CVU) Corvo Airport - Portugal", value: "CVU" },
    { label: "(QSR) Salerno Pontecagnano Airport - Italy", value: "QSR" },
    { label: "(AOT) Aosta Airport - Italy", value: "AOT" },
    { label: "(SOB) Sármellék International Airport - Hungary", value: "SOB" },
    { label: "(QGY) Győr-Pér International Airport - Hungary", value: "QGY" },
    { label: "(PEV) Pécs-Pogány Airport - Hungary", value: "PEV" },
    { label: "(JSY) Syros Airport - Greece", value: "JSY" },
    { label: "(LTT) La Môle Airport - France", value: "LTT" },
    { label: "(EAP) EuroAirport - France", value: "EAP" },
    { label: "(ANE) Angers-Loire Airport - France", value: "ANE" },
    { label: "(IDY) Île d'Yeu Airport - France", value: "IDY" },
    { label: "(RJL) Logroño-Agoncillo Airport - Spain", value: "RJL" },
    { label: "(ECN) Ercan International Airport - Cyprus", value: "ECN" },
    {
      label: "(YKM) Yakima Air Terminal McAllister Field - United States",
      value: "YKM",
    },
    { label: "(KWY) Kiwayu (Mkononi) Airport - Kenya", value: "KWY" },
    { label: "(WRL) Worland Municipal Airport - United States", value: "WRL" },
    { label: "(VLD) Valdosta Regional Airport - United States", value: "VLD" },
    { label: "(VCT) Victoria Regional Airport - United States", value: "VCT" },
    {
      label: "(UIN) Quincy Regional Baldwin Field - United States",
      value: "UIN",
    },
    { label: "(TUP) Tupelo Regional Airport - United States", value: "TUP" },
    {
      label:
        "(SMX) Santa Maria Pub Cpt G Allan Hancock Airport - United States",
      value: "SMX",
    },
    { label: "(SLN) Salina Municipal Airport - United States", value: "SLN" },
    {
      label: "(SLK) Adirondack Regional Airport - United States",
      value: "SLK",
    },
    { label: "(SHR) Sheridan County Airport - United States", value: "SHR" },
    {
      label: "(SBP) San Luis County Regional Airport - United States",
      value: "SBP",
    },
    { label: "(RUT) Rutland State Airport - United States", value: "RUT" },
    {
      label: "(RKS) Rock Springs Sweetwater County Airport - United States",
      value: "RKS",
    },
    {
      label: "(RHI) Rhinelander Oneida County Airport - United States",
      value: "RHI",
    },
    {
      label: "(RDG) Reading Regional Carl A Spaatz Field - United States",
      value: "RDG",
    },
    {
      label: "(PSM) Pease International Tradeport - United States",
      value: "PSM",
    },
    {
      label:
        "(PLN) Pellston Regional Airport of Emmet County Airport - United States",
      value: "PLN",
    },
    { label: "(PIR) Pierre Regional Airport - United States", value: "PIR" },
    { label: "(PIH) Pocatello Regional Airport - United States", value: "PIH" },
    {
      label: "(PIB) Hattiesburg Laurel Regional Airport - United States",
      value: "PIB",
    },
    {
      label: "(OWB) Owensboro Daviess County Airport - United States",
      value: "OWB",
    },
    {
      label: "(OTH) Southwest Oregon Regional Airport - United States",
      value: "OTH",
    },
    {
      label: "(MSL) Northwest Alabama Regional Airport - United States",
      value: "MSL",
    },
    { label: "(MLS) Frank Wiley Field - United States", value: "MLS" },
    { label: "(MKG) Muskegon County Airport - United States", value: "MKG" },
    {
      label: "(LYH) Lynchburg Regional Preston Glenn Field - United States",
      value: "LYH",
    },
    {
      label: "(LWT) Lewistown Municipal Airport - United States",
      value: "LWT",
    },
    { label: "(LNS) Lancaster Airport - United States", value: "LNS" },
    { label: "(LMT) Klamath Falls Airport - United States", value: "LMT" },
    { label: "(LEB) Lebanon Municipal Airport - United States", value: "LEB" },
    {
      label:
        "(LBF) North Platte Regional Airport Lee Bird Field - United States",
      value: "LBF",
    },
    {
      label: "(LBE) Arnold Palmer Regional Airport - United States",
      value: "LBE",
    },
    { label: "(LAR) Laramie Regional Airport - United States", value: "LAR" },
    { label: "(JMS) Jamestown Regional Airport - United States", value: "JMS" },
    {
      label: "(IRK) Kirksville Regional Airport - United States",
      value: "IRK",
    },
    { label: "(KIO) Kili Airport - Marshall Islands", value: "KIO" },
    {
      label: "(HTS) Tri State Milton J Ferguson Field - United States",
      value: "HTS",
    },
    { label: "(HOT) Memorial Field - United States", value: "HOT" },
    {
      label: "(GRI) Central Nebraska Regional Airport - United States",
      value: "GRI",
    },
    {
      label: "(GGW) Wokal Field Glasgow International Airport - United States",
      value: "GGW",
    },
    {
      label: "(FAY) Fayetteville Regional Grannis Field - United States",
      value: "FAY",
    },
    {
      label: "(EWB) New Bedford Regional Airport - United States",
      value: "EWB",
    },
    { label: "(EKO) Elko Regional Airport - United States", value: "EKO" },
    {
      label: "(EAU) Chippewa Valley Regional Airport - United States",
      value: "EAU",
    },
    { label: "(DUJ) DuBois Regional Airport - United States", value: "DUJ" },
    {
      label: "(DDC) Dodge City Regional Airport - United States",
      value: "DDC",
    },
    {
      label: "(CMX) Houghton County Memorial Airport - United States",
      value: "CMX",
    },
    {
      label: "(CLM) William R Fairchild International Airport - United States",
      value: "CLM",
    },
    {
      label: "(CKB) Harrison Marion Regional Airport - United States",
      value: "CKB",
    },
    {
      label: "(CIU) Chippewa County International Airport - United States",
      value: "CIU",
    },
    {
      label: "(CGI) Cape Girardeau Regional Airport - United States",
      value: "CGI",
    },
    { label: "(CEC) Del Norte County Airport - United States", value: "CEC" },
    {
      label: "(BRL) Southeast Iowa Regional Airport - United States",
      value: "BRL",
    },
    {
      label: "(BQK) Brunswick Golden Isles Airport - United States",
      value: "BQK",
    },
    {
      label: "(BKW) Raleigh County Memorial Airport - United States",
      value: "BKW",
    },
    {
      label: "(BFF) Western Nebraska Regional Airport - United States",
      value: "BFF",
    },
    { label: "(BFD) Bradford Regional Airport - United States", value: "BFD" },
    { label: "(ATY) Watertown Regional Airport - United States", value: "ATY" },
    {
      label: "(APN) Alpena County Regional Airport - United States",
      value: "APN",
    },
    {
      label: "(ALW) Walla Walla Regional Airport - United States",
      value: "ALW",
    },
    { label: "(ALO) Waterloo Regional Airport - United States", value: "ALO" },
    {
      label: "(ALM) Alamogordo White Sands Regional Airport - United States",
      value: "ALM",
    },
    { label: "(AHN) Athens Ben Epps Airport - United States", value: "AHN" },
    {
      label: "(ABY) Southwest Georgia Regional Airport - United States",
      value: "ABY",
    },
    { label: "(ABR) Aberdeen Regional Airport - United States", value: "ABR" },
    { label: "(TQR) San Domino Island Heliport - Italy", value: "TQR" },
    { label: "(GSM) Gheshm Airport - Iran", value: "GSM" },
    { label: "(DIU) Diu Airport - India", value: "DIU" },
    { label: "(ULU) Gulu Airport - Uganda", value: "ULU" },
    { label: "(RUA) Arua Airport - Uganda", value: "RUA" },
    { label: "(TBO) Tabora Airport - Tanzania", value: "TBO" },
    { label: "(SHY) Shinyanga Airport - Tanzania", value: "SHY" },
    { label: "(MUZ) Musoma Airport - Tanzania", value: "MUZ" },
    { label: "(LDI) Kikwetu Airport - Tanzania", value: "LDI" },
    { label: "(TKQ) Kigoma Airport - Tanzania", value: "TKQ" },
    { label: "(BKZ) Bukoba Airport - Tanzania", value: "BKZ" },
    {
      label: "(PZU) Port Sudan New International Airport - Sudan",
      value: "PZU",
    },
    { label: "(UYL) Nyala Airport - Sudan", value: "UYL" },
    { label: "(ATB) Atbara Airport - Sudan", value: "ATB" },
    { label: "(LAQ) La Abraq Airport - Libya", value: "LAQ" },
    { label: "(MJI) Mitiga Airport - Libya", value: "MJI" },
    { label: "(TOB) Gamal Abdel Nasser Airport - Libya", value: "TOB" },
    { label: "(SRX) Gardabya Airport - Libya", value: "SRX" },
    { label: "(NYK) Nanyuki Civil Airport - Kenya", value: "NYK" },
    { label: "(MYD) Malindi Airport - Kenya", value: "MYD" },
    { label: "(LKG) Lokichoggio Airport - Kenya", value: "LKG" },
    { label: "(ASV) Amboseli Airport - Kenya", value: "ASV" },
    { label: "(ATZ) Asyut International Airport - Egypt", value: "ATZ" },
    { label: "(AAC) El Arish International Airport - Egypt", value: "AAC" },
    { label: "(BUO) Burao Airport - Somalia", value: "BUO" },
    { label: "(GLK) Galcaio Airport - Somalia", value: "GLK" },
    { label: "(MGQ) Aden Adde International Airport - Somalia", value: "MGQ" },
    { label: "(BSA) Bosaso Airport - Somalia", value: "BSA" },
    { label: "(ALU) Alula Airport - Somalia", value: "ALU" },
    { label: "(TIE) Tippi Airport - Ethiopia", value: "TIE" },
    { label: "(MTF) Mizan Teferi Airport - Ethiopia", value: "MTF" },
    { label: "(ABK) Kabri Dehar Airport - Ethiopia", value: "ABK" },
    { label: "(GOR) Gore Airport - Ethiopia", value: "GOR" },
    { label: "(GDE) Gode Airport - Ethiopia", value: "GDE" },
    { label: "(DEM) Dembidollo Airport - Ethiopia", value: "DEM" },
    { label: "(DSE) Combolcha Airport - Ethiopia", value: "DSE" },
    { label: "(BEI) Beica Airport - Ethiopia", value: "BEI" },
    { label: "(BCO) Baco Airport - Ethiopia", value: "BCO" },
    { label: "(SFL) Sao Filipe Airport - Cape Verde", value: "SFL" },
    { label: "(RAI) Praia International Airport - Cape Verde", value: "RAI" },
    { label: "(NDR) El Aroui Airport - Morocco", value: "NDR" },
    { label: "(EUN) Hassan I Airport - Western Sahara", value: "EUN" },
    { label: "(ESU) Mogador Airport - Morocco", value: "ESU" },
    { label: "(VIL) Dakhla Airport - Western Sahara", value: "VIL" },
    { label: "(SMW) Smara Airport - Western Sahara", value: "SMW" },
    { label: "(QFI) Iginniarfik Heliport - Greenland", value: "QFI" },
    { label: "(QCU) Akunnaaq Heliport - Greenland", value: "QCU" },
    { label: "(JGR) Groennedal Heliport - Greenland", value: "JGR" },
    {
      label: "(OXB) Osvaldo Vieira International Airport - Guinea-Bissau",
      value: "OXB",
    },
    { label: "(KEN) Kenema Airport - Sierra Leone", value: "KEN" },
    { label: "(KBS) Bo Airport - Sierra Leone", value: "KBS" },
    {
      label: "(BTE) Sherbro International Airport - Sierra Leone",
      value: "BTE",
    },
    { label: "(JCU) Ceuta Heliport - Spain", value: "JCU" },
    { label: "(CRU) Lauriston Airport - Grenada", value: "CRU" },
    { label: "(GMZ) La Gomera Airport - Spain", value: "GMZ" },
    { label: "(PSV) Papa Stour Airport - United Kingdom", value: "PSV" },
    { label: "(OUK) Outer Skerries Airport - United Kingdom", value: "OUK" },
    { label: "(FOA) Foula Airport - United Kingdom", value: "FOA" },
    { label: "(GAX) Gamba - Gabon", value: "GAX" },
    { label: "(PFR) Ilebo Airport - Congo (Kinshasa)", value: "PFR" },
    { label: "(LJA) Lodja Airport - Congo (Kinshasa)", value: "LJA" },
    { label: "(TSH) Tshikapa Airport - Congo (Kinshasa)", value: "TSH" },
    { label: "(BSU) Basankusu Airport - Congo (Kinshasa)", value: "BSU" },
    {
      label: "(KRZ) Basango Mboliasa Airport - Congo (Kinshasa)",
      value: "KRZ",
    },
    { label: "(NIO) Nioki Airport - Congo (Kinshasa)", value: "NIO" },
    { label: "(INO) Inongo Airport - Congo (Kinshasa)", value: "INO" },
    { label: "(MAT) Tshimpi Airport - Congo (Kinshasa)", value: "MAT" },
    { label: "(BOA) Boma Airport - Congo (Kinshasa)", value: "BOA" },
    { label: "(ERS) Eros Airport - Namibia", value: "ERS" },
    { label: "(SWP) Swakopmund Airport - Namibia", value: "SWP" },
    { label: "(OMD) Oranjemund Airport - Namibia", value: "OMD" },
    { label: "(OND) Ondangwa Airport - Namibia", value: "OND" },
    { label: "(LUD) Luderitz Airport - Namibia", value: "LUD" },
    { label: "(CMK) Club Makokola Airport - Malawi", value: "CMK" },
    { label: "(SRH) Sarh Airport - Chad", value: "SRH" },
    { label: "(JCA) Croisette Heliport - France", value: "JCA" },
    { label: "(VPY) Chimoio Airport - Mozambique", value: "VPY" },
    { label: "(TCH) Tchibanga Airport - Gabon", value: "TCH" },
    { label: "(MJL) Mouilla Ville Airport - Gabon", value: "MJL" },
    { label: "(KOU) Koulamoutou Airport - Gabon", value: "KOU" },
    { label: "(MSZ) Namibe Airport - Angola", value: "MSZ" },
    { label: "(VPE) Ondjiva Pereira Airport - Angola", value: "VPE" },
    { label: "(DUE) Dundo Airport - Angola", value: "DUE" },
    { label: "(CBT) Catumbela Airport - Angola", value: "CBT" },
    { label: "(MJA) Manja Airport - Madagascar", value: "MJA" },
    { label: "(WMA) Mandritsara Airport - Madagascar", value: "WMA" },
    { label: "(TTS) Tsaratanana Airport - Madagascar", value: "TTS" },
    { label: "(WMP) Mampikony Airport - Madagascar", value: "WMP" },
    { label: "(DWB) Soalala Airport - Madagascar", value: "DWB" },
    { label: "(IVA) Ambanja Airport - Madagascar", value: "IVA" },
    { label: "(WPB) Port Bergé Airport - Madagascar", value: "WPB" },
    { label: "(WAM) Ambatondrazaka Airport - Madagascar", value: "WAM" },
    { label: "(WTS) Tsiroanomandidy Airport - Madagascar", value: "WTS" },
    { label: "(WTA) Tambohorano Airport - Madagascar", value: "WTA" },
    { label: "(TVA) Morafenobe Airport - Madagascar", value: "TVA" },
    { label: "(MXT) Maintirano Airport - Madagascar", value: "MXT" },
    { label: "(BMD) Belo sur Tsiribihina Airport - Madagascar", value: "BMD" },
    { label: "(JVA) Ankavandra Airport - Madagascar", value: "JVA" },
    { label: "(WAQ) Antsalova Airport - Madagascar", value: "WAQ" },
    { label: "(YVA) Iconi Airport - Comoros", value: "YVA" },
    { label: "(SLI) Solwesi Airport - Zambia", value: "SLI" },
    { label: "(CIP) Chipata Airport - Zambia", value: "CIP" },
    { label: "(DIS) Loubomo Airport - Congo (Brazzaville)", value: "DIS" },
    { label: "(TLD) Limpopo Valley Airport - Botswana", value: "TLD" },
    { label: "(SWX) Shakawe Airport - Botswana", value: "SWX" },
    { label: "(ORP) Orapa Airport - Botswana", value: "ORP" },
    { label: "(GNZ) Ghanzi Airport - Botswana", value: "GNZ" },
    {
      label: "(MBD) Mmabatho International Airport - South Africa",
      value: "MBD",
    },
    { label: "(AAM) Malamala Airport - South Africa", value: "AAM" },
    {
      label: "(MQP) Kruger Mpumalanga International Airport - South Africa",
      value: "MQP",
    },
    { label: "(QRA) Rand Airport - South Africa", value: "QRA" },
    { label: "(VTS) Ventspils International Airport - Latvia", value: "VTS" },
    { label: "(SHC) Shire Inda Selassie Airport - Ethiopia", value: "SHC" },
    { label: "(HIL) Shilavo Airport - Ethiopia", value: "HIL" },
    { label: "(HMV) Hemavan Airport - Sweden", value: "HMV" },
    { label: "(SQO) Storuman Airport - Sweden", value: "SQO" },
    { label: "(AGH) Ängelholm-Helsingborg Airport - Sweden", value: "AGH" },
    { label: "(TYF) Torsby Airport - Sweden", value: "TYF" },
    { label: "(KSD) Karlstad Airport - Sweden", value: "KSD" },
    { label: "(HFS) Hagfors Airport - Sweden", value: "HFS" },
    { label: "(OSD) Östersund Airport - Sweden", value: "OSD" },
    { label: "(LCJ) Łódź Władysław Reymont Airport - Poland", value: "LCJ" },
    {
      label: "(BZG) Bydgoszcz Ignacy Jan Paderewski Airport - Poland",
      value: "BZG",
    },
    { label: "(VRY) Værøy Heliport - Norway", value: "VRY" },
    { label: "(VAW) Svartnes Airport - Norway", value: "VAW" },
    { label: "(SOJ) Sorkjosen Airport - Norway", value: "SOJ" },
    { label: "(SVJ) Svolvær Helle Airport - Norway", value: "SVJ" },
    { label: "(SOG) Sogndal Airport - Norway", value: "SOG" },
    { label: "(SDN) Anda Airport - Norway", value: "SDN" },
    { label: "(RET) Røst Airport - Norway", value: "RET" },
    { label: "(RVK) Ryum Airport - Norway", value: "RVK" },
    { label: "(MQN) Røssvoll Airport - Norway", value: "MQN" },
    { label: "(OSY) Namsos Høknesøra Airport - Norway", value: "OSY" },
    { label: "(LKN) Leknes Airport - Norway", value: "LKN" },
    { label: "(CNL) Sindal Airport - Denmark", value: "CNL" },
    { label: "(CFN) Donegal Airport - Ireland", value: "CFN" },
    { label: "(BRR) Barra Airport - United Kingdom", value: "BRR" },
    { label: "(HLY) Anglesey Airport - United Kingdom", value: "HLY" },
    { label: "(PZE) Penzance Heliport - United Kingdom", value: "PZE" },
    {
      label: "(LEQ) Land's End / St. Just Airport - United Kingdom",
      value: "LEQ",
    },
    { label: "(WRY) Westray Airport - United Kingdom", value: "WRY" },
    {
      label: "(LWK) Lerwick / Tingwall Airport - United Kingdom",
      value: "LWK",
    },
    { label: "(NDY) Sanday Airport - United Kingdom", value: "NDY" },
    { label: "(SOY) Stronsay Airport - United Kingdom", value: "SOY" },
    { label: "(PPW) Papa Westray Airport - United Kingdom", value: "PPW" },
    { label: "(NRL) North Ronaldsay Airport - United Kingdom", value: "NRL" },
    { label: "(FIE) Fair Isle Airport - United Kingdom", value: "FIE" },
    { label: "(EOI) Eday Airport - United Kingdom", value: "EOI" },
    { label: "(CAL) Campbeltown Airport - United Kingdom", value: "CAL" },
    {
      label: "(DSA) Robin Hood Doncaster Sheffield Airport - United Kingdom",
      value: "DSA",
    },
    { label: "(NQT) Nottingham Airport - United Kingdom", value: "NQT" },
    { label: "(SJY) Seinäjoki Airport - Finland", value: "SJY" },
    { label: "(HGL) Helgoland-Düne Airport - Germany", value: "HGL" },
    { label: "(HEI) Heide-Büsum Airport - Germany", value: "HEI" },
    { label: "(HDF) Heringsdorf Airport - Germany", value: "HDF" },
    { label: "(KMS) Kumasi Airport - Ghana", value: "KMS" },
    { label: "(ELU) Guemar Airport - Algeria", value: "ELU" },
    { label: "(BMW) Bordj Badji Mokhtar Airport - Algeria", value: "BMW" },
    {
      label: "(CBH) Béchar Boudghene Ben Ali Lotfi Airport - Algeria",
      value: "CBH",
    },
    { label: "(BLJ) Batna Airport - Algeria", value: "BLJ" },
    { label: "(ZWL) Wollaston Lake Airport - Canada", value: "ZWL" },
    { label: "(ZUM) Churchill Falls Airport - Canada", value: "ZUM" },
    { label: "(ZTM) Shamattawa Airport - Canada", value: "ZTM" },
    { label: "(ZSJ) Sandy Lake Airport - Canada", value: "ZSJ" },
    {
      label: "(ZRJ) Round Lake (Weagamow Lake) Airport - Canada",
      value: "ZRJ",
    },
    { label: "(ZPB) Sachigo Lake Airport - Canada", value: "ZPB" },
    { label: "(ZMT) Masset Airport - Canada", value: "ZMT" },
    { label: "(MSA) Muskrat Dam Airport - Canada", value: "MSA" },
    { label: "(ZKE) Kashechewan Airport - Canada", value: "ZKE" },
    { label: "(ZJN) Swan River Airport - Canada", value: "ZJN" },
    { label: "(ZGI) Gods River Airport - Canada", value: "ZGI" },
    { label: "(ZFD) Fond-Du-Lac Airport - Canada", value: "ZFD" },
    { label: "(ZEM) Eastmain River Airport - Canada", value: "ZEM" },
    { label: "(ZBF) Bathurst Airport - Canada", value: "ZBF" },
    { label: "(ILF) Ilford Airport - Canada", value: "ILF" },
    { label: "(ZAC) York Landing Airport - Canada", value: "ZAC" },
    { label: "(YZG) Salluit Airport - Canada", value: "YZG" },
    { label: "(YXN) Whale Cove Airport - Canada", value: "YXN" },
    { label: "(YWP) Webequie Airport - Canada", value: "YWP" },
    { label: "(YVZ) Deer Lake Airport - Canada", value: "YVZ" },
    { label: "(YTL) Big Trout Lake Airport - Canada", value: "YTL" },
    { label: "(YST) St. Theresa Point Airport - Canada", value: "YST" },
    { label: "(YSK) Sanikiluaq Airport - Canada", value: "YSK" },
    { label: "(YSF) Stony Rapids Airport - Canada", value: "YSF" },
    { label: "(YRL) Red Lake Airport - Canada", value: "YRL" },
    { label: "(YRA) Rae Lakes Airport - Canada", value: "YRA" },
    { label: "(YQN) Nakina Airport - Canada", value: "YQN" },
    { label: "(YQD) The Pas Airport - Canada", value: "YQD" },
    { label: "(YPW) Powell River Airport - Canada", value: "YPW" },
    { label: "(YPO) Peawanuck Airport - Canada", value: "YPO" },
    { label: "(YPM) Pikangikum Airport - Canada", value: "YPM" },
    { label: "(YPH) Inukjuak Airport - Canada", value: "YPH" },
    { label: "(YOH) Oxford House Airport - Canada", value: "YOH" },
    { label: "(YNL) Points North Landing Airport - Canada", value: "YNL" },
    { label: "(YNE) Norway House Airport - Canada", value: "YNE" },
    { label: "(YNC) Wemindji Airport - Canada", value: "YNC" },
    { label: "(YUD) Umiujaq Airport - Canada", value: "YUD" },
    { label: "(YMT) Chapais Airport - Canada", value: "YMT" },
    { label: "(YMH) Mary's Harbour Airport - Canada", value: "YMH" },
    {
      label: "(XGR) Kangiqsualujjuaq (Georges River) Airport - Canada",
      value: "XGR",
    },
    { label: "(YSG) Lutselk'e Airport - Canada", value: "YSG" },
    { label: "(YLH) Lansdowne House Airport - Canada", value: "YLH" },
    { label: "(YLC) Kimmirut Airport - Canada", value: "YLC" },
    { label: "(YPJ) Aupaluk Airport - Canada", value: "YPJ" },
    { label: "(YKQ) Waskaganish Airport - Canada", value: "YKQ" },
    { label: "(AKV) Akulivik Airport - Canada", value: "AKV" },
    { label: "(YIV) Island Lake Airport - Canada", value: "YIV" },
    { label: "(YIK) Ivujivik Airport - Canada", value: "YIK" },
    { label: "(YHR) Chevery Airport - Canada", value: "YHR" },
    { label: "(YHO) Hopedale Airport - Canada", value: "YHO" },
    { label: "(YNS) Nemiscau Airport - Canada", value: "YNS" },
    { label: "(YHC) Vancouver Harbour Water Airport - Canada", value: "YHC" },
    { label: "(YQC) Quaqtaq Airport - Canada", value: "YQC" },
    { label: "(YGZ) Grise Fiord Airport - Canada", value: "YGZ" },
    { label: "(YGX) Gillam Airport - Canada", value: "YGX" },
    { label: "(YGW) Kuujjuarapik Airport - Canada", value: "YGW" },
    { label: "(YGT) Igloolik Airport - Canada", value: "YGT" },
    { label: "(YGO) Gods Lake Narrows Airport - Canada", value: "YGO" },
    { label: "(YGB) Texada Gillies Bay Airport - Canada", value: "YGB" },
    { label: "(YMN) Makkovik Airport - Canada", value: "YMN" },
    { label: "(YFH) Fort Hope Airport - Canada", value: "YFH" },
    { label: "(YFA) Fort Albany Airport - Canada", value: "YFA" },
    { label: "(YER) Fort Severn Airport - Canada", value: "YER" },
    { label: "(YDP) Nain Airport - Canada", value: "YDP" },
    { label: "(YCS) Chesterfield Inlet Airport - Canada", value: "YCS" },
    { label: "(YRF) Cartwright Airport - Canada", value: "YRF" },
    { label: "(YBX) Lourdes De Blanc Sablon Airport - Canada", value: "YBX" },
    { label: "(YBE) Uranium City Airport - Canada", value: "YBE" },
    { label: "(YAT) Attawapiskat Airport - Canada", value: "YAT" },
    { label: "(YKG) Kangirsuk Airport - Canada", value: "YKG" },
    { label: "(XKS) Kasabonika Airport - Canada", value: "XKS" },
    { label: "(YAG) Fort Frances Municipal Airport - Canada", value: "YAG" },
    { label: "(YAC) Cat Lake Airport - Canada", value: "YAC" },
    { label: "(TCD) Tarapacá Airport - Colombia", value: "TCD" },
    { label: "(APO) Apartadó Airport - Colombia", value: "APO" },
    { label: "(NTG) Nantong Airport - China", value: "NTG" },
    { label: "(ZLT) La Tabatière Airport - Canada", value: "ZLT" },
    { label: "(ZTB) Tête-à-la-Baleine Airport - Canada", value: "ZTB" },
    { label: "(YKU) Chisasibi Airport - Canada", value: "YKU" },
    { label: "(YHP) Poplar Hill Airport - Canada", value: "YHP" },
    { label: "(YOG) Ogoki Post Airport - Canada", value: "YOG" },
    { label: "(KIF) Kingfisher Lake Airport - Canada", value: "KIF" },
    { label: "(XBE) Bearskin Lake Airport - Canada", value: "XBE" },
    { label: "(YNO) North Spirit Lake Airport - Canada", value: "YNO" },
    { label: "(WNN) Wunnumin Lake Airport - Canada", value: "WNN" },
    { label: "(YAX) Wapekeka Airport - Canada", value: "YAX" },
    { label: "(SUR) Summer Beaver Airport - Canada", value: "SUR" },
    { label: "(YLE) Whatì Airport - Canada", value: "YLE" },
    { label: "(YCK) Colville Lake Airport - Canada", value: "YCK" },
    { label: "(YRG) Rigolet Airport - Canada", value: "YRG" },
    { label: "(YHA) Port Hope Simpson Airport - Canada", value: "YHA" },
    { label: "(YFX) St. Lewis (Fox Harbour) Airport - Canada", value: "YFX" },
    { label: "(YWM) Williams Harbour Airport - Canada", value: "YWM" },
    { label: "(YAA) Anahim Lake Airport - Canada", value: "YAA" },
    {
      label: "(YWS) Whistler/Green Lake Water Aerodrome - Canada",
      value: "YWS",
    },
    { label: "(PND) Punta Gorda Airport - Belize", value: "PND" },
    { label: "(CUK) Caye Caulker Airport - Belize", value: "CUK" },
    { label: "(VPN) Vopnafjörður Airport - Iceland", value: "VPN" },
    { label: "(THO) Thorshofn Airport - Iceland", value: "THO" },
    { label: "(DRK) Drake Bay Airport - Costa Rica", value: "DRK" },
    { label: "(GRY) Grímsey Airport - Iceland", value: "GRY" },
    { label: "(JQA) Qaarsut Airport - Greenland", value: "JQA" },
    { label: "(JUV) Upernavik Airport - Greenland", value: "JUV" },
    { label: "(JHS) Sisimiut Airport - Greenland", value: "JHS" },
    { label: "(NAQ) Qaanaaq Airport - Greenland", value: "NAQ" },
    { label: "(JNS) Narsaq Heliport - Greenland", value: "JNS" },
    { label: "(JNN) Nanortalik Heliport - Greenland", value: "JNN" },
    { label: "(JSU) Maniitsoq Airport - Greenland", value: "JSU" },
    { label: "(JJU) Qaqortoq Heliport - Greenland", value: "JJU" },
    { label: "(JGO) Qeqertarsuaq Heliport - Greenland", value: "JGO" },
    { label: "(JFR) Paamiut Heliport - Greenland", value: "JFR" },
    { label: "(CNP) Neerlerit Inaat Airport - Greenland", value: "CNP" },
    { label: "(LLU) Alluitsup Paa Heliport - Greenland", value: "LLU" },
    { label: "(WBM) Wapenamanda Airport - Papua New Guinea", value: "WBM" },
    { label: "(VAI) Vanimo Airport - Papua New Guinea", value: "VAI" },
    { label: "(RAB) Tokua Airport - Papua New Guinea", value: "RAB" },
    { label: "(TBG) Tabubil Airport - Papua New Guinea", value: "TBG" },
    { label: "(TIZ) Tari Airport - Papua New Guinea", value: "TIZ" },
    { label: "(MIS) Misima Island Airport - Papua New Guinea", value: "MIS" },
    { label: "(MXH) Moro Airport - Papua New Guinea", value: "MXH" },
    { label: "(MAS) Momote Airport - Papua New Guinea", value: "MAS" },
    { label: "(MDU) Mendi Airport - Papua New Guinea", value: "MDU" },
    { label: "(KVG) Kavieng Airport - Papua New Guinea", value: "KVG" },
    { label: "(KMA) Kerema Airport - Papua New Guinea", value: "KMA" },
    { label: "(KRI) Kikori Airport - Papua New Guinea", value: "KRI" },
    { label: "(UNG) Kiunga Airport - Papua New Guinea", value: "UNG" },
    { label: "(HKN) Kimbe Airport - Papua New Guinea", value: "HKN" },
    { label: "(PNP) Girua Airport - Papua New Guinea", value: "PNP" },
    { label: "(GUR) Gurney Airport - Papua New Guinea", value: "GUR" },
    { label: "(DAU) Daru Airport - Papua New Guinea", value: "DAU" },
    { label: "(CMU) Chimbu Airport - Papua New Guinea", value: "CMU" },
    { label: "(BUA) Buka Airport - Papua New Guinea", value: "BUA" },
    { label: "(RBV) Ramata Airport - Solomon Islands", value: "RBV" },
    { label: "(KGE) Kagau Island Airport - Solomon Islands", value: "KGE" },
    { label: "(VAO) Suavanao Airport - Solomon Islands", value: "VAO" },
    { label: "(RUS) Marau Airport - Solomon Islands", value: "RUS" },
    { label: "(RNL) Rennell/Tingoa Airport - Solomon Islands", value: "RNL" },
    { label: "(MNY) Mono Airport - Solomon Islands", value: "MNY" },
    { label: "(GZO) Nusatupe Airport - Solomon Islands", value: "GZO" },
    { label: "(MUA) Munda Airport - Solomon Islands", value: "MUA" },
    {
      label: "(SCZ) Santa Cruz/Graciosa Bay/Luova Airport - Solomon Islands",
      value: "SCZ",
    },
    { label: "(IRA) Ngorangora Airport - Solomon Islands", value: "IRA" },
    { label: "(MBU) Babanakira Airport - Solomon Islands", value: "MBU" },
    { label: "(FRE) Fera/Maringe Airport - Solomon Islands", value: "FRE" },
    { label: "(BAS) Ballalae Airport - Solomon Islands", value: "BAS" },
    { label: "(AKS) Auki Airport - Solomon Islands", value: "AKS" },
    { label: "(ATD) Uru Harbour Airport - Solomon Islands", value: "ATD" },
    { label: "(KXK) Komsomolsk-on-Amur Airport - Russia", value: "KXK" },
    { label: "(OYG) Moyo Airport - Uganda", value: "OYG" },
    { label: "(IKS) Tiksi Airport - Russia", value: "IKS" },
    { label: "(CYX) Cherskiy Airport - Russia", value: "CYX" },
    { label: "(CKH) Chokurdakh Airport - Russia", value: "CKH" },
    { label: "(CNN) Chulman - Russia", value: "CNN" },
    { label: "(KSN) Kostanay West Airport - Kazakhstan", value: "KSN" },
    { label: "(DZN) Zhezkazgan Airport - Kazakhstan", value: "DZN" },
    { label: "(KOV) Kokshetau Airport - Kazakhstan", value: "KOV" },
    {
      label:
        "(UNI) Union Island International Airport - Saint Vincent and the Grenadines",
      value: "UNI",
    },
    {
      label: "(BQU) J F Mitchell Airport - Saint Vincent and the Grenadines",
      value: "BQU",
    },
    {
      label: "(VIJ) Virgin Gorda Airport - British Virgin Islands",
      value: "VIJ",
    },
    {
      label:
        "(NEV) Vance Winkworth Amory International Airport - Saint Kitts and Nevis",
      value: "NEV",
    },
    { label: "(BBR) Baillif Airport - Guadeloupe", value: "BBR" },
    { label: "(DSD) La Désirade Airport - Guadeloupe", value: "DSD" },
    {
      label: "(VIG) Juan Pablo Pérez Alfonso Airport - Venezuela",
      value: "VIG",
    },
    {
      label: "(MDO) El Jaguel / Punta del Este Airport - Uruguay",
      value: "MDO",
    },
    { label: "(SRA) Santa Rosa Airport - Brazil", value: "SRA" },
    {
      label: "(HUU) Alferez Fap David Figueroa Fernandini Airport - Peru",
      value: "HUU",
    },
    { label: "(LHC) Caballococha Airport - Peru", value: "LHC" },
    {
      label: "(SRJ) Capitán Av. German Quiroga G. Airport - Bolivia",
      value: "SRJ",
    },
    {
      label: "(RIB) Capitán Av. Selin Zeitun Lopez Airport - Bolivia",
      value: "RIB",
    },
    {
      label: "(GYA) Capitán de Av. Emilio Beltrán Airport - Bolivia",
      value: "GYA",
    },
    { label: "(PDA) Obando Airport - Colombia", value: "PDA" },
    { label: "(NQU) Reyes Murillo Airport - Colombia", value: "NQU" },
    { label: "(LPD) La Pedrera Airport - Colombia", value: "LPD" },
    { label: "(LQM) Caucaya Airport - Colombia", value: "LQM" },
    { label: "(GLJ) La Jagua Airport - Colombia", value: "GLJ" },
    { label: "(CRC) Santa Ana Airport - Colombia", value: "CRC" },
    { label: "(PSY) Stanley Airport - Falkland Islands", value: "PSY" },
    { label: "(LOH) Camilo Ponce Enriquez Airport - Ecuador", value: "LOH" },
    { label: "(SCY) San Cristóbal Airport - Ecuador", value: "SCY" },
    { label: "(SOD) Sorocaba Airport - Brazil", value: "SOD" },
    { label: "(ESR) Ricardo García Posada Airport - Chile", value: "ESR" },
    { label: "(VDC) Vitória da Conquista Airport - Brazil", value: "VDC" },
    { label: "(MII) Marília Airport - Brazil", value: "MII" },
    { label: "(MEA) Macaé Airport - Brazil", value: "MEA" },
    { label: "(NEC) Necochea Airport - Argentina", value: "NEC" },
    { label: "(ING) Lago Argentino Airport - Argentina", value: "ING" },
    { label: "(RXS) Roxas Airport - Philippines", value: "RXS" },
    { label: "(CYP) Calbayog Airport - Philippines", value: "CYP" },
    { label: "(VRC) Virac Airport - Philippines", value: "VRC" },
    { label: "(TUG) Tuguegarao Airport - Philippines", value: "TUG" },
    { label: "(SFE) San Fernando Airport - Philippines", value: "SFE" },
    { label: "(BSO) Basco Airport - Philippines", value: "BSO" },
    { label: "(WNP) Naga Airport - Philippines", value: "WNP" },
    { label: "(TDG) Tandag Airport - Philippines", value: "TDG" },
    { label: "(SUG) Surigao Airport - Philippines", value: "SUG" },
    { label: "(SGS) Sanga Sanga Airport - Philippines", value: "SGS" },
    {
      label: "(GES) General Santos International Airport - Philippines",
      value: "GES",
    },
    {
      label: "(SFS) Subic Bay International Airport - Philippines",
      value: "SFS",
    },
    {
      label: "(YNY) Yangyang International Airport - South Korea",
      value: "YNY",
    },
    { label: "(DYR) Ugolny Airport - Russia", value: "DYR" },
    { label: "(OHO) Okhotsk Airport - Russia", value: "OHO" },
    { label: "(UJE) Ujae Atoll Airport - Marshall Islands", value: "UJE" },
    { label: "(MPW) Mariupol International Airport - Ukraine", value: "MPW" },
    { label: "(VSG) Luhansk International Airport - Ukraine", value: "VSG" },
    {
      label: "(OZH) Zaporizhzhia International Airport - Ukraine",
      value: "OZH",
    },
    { label: "(KWG) Lozuvatka International Airport - Ukraine", value: "KWG" },
    { label: "(HRK) Osnova International Airport - Ukraine", value: "HRK" },
    {
      label: "(IFO) Ivano Frankivsk International Airport - Ukraine",
      value: "IFO",
    },
    { label: "(CWC) Chernivtsi International Airport - Ukraine", value: "CWC" },
    { label: "(RWN) Rivne International Airport - Ukraine", value: "RWN" },
    { label: "(UDJ) Uzhhorod International Airport - Ukraine", value: "UDJ" },
    { label: "(CSH) Solovki Airport - Russia", value: "CSH" },
    { label: "(CEE) Cherepovets Airport - Russia", value: "CEE" },
    { label: "(AMV) Amderma Airport - Russia", value: "AMV" },
    { label: "(KSZ) Kotlas Airport - Russia", value: "KSZ" },
    { label: "(PES) Petrozavodsk Airport - Russia", value: "PES" },
    { label: "(GNA) Hrodno Airport - Belarus", value: "GNA" },
    { label: "(MVQ) Mogilev Airport - Belarus", value: "MVQ" },
    { label: "(EIE) Yeniseysk Airport - Russia", value: "EIE" },
    { label: "(KYZ) Kyzyl Airport - Russia", value: "KYZ" },
    { label: "(NOZ) Spichenkovo Airport - Russia", value: "NOZ" },
    { label: "(HTG) Khatanga Airport - Russia", value: "HTG" },
    { label: "(IAA) Igarka Airport - Russia", value: "IAA" },
    { label: "(GRV) Grozny Airport - Russia", value: "GRV" },
    { label: "(NAL) Nalchik Airport - Russia", value: "NAL" },
    { label: "(OGZ) Beslan Airport - Russia", value: "OGZ" },
    { label: "(ESL) Elista Airport - Russia", value: "ESL" },
    { label: "(WKK) Aleknagik Airport - United States", value: "WKK" },
    { label: "(BKX) Brookings Regional Airport - United States", value: "BKX" },
    { label: "(BLF) Mercer County Airport - United States", value: "BLF" },
    { label: "(EAR) Kearney Municipal Airport - United States", value: "EAR" },
    { label: "(GLH) Mid Delta Regional Airport - United States", value: "GLH" },
    { label: "(IFP) Laughlin-Bullhead Intl - United States", value: "IFP" },
    { label: "(IGM) Kingman Airport - United States", value: "IGM" },
    { label: "(PSC) Tri Cities Airport - United States", value: "PSC" },
    { label: "(KQA) Akutan Seaplane Base - United States", value: "KQA" },
    { label: "(SVC) Grant County Airport - United States", value: "SVC" },
    { label: "(LPS) Lopez Island Airport - United States", value: "LPS" },
    { label: "(SLY) Salekhard Airport - Russia", value: "SLY" },
    { label: "(HMA) Khanty Mansiysk Airport - Russia", value: "HMA" },
    { label: "(NYA) Nyagan Airport - Russia", value: "NYA" },
    { label: "(OVS) Sovetsky Tyumenskaya Airport - Russia", value: "OVS" },
    { label: "(IJK) Izhevsk Airport - Russia", value: "IJK" },
    { label: "(KVX) Pobedilovo Airport - Russia", value: "KVX" },
    { label: "(NYM) Nadym Airport - Russia", value: "NYM" },
    { label: "(RAT) Raduzhny Airport - Russia", value: "RAT" },
    { label: "(NFG) Nefteyugansk Airport - Russia", value: "NFG" },
    { label: "(KRO) Kurgan Airport - Russia", value: "KRO" },
    { label: "(LBD) Khudzhand Airport - Tajikistan", value: "LBD" },
    { label: "(AZN) Andizhan Airport - Uzbekistan", value: "AZN" },
    { label: "(FEG) Fergana Airport - Uzbekistan", value: "FEG" },
    { label: "(NMA) Namangan Airport - Uzbekistan", value: "NMA" },
    { label: "(NCU) Nukus Airport - Uzbekistan", value: "NCU" },
    { label: "(UGC) Urgench Airport - Uzbekistan", value: "UGC" },
    { label: "(KSQ) Karshi Khanabad Airport - Uzbekistan", value: "KSQ" },
    { label: "(TMJ) Termez Airport - Uzbekistan", value: "TMJ" },
    { label: "(RYB) Staroselye Airport - Russia", value: "RYB" },
    { label: "(EGO) Belgorod International Airport - Russia", value: "EGO" },
    { label: "(URS) Kursk East Airport - Russia", value: "URS" },
    { label: "(LPK) Lipetsk Airport - Russia", value: "LPK" },
    { label: "(VKT) Vorkuta Airport - Russia", value: "VKT" },
    { label: "(UUA) Bugulma Airport - Russia", value: "UUA" },
    { label: "(JOK) Yoshkar-Ola Airport - Russia", value: "JOK" },
    { label: "(CSY) Cheboksary Airport - Russia", value: "CSY" },
    { label: "(ULY) Ulyanovsk East Airport - Russia", value: "ULY" },
    { label: "(OSW) Orsk Airport - Russia", value: "OSW" },
    { label: "(PEZ) Penza Airport - Russia", value: "PEZ" },
    { label: "(SKX) Saransk Airport - Russia", value: "SKX" },
    { label: "(BWO) Balakovo Airport - Russia", value: "BWO" },
    { label: "(HBX) Hubli Airport - India", value: "HBX" },
    { label: "(KCT) Koggala Airport - Sri Lanka", value: "KCT" },
    { label: "(WRZ) Wirawila Airport - Sri Lanka", value: "WRZ" },
    { label: "(BBM) Battambang Airport - Cambodia", value: "BBM" },
    { label: "(SHL) Shillong Airport - India", value: "SHL" },
    {
      label: "(GAU) Lokpriya Gopinath Bordoloi International Airport - India",
      value: "GAU",
    },
    { label: "(DMU) Dimapur Airport - India", value: "DMU" },
    { label: "(TEZ) Tezpur Airport - India", value: "TEZ" },
    { label: "(BZL) Barisal Airport - Bangladesh", value: "BZL" },
    { label: "(OUI) Ban Huoeisay Airport - Laos", value: "OUI" },
    { label: "(KON) Kontum Airport - Vietnam", value: "KON" },
    { label: "(BHR) Bharatpur Airport - Nepal", value: "BHR" },
    { label: "(BDP) Chandragadhi Airport - Nepal", value: "BDP" },
    { label: "(MEY) Meghauli Airport - Nepal", value: "MEY" },
    { label: "(KEP) Nepalgunj Airport - Nepal", value: "KEP" },
    { label: "(GAN) Gan Island Airport - Maldives", value: "GAN" },
    { label: "(HAQ) Hanimaadhoo Airport - Maldives", value: "HAQ" },
    { label: "(KDO) Kadhdhoo Airport - Maldives", value: "KDO" },
    { label: "(MAQ) Mae Sot Airport - Thailand", value: "MAQ" },
    { label: "(BMV) Buon Ma Thuot Airport - Vietnam", value: "BMV" },
    { label: "(HPH) Cat Bi International Airport - Vietnam", value: "HPH" },
    { label: "(CXR) Cam Ranh Airport - Vietnam", value: "CXR" },
    { label: "(VCS) Co Ong Airport - Vietnam", value: "VCS" },
    { label: "(VCA) Trà Nóc Airport - Vietnam", value: "VCA" },
    { label: "(DIN) Dien Bien Phu Airport - Vietnam", value: "DIN" },
    { label: "(UIH) Phu Cat Airport - Vietnam", value: "UIH" },
    { label: "(PXU) Pleiku Airport - Vietnam", value: "PXU" },
    { label: "(VII) Vinh Airport - Vietnam", value: "VII" },
    { label: "(BMO) Banmaw Airport - Burma", value: "BMO" },
    { label: "(TVY) Dawei Airport - Burma", value: "TVY" },
    { label: "(KAW) Kawthoung Airport - Burma", value: "KAW" },
    { label: "(LIW) Loikaw Airport - Burma", value: "LIW" },
    { label: "(MNU) Mawlamyine Airport - Burma", value: "MNU" },
    { label: "(BSX) Pathein Airport - Burma", value: "BSX" },
    { label: "(PKK) Pakhokku Airport - Burma", value: "PKK" },
    { label: "(SWQ) Sumbawa Besar Airport - Indonesia", value: "SWQ" },
    { label: "(TMC) Tambolaka Airport - Indonesia", value: "TMC" },
    { label: "(BUI) Bokondini Airport - Indonesia", value: "BUI" },
    { label: "(SEH) Senggeh Airport - Indonesia", value: "SEH" },
    { label: "(TJS) Tanjung Harapan Airport - Indonesia", value: "TJS" },
    { label: "(DTD) Datadawai Airport - Indonesia", value: "DTD" },
    { label: "(BEJ) Barau(Kalimaru) Airport - Indonesia", value: "BEJ" },
    { label: "(TJG) Warukin Airport - Indonesia", value: "TJG" },
    { label: "(SMQ) Sampit(Hasan) Airport - Indonesia", value: "SMQ" },
    { label: "(LUV) Dumatubun Airport - Indonesia", value: "LUV" },
    { label: "(ARD) Mali Airport - Indonesia", value: "ARD" },
    { label: "(BLG) Belaga Airport - Malaysia", value: "BLG" },
    { label: "(LGL) Long Lellang Airport - Malaysia", value: "LGL" },
    { label: "(ODN) Long Seridan Airport - Malaysia", value: "ODN" },
    { label: "(MKM) Mukah Airport - Malaysia", value: "MKM" },
    { label: "(BKM) Bakalalan Airport - Malaysia", value: "BKM" },
    { label: "(LWY) Lawas Airport - Malaysia", value: "LWY" },
    { label: "(BBN) Bario Airport - Malaysia", value: "BBN" },
    { label: "(TMG) Tomanggong Airport - Malaysia", value: "TMG" },
    { label: "(KUD) Kudat Airport - Malaysia", value: "KUD" },
    {
      label: "(TKG) Radin Inten II (Branti) Airport - Indonesia",
      value: "TKG",
    },
    {
      label: "(HLP) Halim Perdanakusuma International Airport - Indonesia",
      value: "HLP",
    },
    { label: "(NTX) Ranai Airport - Indonesia", value: "NTX" },
    { label: "(PSU) Pangsuma Airport - Indonesia", value: "PSU" },
    { label: "(SQG) Susilo Airport - Indonesia", value: "SQG" },
    { label: "(PDO) Pendopo Airport - Indonesia", value: "PDO" },
    { label: "(LSW) Malikus Saleh Airport - Indonesia", value: "LSW" },
    { label: "(PKG) Pulau Pangkor Airport - Malaysia", value: "PKG" },
    { label: "(KBU) Stagen Airport - Indonesia", value: "KBU" },
    { label: "(LBW) Long Bawan Airport - Indonesia", value: "LBW" },
    { label: "(NNX) Nunukan Airport - Indonesia", value: "NNX" },
    { label: "(LPU) Long Apung Airport - Indonesia", value: "LPU" },
    { label: "(ALH) Albany Airport - Australia", value: "ALH" },
    { label: "(GYL) Argyle Airport - Australia", value: "GYL" },
    { label: "(AUU) Aurukun Airport - Australia", value: "AUU" },
    { label: "(BCI) Barcaldine Airport - Australia", value: "BCI" },
    { label: "(BDD) Badu Island Airport - Australia", value: "BDD" },
    { label: "(BVI) Birdsville Airport - Australia", value: "BVI" },
    { label: "(BHQ) Broken Hill Airport - Australia", value: "BHQ" },
    { label: "(HTI) Hamilton Island Airport - Australia", value: "HTI" },
    { label: "(BEU) Bedourie Airport - Australia", value: "BEU" },
    { label: "(BRK) Bourke Airport - Australia", value: "BRK" },
    { label: "(BUC) Burketown Airport - Australia", value: "BUC" },
    { label: "(GIC) Boigu Airport - Australia", value: "GIC" },
    { label: "(OKY) Oakey Airport - Australia", value: "OKY" },
    { label: "(BQL) Boulia Airport - Australia", value: "BQL" },
    { label: "(BHS) Bathurst Airport - Australia", value: "BHS" },
    { label: "(BLT) Blackwater Airport - Australia", value: "BLT" },
    { label: "(CVQ) Carnarvon Airport - Australia", value: "CVQ" },
    { label: "(CAZ) Cobar Airport - Australia", value: "CAZ" },
    { label: "(CPD) Coober Pedy Airport - Australia", value: "CPD" },
    { label: "(CNC) Coconut Island Airport - Australia", value: "CNC" },
    { label: "(CNJ) Cloncurry Airport - Australia", value: "CNJ" },
    { label: "(CED) Ceduna Airport - Australia", value: "CED" },
    { label: "(CTN) Cooktown Airport - Australia", value: "CTN" },
    { label: "(CMA) Cunnamulla Airport - Australia", value: "CMA" },
    { label: "(CNB) Coonamble Airport - Australia", value: "CNB" },
    { label: "(CUQ) Coen Airport - Australia", value: "CUQ" },
    { label: "(OOM) Cooma Snowy Mountains Airport - Australia", value: "OOM" },
    { label: "(DMD) Doomadgee Airport - Australia", value: "DMD" },
    { label: "(NLF) Darnley Island Airport - Australia", value: "NLF" },
    { label: "(DPO) Devonport Airport - Australia", value: "DPO" },
    { label: "(ELC) Elcho Island Airport - Australia", value: "ELC" },
    { label: "(EPR) Esperance Airport - Australia", value: "EPR" },
    { label: "(FLS) Flinders Island Airport - Australia", value: "FLS" },
    { label: "(GET) Geraldton Airport - Australia", value: "GET" },
    { label: "(GLT) Gladstone Airport - Australia", value: "GLT" },
    { label: "(GTE) Groote Eylandt Airport - Australia", value: "GTE" },
    { label: "(GFF) Griffith Airport - Australia", value: "GFF" },
    { label: "(HID) Horn Island Airport - Australia", value: "HID" },
    { label: "(HOK) Hooker Creek Airport - Australia", value: "HOK" },
    { label: "(MHU) Mount Hotham Airport - Australia", value: "MHU" },
    { label: "(HGD) Hughenden Airport - Australia", value: "HGD" },
    { label: "(JCK) Julia Creek Airport - Australia", value: "JCK" },
    { label: "(KAX) Kalbarri Airport - Australia", value: "KAX" },
    { label: "(KNS) King Island Airport - Australia", value: "KNS" },
    { label: "(KFG) Kalkgurung Airport - Australia", value: "KFG" },
    { label: "(KRB) Karumba Airport - Australia", value: "KRB" },
    { label: "(KWM) Kowanyama Airport - Australia", value: "KWM" },
    { label: "(KUG) Kubin Airport - Australia", value: "KUG" },
    { label: "(LNO) Leonora Airport - Australia", value: "LNO" },
    { label: "(LEL) Lake Evella Airport - Australia", value: "LEL" },
    { label: "(LDH) Lord Howe Island Airport - Australia", value: "LDH" },
    { label: "(IRG) Lockhart River Airport - Australia", value: "IRG" },
    { label: "(LSY) Lismore Airport - Australia", value: "LSY" },
    { label: "(LHG) Lightning Ridge Airport - Australia", value: "LHG" },
    { label: "(LRE) Longreach Airport - Australia", value: "LRE" },
    { label: "(LER) Leinster Airport - Australia", value: "LER" },
    { label: "(LVO) Laverton Airport - Australia", value: "LVO" },
    { label: "(UBB) Mabuiag Island Airport - Australia", value: "UBB" },
    { label: "(MKR) Meekatharra Airport - Australia", value: "MKR" },
    { label: "(MIM) Merimbula Airport - Australia", value: "MIM" },
    { label: "(MGT) Milingimbi Airport - Australia", value: "MGT" },
    { label: "(MNG) Maningrida Airport - Australia", value: "MNG" },
    { label: "(MCV) McArthur River Mine Airport - Australia", value: "MCV" },
    { label: "(MQL) Mildura Airport - Australia", value: "MQL" },
    { label: "(MMG) Mount Magnet Airport - Australia", value: "MMG" },
    { label: "(MRZ) Moree Airport - Australia", value: "MRZ" },
    { label: "(MOV) Moranbah Airport - Australia", value: "MOV" },
    { label: "(MYA) Moruya Airport - Australia", value: "MYA" },
    { label: "(MGB) Mount Gambier Airport - Australia", value: "MGB" },
    { label: "(ONG) Mornington Island Airport - Australia", value: "ONG" },
    { label: "(MYI) Murray Island Airport - Australia", value: "MYI" },
    { label: "(MBH) Maryborough Airport - Australia", value: "MBH" },
    { label: "(NRA) Narrandera Airport - Australia", value: "NRA" },
    { label: "(NAA) Narrabri Airport - Australia", value: "NAA" },
    { label: "(NTN) Normanton Airport - Australia", value: "NTN" },
    { label: "(ZNE) Newman Airport - Australia", value: "ZNE" },
    { label: "(OLP) Olympic Dam Airport - Australia", value: "OLP" },
    { label: "(PUG) Port Augusta Airport - Australia", value: "PUG" },
    { label: "(PMK) Palm Island Airport - Australia", value: "PMK" },
    { label: "(PBO) Paraburdoo Airport - Australia", value: "PBO" },
    {
      label: "(CCK) Cocos Keeling Island Airport - Cocos (Keeling) Islands",
      value: "CCK",
    },
    { label: "(GOV) Gove Airport - Australia", value: "GOV" },
    { label: "(PKE) Parkes Airport - Australia", value: "PKE" },
    { label: "(PLO) Port Lincoln Airport - Australia", value: "PLO" },
    { label: "(EDR) Pormpuraaw Airport - Australia", value: "EDR" },
    { label: "(PQQ) Port Macquarie Airport - Australia", value: "PQQ" },
    { label: "(PTJ) Portland Airport - Australia", value: "PTJ" },
    { label: "(ULP) Quilpie Airport - Australia", value: "ULP" },
    { label: "(RAM) Ramingining Airport - Australia", value: "RAM" },
    { label: "(RMA) Roma Airport - Australia", value: "RMA" },
    { label: "(SGO) St George Airport - Australia", value: "SGO" },
    { label: "(MJK) Shark Bay Airport - Australia", value: "MJK" },
    { label: "(SBR) Saibai Island Airport - Australia", value: "SBR" },
    { label: "(SRN) Strahan Airport - Australia", value: "SRN" },
    { label: "(XTG) Thargomindah Airport - Australia", value: "XTG" },
    { label: "(TCA) Tennant Creek Airport - Australia", value: "TCA" },
    { label: "(VCD) Victoria River Downs Airport - Australia", value: "VCD" },
    { label: "(SYU) Warraber Island Airport - Australia", value: "SYU" },
    { label: "(WNR) Windorah Airport - Australia", value: "WNR" },
    { label: "(WYA) Whyalla Airport - Australia", value: "WYA" },
    { label: "(WUN) Wiluna Airport - Australia", value: "WUN" },
    { label: "(WOL) Wollongong Airport - Australia", value: "WOL" },
    { label: "(WIN) Winton Airport - Australia", value: "WIN" },
    { label: "(BWT) Wynyard Airport - Australia", value: "BWT" },
    { label: "(OKR) Yorke Island Airport - Australia", value: "OKR" },
    { label: "(XMY) Yam Island Airport - Australia", value: "XMY" },
    { label: "(NAY) Beijing Nanyuan Airport - China", value: "NAY" },
    { label: "(CIF) Chifeng Airport - China", value: "CIF" },
    { label: "(CIH) Changzhi Airport - China", value: "CIH" },
    { label: "(DAT) Datong Airport - China", value: "DAT" },
    { label: "(HET) Baita Airport - China", value: "HET" },
    { label: "(BAV) Baotou Airport - China", value: "BAV" },
    {
      label: "(SJW) Shijiazhuang Daguocun International Airport - China",
      value: "SJW",
    },
    { label: "(TGO) Tongliao Airport - China", value: "TGO" },
    { label: "(HLH) Ulanhot Airport - China", value: "HLH" },
    { label: "(XIL) Xilinhot Airport - China", value: "XIL" },
    { label: "(BHY) Beihai Airport - China", value: "BHY" },
    { label: "(CGD) Changde Airport - China", value: "CGD" },
    { label: "(DYG) Dayong Airport - China", value: "DYG" },
    { label: "(MXZ) Meixian Airport - China", value: "MXZ" },
    { label: "(ZUH) Zhuhai Airport - China", value: "ZUH" },
    { label: "(LZH) Bailian Airport - China", value: "LZH" },
    { label: "(ZHA) Zhanjiang Airport - China", value: "ZHA" },
    { label: "(ENH) Enshi Airport - China", value: "ENH" },
    { label: "(NNY) Nanyang Airport - China", value: "NNY" },
    { label: "(XFN) Xiangfan Airport - China", value: "XFN" },
    { label: "(YIH) Yichang Airport - China", value: "YIH" },
    { label: "(AKA) Ankang Airport - China", value: "AKA" },
    { label: "(GOQ) Golmud Airport - China", value: "GOQ" },
    { label: "(HZG) Hanzhong Airport - China", value: "HZG" },
    { label: "(IQN) Qingyang Airport - China", value: "IQN" },
    { label: "(XNN) Xining Caojiabu Airport - China", value: "XNN" },
    { label: "(ENY) Yan'an Airport - China", value: "ENY" },
    { label: "(UYN) Yulin Airport - China", value: "UYN" },
    { label: "(AVK) Arvaikheer Airport - Mongolia", value: "AVK" },
    { label: "(LTI) Altai Airport - Mongolia", value: "LTI" },
    { label: "(BYN) Bayankhongor Airport - Mongolia", value: "BYN" },
    { label: "(DLZ) Dalanzadgad Airport - Mongolia", value: "DLZ" },
    { label: "(HVD) Khovd Airport - Mongolia", value: "HVD" },
    { label: "(MXV) Muren Airport - Mongolia", value: "MXV" },
    { label: "(DIG) Diqing Airport - China", value: "DIG" },
    { label: "(LUM) Mangshi Airport - China", value: "LUM" },
    { label: "(SYM) Simao Airport - China", value: "SYM" },
    { label: "(ZAT) Zhaotong Airport - China", value: "ZAT" },
    { label: "(KOW) Ganzhou Airport - China", value: "KOW" },
    { label: "(JDZ) Jingdezhen Airport - China", value: "JDZ" },
    { label: "(JIU) Jiujiang Lushan Airport - China", value: "JIU" },
    { label: "(JUZ) Quzhou Airport - China", value: "JUZ" },
    { label: "(LYG) Lianyungang Airport - China", value: "LYG" },
    { label: "(HYN) Huangyan Luqiao Airport - China", value: "HYN" },
    { label: "(LYI) Shubuling Airport - China", value: "LYI" },
    { label: "(JJN) Quanzhou Airport - China", value: "JJN" },
    { label: "(TXN) Tunxi International Airport - China", value: "TXN" },
    { label: "(WEF) Weifang Airport - China", value: "WEF" },
    { label: "(WEH) Weihai Airport - China", value: "WEH" },
    { label: "(WUX) Wuxi Airport - China", value: "WUX" },
    { label: "(WUS) Nanping Wuyishan Airport - China", value: "WUS" },
    { label: "(WNZ) Wenzhou Yongqiang Airport - China", value: "WNZ" },
    { label: "(YNZ) Yancheng Airport - China", value: "YNZ" },
    { label: "(YIW) Yiwu Airport - China", value: "YIW" },
    { label: "(HSN) Zhoushan Airport - China", value: "HSN" },
    { label: "(BPX) Qamdo Bangda Airport - China", value: "BPX" },
    { label: "(DAX) Dachuan Airport - China", value: "DAX" },
    { label: "(GYS) Guangyuan Airport - China", value: "GYS" },
    { label: "(LZO) Luzhou Airport - China", value: "LZO" },
    { label: "(MIG) Mianyang Airport - China", value: "MIG" },
    { label: "(NAO) Nanchong Airport - China", value: "NAO" },
    { label: "(LZY) Nyingchi Airport - China", value: "LZY" },
    { label: "(WXN) Wanxian Airport - China", value: "WXN" },
    { label: "(AKU) Aksu Airport - China", value: "AKU" },
    { label: "(IQM) Qiemo Airport - China", value: "IQM" },
    { label: "(KCA) Kuqa Airport - China", value: "KCA" },
    { label: "(KRL) Korla Airport - China", value: "KRL" },
    { label: "(KRY) Karamay Airport - China", value: "KRY" },
    { label: "(YIN) Yining Airport - China", value: "YIN" },
    { label: "(HEK) Heihe Airport - China", value: "HEK" },
    { label: "(JMU) Jiamusi Airport - China", value: "JMU" },
    { label: "(JNZ) Jinzhou Airport - China", value: "JNZ" },
    { label: "(NDG) Qiqihar Sanjiazi Airport - China", value: "NDG" },
    { label: "(YNJ) Yanji Airport - China", value: "YNJ" },
    { label: "(WME) Mount Keith - Australia", value: "WME" },
    { label: "(LRV) Gran Roque Airport - Venezuela", value: "LRV" },
    { label: "(IOR) Inishmore Airport - Ireland", value: "IOR" },
    { label: "(NNR) Connemara Regional Airport - Ireland", value: "NNR" },
    {
      label: "(GTI) Guettin MecklenburgVorpommern Germany - Germany",
      value: "GTI",
    },
    { label: "(NBB) Berezovo - Russia", value: "NBB" },
    { label: "(ORH) Worcester Regional Airport - United States", value: "ORH" },
    { label: "(AQG) Anqing Airport - China", value: "AQG" },
    { label: "(JGS) Jing Gang Shan Airport - China", value: "JGS" },
    { label: "(SHP) Shanhaiguan Airport - China", value: "SHP" },
    { label: "(YCU) Zhangxiao - China", value: "YCU" },
    { label: "(LHW) Lanzhou Airport - China", value: "LHW" },
    { label: "(JGN) Jiayuguan Airport - China", value: "JGN" },
    { label: "(DDG) Dandong - China", value: "DDG" },
    { label: "(DSN) Ordos Ejin Horo - China", value: "DSN" },
    { label: "(PZI) Panzhihua - China", value: "PZI" },
    { label: "(ZVE) New Haven Rail Station - United States", value: "ZVE" },
    { label: "(DIB) Dibrugarh Airport - India", value: "DIB" },
    { label: "(XOZ) Doha Free Zone Airport - Qatar", value: "XOZ" },
    { label: "(PWT) Bremerton National - United States", value: "PWT" },
    { label: "(SPW) Spencer Muni - United States", value: "SPW" },
    {
      label: "(JEF) Jefferson City Memorial Airport - United States",
      value: "JEF",
    },
    { label: "(GCW) Grand Canyon West Airport - United States", value: "GCW" },
    {
      label: "(BLD) Boulder City Municipal Airport - United States",
      value: "BLD",
    },
    { label: "(UNT) Unst Airport - United Kingdom", value: "UNT" },
    { label: "(PVC) Provincetown Muni - United States", value: "PVC" },
    {
      label: "(LKE) Kenmore Air Harbor Seaplane Base - United States",
      value: "LKE",
    },
    { label: "(%u0) Magas - Russia", value: "%u0" },
    { label: "(SBH) Saint Barthelemy - France", value: "SBH" },
    { label: "(TZA) Belize City Municipal Airport - Belize", value: "TZA" },
    { label: "(SUI) Sukhumi Dranda - Georgia", value: "SUI" },
    { label: "(TBW) Tambow - Russia", value: "TBW" },
    { label: "(OBN) Oban Airport - United Kingdom", value: "OBN" },
    { label: "(FSZ) Mt. Fuji Shizuoka Airport - Japan", value: "FSZ" },
    { label: "(ERM) Erechim Airport - Brazil", value: "ERM" },
    { label: "(CVF) Courchevel Airport - France", value: "CVF" },
    {
      label: "(FUL) Fullerton Municipal Airport - United States",
      value: "FUL",
    },
    { label: "(FWM) Fort William Heliport - United Kingdom", value: "FWM" },
    { label: "(NVI) Navoi Airport - Uzbekistan", value: "NVI" },
    { label: "(JPU) La Defense Heliport - France", value: "JPU" },
    { label: "(RRA) Ronda Airport - Spain", value: "RRA" },
    { label: "(QSF) Ain Arnat Airport - Algeria", value: "QSF" },
    { label: "(LRH) La Rochelle-Ile de Re - France", value: "LRH" },
    { label: "(SUN) Friedman Mem - United States", value: "SUN" },
    { label: "(PME) Portsmouth Airport - United Kingdom", value: "PME" },
    { label: "(MCW) Mason City Municipal - United States", value: "MCW" },
    { label: "(JNG) Jining Airport  - China", value: "JNG" },
    { label: "(OHE) Heilongjiang Mohe Airport - China", value: "OHE" },
    { label: "(DAQ) Daqing Saertu Airport - China", value: "DAQ" },
    { label: "(IAR) Tunoshna - Russia", value: "IAR" },
    { label: "(QNC) Neuchatel Airport - Switzerland", value: "QNC" },
    { label: "(ZJI) Locarno Airport - Switzerland", value: "ZJI" },
    { label: "(RMT) Rimatara - French Polynesia", value: "RMT" },
    { label: "(UKX) Ust-Kut - Russia", value: "UKX" },
    { label: "(1OH) Fortman Airport - United States", value: "1OH" },
    { label: "(BN1) Bellona - Solomon Islands", value: "BN1" },
    { label: "(BNY) Bellona - Solomon Islands", value: "BNY" },
    { label: "(RIN) Ringi Cove Airport - Solomon Islands", value: "RIN" },
    { label: "(ARE) Antonio Juarbe Pol Airport - Puerto Rico", value: "ARE" },
    { label: "(EAT) Pangborn Field - United States", value: "EAT" },
    {
      label: "(JDR) Aeroporto Prefeito Octavio de Almeida Neves - Brazil",
      value: "JDR",
    },
    { label: "(AGE) Wangerooge Airport - Germany", value: "AGE" },
    { label: "(OSH) Wittman Regional Airport - United States", value: "OSH" },
    { label: "(BQT) Brest - Belarus", value: "BQT" },
    { label: "(TNL) Ternopol - Ukraine", value: "TNL" },
    { label: "(CEJ) Chernigov - Ukraine", value: "CEJ" },
    { label: "(UKC) Lutsk - Ukraine", value: "UKC" },
    {
      label: "(BEH) Southwest Michigan Regional Airport - United States",
      value: "BEH",
    },
    { label: "(UES) Waukesha County Airport - United States", value: "UES" },
    { label: "(NOA) Nowra Airport - Australia", value: "NOA" },
    { label: "(KTR) Tindal Airport - Australia", value: "KTR" },
    { label: "(10C) Galt Field Airport - United States", value: "10C" },
    { label: "(X01) Everglades Airpark - United States", value: "X01" },
    { label: "(COQ) Choibalsan Airport - Mongolia", value: "COQ" },
    { label: "(TRO) Taree Airport - Australia", value: "TRO" },
    { label: "(OAG) Orange Airport - Australia", value: "OAG" },
    { label: "(GFN) Grafton Airport - Australia", value: "GFN" },
    { label: "(MRQ) Marinduque Airport - Philippines", value: "MRQ" },
    { label: "(HDM) Hamadan Airport - Iran", value: "HDM" },
    { label: "(YIF) St Augustin Airport - Canada", value: "YIF" },
    { label: "(VQS) Vieques Airport - Puerto Rico", value: "VQS" },
    { label: "(KMV) Kalay Airport - Myanmar", value: "KMV" },
    { label: "(LSS) Terre-de-Haut Airport - Guadeloupe", value: "LSS" },
    { label: "(YEI) Yenisehir Airport - Turkey", value: "YEI" },
    { label: "(TEQ) Tekirdağ Çorlu Airport - Turkey", value: "TEQ" },
    { label: "(SIC) Sinop Airport - Turkey", value: "SIC" },
    { label: "(MSR) Mus Airport - Turkey", value: "MSR" },
    { label: "(CKZ) Canakkale Airport - Turkey", value: "CKZ" },
    { label: "(AOE) Anadolu Airport - Turkey", value: "AOE" },
    { label: "(MPA) Katima Mulilo Airport - Namibia", value: "MPA" },
    { label: "(WVB) Walvis Bay Airport - Namibia", value: "WVB" },
    {
      label:
        "(PDP) Capitan Corbeta C A Curbelo International Airport - Uruguay",
      value: "PDP",
    },
    { label: "(SKT) Sialkot Airport - Pakistan", value: "SKT" },
    { label: "(YVB) Bonaventure Airport - Canada", value: "YVB" },
    { label: "(BHG) Brus Laguna Airport - Honduras", value: "BHG" },
    { label: "(UAS) Samburu South Airport - Kenya", value: "UAS" },
    { label: "(CHG) Chaoyang Airport - China", value: "CHG" },
    { label: "(WLH) Walaha Airport - Vanuatu", value: "WLH" },
    { label: "(TGC) Tanjung Manis Airport - Malaysia", value: "TGC" },
    { label: "(LKH) Long Akah Airport - Malaysia", value: "LKH" },
    { label: "(EGN) Geneina Airport - Sudan", value: "EGN" },
    { label: "(TOG) Togiak Airport - United States", value: "TOG" },
    { label: "(PTH) Port Heiden Airport - United States", value: "PTH" },
    { label: "(KVC) King Cove Airport - United States", value: "KVC" },
    { label: "(KNW) New Stuyahok Airport - United States", value: "KNW" },
    { label: "(IGG) Igiugig Airport - United States", value: "IGG" },
    { label: "(SLV) Shimla Airport - India", value: "SLV" },
    { label: "(NDC) Nanded Airport - India", value: "NDC" },
    { label: "(DHM) Kangra Airport - India", value: "DHM" },
    { label: "(CQD) Shahre Kord Airport - Iran", value: "CQD" },
    { label: "(EGM) Sege Airport - Solomon Islands", value: "EGM" },
    { label: "(RGS) Burgos Airport - Spain", value: "RGS" },
    { label: "(LEN) Leon Airport - Spain", value: "LEN" },
    { label: "(DRG) Deering Airport - United States", value: "DRG" },
    { label: "(AFS) Sugraly Airport - Uzbekistan", value: "AFS" },
    { label: "(MQM) Mardin Airport - Turkey", value: "MQM" },
    { label: "(TCG) Tacheng Airport - China", value: "TCG" },
    { label: "(LGQ) Nueva Loja Airport - Ecuador", value: "LGQ" },
    { label: "(PFQ) Parsabade Moghan Airport - Iran", value: "PFQ" },
    { label: "(IIL) Ilam Airport - Iran", value: "IIL" },
    { label: "(GBT) Gorgan Airport - Iran", value: "GBT" },
    { label: "(ACP) Sahand Airport - Iran", value: "ACP" },
    { label: "(TBH) Romblon Airport - Philippines", value: "TBH" },
    { label: "(WUZ) Changzhoudao Airport - China", value: "WUZ" },
    { label: "(HMI) Hami Airport - China", value: "HMI" },
    { label: "(SDP) Sand Point Airport - United States", value: "SDP" },
    { label: "(GOP) Gorakhpur Airport - India", value: "GOP" },
    { label: "(ACR) Araracuara Airport - Colombia", value: "ACR" },
    {
      label: "(HGR) Hagerstown Regional Richard A Henson Field - United States",
      value: "HGR",
    },
    { label: "(QBC) Bella Coola Airport - Canada", value: "QBC" },
    { label: "(PJA) Pajala Airport - Sweden", value: "PJA" },
    {
      label: "(KPC) Port Clarence Coast Guard Station - United States",
      value: "KPC",
    },
    { label: "(GVR) Governador Valadares Airport - Brazil", value: "GVR" },
    { label: "(KVK) Kirovsk-Apatity Airport - Russia", value: "KVK" },
    { label: "(CYZ) Cauayan Airport - Philippines", value: "CYZ" },
    { label: "(TMU) Tambor Airport - Costa Rica", value: "TMU" },
    { label: "(FON) Arenal Airport - Costa Rica", value: "FON" },
    { label: "(QOW) Imo Airport - Nigeria", value: "QOW" },
    { label: "(ARC) Arctic Village Airport - United States", value: "ARC" },
    { label: "(YTQ) Tasiujaq Airport - Canada", value: "YTQ" },
    { label: "(YPX) Puvirnituq Airport - Canada", value: "YPX" },
    { label: "(OMC) Ormoc Airport - Philippines", value: "OMC" },
    { label: "(WTK) Noatak Airport - United States", value: "WTK" },
    { label: "(SVA) Savoonga Airport - United States", value: "SVA" },
    { label: "(SHH) Shishmaref Airport - United States", value: "SHH" },
    { label: "(RBY) Ruby Airport - United States", value: "RBY" },
    { label: "(PHO) Point Hope Airport - United States", value: "PHO" },
    { label: "(MYU) Mekoryuk Airport - United States", value: "MYU" },
    { label: "(KVL) Kivalina Airport - United States", value: "KVL" },
    { label: "(KSM) St Marys Airport - United States", value: "KSM" },
    { label: "(KAL) Kaltag Airport - United States", value: "KAL" },
    { label: "(HPB) Hooper Bay Airport - United States", value: "HPB" },
    { label: "(GAM) Gambell Airport - United States", value: "GAM" },
    {
      label: "(ATK) Atqasuk Edward Burnell Sr Memorial Airport - United States",
      value: "ATK",
    },
    { label: "(ANV) Anvik Airport - United States", value: "ANV" },
    { label: "(AKP) Anaktuvuk Pass Airport - United States", value: "AKP" },
    { label: "(AAT) Altay Airport - China", value: "AAT" },
    { label: "(ELA) Naypyidaw - Burma", value: "ELA" },
    { label: "(ZXB) Jan Mayensfield - Norway", value: "ZXB" },
    { label: "(HHA) Huanghua Intl - China", value: "HHA" },
    { label: "(NZH) Manzhouli - China", value: "NZH" },
    { label: "(WUA) Wuhai - China", value: "WUA" },
    {
      label: "(GYY) Gary Chicago International Airport - United States",
      value: "GYY",
    },
    { label: "(BRD) Brainerd Lakes Rgnl - United States", value: "BRD" },
    { label: "(LWB) Greenbrier Valley Airport - United States", value: "LWB" },
    { label: "(PGV) Pitt-Greenville Airport - United States", value: "PGV" },
    { label: "(CYF) Chefornak Airport - United States", value: "CYF" },
    { label: "(OXR) Oxnard - Ventura County - United States", value: "OXR" },
    { label: "(BKG) Branson LLC - United States", value: "BKG" },
    { label: "(TEN) Tongren - China", value: "TEN" },
    { label: "(KNC) Jinggangshan - China", value: "KNC" },
    { label: "(ZBP) Penn Station - United States", value: "ZBP" },
    { label: "(ZYP) Penn Station - United States", value: "ZYP" },
    { label: "(NIU) Niau - French Polynesia", value: "NIU" },
    {
      label: "(SCH) Stratton ANGB - Schenectady County Airpor - United States",
      value: "SCH",
    },
    { label: "(NBC) Begishevo - Russia", value: "NBC" },
    { label: "(QRW) Warri Airport - Nigeria", value: "QRW" },
    { label: "(LGO) Langeoog Airport - Germany", value: "LGO" },
    { label: "(FNE) Fane Airport - Papua New Guinea", value: "FNE" },
    { label: "(ITK) Itokama Airport - Papua New Guinea", value: "ITK" },
    { label: "(ONB) Ononge Airport - Papua New Guinea", value: "ONB" },
    { label: "(TPI) Tapini Airport - Papua New Guinea", value: "TPI" },
    { label: "(AGL) Wanigela Airport - Papua New Guinea", value: "AGL" },
    { label: "(WTP) Woitape Airport - Papua New Guinea", value: "WTP" },
    { label: "(AWB) Awaba Airport - Papua New Guinea", value: "AWB" },
    { label: "(TFM) Telefomin Airport - Papua New Guinea", value: "TFM" },
    { label: "(NLP) Nelspruit Airport - South Africa", value: "NLP" },
    { label: "(CKC) Cherkassy - Ukraine", value: "CKC" },
    { label: "(UST) St. Augustine Airport - United States", value: "UST" },
    { label: "(NLV) Mykolaiv International Airport - Ukraine", value: "NLV" },
    { label: "(RHP) Ramechhap - Nepal", value: "RHP" },
    { label: "(STS) Charles M Schulz Sonoma Co - United States", value: "STS" },
    { label: "(ISM) Kissimmee Gateway Airport - United States", value: "ISM" },
    {
      label: "(LCQ) Lake City Municipal Airport - United States",
      value: "LCQ",
    },
    { label: "(LGU) Logan-Cache - United States", value: "LGU" },
    { label: "(BMC) Brigham City - United States", value: "BMC" },
    { label: "(MLD) Malad City - United States", value: "MLD" },
    {
      label: "(ASE) Aspen Pitkin County Sardy Field - United States",
      value: "ASE",
    },
    { label: "(HHH) Hilton Head - United States", value: "HHH" },
    { label: "(ULV) Barataevka - Russia", value: "ULV" },
    { label: "(GSS) Sabi Sabi Airport - South Africa", value: "GSS" },
    {
      label: "(ZFV) Philadelphia 30th St Station - United States",
      value: "ZFV",
    },
    { label: "(BWD) KBWD - United States", value: "BWD" },
    {
      label: "(LXY) Mexia - Limestone County Airport - United States",
      value: "LXY",
    },
    {
      label: "(ERV) Kerrville Municipal Airport - United States",
      value: "ERV",
    },
    { label: "(GED) Sussex Co - United States", value: "GED" },
    { label: "(ZSW) Seal Cove Seaplane Base - Canada", value: "ZSW" },
    { label: "(GBN) Great Bend Municipal - United States", value: "GBN" },
    { label: "(HYS) Hays Regional Airport - United States", value: "HYS" },
    { label: "(SUS) Spirit Of St Louis - United States", value: "SUS" },
    { label: "(LYU) Ely Municipal - United States", value: "LYU" },
    { label: "(GPZ) Grand Rapids Itasca County - United States", value: "GPZ" },
    { label: "(TVF) Thief River Falls - United States", value: "TVF" },
    { label: "(EGV) Eagle River - United States", value: "EGV" },
    { label: "(ARV) Lakeland - United States", value: "ARV" },
    { label: "(IKV) Ankeny Regl Airport - United States", value: "IKV" },
    { label: "(YBV) Berens River - Canada", value: "YBV" },
    { label: "(NGP) Corpus Christi NAS - United States", value: "NGP" },
    { label: "(YPI) Seaplane Base - Canada", value: "YPI" },
    { label: "(AVX) Avalon - United States", value: "AVX" },
    { label: "(MHV) Mojave - United States", value: "MHV" },
    { label: "(ZIN) Air Base - Switzerland", value: "ZIN" },
    {
      label: "(KEH) Kenmore Air Harbor Inc Seaplane Base - United States",
      value: "KEH",
    },
    { label: "(CZH) Municipal - Belize", value: "CZH" },
    { label: "(INQ) Inisheer - Ireland", value: "INQ" },
    { label: "(SWT) Strezhevoy - Russia", value: "SWT" },
    {
      label: "(HUT) Hutchinson Municipal Airport - United States",
      value: "HUT",
    },
    { label: "(BPM) Bagram AFB - Afghanistan", value: "BPM" },
    { label: "(EGA) Eagle County Airport - United States", value: "EGA" },
    { label: "(GDZ) Gelendzik - Russia", value: "GDZ" },
    { label: "(STJ) Rosecrans Mem - United States", value: "STJ" },
    { label: "(ZRT) Hartford Union Station - United States", value: "ZRT" },
    { label: "(ZTF) Stamford Amtrak Station - United States", value: "ZTF" },
    { label: "(ZRP) Newark Penn Station - United States", value: "ZRP" },
    { label: "(NDZ) Cuxhaven Airport - Germany", value: "NDZ" },
    { label: "(VOK) Volk Fld - United States", value: "VOK" },
    { label: "(BFT) BFT County Airport - United States", value: "BFT" },
    { label: "(UAB) Adana-Incirlik Airbase - Turkey", value: "UAB" },
    { label: "(GUC) Gunnison - Crested Butte - United States", value: "GUC" },
    { label: "(SIA) Xi\\\\'An Xiguan - China", value: "SIA" },
    { label: "(TOA) Zamperini Field Airport - United States", value: "TOA" },
    {
      label: "(MBL) Manistee County-Blacker Airport - United States",
      value: "MBL",
    },
    {
      label: "(PGD) Charlotte County-Punta Gorda Airport - United States",
      value: "PGD",
    },
    { label: "(JGC) Grand Canyon Heliport - United States", value: "JGC" },
    {
      label: "(WFK) Northern Aroostook Regional Airport - United States",
      value: "WFK",
    },
    {
      label: "(JHW) Chautauqua County-Jamestown - United States",
      value: "JHW",
    },
    {
      label:
        "(YTM) Riviere Rouge - Mont-Tremblant International Inc. Airport - Canada",
      value: "YTM",
    },
    {
      label: "(SME) Lake Cumberland Regional Airport - United States",
      value: "SME",
    },
    {
      label: "(SHD) Shenandoah Valley Regional Airport - United States",
      value: "SHD",
    },
    {
      label: "(DVL) Devils Lake Regional Airport - United States",
      value: "DVL",
    },
    {
      label:
        "(DIK) Dickinson Theodore Roosevelt Regional Airport - United States",
      value: "DIK",
    },
    {
      label: "(SDY) Sidney-Richland Municipal Airport - United States",
      value: "SDY",
    },
    { label: "(CDR) Chadron Municipal Airport - United States", value: "CDR" },
    { label: "(AIA) Alliance Municipal Airport - United States", value: "AIA" },
    { label: "(MCK) McCook Regional Airport - United States", value: "MCK" },
    {
      label: "(MTH) Florida Keys Marathon Airport - United States",
      value: "MTH",
    },
    { label: "(GDV) Dawson Community Airport - United States", value: "GDV" },
    { label: "(OLF) LM Clayton Airport - United States", value: "OLF" },
    { label: "(WYS) Yellowstone Airport - United States", value: "WYS" },
    {
      label: "(ALS) San Luis Valley Regional Airport - United States",
      value: "ALS",
    },
    { label: "(CNY) Canyonlands Field - United States", value: "CNY" },
    { label: "(ELY) Ely Airport - United States", value: "ELY" },
    { label: "(VEL) Vernal Regional Airport - United States", value: "VEL" },
    {
      label: "(SRR) Sierra Blanca Regional Airport - United States",
      value: "SRR",
    },
    { label: "(SOW) Show Low Regional Airport - United States", value: "SOW" },
    { label: "(MYL) McCall Municipal Airport - United States", value: "MYL" },
    { label: "(SMN) Lemhi County Airport - United States", value: "SMN" },
    { label: "(MMH) Mammoth Yosemite Airport - United States", value: "MMH" },
    { label: "(FRD) Friday Harbor Airport - United States", value: "FRD" },
    { label: "(ESD) Orcas Island Airport - United States", value: "ESD" },
    { label: "(OTS) Anacortes Airport - United States", value: "OTS" },
    { label: "(AST) Astoria Regional Airport - United States", value: "AST" },
    { label: "(ONP) Newport Municipal Airport - United States", value: "ONP" },
    { label: "(EMK) Emmonak Airport - United States", value: "EMK" },
    { label: "(UNK) Unalakleet Airport - United States", value: "UNK" },
    { label: "(UUK) Ugnu-Kuparuk Airport - United States", value: "UUK" },
    { label: "(SHX) Shageluk Airport - United States", value: "SHX" },
    { label: "(CHU) Chuathbaluk Airport - United States", value: "CHU" },
    { label: "(NUI) Nuiqsut Airport - United States", value: "NUI" },
    { label: "(EEK) Eek Airport - United States", value: "EEK" },
    { label: "(KUK) Kasigluk Airport - United States", value: "KUK" },
    { label: "(KWT) Kwethluk Airport - United States", value: "KWT" },
    { label: "(KWK) Kwigillingok Airport - United States", value: "KWK" },
    {
      label: "(MLL) Marshall Don Hunter Sr. Airport - United States",
      value: "MLL",
    },
    { label: "(RSH) Russian Mission Airport - United States", value: "RSH" },
    { label: "(WTL) Tuntutuliak Airport - United States", value: "WTL" },
    { label: "(KEK) Ekwok Airport - United States", value: "KEK" },
    { label: "(KGK) Koliganek Airport - United States", value: "KGK" },
    { label: "(KLL) Levelock Airport - United States", value: "KLL" },
    { label: "(KMO) Manokotak Airport - United States", value: "KMO" },
    { label: "(TWA) Twin Hills Airport - United States", value: "TWA" },
    { label: "(CIK) Chalkyitsik Airport - United States", value: "CIK" },
    { label: "(EAA) Eagle Airport - United States", value: "EAA" },
    { label: "(HUS) Hughes Airport - United States", value: "HUS" },
    { label: "(HSL) Huslia Airport - United States", value: "HSL" },
    { label: "(LIV) Livingood Airport - United States", value: "LIV" },
    { label: "(MNT) Minto Airport - United States", value: "MNT" },
    { label: "(NUL) Nulato Airport - United States", value: "NUL" },
    { label: "(RMP) Rampart Airport - United States", value: "RMP" },
    { label: "(TAL) Tanana Airport - United States", value: "TAL" },
    { label: "(VEE) Venetie Airport - United States", value: "VEE" },
    { label: "(WBQ) Beaver Airport - United States", value: "WBQ" },
    { label: "(CEM) Central Airport - United States", value: "CEM" },
    { label: "(SHG) Shungnak Airport - United States", value: "SHG" },
    { label: "(KBC) Birch Creek Airport - United States", value: "KBC" },
    { label: "(CXF) Coldfoot Airport - United States", value: "CXF" },
    { label: "(IYK) Inyokern Airport - United States", value: "IYK" },
    { label: "(VIS) Visalia Municipal Airport - United States", value: "VIS" },
    { label: "(MCE) Merced Municipal Airport - United States", value: "MCE" },
    {
      label: "(CYR) Laguna de Los Patos International Airport - Uruguay",
      value: "CYR",
    },
    { label: "(CPQ) Amarais Airport - Brazil", value: "CPQ" },
    { label: "(TWB) Toowoomba - Australia", value: "TWB" },
    { label: "(AYK) Arkalyk Airport - Kazakhstan", value: "AYK" },
    { label: "(AGN) Angoon Seaplane Base - United States", value: "AGN" },
    { label: "(ELV) Elfin Cove Seaplane Base - United States", value: "ELV" },
    { label: "(TKE) Tenakee Seaplane Base - United States", value: "TKE" },
    { label: "(PEC) Pelican Seaplane Base - United States", value: "PEC" },
    { label: "(CYM) Chatham Seaplane Base - United States", value: "CYM" },
    { label: "(FNR) Funter Bay Seaplane Base - United States", value: "FNR" },
    {
      label: "(EXI) Excursion Inlet Seaplane Base - United States",
      value: "EXI",
    },
    { label: "(HNH) Hoonah Airport - United States", value: "HNH" },
    { label: "(AFE) Kake Airport - United States", value: "AFE" },
    { label: "(CGA) Craig Seaplane Base - United States", value: "CGA" },
    { label: "(HYL) Hollis Seaplane Base - United States", value: "HYL" },
    { label: "(MTM) Metlakatla Seaplane Base - United States", value: "MTM" },
    { label: "(KTB) Thorne Bay Seaplane Base - United States", value: "KTB" },
    { label: "(HYG) Hydaburg Seaplane Base - United States", value: "HYG" },
    { label: "(WHD) Hyder Seaplane Base - United States", value: "WHD" },
    { label: "(KPB) Point Baker Seaplane Base - United States", value: "KPB" },
    {
      label: "(PPV) Port Protection Seaplane Base - United States",
      value: "PPV",
    },
    { label: "(WWP) North Whale Seaplane Base - United States", value: "WWP" },
    { label: "(KCQ) Chignik Lake Airport - United States", value: "KCQ" },
    { label: "(EGX) Egegik Airport - United States", value: "EGX" },
    { label: "(KCL) Chignik Lagoon Airport - United States", value: "KCL" },
    { label: "(KBW) Chignik Bay Seaplane Base - United States", value: "KBW" },
    { label: "(KPV) Perryville Airport - United States", value: "KPV" },
    { label: "(PIP) Pilot Point Airport - United States", value: "PIP" },
    { label: "(WSN) South Naknek Airport - United States", value: "WSN" },
    { label: "(AKK) Akhiok Airport - United States", value: "AKK" },
    { label: "(KYK) Karuluk Airport - United States", value: "KYK" },
    { label: "(KLN) Larsen Bay Airport - United States", value: "KLN" },
    { label: "(OLH) Old Harbor Airport - United States", value: "OLH" },
    { label: "(KOZ) Ouzinkie Airport - United States", value: "KOZ" },
    { label: "(ORI) Port Lions Airport - United States", value: "ORI" },
    { label: "(ALZ) Alitak Seaplane Base - United States", value: "ALZ" },
    { label: "(AOS) Amook Bay Seaplane Base - United States", value: "AOS" },
    { label: "(KKB) Kitoi Bay Seaplane Base - United States", value: "KKB" },
    { label: "(KMY) Moser Bay Seaplane Base - United States", value: "KMY" },
    { label: "(KOY) Olga Bay Seaplane Base - United States", value: "KOY" },
    { label: "(KPY) Port Bailey Seaplane Base - United States", value: "KPY" },
    {
      label: "(KPR) Port Williams Seaplane Base - United States",
      value: "KPR",
    },
    { label: "(SYB) Seal Bay Seaplane Base - United States", value: "SYB" },
    {
      label: "(WSJ) San Juan - Uganik Seaplane Base - United States",
      value: "WSJ",
    },
    {
      label: "(KWP) West Point Village Seaplane Base - United States",
      value: "KWP",
    },
    { label: "(KZB) Zachar Bay Seaplane Base - United States", value: "KZB" },
    { label: "(ABL) Ambler Airport - United States", value: "ABL" },
    { label: "(BKC) Buckland Airport - United States", value: "BKC" },
    { label: "(IAN) Bob Baker Memorial Airport - United States", value: "IAN" },
    { label: "(OBU) Kobuk Airport - United States", value: "OBU" },
    {
      label: "(ORV) Robert Curtis Memorial Airport - United States",
      value: "ORV",
    },
    { label: "(WLK) Selawik Airport - United States", value: "WLK" },
    { label: "(KTS) Brevig Mission Airport - United States", value: "KTS" },
    { label: "(ELI) Elim Airport - United States", value: "ELI" },
    { label: "(GLV) Golovin Airport - United States", value: "GLV" },
    { label: "(TLA) Teller Airport - United States", value: "TLA" },
    { label: "(WAA) Wales Airport - United States", value: "WAA" },
    { label: "(WMO) White Mountain Airport - United States", value: "WMO" },
    { label: "(CIL) Council Airport - United States", value: "CIL" },
    { label: "(KKA) Koyuk Alfred Adams Airport - United States", value: "KKA" },
    { label: "(SMK) St. Michael Airport - United States", value: "SMK" },
    { label: "(SKK) Shaktoolik Airport - United States", value: "SKK" },
    { label: "(WBB) Stebbins Airport - United States", value: "WBB" },
    { label: "(TNC) Tin City LRRS Airport - United States", value: "TNC" },
    { label: "(AKB) Atka Airport - United States", value: "AKB" },
    { label: "(IKO) Nikolski Air Station - United States", value: "IKO" },
    { label: "(ICY) Icy Bay Airport - United States", value: "ICY" },
    { label: "(CYT) Yakataga Airport - United States", value: "CYT" },
    { label: "(AUK) Alakanuk Airport - United States", value: "AUK" },
    { label: "(SXP) Sheldon Point Airport - United States", value: "SXP" },
    { label: "(KPN) Kipnuk Airport - United States", value: "KPN" },
    { label: "(KFP) False Pass Airport - United States", value: "KFP" },
    { label: "(NLG) Nelson Lagoon - United States", value: "NLG" },
    { label: "(PML) Port Moller Airport - United States", value: "PML" },
    { label: "(KLW) Klawock Airport - United States", value: "KLW" },
    { label: "(KWN) Quinhagak Airport - United States", value: "KWN" },
    { label: "(KOT) Kotlik Airport - United States", value: "KOT" },
    { label: "(KYU) Koyukuk Airport - United States", value: "KYU" },
    { label: "(SCM) Scammon Bay Airport - United States", value: "SCM" },
    { label: "(NNL) Nondalton Airport - United States", value: "NNL" },
    { label: "(PDB) Pedro Bay Airport - United States", value: "PDB" },
    { label: "(NUP) Nunapitchuk Airport - United States", value: "NUP" },
    { label: "(KKH) Kongiganak Airport - United States", value: "KKH" },
    { label: "(NIB) Nikolai Airport - United States", value: "NIB" },
    { label: "(TCT) Takotna Airport - United States", value: "TCT" },
    { label: "(PQS) Pilot Station Airport - United States", value: "PQS" },
    { label: "(AKI) Akiak Airport - United States", value: "AKI" },
    { label: "(TLT) Tuluksak Airport - United States", value: "TLT" },
    { label: "(KGX) Grayling Airport - United States", value: "KGX" },
    { label: "(AIN) Wainwright Airport - United States", value: "AIN" },
    { label: "(APZ) ZAPALA - Argentina", value: "APZ" },
    { label: "(RDS) Rincon de los Sauces - Argentina", value: "RDS" },
    { label: "(OLN) Colonia Sarmiento - Argentina", value: "OLN" },
    { label: "(RYO) Rio Turbio - Argentina", value: "RYO" },
    { label: "(PNT) Puerto Natales - Chile", value: "PNT" },
    { label: "(CVI) Caleta Olivia - Argentina", value: "CVI" },
    { label: "(SGV) Sierra Grande - Argentina", value: "SGV" },
    { label: "(IGB) Ingeniero Jacobacci - Argentina", value: "IGB" },
    { label: "(ELX) El Chalten - Argentina", value: "ELX" },
    { label: "(NCN) Chenega Bay Airport - United States", value: "NCN" },
    { label: "(CZN) Chisana Airport - United States", value: "CZN" },
    { label: "(6K8) Tok Junction Airport - United States", value: "6K8" },
    { label: "(IRC) Circle City Airport - United States", value: "IRC" },
    { label: "(KCC) Coffman Cove Seaplane Base - United States", value: "KCC" },
    { label: "(CKD) Crooked Creek Airport - United States", value: "CKD" },
    { label: "(RDV) Red Devil Airport - United States", value: "RDV" },
    { label: "(SLQ) Sleetmute Airport - United States", value: "SLQ" },
    { label: "(SRV) Stony River 2 Airport - United States", value: "SRV" },
    { label: "(HKB) Healy River Airport - United States", value: "HKB" },
    { label: "(KAE) Kake Seaplane Base - United States", value: "KAE" },
    { label: "(AQC) Klawock Seaplane Base - United States", value: "AQC" },
    { label: "(MHM) Minchumina Airport - United States", value: "MHM" },
    { label: "(MLY) Manley Hot Springs Airport - United States", value: "MLY" },
    { label: "(STG) St. George Airport - United States", value: "STG" },
    { label: "(TEK) Tatitlek Airport - United States", value: "TEK" },
    {
      label: "(WFB) Ketchikan harbor Seaplane Base - United States",
      value: "WFB",
    },
    { label: "(YSO) Postville Airport - Canada", value: "YSO" },
    {
      label: "(YWB) Kangiqsujuaq - Wakeham Bay Airport - Canada",
      value: "YWB",
    },
    { label: "(YTF) Alma Airport - Canada", value: "YTF" },
    { label: "(YGV) Havre Saint-Pierre Airport - Canada", value: "YGV" },
    { label: "(YXK) Rimouski Airport - Canada", value: "YXK" },
    { label: "(XTL) Tadoule Lake Airport - Canada", value: "XTL" },
    { label: "(XLB) Lac Brochet Airport - Canada", value: "XLB" },
    { label: "(XSI) South Indian Lake Airport - Canada", value: "XSI" },
    { label: "(YBT) Brochet Airport - Canada", value: "YBT" },
    { label: "(ZGR) Little Grand Rapids Airport - Canada", value: "ZGR" },
    {
      label: "(YCR) Cross Lake - Charlie Sinclair Memorial Airport - Canada",
      value: "YCR",
    },
    { label: "(YRS) Red Sucker Lake Airport - Canada", value: "YRS" },
    { label: "(YOP) Rainbow Lake Airport - Canada", value: "YOP" },
    { label: "(YBY) Bonnyville Airport - Canada", value: "YBY" },
    { label: "(ZNA) Nanaimo Harbour Water Airport - Canada", value: "ZNA" },
    { label: "(XQU) Qualicum Beach Airport - Canada", value: "XQU" },
    { label: "(YJM) Fort St. James - Perison Airport - Canada", value: "YJM" },
    { label: "(YDT) Boundary Bay Airport - Canada", value: "YDT" },
    { label: "(ZEL) Bella Bella Airport - Canada", value: "ZEL" },
    { label: "(YHS) Sechelt Aerodrome - Canada", value: "YHS" },
    { label: "(PVP) Palo Verde Airport - Mexico", value: "PVP" },
    { label: "(ZYR) Brussels Gare du Midi - Belgium", value: "ZYR" },
    { label: "(CYC) Caye Chapel Airport - Belize", value: "CYC" },
    { label: "(BGK) Big Creek Airport - Belize", value: "BGK" },
    { label: "(DGA) Dangriga Airport - Belize", value: "DGA" },
    { label: "(PLJ) Placencia Airport - Belize", value: "PLJ" },
    { label: "(SJX) Sartaneja Airport - Belize", value: "SJX" },
    { label: "(RNI) Corn Island Airport - Nicaragua", value: "RNI" },
    { label: "(BZA) Bonanza Airport - Nicaragua", value: "BZA" },
    { label: "(RFS) Rosita Airport - Nicaragua", value: "RFS" },
    { label: "(SIU) Siuna Airport - Nicaragua", value: "SIU" },
    { label: "(WSP) Waspam Airport - Nicaragua", value: "WSP" },
    { label: "(RIK) Carrillo Airport - Costa Rica", value: "RIK" },
    { label: "(FUS) Fussen - Germany", value: "FUS" },
    { label: "(COZ) Constanza Airport - Dominican Republic", value: "COZ" },
    { label: "(NEG) Negril Aerodrome - Jamaica", value: "NEG" },
    { label: "(EBO) Bochum Railway - Germany", value: "EBO" },
    { label: "(KFB) Fliegerhost  - Germany", value: "KFB" },
    { label: "(ZMU) Munich Railway - Germany", value: "ZMU" },
    { label: "(ZAQ) Nuernberg Railway - Germany", value: "ZAQ" },
    {
      label: "(RVR) Jose Aponte de la Torre Airport - Puerto Rico",
      value: "RVR",
    },
    {
      label: "(RLO) Aeropuerto Internacional Valle del Conlara - Argentina",
      value: "RLO",
    },
    {
      label: "(SSB) Christiansted Harbor Seaplane Base - Virgin Islands",
      value: "SSB",
    },
    { label: "(ARR) Alto Rio Senguer Airport - Argentina", value: "ARR" },
    { label: "(JSM) Jose de San Martin Airport - Argentina", value: "JSM" },
    { label: "(UYU) Uyuni Airport - Bolivia", value: "UYU" },
    { label: "(ZAU) Augsburg Railway - Germany", value: "ZAU" },
    { label: "(ZMA) Mannheim Railway - Germany", value: "ZMA" },
    { label: "(ZES) Essen Railway - Germany", value: "ZES" },
    { label: "(RBQ) Rurrenabaque Airport - Bolivia", value: "RBQ" },
    { label: "(ABF) Abaiang Atoll Airport - Kiribati", value: "ABF" },
    { label: "(CPS) St. Louis Downtown Airport - United States", value: "CPS" },
    { label: "(ABN) Albina Airstrip - Surilabel", value: "ABN" },
    { label: "(BTO) Botopassi Airstrip - Surilabel", value: "BTO" },
    { label: "(DOE) Djoemoe Airstrip - Surilabel", value: "DOE" },
    { label: "(DRJ) Drietabbetje Airstrip - Surilabel", value: "DRJ" },
    { label: "(ICK) Majoor Henry Fernandes Airport - Surilabel", value: "ICK" },
    { label: "(OEM) Vincent Fayks Airport - Surilabel", value: "OEM" },
    { label: "(SMZ) Stoelmans Eiland Airstrip - Surilabel", value: "SMZ" },
    { label: "(TOT) Totness Airstrip - Surilabel", value: "TOT" },
    { label: "(AGI) Wageningen Airstrip - Surilabel", value: "AGI" },
    { label: "(KIA) Kaieteur International Airport - Guyana", value: "KIA" },
    { label: "(CSC) Codela Airport - Costa Rica", value: "CSC" },
    { label: "(ORJ) Orinduik Airport - Guyana", value: "ORJ" },
    { label: "(NAI) Annai Airport - Guyana", value: "NAI" },
    { label: "(IMB) Imbaimadai Airport - Guyana", value: "IMB" },
    { label: "(KAR) Kamarang Airport - Guyana", value: "KAR" },
    { label: "(USI) Mabaruma Airport - Guyana", value: "USI" },
    { label: "(MHA) Mahdia Airport - Guyana", value: "MHA" },
    {
      label:
        "(PJC) Dr. Augusto Roberto Fuster International Airport - Paraguay",
      value: "PJC",
    },
    { label: "(ACD) Alcides Fernandez Airport - Colombia", value: "ACD" },
    { label: "(RVE) Los Colonizadores Airport - Colombia", value: "RVE" },
    { label: "(LCR) La Chorrera Airport - Colombia", value: "LCR" },
    { label: "(LMC) La Macarena - Colombia", value: "LMC" },
    { label: "(VGZ) Villa Garzon Airport - Colombia", value: "VGZ" },
    { label: "(EBG) El Bagre Airport - Colombia", value: "EBG" },
    { label: "(CAQ) Juan H. White - Colombia", value: "CAQ" },
    { label: "(COG) Mandinga Airport - Colombia", value: "COG" },
    { label: "(TLU) Golfo de Morrosquillo Airport - Colombia", value: "TLU" },
    { label: "(CFB) Cabo Frio International Airport - Brazil", value: "CFB" },
    { label: "(OPS) Sinop Airport - Brazil", value: "OPS" },
    { label: "(GRP) Gurupi Airport - Brazil", value: "GRP" },
    { label: "(CMP) Campo Alegre Airport - Brazil", value: "CMP" },
    { label: "(BVS) Breves Airport - Brazil", value: "BVS" },
    { label: "(SFK) Soure Airport - Brazil", value: "SFK" },
    { label: "(PIN) Julio Belem Airport - Brazil", value: "PIN" },
    { label: "(BRA) Barreiras Airport - Brazil", value: "BRA" },
    { label: "(STZ) Confresa Airport - Brazil", value: "STZ" },
    { label: "(MQH) Minacu Airport - Brazil", value: "MQH" },
    { label: "(AUX) Araguaina Airport - Brazil", value: "AUX" },
    { label: "(NVP) Novo Aripuana Airport - Brazil", value: "NVP" },
    { label: "(LVR) Bom Futuro Airport - Brazil", value: "LVR" },
    { label: "(FRC) Franca Airport - Brazil", value: "FRC" },
    { label: "(DOU) Dourados Airport - Brazil", value: "DOU" },
    { label: "(LBR) Labrea Airport - Brazil", value: "LBR" },
    { label: "(ROO) Rondonopolis Airport - Brazil", value: "ROO" },
    { label: "(GPB) Tancredo Thomaz de Faria Airport - Brazil", value: "GPB" },
    { label: "(JCB) Joacaba Airport - Brazil", value: "JCB" },
    { label: "(ZXE) Edinburgh Waverly Station - United Kingdom", value: "ZXE" },
    { label: "(RVD) General leite de Castro Airport - Brazil", value: "RVD" },
    { label: "(AAX) Araxa Airport - Brazil", value: "AAX" },
    { label: "(MBZ) Maues Airport - Brazil", value: "MBZ" },
    { label: "(RBB) Borba Airport - Brazil", value: "RBB" },
    { label: "(CIZ) Coari Airport - Brazil", value: "CIZ" },
    { label: "(BAZ) Barcelos Airport - Brazil", value: "BAZ" },
    { label: "(DMT) Diamantino Airport - Brazil", value: "DMT" },
    { label: "(GNM) Guanambi Airport - Brazil", value: "GNM" },
    { label: "(QDJ) Tsletsi Airport - Algeria", value: "QDJ" },
    { label: "(LBZ) Lucapa Airport - Angola", value: "LBZ" },
    { label: "(KNP) Kapanda Airport - Angola", value: "KNP" },
    { label: "(AMC) Am Timan Airport - Chad", value: "AMC" },
    { label: "(GSQ) Sharq Al-Owainat Airport - Egypt", value: "GSQ" },
    {
      label: "(MRB) Eastern WV Regional Airport - United States",
      value: "MRB",
    },
    { label: "(AWA) Awasa Airport - Ethiopia", value: "AWA" },
    { label: "(JIJ) Jijiga Airport - Ethiopia", value: "JIJ" },
    { label: "(MKS) Mekane Salam Airport - Ethiopia", value: "MKS" },
    { label: "(DBM) Debre Marqos - Ethiopia", value: "DBM" },
    { label: "(DBT) Debre Tabor Airport - Ethiopia", value: "DBT" },
    { label: "(QHR) Harar Meda Airport - Ethiopia", value: "QHR" },
    { label: "(GOB) Robe Airport - Ethiopia", value: "GOB" },
    { label: "(MYB) Mayumba Airport - Gabon", value: "MYB" },
    { label: "(MRE) Mara Serena Airport - Kenya", value: "MRE" },
    { label: "(RBX) Rumbek Airport - Sudan", value: "RBX" },
    { label: "(CPA) Cape Palmas Airport - Liberia", value: "CPA" },
    { label: "(AMY) Ambatomainty Airport - Madagascar", value: "AMY" },
    { label: "(UKY) Kyoto - Japan", value: "UKY" },
    { label: "(BZB) Bazaruto Island Airport - Mozambique", value: "BZB" },
    { label: "(BCW) Benguera Island Airport - Mozambique", value: "BCW" },
    { label: "(IBL) Indigo Bay Lodge Airport - Mozambique", value: "IBL" },
    { label: "(MAX) Ouro Sogui Airport - Senegal", value: "MAX" },
    { label: "(BDI) Bird Island Airport - Seychelles", value: "BDI" },
    { label: "(WHF) Wadi Halfa Airport - Sudan", value: "WHF" },
    {
      label:
        "(NBE) Enfidha - Zine El Abidine Ben Ali International Airport - Tunisia",
      value: "NBE",
    },
    { label: "(PAF) Pakuba Airport - Uganda", value: "PAF" },
    { label: "(HTY) Hatay Airport - Turkey", value: "HTY" },
    { label: "(RVV) Raivavae Airport - French Polynesia", value: "RVV" },
    { label: "(FUO) Foshan - China", value: "FUO" },
    { label: "(HUZ) Huizhou - China", value: "HUZ" },
    { label: "(ILD) Lleida-Alguaire Airport - Spain", value: "ILD" },
    {
      label: "(WPR) Aeropuerto Capitan Fuentes Martinez - Chile",
      value: "WPR",
    },
    { label: "(YMY) Central Railway Station - Canada", value: "YMY" },
    { label: "(YBZ) Union Station - Canada", value: "YBZ" },
    { label: "(BIU) Bildudalur Airport - Iceland", value: "BIU" },
    { label: "(GJR) Gjogur Airport - Iceland", value: "GJR" },
    { label: "(SAK) Saudarkrokur - Iceland", value: "SAK" },
    { label: "(IIA) Inishmaan Aerodrome - Ireland", value: "IIA" },
    { label: "(TDK) Taldykorgan Airport - Kazakhstan", value: "TDK" },
    { label: "(ULG) Olgii Airport - Mongolia", value: "ULG" },
    { label: "(XDB) Lille - France", value: "XDB" },
    { label: "(VGD) Vologda Airport - Russia", value: "VGD" },
    { label: "(BVV) Burevestnik Airport - Russia", value: "BVV" },
    { label: "(OHH) Okha Airport - Russia", value: "OHH" },
    { label: "(LDG) Leshukonskoye Airport - Russia", value: "LDG" },
    { label: "(HSK) Huesca-Pirineos Airport - Spain", value: "HSK" },
    { label: "(CQM) Ciudad Real Central Airport - Spain", value: "CQM" },
    { label: "(NJF) Al Najaf International Airport - Iraq", value: "NJF" },
    { label: "(QYI) Hilversum Railway Station - Netherlands", value: "QYI" },
    { label: "(CSA) Colonsay Airport - United Kingdom", value: "CSA" },
    { label: "(COL) Coll Airport - United Kingdom", value: "COL" },
    {
      label: "(RKH) Rock Hill York Co Bryant Airport - United States",
      value: "RKH",
    },
    { label: "(AGC) Allegheny County Airport - United States", value: "AGC" },
    { label: "(NZC) Cecil Field - United States", value: "NZC" },
    {
      label: "(FTY) Fulton County Airport Brown Field - United States",
      value: "FTY",
    },
    { label: "(TSO) Tresco Heliport - United Kingdom", value: "TSO" },
    { label: "(TII) Tarin Kowt Airport - Afghanistan", value: "TII" },
    { label: "(ZAJ) Zaranj Airport - Afghanistan", value: "ZAJ" },
    { label: "(CCN) Chaghcharan Airport - Afghanistan", value: "CCN" },
    { label: "(FUG) Fuyang Airport - China", value: "FUG" },
    { label: "(LCX) Longyan Airport - China", value: "LCX" },
    { label: "(BSD) Baoshan Airport - China", value: "BSD" },
    { label: "(ACX) Xingyi Airport - China", value: "ACX" },
    { label: "(XZM) Macau Ferry Pier - Macau", value: "XZM" },
    { label: "(HZH) Liping Airport - China", value: "HZH" },
    { label: "(60J) Ocean Isle Beach Airport - United States", value: "60J" },
    {
      label: "(OSU) Ohio State University Airport - United States",
      value: "OSU",
    },
    { label: "(RSI) Rio Sidra - Panama", value: "RSI" },
    { label: "(ADS) Addison - United States", value: "ADS" },
    { label: "(DTS) Destin - United States", value: "DTS" },
    { label: "(RBN) Fort Jefferson - United States", value: "RBN" },
    { label: "(KHE) Chernobayevka Airport - Ukraine", value: "KHE" },
    { label: "(SZS) Ryans Creek Aerodrome - New Zealand", value: "SZS" },
    { label: "(HJJ) Zhijiang Airport - China", value: "HJJ" },
    { label: "(YQI) Yarmouth Airport - Canada", value: "YQI" },
    { label: "(ISO) Kinston Regional Jetport - United States", value: "ISO" },
    { label: "(FFA) First Flight Airport - United States", value: "FFA" },
    { label: "(LNJ) Lincang Airport - China", value: "LNJ" },
    { label: "(WNH) Wenshan Airport - China", value: "WNH" },
    { label: "(PLL) Ponta Pelada Airport - Brazil", value: "PLL" },
    { label: "(SJL) Sao Gabriel da Cachoeira Airport - Brazil", value: "SJL" },
    { label: "(CKS) Carajas Airport - Brazil", value: "CKS" },
    { label: "(ITB) Cachimbo - Brazil", value: "ITB" },
    { label: "(LTU) Latur Airport - India", value: "LTU" },
    { label: "(MWK) Matak Airport - Indonesia", value: "MWK" },
    { label: "(QFZ) Mainz Finthen - Germany", value: "QFZ" },
    { label: "(QMZ) Mainz - Germany", value: "QMZ" },
    { label: "(GWW) Berlin Gatow - Germany", value: "GWW" },
    { label: "(ZPQ) Rheine Bentlage - Germany", value: "ZPQ" },
    { label: "(TTR) Tana Toraja Airport - Indonesia", value: "TTR" },
    { label: "(PGU) Persian Gulf Airport - Iran", value: "PGU" },
    { label: "(YES) Yasuj Airport - Iran", value: "YES" },
    { label: "(OSB) Mosul International Airport - Iraq", value: "OSB" },
    { label: "(TJH) Tajima Airport - Japan", value: "TJH" },
    { label: "(AXJ) Amakusa Airfield - Japan", value: "AXJ" },
    { label: "(KKX) Kikai Airport - Japan", value: "KKX" },
    { label: "(AGJ) Aguni Airport - Japan", value: "AGJ" },
    { label: "(HAE) Haeju Airport - North Korea", value: "HAE" },
    { label: "(LAC) Layang Layang Airport - Malaysia", value: "LAC" },
    { label: "(UGA) Bulgan Airport - Mongolia", value: "UGA" },
    { label: "(ULO) Ulaangom Airport - Mongolia", value: "ULO" },
    { label: "(BPR) Borongan Airport - Philippines", value: "BPR" },
    { label: "(LBX) Lubang Community Airport - Philippines", value: "LBX" },
    { label: "(BJT) Bentota Airport - Sri Lanka", value: "BJT" },
    { label: "(DIW) Dickwella Airport - Sri Lanka", value: "DIW" },
    { label: "(TJU) Kulob Airport - Tajikistan", value: "TJU" },
    { label: "(CMJ) Cimei Airport - Taiwan", value: "CMJ" },
    { label: "(TAZ) Dasoguz Airport - Turkmenistan", value: "TAZ" },
    { label: "(BWB) Barrow Island Airport - Australia", value: "BWB" },
    { label: "(MWB) Morawa Airport - Australia", value: "MWB" },
    { label: "(EXM) Exmouth Airport - Australia", value: "EXM" },
    { label: "(DRB) Derby Airport - Australia", value: "DRB" },
    { label: "(WGE) Walgett Airport - Australia", value: "WGE" },
    { label: "(BRT) Bathurst Island Airport - Australia", value: "BRT" },
    { label: "(DKI) Dunk Island Airport - Australia", value: "DKI" },
    { label: "(LZR) Lizard Island Airport - Australia", value: "LZR" },
    { label: "(HLT) Hamilton Airport - Australia", value: "HLT" },
    { label: "(HCQ) Halls Creek Airport - Australia", value: "HCQ" },
    { label: "(FIZ) Fitzroy Crossing Airport - Australia", value: "FIZ" },
    { label: "(RVT) Ravensthorpe Airport - Australia", value: "RVT" },
    { label: "(PVU) Provo Municipal Airport - United States", value: "PVU" },
    {
      label: "(SBS) Steamboat Springs Airport-Bob Adams Field - United States",
      value: "SBS",
    },
    { label: "(DTA) Delta Municipal Airport - United States", value: "DTA" },
    {
      label: "(RIF) Richfield Minicipal Airport - United States",
      value: "RIF",
    },
    {
      label: "(PUC) Carbon County Regional-Buck Davis Field - United States",
      value: "PUC",
    },
    { label: "(LAM) Los Alamos Airport - United States", value: "LAM" },
    { label: "(BXS) Borrego Valley Airport - United States", value: "BXS" },
    { label: "(HII) Lake Havasu City Airport - United States", value: "HII" },
    {
      label: "(INW) Winslow-Lindbergh Regional Airport - United States",
      value: "INW",
    },
    { label: "(DGL) Douglas Municipal Airport - United States", value: "DGL" },
    { label: "(MZK) Marakei Airport - Kiribati", value: "MZK" },
    { label: "(AEA) Abemama Atoll Airport - Kiribati", value: "AEA" },
    { label: "(AAK) Aranuka Airport - Kiribati", value: "AAK" },
    { label: "(KUC) Kuria Airport - Kiribati", value: "KUC" },
    { label: "(AIS) Arorae Island Airport - Kiribati", value: "AIS" },
    { label: "(TMN) Tamana Airport - Kiribati", value: "TMN" },
    { label: "(BEZ) Beru Island Airport - Kiribati", value: "BEZ" },
    { label: "(NIG) Nikunau Airport - Kiribati", value: "NIG" },
    { label: "(BBG) Butaritari Atoll Airport - Kiribati", value: "BBG" },
    { label: "(MTK) Makin Airport - Kiribati", value: "MTK" },
    { label: "(MNK) Maiana Airport - Kiribati", value: "MNK" },
    { label: "(NON) Nonouti Airport - Kiribati", value: "NON" },
    { label: "(TSU) Tabiteuea South Airport - Kiribati", value: "TSU" },
    { label: "(BOT) Bosset Airport - Papua New Guinea", value: "BOT" },
    { label: "(IMI) Ine Airport - Marshall Islands", value: "IMI" },
    { label: "(TIC) Tinak Airport - Marshall Islands", value: "TIC" },
    { label: "(EAL) Elenak Airport - Marshall Islands", value: "EAL" },
    { label: "(LML) Lae Airport - Marshall Islands", value: "LML" },
    { label: "(AIC) Airok Airport - Marshall Islands", value: "AIC" },
    { label: "(EJT) Enejit Airport - Marshall Islands", value: "EJT" },
    { label: "(WTZ) Whitianga Airport - New Zealand", value: "WTZ" },
    { label: "(KTF) Takaka Aerodrome - New Zealand", value: "KTF" },
    { label: "(C23) Peleliu Airfield - Palau", value: "C23" },
    { label: "(AAU) Asau Airport - Samoa", value: "AAU" },
    { label: "(AFT) Afutara Airport - Solomon Islands", value: "AFT" },
    { label: "(RNA) Ulawa Airport - Solomon Islands", value: "RNA" },
    { label: "(CHY) Choiseul Bay Airport - Solomon Islands", value: "CHY" },
    { label: "(NNB) Santa Ana Airport - Solomon Islands", value: "NNB" },
    { label: "(XYA) Yandina Airport - Solomon Islands", value: "XYA" },
    { label: "(BPF) Batuna Airport - Solomon Islands", value: "BPF" },
    { label: "(BOW) Bartow Municipal Airport - United States", value: "BOW" },
    { label: "(KMW) Sokerkino - Russia", value: "KMW" },
    { label: "(FTI) Fitiuta Airport - American Samoa", value: "FTI" },
    { label: "(OFU) Ofu Airport - American Samoa", value: "OFU" },
    { label: "(LVK) Livermore Municipal - United States", value: "LVK" },
    { label: "(MPI) MariposaYosemite - United States", value: "MPI" },
    { label: "(GFY) Grootfontein - Namibia", value: "GFY" },
    { label: "(NDU) Rundu - Namibia", value: "NDU" },
    { label: "(BPU) Beppu Airport - Japan", value: "BPU" },
    { label: "(HRN) Heron Island - Australia", value: "HRN" },
    { label: "(LYT) Lady Elliot Island - Australia", value: "LYT" },
    { label: "(ORS) Orpheus Island - Australia", value: "ORS" },
    { label: "(QQP) Paddington Station - United Kingdom", value: "QQP" },
    { label: "(AGM) Tasiilaq - Greenland", value: "AGM" },
    {
      label: "(TRM) Jacqueline Cochran Regional Airport - United States",
      value: "TRM",
    },
    {
      label: "(SMO) Santa Monica Municipal Airport - United States",
      value: "SMO",
    },
    { label: "(UDD) Bermuda Dunes Airport - United States", value: "UDD" },
    { label: "(ZSY) Scottsdale Airport - United States", value: "ZSY" },
    { label: "(OLM) Olympia Regional Airpor - United States", value: "OLM" },
    { label: "(DWA) Yolo County Airport - United States", value: "DWA" },
    {
      label: "(RIL) Garfield County Regional Airport - United States",
      value: "RIL",
    },
    { label: "(SAA) Shively Field Airport - United States", value: "SAA" },
    { label: "(PDK) Dekalb-Peachtree Airport - United States", value: "PDK" },
    { label: "(BMG) Monroe County Airport - United States", value: "BMG" },
    { label: "(SUA) Witham Field Airport - United States", value: "SUA" },
    {
      label: "(MMU) Morristown Municipal Airport - United States",
      value: "MMU",
    },
    { label: "(APC) Napa County Airport - United States", value: "APC" },
    {
      label: "(SDM) Brown Field Municipal Airport - United States",
      value: "SDM",
    },
    { label: "(PHK) Pahokee Airport - United States", value: "PHK" },
    { label: "(KIE) Kineshma - Russia", value: "KIE" },
    { label: "(NEZ) Nezhitino - Russia", value: "NEZ" },
    { label: "(MFT) Machu Pichu Airport - Peru", value: "MFT" },
    {
      label: "(ECP) Panama City-NW Florida Bea. - United States",
      value: "ECP",
    },
    {
      label: "(SBD) San Bernardino International Airport - United States",
      value: "SBD",
    },
    { label: "(VAL) Valenca Airport - Brazil", value: "VAL" },
    { label: "(MVF) Dix Sept Rosado Airport - Brazil", value: "MVF" },
    { label: "(CAU) Caruaru Airport - Brazil", value: "CAU" },
    { label: "(AWK) Wake Island Afld - Wake Island", value: "AWK" },
    { label: "(QNV) Aeroclube de Nova Iguacu - Brazil", value: "QNV" },
    { label: "(XPG) Gare du Nord - France", value: "XPG" },
    { label: "(XGB) Gare Montparnasse - France", value: "XGB" },
    { label: "(XSH) Saint-Pierre-des-Corps - France", value: "XSH" },
    { label: "(SQL) San Carlos Airport - United States", value: "SQL" },
    {
      label: "(OSZ) Koszalin - Zegrze Pomorskie Airport - Poland",
      value: "OSZ",
    },
    { label: "(LEY) Lelystad Airport - Netherlands", value: "LEY" },
    {
      label: "(RWI) Rocky Mount Wilson Regional Airport - United States",
      value: "RWI",
    },
    { label: "(SXQ) Soldotna Airport - United States", value: "SXQ" },
    { label: "(SEE) Gillespie - United States", value: "SEE" },
    { label: "(LTX) Cotopaxi International Airport - Ecuador", value: "LTX" },
    { label: "(STP) London St Pancras - United Kingdom", value: "STP" },
    { label: "(ZYA) Amsterdam Centraal - Netherlands", value: "ZYA" },
    { label: "(JMY) Mammy Yoko Heliport - Sierra Leone", value: "JMY" },
    { label: "(PHA) Phan Rang Airport - Vietnam", value: "PHA" },
    { label: "(SQH) Na-San Airport - Vietnam", value: "SQH" },
    { label: "(TKF) Truckee-Tahoe Airport - United States", value: "TKF" },
    { label: "(FRJ) Frejus Saint Raphael - France", value: "FRJ" },
    { label: "(GEX) Geelong Airport - Australia", value: "GEX" },
    { label: "(QPP) Berlin Hauptbahnhof - Germany", value: "QPP" },
    { label: "(ZYA) Amsterdam Centraal - Netherlands", value: "ZYA" },
    { label: "(MGR) Moultrie Municipal Airport - United States", value: "MGR" },
    {
      label: "(RYY) Cobb County Airport-Mc Collum Field - United States",
      value: "RYY",
    },
    { label: "(ONH) Oneonta Municipal Airport - United States", value: "ONH" },
    { label: "(ASI) Wideawake Field - United Kingdom", value: "ASI" },
    { label: "(4U9) Dell Flight Strip - United States", value: "4U9" },
    { label: "(LVM) Mission Field Airport - United States", value: "LVM" },
    { label: "(ZWR) Kota Kinabalu Airport - Malaysia", value: "ZWR" },
    { label: "(6S0) Big Timber Airport - United States", value: "6S0" },
    { label: "(BIV) Tulip City Airport - United States", value: "BIV" },
    { label: "(HEN) Hernesaari Heliport - Finland", value: "HEN" },
    { label: "(JRA) West 30th St. Heliport - United States", value: "JRA" },
    {
      label: "(LAL) Lakeland Linder Regional Airport - United States",
      value: "LAL",
    },
    { label: "(SYH) Syangboche - Nepal", value: "SYH" },
    { label: "(IDL) Idlewild Intl - United States", value: "IDL" },
    { label: "(RBK) French Valley Airport - United States", value: "RBK" },
    { label: "(FNU) Fenosu - Italy", value: "FNU" },
    { label: "(MYQ) Mysore Airport - India", value: "MYQ" },
    {
      label: "(PCW) Erie-Ottawa Regional Airport - United States",
      value: "PCW",
    },
    {
      label: "(MGY) Dayton-Wright Brothers Airport - United States",
      value: "MGY",
    },
    { label: "(RID) Richmond Municipal Airport - United States", value: "RID" },
    { label: "(FDY) Findlay Airport - United States", value: "FDY" },
    { label: "(PEA) Penneshaw Airport - Australia", value: "PEA" },
    { label: "(KFX) Kaufbeuren BF - Germany", value: "KFX" },
    { label: "(MUQ) Munich HBF - Germany", value: "MUQ" },
    { label: "(NUR) Nurnberg HBF - Germany", value: "NUR" },
    { label: "(EBE) Ebenhofen BF - Germany", value: "EBE" },
    { label: "(AUB) Augsburg HBF - Germany", value: "AUB" },
    { label: "(BIE) Biessenhofen BF - Germany", value: "BIE" },
    { label: "(BUH) Buchloe BF - Germany", value: "BUH" },
    { label: "(FUX) Fussen BF - Germany", value: "FUX" },
    { label: "(KEX) Kempten HBF - Germany", value: "KEX" },
    { label: "(AIE) Aiome - Papua New Guinea", value: "AIE" },
    { label: "(SIM) Simbai - Papua New Guinea", value: "SIM" },
    { label: "(AUJ) Ambunti - Papua New Guinea", value: "AUJ" },
    { label: "(OAL) Marktoberdorf BF - Germany", value: "OAL" },
    { label: "(MOS) Marktoberdorf Schule - Germany", value: "MOS" },
    { label: "(ESX) Essen HBF - Germany", value: "ESX" },
    { label: "(BOX) Bochum HBF - Germany", value: "BOX" },
    { label: "(KOX) Koln HBF - Germany", value: "KOX" },
    { label: "(BBP) Bembridge - United Kingdom", value: "BBP" },
    { label: "(LES) Leuterschach BF - Germany", value: "LES" },
    {
      label: "(SPF) Black Hills Airport-Clyde Ice Field - United States",
      value: "SPF",
    },
    {
      label: "(KNO) Knokke-Heist Westkapelle Heliport - Belgium",
      value: "KNO",
    },
    { label: "(QYD) Gdynia - Poland", value: "QYD" },
    { label: "(OLV) Olive Branch Muni - United States", value: "OLV" },
    { label: "(ONQ) Zonguldak - Turkey", value: "ONQ" },
    {
      label: "(BJC) Rocky Mountain Metropolitan Airport - United States",
      value: "BJC",
    },
    { label: "(SLE) McNary Field - United States", value: "SLE" },
    { label: "(UTM) Tunica Municipal Airport - United States", value: "UTM" },
    { label: "(ZKB) Kasaba Bay Airport - Zambia", value: "ZKB" },
    { label: "(LND) Lindau HBF - Germany", value: "LND" },
    { label: "(WPU) Guardiamarina Zanartu Airport - Chile", value: "WPU" },
    { label: "(UDE) Volkel AB - Netherlands", value: "UDE" },
    {
      label: "(MWC) Lawrence J Timmerman Airport - United States",
      value: "MWC",
    },
    {
      label: "(JVL) Southern Wisconsin Regional Airport - United States",
      value: "JVL",
    },
    { label: "(HTF) Hatfield - United Kingdom", value: "HTF" },
    { label: "(GKY) Arlington Municipal - United States", value: "GKY" },
    {
      label: "(LZU) Gwinnett County Airport-Briscoe Field - United States",
      value: "LZU",
    },
    {
      label:
        "(BWG) Bowling Green-Warren County Regional Airport - United States",
      value: "BWG",
    },
    {
      label: "(RVS) Richard Lloyd Jones Jr Airport - United States",
      value: "RVS",
    },
    { label: "(NOI) Krymsk - Russia", value: "NOI" },
    { label: "(NHD) Minhad HB - United Arab Emirates", value: "NHD" },
    { label: "(KGO) Kirovograd - Ukraine", value: "KGO" },
    { label: "(DBB) Alalamain Intl. - Egypt", value: "DBB" },
    { label: "(BCE) Bryce Canyon - United States", value: "BCE" },
    { label: "(HDB) Heidelberg - Germany", value: "HDB" },
    {
      label: "(BUY) Burlington-Alamance Regional Airport - United States",
      value: "BUY",
    },
    { label: "(CKL) Chkalovsky Airport - Russia", value: "CKL" },
    { label: "(TCZ) Tengchong Tuofeng Airport - China", value: "TCZ" },
    {
      label: "(UKS) Belbek Sevastopol International Airport - Ukraine",
      value: "UKS",
    },
    { label: "(BER) Berlin Brandenburg Willy Brandt - Germany", value: "BER" },
    { label: "(WZY) Paradise Island Seaplane Base - Bahamas", value: "WZY" },
    {
      label: "(JCI) New Century AirCenter Airport - United States",
      value: "JCI",
    },
    {
      label: "(ESN) Easton-Newnam Field Airport - United States",
      value: "ESN",
    },
    { label: "(HMR) Stafsberg Airport - Norway", value: "HMR" },
    { label: "(R49) Ferry County Airport - United States", value: "R49" },
    { label: "(MYV) Yuba County Airport - United States", value: "MYV" },
    { label: "(STO) Stockholm Cruise Port - Sweden", value: "STO" },
    { label: "(JHE) Helsingborg Cruise Port - Sweden", value: "JHE" },
    { label: "(DUC) Halliburton Field Airport - United States", value: "DUC" },
    { label: "(E91) Chinle Municipal Airport - United States", value: "E91" },
    { label: "(UVA) Garner Field - United States", value: "UVA" },
    { label: "(LOT) Lewis University Airport - United States", value: "LOT" },
    { label: "(C16) Frasca Field - United States", value: "C16" },
    { label: "(CCR) Buchanan Field Airport - United States", value: "CCR" },
    { label: "(OCA) Key Largo - United States", value: "OCA" },
    { label: "(YUS) Yushu Batang - China", value: "YUS" },
    { label: "(PYC) Playon Chico - Panama", value: "PYC" },
    { label: "(UTU) Ustupo - Panama", value: "UTU" },
    { label: "(MPU) Mamitupo - Panama", value: "MPU" },
    { label: "(HIA) Huai An Lianshui Airport - China", value: "HIA" },
    { label: "(PVE) El Porvenir - Panama", value: "PVE" },
    { label: "(YOO) Oshawa Airport - Canada", value: "YOO" },
    { label: "(LHA) Lahr Airport - Germany", value: "LHA" },
    {
      label: "(SGH) Springfield-Beckly Municipal Airport - United States",
      value: "SGH",
    },
    { label: "(MSI) Sun Island Airport - Maldives", value: "MSI" },
    {
      label: "(HEX) Herrera International Airport - Dominican Republic",
      value: "HEX",
    },
    { label: "(CDA) Cooinda - Australia", value: "CDA" },
    { label: "(JAB) Jabiru - Australia", value: "JAB" },
    { label: "(RGB) Regensburg HBF - Germany", value: "RGB" },
    { label: "(TLG) Treuchtlingen BF - Germany", value: "TLG" },
    { label: "(MPB) Miami Seaplane Base - United States", value: "MPB" },
    { label: "(HGS) Hastings Airport - Sierra Leone", value: "HGS" },
    { label: "(TOP) Philip Billard Muni - United States", value: "TOP" },
    { label: "(EMP) Emporia Municipal Airport - United States", value: "EMP" },
    { label: "(NGQ) Gunsa - China", value: "NGQ" },
    { label: "(CSO) Magdeburg-Cochstedt - Germany", value: "CSO" },
    { label: "(WZB) Wurzburg HBF - Germany", value: "WZB" },
    {
      label:
        "(TKI) Collin County Regional Airport at Mc Kinney - United States",
      value: "TKI",
    },
    { label: "(PWK) Chicago Executive - United States", value: "PWK" },
    { label: "(KLS) Kelso Longview - United States", value: "KLS" },
    { label: "(3W2) Put-in-Bay Airport - United States", value: "3W2" },
    { label: "(ZTA) Tureia Airport - French Polynesia", value: "ZTA" },
    { label: "(TWD) Jefferson County Intl - United States", value: "TWD" },
    { label: "(38W) Lynden Airport - United States", value: "38W" },
    { label: "(0S9) Jefferson County Intl - United States", value: "0S9" },
    { label: "(PUE) Puerto Obaldia - Panama", value: "PUE" },
    { label: "(KHC) Kerch Intl - Ukraine", value: "KHC" },
    { label: "(XDS) Train Station - Canada", value: "XDS" },
    { label: "(XVV) Train Station - Canada", value: "XVV" },
    { label: "(XZL) Train Station - Canada", value: "XZL" },
    { label: "(ZRD) Train Station - United States", value: "ZRD" },
    { label: "(XKL) Sentral - Malaysia", value: "XKL" },
    { label: "(XAD) Train Station - Canada", value: "XAD" },
    { label: "(XEF) Train Station - Canada", value: "XEF" },
    { label: "(UKA) Ukunda Airport - Kenya", value: "UKA" },
    {
      label: "(ILN) Wilmington Airborne Airpark - United States",
      value: "ILN",
    },
    { label: "(AVW) Marana Regional - United States", value: "AVW" },
    {
      label: "(CGZ) Casa Grande Municipal Airport - United States",
      value: "CGZ",
    },
    { label: "(BXK) Buckeye Municipal Airport - United States", value: "BXK" },
    {
      label: "(E63) Gila Bend Municipal Airport - United States",
      value: "E63",
    },
    { label: "(MMI) McMinn Co - United States", value: "MMI" },
    { label: "(STK) Sterling Municipal Airport - United States", value: "STK" },
    {
      label: "(RWL) Rawlins Municipal Airport-Harvey Field - United States",
      value: "RWL",
    },
    { label: "(YZY) Mackenzie Airport - Canada", value: "YZY" },
    {
      label: "(CDW) Caldwell Essex County Airport - United States",
      value: "CDW",
    },
    {
      label: "(AIZ) Lee C Fine Memorial Airport - United States",
      value: "AIZ",
    },
    { label: "(L35) Big Bear City - United States", value: "L35" },
    { label: "(KIP) KIEV  INTERNATIONAL AIRPORT - Ukraine", value: "KIP" },
    { label: "(BAM) Bamberg BF - Germany", value: "BAM" },
    { label: "(IGS) Ingolstadt BF - Germany", value: "IGS" },
    {
      label: "(TVI) Thomasville Regional Airport - United States",
      value: "TVI",
    },
    {
      label: "(HSH) Henderson Executive Airport - United States",
      value: "HSH",
    },
    { label: "(GML) Gostomel Antonov - Ukraine", value: "GML" },
    { label: "(TMA) Henry Tift Myers Airport - United States", value: "TMA" },
    { label: "(ZRB) Frankfurt-Main Hauptbahnhof - Germany", value: "ZRB" },
    { label: "(XYG) Praha hlavni nadrazi - Czech Republic", value: "XYG" },
    {
      label: "(QQS) St Pancras Railway Station - United Kingdom",
      value: "QQS",
    },
    { label: "(ULX) Ulusaba Airstrip - Namibia", value: "ULX" },
    { label: "(QXR) RADOM - Poland", value: "QXR" },
    {
      label: "(DVT) Deer Valley Municipal Airport - United States",
      value: "DVT",
    },
    { label: "(YBW) Calgary Springbank Airport - Canada", value: "YBW" },
    { label: "(YGE) Golden Airport - Canada", value: "YGE" },
    { label: "(YRV) Revelstoke Airport - Canada", value: "YRV" },
    { label: "(TYA) Tula - Russia", value: "TYA" },
    { label: "(HDO) Hondo Municipal Airport - United States", value: "HDO" },
    { label: "(ZHY) Zhongwei Xiangshan Airport - China", value: "ZHY" },
    {
      label: "(MCL) McKinley National Park Airport - United States",
      value: "MCL",
    },
    { label: "(LHD) Lake Hood Seaplane Base - United States", value: "LHD" },
    { label: "(PPC) Prospect Creek Airport - United States", value: "PPC" },
    { label: "(KHW) Khwai River Lodge - Botswana", value: "KHW" },
    { label: "(TXG) Taichung Airport - Taiwan", value: "TXG" },
    { label: "(HCC) Columbia County - United States", value: "HCC" },
    {
      label: "(HLG) Wheeling Ohio County Airport - United States",
      value: "HLG",
    },
    {
      label: "(FZG) Fitzgerald Municipal Airport - United States",
      value: "FZG",
    },
    { label: "(40J) Perry-Foley Airport - United States", value: "40J" },
    { label: "(SSX) Samsun  - Turkey", value: "SSX" },
    { label: "(XYE) Ye - Burma", value: "XYE" },
    { label: "(XEG) Kingston Train Station - Canada", value: "XEG" },
    { label: "(XAX) Dorval Railway Station - Canada", value: "XAX" },
    { label: "(DWC) Dubai Al Maktoum - United Arab Emirates", value: "DWC" },
    { label: "(RKP) Aransas County Airport - United States", value: "RKP" },
    { label: "(NDA) Bandanaira Airport - Indonesia", value: "NDA" },
    { label: "(MVV) Megeve Airport - France", value: "MVV" },
    { label: "(MFX) Meribel Airport - France", value: "MFX" },
    { label: "(AEB) Tianyang - China", value: "AEB" },
    { label: "(OKF) Okaukuejo Airport - Namibia", value: "OKF" },
    { label: "(OKU) Mokuti Lodge Airport - Namibia", value: "OKU" },
    { label: "(PSH) St. Peter-Ording Airport - Germany", value: "PSH" },
    {
      label: "(CKF) Crisp County Cordele Airport - United States",
      value: "CKF",
    },
    {
      label: "(OMN) Ormond Beach municipal Airport - United States",
      value: "OMN",
    },
    { label: "(TTD) Portland Troutdale - United States", value: "TTD" },
    { label: "(HIO) Portland Hillsboro - United States", value: "HIO" },
    { label: "(24J) Suwannee County Airport - United States", value: "24J" },
    { label: "(KHT) FOB Salerno - Afghanistan", value: "KHT" },
    { label: "(NYT) NAYPYITAW - Burma", value: "NYT" },
    { label: "(GAI) Montgomery County Airpark - United States", value: "GAI" },
    { label: "(AZ3) Sharona - Afghanistan", value: "AZ3" },
    { label: "(YTA) Pembroke Airport - Canada", value: "YTA" },
    { label: "(TSB) Tsumeb Airport - Namibia", value: "TSB" },
    { label: "(YSD) Suffield Heliport - Canada", value: "YSD" },
    { label: "(BNU) Aeroporto Blumenau - Brazil", value: "BNU" },
    { label: "(SIB) Aeroclub Sibiu - Romania", value: "SIB" },
    { label: "(CIO) Aeroclub Cioca - Romania", value: "CIO" },
    {
      label: "(CVX) Charlevoix Municipal Airport - United States",
      value: "CVX",
    },
    { label: "(2J9) Quincy Municipal Airport - United States", value: "2J9" },
    { label: "(RCE) Roche Harbor Seaplane Base - United States", value: "RCE" },
    { label: "(BYW) Blakely Island Airport - United States", value: "BYW" },
    { label: "(RSJ) Rosario Seaplane Base - United States", value: "RSJ" },
    { label: "(WSX) Westsound Seaplane Base - United States", value: "WSX" },
    {
      label: "(FBS) Friday Harbor Seaplane Base - United States",
      value: "FBS",
    },
    { label: "(YRR) Big Bay Water Aerodrome - Canada", value: "YRR" },
    { label: "(L06) Furnace Creek - United States", value: "L06" },
    { label: "(YCC) Cornwall Regional Airport - Canada", value: "YCC" },
    { label: "(IZA) Zona da Mata Regional Airport - Brazil", value: "IZA" },
    { label: "(XFL) Flagler County Airport - United States", value: "XFL" },
    { label: "(DVA) Aeroclub Deva - Romania", value: "DVA" },
    { label: "(DZM) Aeroclub Cluj - Romania", value: "DZM" },
    {
      label: "(MVL) Morrisville Stowe State Airport - United States",
      value: "MVL",
    },
    { label: "(RBD) Dallas Executive Airport - United States", value: "RBD" },
    { label: "(6Y8) Welke Airport - United States", value: "6Y8" },
    { label: "(MOW) MOW - Russia", value: "MOW" },
    { label: "(WST) Westerly State Airport - United States", value: "WST" },
    { label: "(BID) Block Island State Airport - United States", value: "BID" },
    { label: "(369) Atmautluak Airport - United States", value: "369" },
    { label: "(NME) Nightmute Airport - United States", value: "NME" },
    { label: "(OOK) Toksook Bay Airport - United States", value: "OOK" },
    { label: "(TNK) Tununak Airport - United States", value: "TNK" },
    { label: "(GNU) Goodnews Airport - United States", value: "GNU" },
    { label: "(WWT) Newtok Airport - United States", value: "WWT" },
    { label: "(ACU) Achutupo Airport - Panama", value: "ACU" },
    { label: "(TUW) Tubuala Airport - Panama", value: "TUW" },
    { label: "(GHE) Garachine Airport - Panama", value: "GHE" },
    { label: "(MPP) Mulatupo Airport - Panama", value: "MPP" },
    { label: "(OBY) Ittoqqortoormiit Heliport - Greenland", value: "OBY" },
    { label: "(VIN) Vinnitsa - Ukraine", value: "VIN" },
    { label: "(QXG) Angers St Laud - France", value: "QXG" },
    {
      label: "(BGE) Decatur County Industrial Air Park - United States",
      value: "BGE",
    },
    { label: "(ZKG) Kegaska Airport - Canada", value: "ZKG" },
    { label: "(YBI) Black Tickle Airport - Canada", value: "YBI" },
    { label: "(SPZ) Silver Springs Airport - United States", value: "SPZ" },
    { label: "(WHP) Whiteman Airport - United States", value: "WHP" },
    { label: "(MAE) Madera Municipal Airport - United States", value: "MAE" },
    { label: "(YZZ) Trail Airport - Canada", value: "YZZ" },
    { label: "(YAB) Arctic Bay Airport - Canada", value: "YAB" },
    { label: "(BCV) Hector Silva Airstrip - Belize", value: "BCV" },
    { label: "(MPY) Maripasoula Airport - French Guiana", value: "MPY" },
    {
      label: "(LDX) Saint-Laurent-du-Maroni Airport - French Guiana",
      value: "LDX",
    },
    { label: "(AAJ) Cayana Airstrip - Surilabel", value: "AAJ" },
    { label: "(LDO) Laduani Airstrip - Surilabel", value: "LDO" },
    { label: "(KJI) Kanas Airport - China", value: "KJI" },
    { label: "(CPB) Capurgana Airport - Colombia", value: "CPB" },
    { label: "(HMB) Sohag International - Egypt", value: "HMB" },
    { label: "(RVY) Rivera International Airport - Uruguay", value: "RVY" },
    { label: "(POJ) Patos de Minas Airport - Brazil", value: "POJ" },
    { label: "(JTC) Bauru-Arealva - Brazil", value: "JTC" },
    { label: "(OIA) Ourilandia do Norte Airport - Brazil", value: "OIA" },
    { label: "(RDC) Redencao Airport - Brazil", value: "RDC" },
    { label: "(SXX) Sao Felix do Xingu Airport - Brazil", value: "SXX" },
    { label: "(BYO) Bonito Airport - Brazil", value: "BYO" },
    { label: "(SXO) Sao Felix do Araguaia Airport - Brazil", value: "SXO" },
    {
      label: "(CFC) Carlos Alberto da Costa Neves Airport - Brazil",
      value: "CFC",
    },
    { label: "(CAF) Carauari Airport - Brazil", value: "CAF" },
    { label: "(ERN) Amaury Feitosa Tomaz Airport - Brazil", value: "ERN" },
    { label: "(CCI) Concordia Airport - Brazil", value: "CCI" },
    { label: "(FBE) Paulo Abdala Airport - Brazil", value: "FBE" },
    { label: "(CFO) Confresa Airport - Brazil", value: "CFO" },
    { label: "(19A) Jackson County Airport - United States", value: "19A" },
    {
      label: "(AAF) Apalachicola Regional Airport - United States",
      value: "AAF",
    },
    { label: "(UMU) Orlando de Carvalho Airport - Brazil", value: "UMU" },
    { label: "(DTI) Diamantina Airport - Brazil", value: "DTI" },
    { label: "(FBA) Fonte Boa Airport - Brazil", value: "FBA" },
    { label: "(OLC) Senadora Eunice Micheles Airport - Brazil", value: "OLC" },
    { label: "(HUW) Humaita Airport - Brazil", value: "HUW" },
    { label: "(IRZ) Tapuruquara Airport - Brazil", value: "IRZ" },
    { label: "(ORX) Oriximina Airport - Brazil", value: "ORX" },
    { label: "(UNA) Una-Comandatuba Airport - Brazil", value: "UNA" },
    { label: "(TEF) Telfer Airport - Australia", value: "TEF" },
    { label: "(GZP) Gazipasa Airport - Turkey", value: "GZP" },
    { label: "(SGJ) St. Augustine Airport - United States", value: "SGJ" },
    { label: "(LDZ) Londolozi - South Africa", value: "LDZ" },
    { label: "(INY) Singita Sabi Sands - South Africa", value: "INY" },
    { label: "(DQH) Douglas Municipal Airport - United States", value: "DQH" },
    {
      label: "(FRP) St Lucie County International Airport - United States",
      value: "FRP",
    },
    { label: "(ALX) Alexandria - United States", value: "ALX" },
    {
      label: "(TAN) Taunton Municipal Airport - King Field - United States",
      value: "TAN",
    },
    { label: "(PYM) Plymouth Municipal Airport - United States", value: "PYM" },
    { label: "(OQU) Quonset State Airport - United States", value: "OQU" },
    { label: "(1B9) Mansfield Municipal - United States", value: "1B9" },
    { label: "(OWD) Norwood Memorial Airport - United States", value: "OWD" },
    { label: "(BAF) Barnes Municipal - United States", value: "BAF" },
    { label: "(IJD) Windham Airport - United States", value: "IJD" },
    { label: "(MGJ) Orange County Airport - United States", value: "MGJ" },
    { label: "(CXY) Capital City Airport - United States", value: "CXY" },
    {
      label: "(GHG) Marshfield Municipal Airport - United States",
      value: "GHG",
    },
    { label: "(DXR) Danbury Municipal Airport - United States", value: "DXR" },
    { label: "(ASH) Boire Field Airport - United States", value: "ASH" },
    { label: "(LWM) Lawrence Municipal Airport - United States", value: "LWM" },
    { label: "(OXC) Waterbury-Oxford Airport - United States", value: "OXC" },
    {
      label: "(FIT) Fitchburg Municipal Airport - United States",
      value: "FIT",
    },
    { label: "(VPC) Cartersville Airport - United States", value: "VPC" },
    {
      label:
        "(PYP) Centre-Piedmont-Cherokee County Regional Airport - United States",
      value: "PYP",
    },
    { label: "(RMG) Richard B Russell Airport - United States", value: "RMG" },
    {
      label: "(GAD) Northeast Alabama Regional Airport - United States",
      value: "GAD",
    },
    {
      label: "(DKX) Knoxville Downtown Island Airport - United States",
      value: "DKX",
    },
    { label: "(WDR) Barrow County Airport - United States", value: "WDR" },
    { label: "(JYL) Plantation Airpark - United States", value: "JYL" },
    { label: "(DNN) Dalton Municipal Airport - United States", value: "DNN" },
    {
      label:
        "(CTJ) West Georgia Regional Airport - O V Gray Field - United States",
      value: "CTJ",
    },
    { label: "(4A9) Isbell Field Airport - United States", value: "4A9" },
    { label: "(LGC) LaGrange-Callaway Airport - United States", value: "LGC" },
    { label: "(MLJ) Baldwin County Airport - United States", value: "MLJ" },
    {
      label:
        "(4A4) Polk County Airport - Cornelius Moore Field - United States",
      value: "4A4",
    },
    { label: "(PIM) Harris County Airport - United States", value: "PIM" },
    {
      label: "(FFC) Atlanta Regional Airport - Falcon Field - United States",
      value: "FFC",
    },
    {
      label: "(9A1) Covington Municipal Airport - United States",
      value: "9A1",
    },
    {
      label: "(GVL) Lee Gilmer Memorial Airport - United States",
      value: "GVL",
    },
    { label: "(54J) DeFuniak Springs Airport - United States", value: "54J" },
    { label: "(9A5) Barwick Lafayette Airport - United States", value: "9A5" },
    { label: "(PHD) Harry Clever Field Airport - United States", value: "PHD" },
    { label: "(UDG) Darlington County Jetport - United States", value: "UDG" },
    { label: "(HXD) Hilton Head Airport - United States", value: "HXD" },
    { label: "(49A) Gilmer County Airport - United States", value: "49A" },
    {
      label: "(0A9) Elizabethton Municipal Airport - United States",
      value: "0A9",
    },
    {
      label: "(06A) Moton Field Municipal Airport - United States",
      value: "06A",
    },
    { label: "(DNL) Daniel Field Airport - United States", value: "DNL" },
    { label: "(MRN) Foothills Regional Airport - United States", value: "MRN" },
    {
      label: "(PBX) Pike County Airport - Hatcher Field - United States",
      value: "PBX",
    },
    {
      label: "(TOC) Toccoa RG Letourneau Field Airport - United States",
      value: "TOC",
    },
    { label: "(PLV) Poltava - Ukraine", value: "PLV" },
    { label: "(WUU) Wau Airport - Sudan", value: "WUU" },
    { label: "(HUE) Humera Airport - Ethiopia", value: "HUE" },
    { label: "(OYL) Moyale Airport - Kenya", value: "OYL" },
    { label: "(WYE) Yengema Airport - Sierra Leone", value: "WYE" },
    { label: "(GBK) Gbangbatok Airport - Sierra Leone", value: "GBK" },
    { label: "(VDF) Tampa Executive Airport - United States", value: "VDF" },
    {
      label: "(AFW) Fort Worth Alliance Airport - United States",
      value: "AFW",
    },
    {
      label: "(57C) East Troy Municipal Airport - United States",
      value: "57C",
    },
    { label: "(MYF) Montgomery Field - United States", value: "MYF" },
    { label: "(SEL) Gimpo International Airpot - South Korea", value: "SEL" },
    { label: "(RMK) Renmark - Australia", value: "RMK" },
    { label: "(KEW) Keewaywin - Canada", value: "KEW" },
    { label: "(YSP) Marathon - Canada", value: "YSP" },
    { label: "(YHF) Rene Fontaine - Canada", value: "YHF" },
    { label: "(YHN) Hornepayne - Canada", value: "YHN" },
    { label: "(YKX) Kirkland Lake - Canada", value: "YKX" },
    { label: "(YMG) Manitouwadge - Canada", value: "YMG" },
    { label: "(YXZ) Wawa - Canada", value: "YXZ" },
    { label: "(YEM) Manitoulin East - Canada", value: "YEM" },
    { label: "(YFD) Brantford - Canada", value: "YFD" },
    { label: "(LWC) Lawrence Municipal - United States", value: "LWC" },
    { label: "(EGT) Wellington Municipal - United States", value: "EGT" },
    {
      label: "(6A2) Griffin-Spalding County Airport - United States",
      value: "6A2",
    },
    { label: "(NIC) Nicosia International Airport - Cyprus", value: "NIC" },
    { label: "(PMP) Pompano Beach Airpark - United States", value: "PMP" },
    { label: "(XMC) Mallacoota Airport - Australia", value: "XMC" },
    { label: "(ULH) Prince Abdul Majeed Airport - Saudi Arabia", value: "ULH" },
    { label: "(EET) Shelby County Airport - United States", value: "EET" },
    { label: "(YUE) Yuendumu  - Australia", value: "YUE" },
    { label: "(XWG) Gare de Strasbourg - France", value: "XWG" },
    { label: "(GZS) Guangzhou South Railway Station - China", value: "GZS" },
    { label: "(LOP) Lombok International Airport - Indonesia", value: "LOP" },
    { label: "(OMM) Marmul - Oman", value: "OMM" },
    { label: "(ZML) South Cariboo Regional Airport - Canada", value: "ZML" },
    { label: "(HDG) Hebei Handan Airport - China", value: "HDG" },
    {
      label: "(UMP) Indianapolis Metropolitan Airport - United States",
      value: "UMP",
    },
    {
      label: "(LOZ) London-Corbin Airport-MaGee Field - United States",
      value: "LOZ",
    },
    {
      label: "(FBG) Fredericksburg Amtrak Station - United States",
      value: "FBG",
    },
    { label: "(WMI) Warsaw Modlin - Poland", value: "WMI" },
    { label: "(JXA) Jixi Airport - China", value: "JXA" },
    { label: "(YGM) Gimli Industrial Park Airport - Canada", value: "YGM" },
    { label: "(EYK) Beloyarsky - Russia", value: "EYK" },
    { label: "(RAC) John H. Batten Airport - United States", value: "RAC" },
    { label: "(RZP) Taytay Sandoval - Philippines", value: "RZP" },
    { label: "(QOT) Otaru - Japan", value: "QOT" },
    { label: "(RKZ) Shigatse Peace Airport - China", value: "RKZ" },
    { label: "(REI) Redlands Municipal Airport - United States", value: "REI" },
    { label: "(49X) Chemehuevi Valley - United States", value: "49X" },
    { label: "(RIR) Flabob Airport - United States", value: "RIR" },
    { label: "(TIW) Tacoma Narrows Airport - United States", value: "TIW" },
    { label: "(X39) Tampa North Aero Park - United States", value: "X39" },
    { label: "(JKA) Jack Edwards Airport - United States", value: "JKA" },
    { label: "(VIF) Vieste Heliport - Italy", value: "VIF" },
    { label: "(HMJ) Khmeinitskiy - Ukraine", value: "HMJ" },
    { label: "(HIW) Hiroshima-Nishi - Japan", value: "HIW" },
    { label: "(HZL) Hazleton Municipal - United States", value: "HZL" },
    { label: "(CBE) Greater Cumberland Rgnl. - United States", value: "CBE" },
    { label: "(YBO) Bob Quinn Lake - Canada", value: "YBO" },
    { label: "(FGL) Fox Glacier Airstrip - New Zealand", value: "FGL" },
    { label: "(KLF) Grabtsevo - Russia", value: "KLF" },
    { label: "(XEV) Central Station - Sweden", value: "XEV" },
    { label: "(QYX) Central Station - Sweden", value: "QYX" },
    { label: "(QRH) Centraal - Netherlands", value: "QRH" },
    { label: "(XYJ) Holesovice - Czech Republic", value: "XYJ" },
    { label: "(BNJ) Hauptbahnhof - Germany", value: "BNJ" },
    { label: "(ZGH) Central - Denmark", value: "ZGH" },
    { label: "(ZSB) Hauptbahnhof - Austria", value: "ZSB" },
    { label: "(ZWE) Centraal - Belgium", value: "ZWE" },
    { label: "(ELL) Ellisras - South Africa", value: "ELL" },
    {
      label: "(LNR) Tri-County Regional Airport - United States",
      value: "LNR",
    },
    { label: "(JOT) Regional Airport - United States", value: "JOT" },
    { label: "(VYS) Illinois Valley Regional - United States", value: "VYS" },
    { label: "(JXN) Reynolds Field - United States", value: "JXN" },
    { label: "(BBX) Wings Field - United States", value: "BBX" },
    { label: "(OBE) County - United States", value: "OBE" },
    { label: "(SEF) Regional - Hendricks AAF - United States", value: "SEF" },
    { label: "(AVO) Executive - United States", value: "AVO" },
    { label: "(GIF) Gilbert Airport - United States", value: "GIF" },
    { label: "(ZPH) Municipal Airport - United States", value: "ZPH" },
    { label: "(OCF) International Airport - United States", value: "OCF" },
    { label: "(JES) Jesup-Wayne County Airport - United States", value: "JES" },
    {
      label: "(52A) Madison GA Municipal Airport - United States",
      value: "52A",
    },
    { label: "(CCO) Coweta County Airport - United States", value: "CCO" },
    { label: "(HQU) McDuffie County Airport - United States", value: "HQU" },
    { label: "(AIK) Municipal Airport - United States", value: "AIK" },
    { label: "(CDN) Woodward Field - United States", value: "CDN" },
    { label: "(LBT) Municipal Airport - United States", value: "LBT" },
    { label: "(3J1) Ridgeland Airport - United States", value: "3J1" },
    { label: "(SOP) Moore County Airport - United States", value: "SOP" },
    { label: "(RCZ) Richmond County Airport - United States", value: "RCZ" },
    { label: "(99N) Bamberg County Airport - United States", value: "99N" },
    { label: "(93C) Richland Airport - United States", value: "93C" },
    { label: "(Y51) Municipal Airport - United States", value: "Y51" },
    {
      label: "(DLL) Baraboo Wisconsin Dells Airport - United States",
      value: "DLL",
    },
    { label: "(7A4) Foster Field - United States", value: "7A4" },
    { label: "(SVH) Regional Airport - United States", value: "SVH" },
    { label: "(C89) Sylvania Airport - United States", value: "C89" },
    { label: "(BUU) Municipal Airport - United States", value: "BUU" },
    { label: "(N53) Stroudsburg-Pocono Airport - United States", value: "N53" },
    { label: "(70N) Spring Hill Airport - United States", value: "70N" },
    { label: "(06N) Randall Airport - United States", value: "06N" },
    { label: "(LHV) William T. Piper Mem. - United States", value: "LHV" },
    { label: "(29D) Grove City Airport - United States", value: "29D" },
    { label: "(04G) Lansdowne Airport - United States", value: "04G" },
    { label: "(3G3) Wadsworth Municipal - United States", value: "3G3" },
    { label: "(3G4) Ashland County Airport - United States", value: "3G4" },
    {
      label: "(4G0) Pittsburgh-Monroeville Airport - United States",
      value: "4G0",
    },
    { label: "(2G9) Somerset County Airport - United States", value: "2G9" },
    {
      label: "(4G4) Youngstown Elser Metro Airport - United States",
      value: "4G4",
    },
    { label: "(41N) Braceville Airport - United States", value: "41N" },
    {
      label: "(LPR) Lorain County Regional Airport - United States",
      value: "LPR",
    },
    { label: "(7D9) Germack Airport - United States", value: "7D9" },
    { label: "(BKL) Burke Lakefront Airport - United States", value: "BKL" },
    {
      label: "(DKK) Chautauqua County-Dunkirk Airport - United States",
      value: "DKK",
    },
    { label: "(4G2) Hamburg Inc Airport - United States", value: "4G2" },
    {
      label: "(N87) Trenton-Robbinsville Airport - United States",
      value: "N87",
    },
    {
      label: "(VAY) South Jersey Regional Airport - United States",
      value: "VAY",
    },
    { label: "(7N7) Spitfire Aerodrome - United States", value: "7N7" },
    { label: "(LDJ) Linden Airport - United States", value: "LDJ" },
    { label: "(O03) Morgantown Airport - United States", value: "O03" },
    { label: "(0W3) Harford County Airport - United States", value: "0W3" },
    {
      label: "(ANQ) Tri-State Steuben County Airport - United States",
      value: "ANQ",
    },
    { label: "(C65) Plymouth Municipal Airport - United States", value: "C65" },
    { label: "(VNW) Van Wert County Airport - United States", value: "VNW" },
    {
      label: "(17G) Port Bucyrus-Crawford County Airport - United States",
      value: "17G",
    },
    {
      label: "(X07) Lake Wales Municipal Airport - United States",
      value: "X07",
    },
    { label: "(RMY) Brooks Field Airport - United States", value: "RMY" },
    { label: "(GVQ) Genesee County Airport - United States", value: "GVQ" },
    {
      label: "(0G7) Finger Lakes Regional Airport - United States",
      value: "0G7",
    },
    { label: "(N69) Stormville Airport - United States", value: "N69" },
    { label: "(4B8) Robertson Field - United States", value: "4B8" },
    { label: "(0G6) Williams County Airport - United States", value: "0G6" },
    { label: "(CLW) Clearwater Air Park - United States", value: "CLW" },
    { label: "(X49) South Lakeland Airport - United States", value: "X49" },
    { label: "(SCS) Scatsta Airport - United Kingdom", value: "SCS" },
    { label: "(QWC) Zoo - Germany", value: "QWC" },
    { label: "(ZFR) Frankfurt Oder Hbf - Germany", value: "ZFR" },
    { label: "(PLY) Gare de Lyon - France", value: "PLY" },
    { label: "(XHP) Gare de LEst - France", value: "XHP" },
    { label: "(PAR) All Airports - France", value: "PAR" },
    { label: "(BHF) Ostbahnhof - Germany", value: "BHF" },
    { label: "(LON) All Airports - United Kingdom", value: "LON" },
    { label: "(NYC) All Airports - United States", value: "NYC" },
    { label: "(CHI) All Airports - United States", value: "CHI" },
    { label: "(CGX) Meigs Field - United States", value: "CGX" },
    { label: "(TYO) All Airports - Japan", value: "TYO" },
    { label: "(BJS) All Airports - China", value: "BJS" },
    { label: "(MIL) All Airports - Italy", value: "MIL" },
    { label: "(WAS) All Airports - United States", value: "WAS" },
    { label: "(YMQ) All Airports - Canada", value: "YMQ" },
    { label: "(YTO) All Airports - Canada", value: "YTO" },
    { label: "(JZP) Pickens County Airport - United States", value: "JZP" },
    { label: "(BGS) Gesundbrunnen - Germany", value: "BGS" },
    { label: "(CRE) Grand Strand Airport - United States", value: "CRE" },
    { label: "(SMT) Sun Moon Lake Airport - Taiwan", value: "SMT" },
    { label: "(IGQ) Lansing Municipal - United States", value: "IGQ" },
    { label: "(Y72) Bloyer Field - United States", value: "Y72" },
    { label: "(RNM) Ramona Airport - United States", value: "RNM" },
    { label: "(BXO) Buochs Airport - Switzerland", value: "BXO" },
    {
      label: "(OEB) Branch County Memorial Airport - United States",
      value: "OEB",
    },
    {
      label: "(WBW) Wilkes-Barre Wyoming Valley Airport - United States",
      value: "WBW",
    },
    {
      label: "(LNN) Lost Nation Municipal Airport - United States",
      value: "LNN",
    },
    { label: "(UMD) Uummannaq Heliport - Greenland", value: "UMD" },
    { label: "(RLK) Bayannur - China", value: "RLK" },
    { label: "(FFT) Capital City Airport - United States", value: "FFT" },
    { label: "(LEW) Lewiston Maine - United States", value: "LEW" },
    { label: "(6S2) Florence - United States", value: "6S2" },
    {
      label: "(1A3) Martin Campbell Field Airport - United States",
      value: "1A3",
    },
    { label: "(NBU) Naval Air Station - United States", value: "NBU" },
    { label: "(MRK) Marco Islands - United States", value: "MRK" },
    { label: "(DRM) Drummond Island Airport - United States", value: "DRM" },
    { label: "(8M8) Garland Airport - United States", value: "8M8" },
    {
      label: "(GDW) Gladwin Zettel Memorial Airport - United States",
      value: "GDW",
    },
    { label: "(24C) Lowell City Airport - United States", value: "24C" },
    {
      label: "(LWA) South Haven Area Regional Airport - United States",
      value: "LWA",
    },
    { label: "(06C) Schaumburg Regional - United States", value: "06C" },
    {
      label: "(MFI) Marshfield Municipal Airport - United States",
      value: "MFI",
    },
    {
      label: "(ISW) Alexander Field South Wood County Airport - United States",
      value: "ISW",
    },
    { label: "(CWI) Clinton Municipal - United States", value: "CWI" },
    { label: "(BVY) Beverly Municipal Airport - United States", value: "BVY" },
    { label: "(O27) Oakdale Airport - United States", value: "O27" },
    { label: "(YRQ) Trois Rivieres Airport - Canada", value: "YRQ" },
    {
      label: "(POF) Poplar Bluff Municipal Airport - United States",
      value: "POF",
    },
    { label: "(EPM) Eastport Municipal Airport - United States", value: "EPM" },
    { label: "(EOK) Keokuk Municipal Airport - United States", value: "EOK" },
    { label: "(ME5) Banks Airport - United States", value: "ME5" },
    { label: "(PSL) Perth Scone Airport - United Kingdom", value: "PSL" },
    { label: "(SOO) Soderhamn Airport - Sweden", value: "SOO" },
    { label: "(VNA) Saravane Airport - Laos", value: "VNA" },
    { label: "(E51) Bagdad Airport - United States", value: "E51" },
    { label: "(DKS) Dikson Airport - Russia", value: "DKS" },
    { label: "(XBG) Bogande Airport - Canada", value: "XBG" },
    { label: "(BYT) Bantry Aerodrome - Ireland", value: "BYT" },
    { label: "(CHE) Reeroe Airport - Ireland", value: "CHE" },
    { label: "(ADY) Alldays Airport - South Africa", value: "ADY" },
    { label: "(E55) Ocean Ridge Airport - United States", value: "E55" },
    { label: "(1G3) Kent State Airport - United States", value: "1G3" },
    { label: "(GAS) Garissa - Kenya", value: "GAS" },
    { label: "(HOA) Hola - Kenya", value: "HOA" },
    { label: "(KLK) Kalokol - Kenya", value: "KLK" },
    { label: "(KEY) Kericho - Kenya", value: "KEY" },
    { label: "(ILU) Kilaguni - Kenya", value: "ILU" },
    { label: "(KRV) Kerio Valley - Kenya", value: "KRV" },
    { label: "(DVD) Andavadoaka - Madagascar", value: "DVD" },
    { label: "(ATJ) Antsirabe - Madagascar", value: "ATJ" },
    { label: "(OVA) Bekily - Madagascar", value: "OVA" },
    {
      label: "(ZRA) Atlantic City Rail Terminal - United States",
      value: "ZRA",
    },
    { label: "(ZSF) Springfield Amtrak Station - United States", value: "ZSF" },
    { label: "(XZK) Amherst Amtrak Station AMM - United States", value: "XZK" },
    { label: "(QQK) London - Kings Cross - United Kingdom", value: "QQK" },
    { label: "(XVJ) Stevenage Railway Station - United Kingdom", value: "XVJ" },
    {
      label: "(XVH) Peterborough Railway Station - United Kingdom",
      value: "XVH",
    },
    { label: "(PUM) Pomalaa - Indonesia", value: "PUM" },
    {
      label: "(WLF) Whittlesford Parkway Rail Station - United Kingdom",
      value: "WLF",
    },
    { label: "(RGK) Gorno-Altaysk Airport - Russia", value: "RGK" },
    { label: "(FLD) Fond Du Lac County Airport - United States", value: "FLD" },
    { label: "(PCZ) Waupaca Municipal Airport - United States", value: "PCZ" },
    {
      label: "(STE) Stevens Point Municipal Airport - United States",
      value: "STE",
    },
    { label: "(ERY) Luce County Airport - United States", value: "ERY" },
    { label: "(25D) Forest Lake Airport - United States", value: "25D" },
    { label: "(ZVM) Hannover Messe-Heliport - Germany", value: "ZVM" },
    { label: "(PEF) Peenemunde Airfield - Germany", value: "PEF" },
    { label: "(GQQ) Galion Municipal Airport - United States", value: "GQQ" },
    { label: "(TPN) Tiputini - Ecuador", value: "TPN" },
    { label: "(PTZ) Shell Mera - Ecuador", value: "PTZ" },
    {
      label:
        "(CKV) Clarksville-Montgomery County Regional Airport - United States",
      value: "CKV",
    },
    { label: "(XHN) Liege-Guillemins Railway Station - Belgium", value: "XHN" },
    { label: "(OHR) Wyk auf Foehr - Germany", value: "OHR" },
    { label: "(LPC) Lompoc Airport - United States", value: "LPC" },
    {
      label: "(CTH) Chester County G O Carlson Airport - United States",
      value: "CTH",
    },
    { label: "(BST) Bost Airport - Afghanistan", value: "BST" },
    {
      label: "(LLK) Lankaran International Airport - Azerbaijan",
      value: "LLK",
    },
    { label: "(GBB) Qabala Airport - Azerbaijan", value: "GBB" },
    {
      label: "(ZTU) Zaqatala International Airport - Azerbaijan",
      value: "ZTU",
    },
    { label: "(LKP) Lake Placid Airport - United States", value: "LKP" },
    { label: "(NY9) Long Lake - United States", value: "NY9" },
    { label: "(JIQ) Zhoubai - China", value: "JIQ" },
    { label: "(DEE) Mendeleevo - Russia", value: "DEE" },
    { label: "(WIH) Wishram Amtrak Station - United States", value: "WIH" },
    { label: "(AOH) Lima Allen County Airport - United States", value: "AOH" },
    { label: "(DSO) Sondok Airport - North Korea", value: "DSO" },
    { label: "(YJS) Samjiyon Airport - North Korea", value: "YJS" },
    { label: "(SSI) McKinnon Airport - United States", value: "SSI" },
    { label: "(BFP) Beaver Falls - United States", value: "BFP" },
    { label: "(F57) Seaplane Base - United States", value: "F57" },
    { label: "(GGE) Georgetown County Airport - United States", value: "GGE" },
    { label: "(HDI) Hardwick Field Airport - United States", value: "HDI" },
    { label: "(2A0) Mark Anton Airport - United States", value: "2A0" },
    { label: "(2G2) Jefferson County Airpark - United States", value: "2G2" },
    { label: "(RNT) Renton - United States", value: "RNT" },
    { label: "(ZBM) Bromont Airport - Canada", value: "ZBM" },
    { label: "(POC) Brackett Field - United States", value: "POC" },
    { label: "(09J) Jekyll Island Airport - United States", value: "09J" },
    { label: "(CDK) CedarKey - United States", value: "CDK" },
    { label: "(CTY) Cross City - United States", value: "CTY" },
    { label: "(CEU) Clemson - United States", value: "CEU" },
    {
      label: "(36U) Heber City Municipal Airport - United States",
      value: "36U",
    },
    { label: "(BEC) Beech Factory Airport - United States", value: "BEC" },
    { label: "(47A) Cherokee County Airport - United States", value: "47A" },
    {
      label: "(55J) Fernandina Beach Municipal Airport - United States",
      value: "55J",
    },
    { label: "(ZMB) Hamburg Hbf - Germany", value: "ZMB" },
    {
      label: "(GTU) Georgetown Municipal Airport - United States",
      value: "GTU",
    },
    { label: "(QFO) Duxford Aerodrome - United Kingdom", value: "QFO" },
    { label: "(SNY) Sidney Muni Airport - United States", value: "SNY" },
    { label: "(W13) Eagle's Nest Airport - United States", value: "W13" },
    { label: "(GKL) Great Keppel Island - Australia", value: "GKL" },
    { label: "(RPB) Roper Bar - Australia", value: "RPB" },
    { label: "(IFL) Innisfail - Australia", value: "IFL" },
    { label: "(BIN) Bamyan Airport - Afghanistan", value: "BIN" },
    { label: "(NBS) Changbaishan Airport - China", value: "NBS" },
    { label: "(RGO) Chongjin Airport - North Korea", value: "RGO" },
    { label: "(MOO) Moomba - Australia", value: "MOO" },
    { label: "(LUZ) Lublin - Poland", value: "LUZ" },
    { label: "(JYO) Leesburg Executive Airport - United States", value: "JYO" },
    { label: "(VAM) Maamigili Airport - Maldives", value: "VAM" },
    { label: "(IRU) Hilton Iru fushi - Maldives", value: "IRU" },
    { label: "(DHG) Dhigurah Centara Grand Maldives - Maldives", value: "DHG" },
    { label: "(LLF) Yongzhou Lingling Airport - China", value: "LLF" },
    { label: "(LSZ) Losinj Airport - Croatia", value: "LSZ" },
    { label: "(ONS) Onslow  - Australia", value: "ONS" },
    { label: "(TDR) Theodore - Australia", value: "TDR" },
    { label: "(CZW) RUDNIKI  - Poland", value: "CZW" },
    { label: "(SDC) Williamson-Sodus Airport - United States", value: "SDC" },
    { label: "(CLC) Clear Lake Metroport - United States", value: "CLC" },
    { label: "(CFX) Gilberto Lavaque - Argentina", value: "CFX" },
    { label: "(WBU) Boulder Municipal - United States", value: "WBU" },
    { label: "(TVS) Sannvhe - China", value: "TVS" },
    {
      label: "(PAO) Palo Alto Airport of Santa Clara County - United States",
      value: "PAO",
    },
    { label: "(FFZ) Mesa Falcon Field - United States", value: "FFZ" },
    { label: "(P08) Coolidge Municipal Airport - United States", value: "P08" },
    { label: "(P52) Cottonwood Airport - United States", value: "P52" },
    { label: "(A39) Phoenix Regional Airport - United States", value: "A39" },
    {
      label: "(E25) Wickenburg Municipal Airport - United States",
      value: "E25",
    },
    { label: "(YTY) Yangzhou Taizhou Airport - China", value: "YTY" },
    { label: "(PTK) Oakland Co. Intl - United States", value: "PTK" },
    { label: "(KSI) Kissidougou - Guinea", value: "KSI" },
    { label: "(QPJ) Pecs - Hungary", value: "QPJ" },
    { label: "(EEN) Dillant Hopkins Airport - United States", value: "EEN" },
    { label: "(THQ) Tianshui Airport - China", value: "THQ" },
    { label: "(GKK) Kooddoo - Maldives", value: "GKK" },
    { label: "(RCS) Rochester Airport - United Kingdom", value: "RCS" },
    { label: "(JHL) Albian Aerodrome - Canada", value: "JHL" },
    { label: "(EQY) Monroe Reqional Airport - United States", value: "EQY" },
    { label: "(KNN) Kankan - Guinea", value: "KNN" },
    { label: "(RHD) Termal - Argentina", value: "RHD" },
    { label: "(KMP) Keetmanshoop - Namibia", value: "KMP" },
    { label: "(KGT) Kangding Airport - China", value: "KGT" },
    { label: "(VUS) Veliky Ustyug - Russia", value: "VUS" },
    {
      label: "(IOW) Iowa City Municipal Airport - United States",
      value: "IOW",
    },
    { label: "(TLQ) Turpan - China", value: "TLQ" },
    { label: "(MWM) Windom Municipal Airport - United States", value: "MWM" },
    { label: "(ANP) Lee Airport - United States", value: "ANP" },
    { label: "(DUU) Ndutu - Tanzania", value: "DUU" },
    { label: "(FXO) Cuamba - Mozambique", value: "FXO" },
    { label: "(ODO) Bodaibo - Russia", value: "ODO" },
    { label: "(ZTR) Zhytomyr - Ukraine", value: "ZTR" },
    { label: "(HRI) Mattala Rajapaksa Intl. - Sri Lanka", value: "HRI" },
    { label: "(PEQ) Pecos Municipal Airport - United States", value: "PEQ" },
    {
      label:
        "(HBG) Hattiesburg Bobby L. Chain Municipal Airport - United States",
      value: "HBG",
    },
    { label: "(QCJ) Botucatu - Brazil", value: "QCJ" },
    { label: "(QSC) Sao Carlos TAM - Brazil", value: "QSC" },
    { label: "(YKN) Chan Gurney - United States", value: "YKN" },
    { label: "(SES) Selfield Airport - United States", value: "SES" },
    { label: "(XSB) Sir Bani Yas Island - United Arab Emirates", value: "XSB" },
    { label: "(ZDY) Dalma Airport - United Arab Emirates", value: "ZDY" },
    { label: "(PCM) Playa del Carmen Airport - Mexico", value: "PCM" },
    { label: "(KTI) Kratie Airport - Cambodia", value: "KTI" },
    { label: "(GYU) Guyuan - China", value: "GYU" },
    { label: "(CNI) Changhai - China", value: "CNI" },
    { label: "(KRH) Redhill Aerodrome - United Kingdom", value: "KRH" },
    { label: "(JGD) Jiagedaqi Airport - China", value: "JGD" },
    { label: "(CCL) Chinchilla - Australia", value: "CCL" },
    { label: "(1C9) Frazier Lake Airpark - United States", value: "1C9" },
    { label: "(HWD) Hayward Executive Airport - United States", value: "HWD" },
    { label: "(MZP) Motueka - New Zealand", value: "MZP" },
    { label: "(JHQ) Shute Harbour - Australia", value: "JHQ" },
    {
      label: "(ARB) Ann Arbor Municipal Airport - United States",
      value: "ARB",
    },
    { label: "(SHT) Shepparton - Australia", value: "SHT" },
    { label: "(TEM) Temora - Australia", value: "TEM" },
    { label: "(GAH) Gayndah - Australia", value: "GAH" },
    { label: "(EIA) Popondetta - Papua New Guinea", value: "EIA" },
    { label: "(WIO) Wilcannia - Australia", value: "WIO" },
    { label: "(BFJ) Bijie Feixiong Airport - China", value: "BFJ" },
    { label: "(ULK) Lensk - Russia", value: "ULK" },
    { label: "(IGD) Igdir - Turkey", value: "IGD" },
    { label: "(GNY) Sanliurfa GAP - Turkey", value: "GNY" },
    { label: "(KZR) Zafer - Turkey", value: "KZR" },
    { label: "(VLU) Velikiye Luki - Russia", value: "VLU" },
    { label: "(ZTY) Boston Back Bay Station - United States", value: "ZTY" },
    { label: "(YLK) Yelahanka AFB - India", value: "YLK" },
    { label: "(ULI) Ulithi - Micronesia", value: "ULI" },
    { label: "(BKN) Balkanabat - Turkmenistan", value: "BKN" },
    { label: "(BEO) Belmont Airport - Australia", value: "BEO" },
    { label: "(4A7) Clayton County Tara Field - United States", value: "4A7" },
    { label: "(BMP) Brampton Island - Australia", value: "BMP" },
    { label: "(NGZ) NAS Alameda - United States", value: "NGZ" },
    { label: "(ZWI) Wilmington Amtrak Station - United States", value: "ZWI" },
    {
      label: "(NML) Fort McMurray - Mildred Lake Airport - Canada",
      value: "NML",
    },
    { label: "(EKI) Elkhart Municipal - United States", value: "EKI" },
    { label: "(YCN) Cochrane - Canada", value: "YCN" },
    {
      label: "(BJP) Aeroporto Estadual Arthur Siqueira - Brazil",
      value: "BJP",
    },
    { label: "(BQB) Brusselton - Australia", value: "BQB" },
    { label: "(GGR) Garowe - International - Somalia", value: "GGR" },
    { label: "(IVR) Inverell - Australia", value: "IVR" },
    { label: "(GLI) Glen Innes - Australia", value: "GLI" },
    { label: "(IMM) Immokalee  - United States", value: "IMM" },
    { label: "(YIC) Yichun Mingyueshan Airport - China", value: "YIC" },
    {
      label: "(ZRZ) New Carrollton Rail Station - United States",
      value: "ZRZ",
    },
    { label: "(PTB) Dinwiddie County Airport - United States", value: "PTB" },
    { label: "(KGN) Kasongo Lunda - Congo (Kinshasa)", value: "KGN" },
    {
      label: "(SBM) Sheboygan County Memorial Airport - United States",
      value: "SBM",
    },
    { label: "(KFE) Dave Forest Airport - Australia", value: "KFE" },
    { label: "(3D2) Ephraim-Gibraltar Airport - United States", value: "3D2" },
    { label: "(BJU) Bajura Airport - Nepal", value: "BJU" },
    { label: "(THD) Tho Xuan Airport - Vietnam", value: "THD" },
    { label: "(MZJ) Pinal Airpark - United States", value: "MZJ" },
    { label: "(GEU) Glendale Municipal Airport - United States", value: "GEU" },
    { label: "(SAD) Safford Regional Airport - United States", value: "SAD" },
    { label: "(SLJ) Solomon Airport - Australia", value: "SLJ" },
    { label: "(KJP) Kerama Airport - Japan", value: "KJP" },
    { label: "(JCO) Comino Airport - Malta", value: "JCO" },
    {
      label: "(SIK) Sikeston Memorial Municipal - United States",
      value: "SIK",
    },
    { label: "(NYN) Nynashamn Ferry Port - Sweden", value: "NYN" },
    { label: "(ROD) Rodby Port - Denmark", value: "ROD" },
    { label: "(QUA) Puttgarden - Germany", value: "QUA" },
    { label: "(BE2) Port of Belfast - United Kingdom", value: "BE2" },
    { label: "(SR2) Stranraer Ferry Port - United Kingdom", value: "SR2" },
    { label: "(L52) Oceano County Airport - United States", value: "L52" },
    { label: "(TTI) Tetiaroa Airport - French Polynesia", value: "TTI" },
    {
      label: "(GFL) Floyd Bennett Memorial Airport - United States",
      value: "GFL",
    },
    { label: "(5B2) Saratoga County Airport - United States", value: "5B2" },
    {
      label: "(K27) Burrello-Mechanicville Airport - United States",
      value: "K27",
    },
    { label: "(MJU) Tampa Padang - Indonesia", value: "MJU" },
    { label: "(CGC) Crystal River - United States", value: "CGC" },
    { label: "(MTN) Martin State - United States", value: "MTN" },
    {
      label: "(LHM) Lincoln Regional Airport Karl Harder Field - United States",
      value: "LHM",
    },
    {
      label: "(FZI) Fostoria Metropolitan Airport - United States",
      value: "FZI",
    },
    { label: "(IZG) Eastern Slopes Regional - United States", value: "IZG" },
    { label: "(NEW) Lakefront - United States", value: "NEW" },
    { label: "(COE) Pappy Boyington - United States", value: "COE" },
    { label: "(BMT) Beaumont Municipal - United States", value: "BMT" },
    { label: "(DNV) Vermilion Regional - United States", value: "DNV" },
    { label: "(COJ) Coonabarabran - Australia", value: "COJ" },
    { label: "(COI) Merritt Island Airport - United States", value: "COI" },
    { label: "(X59) Valkaria Municipal - United States", value: "X59" },
    { label: "(TIX) Space Coast Reg'l Airport - United States", value: "TIX" },
    { label: "(X26) Sebastian Municipal - United States", value: "X26" },
    { label: "(TCY) Terrace Bay - Namibia", value: "TCY" },
    {
      label: "(KEZ) Kelani River-Peliyagoda Waterdrome - Sri Lanka",
      value: "KEZ",
    },
    { label: "(KDZ) Polgolla Reservoir - Sri Lanka", value: "KDZ" },
    { label: "(NYE) NYERI - Kenya", value: "NYE" },
    { label: "(1H2) Effingham Memorial Airport - United States", value: "1H2" },
    { label: "(AAP) Andrau Airport - United States", value: "AAP" },
    { label: "(FCM) Flying Cloud Airport - United States", value: "FCM" },
    { label: "(LIX) Likoma Island Airport - Malawi", value: "LIX" },
    { label: "(OJC) Johnson County Airport - United States", value: "OJC" },
    { label: "(GIU) Sigiriya Airport - Sri Lanka", value: "GIU" },
    { label: "(XWW) Westbahnhoff - Austria", value: "XWW" },
    { label: "(EUM) Neumuenster - Germany", value: "EUM" },
    { label: "(TKT) Tak - Thailand", value: "TKT" },
    { label: "(YLS) Lake Simcoe - Canada", value: "YLS" },
    { label: "(YEE) Huronia - Canada", value: "YEE" },
    { label: "(NU8) Markham - Canada", value: "NU8" },
    { label: "(ND4) Stanhope - Canada", value: "ND4" },
    { label: "(NF4) Lindsay - Canada", value: "NF4" },
    { label: "(YCM) Niagara District - Canada", value: "YCM" },
    { label: "(X04) Apopka - United States", value: "X04" },
    { label: "(XCM) Kent - Canada", value: "XCM" },
    { label: "(YPD) Parry Sound - Canada", value: "YPD" },
    { label: "(OQN) Brandywine Airport - United States", value: "OQN" },
    { label: "(MNZ) Manassas - United States", value: "MNZ" },
    { label: "(BGG) Bingol - Turkey", value: "BGG" },
    { label: "(KFS) Uzunyazi - Turkey", value: "KFS" },
    { label: "(UT3) Hite Airport - United States", value: "UT3" },
    { label: "(GLQ) Queen Street Station - United Kingdom", value: "GLQ" },
    { label: "(2H0) Shelby County Airport - United States", value: "2H0" },
    { label: "(LLV) Dawu - China", value: "LLV" },
    { label: "(DCY) Yading Daocheng - China", value: "DCY" },
    { label: "(GXH) Gannan - China", value: "GXH" },
    { label: "(1G4) Grand Canyon West Airport - United States", value: "1G4" },
    { label: "(CIY) Comiso - Italy", value: "CIY" },
    { label: "(9G1) Rock Airport - United States", value: "9G1" },
    { label: "(2B2) Plum Island Airport - United States", value: "2B2" },
    { label: "(LKK) Kulik Lake Airport - United States", value: "LKK" },
    { label: "(ZGG) Central Station - United Kingdom", value: "ZGG" },
    { label: "(QQU) Euston Station - United Kingdom", value: "QQU" },
    { label: "(QQW) Waterloo International - United Kingdom", value: "QQW" },
    { label: "(KVM) Markovo Airport - Russia", value: "KVM" },
    { label: "(ZKP) Zyryanka West Airport - Russia", value: "ZKP" },
    { label: "(UMS) Ust-Maya Airport - Russia", value: "UMS" },
    { label: "(ADH) Aldan Airport - Russia", value: "ADH" },
    { label: "(NLT) Nalati - China", value: "NLT" },
    { label: "(PTA) Port Alsworth Airport - United States", value: "PTA" },
    { label: "(BOR) Fontaine Airport - France", value: "BOR" },
    { label: "(BHZ) Pampulha - Brazil", value: "BHZ" },
    { label: "(FDW) Fairfield County Airport - United States", value: "FDW" },
    { label: "(OBC) Obock - Djibouti", value: "OBC" },
    { label: "(TDJ) Tadjoura - Djibouti", value: "TDJ" },
    { label: "(AQB) Santa Cruz des Quiche Airport - Guatemala", value: "AQB" },
    { label: "(NOR) Nordfjordur Airport - Iceland", value: "NOR" },
    { label: "(BTZ) Bursa Airport - Turkey", value: "BTZ" },
    { label: "(DAW) Skyhaven Airport - United States", value: "DAW" },
    { label: "(WAR) Waris Airport - Indonesia", value: "WAR" },
    { label: "(PRL) Port Oceanic Airport - United States", value: "PRL" },
    { label: "(EWK) Newton City-County Airport - United States", value: "EWK" },
    { label: "(BSJ) Bairnsdale Airport - Australia", value: "BSJ" },
    { label: "(TZR) Bolton Field - United States", value: "TZR" },
    { label: "(W04) Ocean Shores Municipal - United States", value: "W04" },
    { label: "(55S) Packwood - United States", value: "55S" },
    { label: "(FBR) Fort Bridger - United States", value: "FBR" },
    { label: "(S40) Prosser - United States", value: "S40" },
    { label: "(CLS) Chehalis-Centralia - United States", value: "CLS" },
    { label: "(M94) Desert Aire - United States", value: "M94" },
    { label: "(S30) Lebanon State - United States", value: "S30" },
    {
      label: "(EVW) Evanston-Uinta CO Burns Fld - United States",
      value: "EVW",
    },
    { label: "(K83) Sabetha Municipal - United States", value: "K83" },
    {
      label: "(LRO) Mount Pleasant Regional-Faison Field - United States",
      value: "LRO",
    },
    { label: "(ACJ) Jimmy Carter Regional - United States", value: "ACJ" },
    { label: "(EUF) Weedon Field - United States", value: "EUF" },
    { label: "(6J4) Saluda County - United States", value: "6J4" },
    { label: "(MQI) Dare County Regional - United States", value: "MQI" },
    { label: "(AUO) Auburn University Regional - United States", value: "AUO" },
    { label: "(CZG) Tri-Cities - United States", value: "CZG" },
    { label: "(EKY) Bessemer - United States", value: "EKY" },
    { label: "(A50) Colorado Springs East - United States", value: "A50" },
    {
      label: "(ИКУ) Issyk-Kul International Airport - Kyrgyzstan",
      value: "ИКУ",
    },
    { label: "(MIC) Crystal Airport - United States", value: "MIC" },
    { label: "(23M) Clarke CO - United States", value: "23M" },
    { label: "(DBN) W H Barron Field - United States", value: "DBN" },
    { label: "(UCA) Union Station - United States", value: "UCA" },
    { label: "(PUK) Pukarua Airport - French Polynesia", value: "PUK" },
    { label: "(CVO) Corvallis Muni - United States", value: "CVO" },
    { label: "(PXH) Prominent Hill - Australia", value: "PXH" },
    { label: "(CWT) Chatsworth Station - United States", value: "CWT" },
    { label: "(YGG) Ganges Water Aerodrome - Canada", value: "YGG" },
    { label: "(YPT) Pender Harbour Water Aerodrome - Canada", value: "YPT" },
    { label: "(YMU) Mansons Landing Water Aerodrome - Canada", value: "YMU" },
    { label: "(YMP) Port McNeill Airport - Canada", value: "YMP" },
    { label: "(YTG) Sullivan Bay Water Aerodrome - Canada", value: "YTG" },
    { label: "(DHB) Deer Harbor Seaplane - United States", value: "DHB" },
    {
      label: "(OLT) San Diego Old Town Transit Center - United States",
      value: "OLT",
    },
  ];

  // Date Values
  function onChange(dates, dateStrings) {
    if (dates !== null) {
      console.log("onChange");
      console.log("From: ", dates[0], ", to: ", dates[1]);
      console.log("From: ", dateStrings[0], ", to: ", dateStrings[1]);
      j["FlightDate"] = dateStrings[0]; // departure date
      k["FlightDate"] = dateStrings[1]; // arrival date
    }
  }
  // From
  function fromValue(value3) {
    console.log("in 3");
    j["From"] = value3;
    k["To"] = value3;
  }
  //To
  function toValue(value4) {
    console.log("in 4");
    j["To"] = value4;
    k["From"] = value4;
  }
  // NO of Passengers
  function onChangeAdult(value1) {
    console.log("in 1");
    AdultNo = 0;
    AdultNo = value1;
  }
  // NO of Passengers
  function onChangeChildren(value2) {
    console.log("in 2");
    childNo = 0;
    childNo = value2;
  }
  // Cabin class

  const onChangeDropDown = ({ key }) => {
    console.log(`Click on item ${key}`);
    console.log(typeof key);
    cabin = key;

    switch (key) {
      case "1":
        setChosenClass("Economy Class");
        break;
      case "2":
        setChosenClass("First Class");
        break;
      case "3":
        setChosenClass("Business Class");
        break;
    }
    console.log("Chosen " + chosenClass);
  };

  const menu = (
    <Menu onClick={onChangeDropDown}>
      <Menu.Item key="1">Economy</Menu.Item>
      <Menu.Item key="2">First</Menu.Item>
      <Menu.Item key="3">Business</Menu.Item>
    </Menu>
  );
  // Search Button
  function buttonClicked() {
    props.setLoading(true);
    if (
      j["From"] === "" ||
      j["To"] === "" ||
      j["FlightDate"] === "" ||
      k["FlightDate"] === "" ||
      cabin === "" ||
      AdultNo === 0
    ) {
      setErrorVisible1(true);
      props.setLoading(false);
    } else {
      if (j["From"] === j["To"]) {
        setErrorVisible(true);
        props.setLoading(false);
      } else {
        setErrorVisible(false);
        setErrorVisible1(false);
        delete search.fseatsAvailable;
        delete search.bseatsAvailable;
        delete search.eseatsAvailable;

        if (cabin === "1") {
          search["eseatsAvailable"] = AdultNo + childNo;
          // j["fseatsAvailable"] = 0;
          // k["fseatsAvailable"] = 0;

          // j["bseatsAvailable"] = 0;
          // k["bseatsAvailable"] = 0;
        }
        if (cabin === "2") {
          search["fseatsAvailable"] = AdultNo + childNo;

          // j["bseatsAvailable"] = 0;
          // k["bseatsAvailable"] = 0;
          // j["eseatsAvailable"] = 0;
          // k["eseatsAvailable"] = 0;
        }
        if (cabin === "3") {
          search["bseatsAvailable"] = AdultNo + childNo;

          // j["eseatsAvailable"] = 0;
          // k["eseatsAvailable"] = 0;

          // j["fseatsAvailable"] = 0;
          // k["fseatsAvailable"] = 0;
        }

        // var x = {};
        // var y = {};

        // x = j;
        // y = k;
        // setDate(Object.assign({}, j)); //Depature Flight
        // setDate2(Object.assign({}, k));

        setFlightOne(Object.assign({}, j)); //Depature Flight
        setFlightTwo(Object.assign({}, k));
        //setSearchQuery(Object.assign({}, search));
        props.setSearchData(search); //searchData

        console.log("Date");
        console.log(flightOne);
        console.log("Date2");
        console.log(flightTwo);
      }
    }
  }
  // useEffect(() => {
  //   const storeddate = parseInt(sessionStorage.getItem("date") || {});
  //   setDate(storeddate);
  //   const storeddate2 = parseInt(sessionStorage.getItem("date2") || {});
  //   setDate2(storeddate2);
  // }, []);

  useEffect(() => {
    if (flightOne !== {}) {
      axios
        .post(serverport+"/flights/search-m2", flightOne)
        .then((res) => {
          let n = Object.keys(res.data).length;
          let arr = [];
          let result = [];
          arr = res.data;
          let noOfPassengers = AdultNo + childNo;
          for (let i = 0; i < n; i++) {
            if (cabin === "1") {
              if (noOfPassengers <= arr[i].eseatsAvailable) {
                result.push(arr[i]);
              }
            }
            if (cabin === "2") {
              if (noOfPassengers <= arr[i].fseatsAvailable) {
                result.push(arr[i]);
              }
            }
            if (cabin === "3") {
              if (noOfPassengers <= arr[i].bseatsAvailable) {
                result.push(arr[i]);
              }
            }
          }

          console.log(result);
          props.setDepFlights(result);

          if (result.length !== 0) {
            $(document).scrollTop(900);
            props.setLoading(false);
            // any value you need
          } else {
            $(document).scrollTop(900); // any value you need

            props.setshowEmpty("No Flights Found");
            props.setLoading(false);
          }
        });
    }
  }, [flightOne]);

  useEffect(() => {
    if (flightTwo !== {}) {
      axios
        .post(serverport+"flights/search-m2", flightTwo)
        .then((res) => {
          let n = Object.keys(res.data).length;
          let arr = [];
          let result = [];
          arr = res.data;
          let noOfPassengers = AdultNo + childNo;
          for (let i = 0; i < n; i++) {
            if (cabin === "1") {
              if (noOfPassengers <= arr[i].eseatsAvailable) {
                result.push(arr[i]);
              }
            }
            if (cabin === "2") {
              if (noOfPassengers <= arr[i].fseatsAvailable) {
                result.push(arr[i]);
              }
            }
            if (cabin === "3") {
              if (noOfPassengers <= arr[i].bseatsAvailable) {
                result.push(arr[i]);
              }
            }
          }
          console.log(result);
          props.setRetFlights(result);
        });
    }
  }, [flightTwo]);

  const tghfk9 = {
    width: "100px",
  };

  return (
    <div>
      <br />
      <br />
      <br />

      <br />

      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          width: "110vh",
        }}
      >
        <Tooltip
          title="Check for the availability of a flight."
          placement="left"
          disableFocusListener
        >
          <div style={{ marginTop: "4px", marginRight: "0px" }}>
            <AirplaneTicketSharpIcon style={{ fontSize: 125 }} />
          </div>
        </Tooltip>
        <div
          class="container-fluid"
          style={{ margin: "4px", marginLeft: "0px" }}
        >
          <div
            class="row"
            style={{ marginBottom: "3px", position: "relative", zIndex: 8 }}
          >
            <div class="col-4" style={{ zIndex: 8 }}>
              {" "}
              <AutoComplete
                size="large"
                style={{ borderColor: "black", width: "100%" }}
                options={options}
                placeholder="Leaving From"
                filterOption={(inputValue, option) =>
                  option.value
                    .toUpperCase()
                    .indexOf(inputValue.toUpperCase()) !== -1
                }
                onChange={fromValue}
              />
            </div>

            <div
              class="col-1"
              style={{ position: "absolute", left: 221, zIndex: 10, top: 3 }}
            >
              <CompareArrowsIcon style={{ color: "#191b3a", fontSize: 35 }} />
            </div>
            <div class="col-4 " style={{ zIndex: 8 }}>
              {" "}
              <AutoComplete
                size="large"
                style={{ borderColor: "black", width: "100%" }}
                options={options}
                placeholder="Going To"
                filterOption={(inputValue, option) =>
                  option.value
                    .toUpperCase()
                    .indexOf(inputValue.toUpperCase()) !== -1
                }
                onChange={toValue}
              />
            </div>
            <div class="col-4">
              <Dropdown
                overlay={menu}
                trigger="click"
                style={{ width: "100%" }}
              >
                <Button
                  style={{ width: "100%" }}
                  className="ant-dropdown-link"
                  onClick={(e) => e.preventDefault()}
                >
                  {chosenClass.localeCompare("") === 0
                    ? "Cabin Class "
                    : chosenClass + " "}
                  <DownOutlined />
                </Button>
              </Dropdown>
            </div>
          </div>

          <div class="row">
            <div class="col-8">
              {" "}
              <RangePicker
                style={{ width: "100%" }}
                size="large"
                format="MM-DD-YYYY"
                onChange={onChange}
                autoFocus={true}
                allowClear
              />
            </div>
            <div class="col-2">
              {" "}
              <InputNumber
                size="large"
                placeholder="Passengers #"
                min={1}
                max={10}
                onChange={onChangeAdult}
                style={{ width: "100%" }}

                // style={{ width: 100 }}
              />
            </div>
            {/* <div class="col-2 " >    <InputNumber
                  size="large"
                  placeholder="Child"
                  min={0}
                  max={10}
                  onChange={onChangeChildren}
                  // style={{ width: 100 }}
                /></div> */}
            <div class="col-2">
              {" "}
              <Button
                size="large"
                id="searchOutput"
                type="primary"
                icon={<SearchOutlined />}
                onClick={buttonClicked}
              >
                Search
              </Button>
            </div>
          </div>
        </div>
      </div>

      {errVisible ? (
        <Tag
          icon={<CloseCircleOutlined />}
          color="error"
          visible={errVisible}
          id="tag"
        >
          Please choose a different destination from origin
        </Tag>
      ) : (
        <Tag
          icon={<CloseCircleOutlined />}
          color="error"
          visible={errVisible}
          id="tag"
        >
          Please choose a different destination from origin
        </Tag>
      )}
      {errVisible1 ? (
        <Tag
          icon={<CloseCircleOutlined />}
          color="error"
          visible={errVisible1}
          id="tag"
        >
          Please enter all the fields
        </Tag>
      ) : (
        <Tag
          icon={<CloseCircleOutlined />}
          color="error"
          visible={errVisible1}
          id="tag"
        >
          Please enter all the fields
        </Tag>
      )}
    </div>
  );
}
